const acciones = [
    { slug:'ver', label: "Ver" },
    { slug:'crear', label: "Crear" },
    { slug:'modificar', label: "Modificar" },
    { slug:'eliminar', label: "Eliminar" },
]

const botones = {
  distrubion:{
    label: "ver_distribucion"
  },
  informe_personalizado:{
    label: "informe_personalizado"
  },
  informe_clasificacion:{
    label: "informe_clasificacion"
  },
  subir_requisitos_vehiculo:{
    label: "subir_requisitos_vehiculo"
  },
  subir_requisitos_conductor:{
    label: "subir_requisitos_conductor"
  },
  asociar_contactos:{
    label: "asociar_contactos"
  },
  graficos:{
    label: "graficos"
  },
  productos:{
    label: "Maestro de productos"
  },
  viajes: {
    label: "Órdenes"
  },
  viajes_retrasados: {
    label: "Órdenes retrasadas"
  }
}

const virtual_tour_settings = {
  locale: { back: 'Anterior', close: 'Cerrar', last: 'Último', next: 'Siguiente', open: 'Abrir el diálogo', skip: 'Saltar' },
  estilo: {
    arrowColor: '#fff',
    backgroundColor: '#fff',
    beaconSize: 36,
    overlayColor: 'rgba(0, 0, 0, 0.5)',
    primaryColor: '#007bff',
    spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
    textColor: '#333',
    width: undefined,
    zIndex: 100,
  },
  pasos_ordenes: [
    {
        title: "Buscador de órdenes",
        disableBeacon: true,
        target: ".delpa-buscador",
        content: "A través del buscador podrás encontrar las órdenes"
    },
    {
        title: "Filtro de órdenes",
        target: ".delpa-filtro",
        content: "A través del filtro podrás encontrar justo las órdenes que necesitas visualizar para luego exportarlas a un excel por ejemplo"
    },
    {
        title: "Descargar reportes excel",
        target: ".delpa-reporte-excel",
        content: "Puedes descargar un reporte de las órdenes, este botón actua en combinación del botón FILTRAR que verás en la parte superior de esta zona."
    },
    {
        title: "Listado de órdenes",
        target: ".delpa-ordenes",
        placement: "right",
        content: "Aquí podrás visualizar el listado de tus órdenes, y hacer click sobre ellas para acceder a todos los detalles"
    },
    {
        title: "Crea órdenes",
        target: ".delpa-nueva-orden",
        content: "Aquí podrás una orden nueva uno a uno, o también puedes importarlas por excel en el módulo de RUTAS"
    },
  ],
  pasos_rutas:[
    {
      title: "Buscador de rutas",
      disableBeacon: true,
      target: ".delpa-buscador-ruta",
      content: "A través del buscador podrás encontrar las rutas por su número identificador"
    },
    {
      title: "Filtro de rutas",
      target: ".delpa-filtro",
      content: "A través del filtro podrás encontrar justo las rutas que necesitas visualizar"
    },
    {
      title: "Listado de rutas",
      target: ".delpa-rutas",
      placement: "right",
      content: "Aquí podrás visualizar el listado de tus rutas"
    },
    {
      title: "Crea nueva ruta",
      target: ".delpa-nueva-ruta",
      content: "Aquí podrás una ruta nueva"
    },
    {
      title: "Importa tus rutas",
      target: ".delpa-importar-ruta",
      content: "Aquí podrás importar un excel de órdenes y agruparlos en una o varias rutas por vehículos"
    },
  ]
} 

const logotipo = window.location.protocol + "//" + window.location.host + "/images/logo.png"
const url_images = window.location.protocol + "//" + window.location.host + "/images"
const host = window.location.protocol + "//" + window.location.host 

const markerSmall = {
    path:
      "M10.453 14.016l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
    fillColor: "#007bff",
    fillOpacity: 0.9,
    scale: 1,
    //strokeColor: "gold",
    strokeWeight: 0,
  }

  const paises_sistema = [
    "CL",
    "CO",
    "BR",
    "MX"
  ]

  const paises_nombres = {
    CL: "Chile",
    BR: "Brasil",
    CO: "Colombia",
    MX: "México"
  }

  const paises_codigos_telefonos = {
    CL: "+56",
    BR: "+55",
    CO: "+57",
    MX: "+52"
  }

  const geojson_rm = {"type":"FeatureCollection","features":[{"geometry":{"coordinates":[[[-70.657302,-33.404785],[-70.657294,-33.404824],[-70.65726,-33.404995],[-70.657216,-33.40521],[-70.657201,-33.405336],[-70.657117,-33.40579],[-70.657112,-33.405792],[-70.657113,-33.405814],[-70.657103,-33.405863],[-70.653521,-33.406646],[-70.653593,-33.411819],[-70.652977,-33.411871],[-70.652978,-33.415227],[-70.652751,-33.415307],[-70.652741,-33.416114],[-70.652723,-33.417562],[-70.651712,-33.417602],[-70.650165,-33.417856],[-70.650768,-33.421285],[-70.651044,-33.423356],[-70.65118,-33.424968],[-70.651383,-33.427202],[-70.651492,-33.428653],[-70.651544,-33.429211],[-70.651652,-33.430391],[-70.651721,-33.431166],[-70.651666,-33.431726],[-70.651753,-33.431833],[-70.651749,-33.43283],[-70.65198,-33.432802],[-70.652269,-33.432746],[-70.653369,-33.43253],[-70.656981,-33.431821],[-70.657852,-33.431614],[-70.65861,-33.431433],[-70.66031,-33.430953],[-70.661426,-33.43053],[-70.665853,-33.428851],[-70.668148,-33.428047],[-70.671514,-33.426868],[-70.671182,-33.425951],[-70.671751,-33.42555],[-70.672505,-33.424656],[-70.673306,-33.423622],[-70.673975,-33.422742],[-70.674476,-33.422113],[-70.675259,-33.421414],[-70.677127,-33.420012],[-70.677779,-33.419345],[-70.678279,-33.418544],[-70.678701,-33.41733],[-70.678805,-33.416587],[-70.679298,-33.413854],[-70.679742,-33.411039],[-70.680329,-33.407036],[-70.680427,-33.405989],[-70.680598,-33.405419],[-70.680881,-33.404865],[-70.681806,-33.403204],[-70.68174,-33.403186],[-70.681818,-33.403063],[-70.681859,-33.403],[-70.68167,-33.40294],[-70.680973,-33.40278],[-70.678983,-33.402185],[-70.678283,-33.401924],[-70.678045,-33.401846],[-70.676456,-33.401263],[-70.67495,-33.400724],[-70.673416,-33.400159],[-70.672176,-33.399716],[-70.671934,-33.400219],[-70.671934,-33.400219],[-70.671901,-33.400287],[-70.669504,-33.400156],[-70.668598,-33.400138],[-70.668363,-33.400146],[-70.667075,-33.400136],[-70.667078,-33.400055],[-70.667857,-33.399382],[-70.668154,-33.399126],[-70.667284,-33.399003],[-70.666704,-33.398954],[-70.665961,-33.398999],[-70.664461,-33.399116],[-70.664002,-33.399153],[-70.663717,-33.399401],[-70.663696,-33.399403],[-70.663672,-33.399337],[-70.663282,-33.399229],[-70.66261,-33.399252],[-70.661052,-33.399406],[-70.658289,-33.399705],[-70.658289,-33.399703],[-70.658206,-33.399714],[-70.658175,-33.400553],[-70.657913,-33.401815],[-70.657678,-33.402877],[-70.65745,-33.404062],[-70.657302,-33.404785]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1310,"DIS_ELEC":19,"NOM_COM":"Independencia","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":7514745.51089,"SHAPE_LENG":11488.695747,"SHAPE_Le_1":11718.687086},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.439462,-33.492062],[-70.438253,-33.492151],[-70.437901,-33.492155],[-70.437851,-33.4922],[-70.437788,-33.492662],[-70.437796,-33.494106],[-70.437705,-33.494562],[-70.437517,-33.495141],[-70.43741,-33.495271],[-70.437367,-33.495445],[-70.437291,-33.49582],[-70.437235,-33.496179],[-70.437193,-33.496632],[-70.437152,-33.49704],[-70.437144,-33.497409],[-70.437165,-33.497753],[-70.437247,-33.498039],[-70.437439,-33.498312],[-70.437653,-33.498523],[-70.437883,-33.49877],[-70.43814,-33.499],[-70.438383,-33.499266],[-70.438561,-33.499543],[-70.438771,-33.499924],[-70.438987,-33.500225],[-70.439205,-33.500467],[-70.43945,-33.50071],[-70.439702,-33.500909],[-70.44006,-33.501219],[-70.440363,-33.501514],[-70.440629,-33.501808],[-70.440897,-33.502065],[-70.441199,-33.502369],[-70.441486,-33.502619],[-70.441767,-33.502877],[-70.442041,-33.503139],[-70.442312,-33.503401],[-70.442711,-33.503893],[-70.443109,-33.504183],[-70.444181,-33.504475],[-70.445572,-33.504593],[-70.446486,-33.504713],[-70.446886,-33.504804],[-70.447293,-33.504891],[-70.447682,-33.504991],[-70.448077,-33.505073],[-70.448465,-33.505164],[-70.448822,-33.505308],[-70.449149,-33.5055],[-70.449514,-33.505599],[-70.449862,-33.505747],[-70.450209,-33.505926],[-70.450519,-33.506068],[-70.450819,-33.506377],[-70.451085,-33.506584],[-70.451399,-33.506847],[-70.451862,-33.507123],[-70.452575,-33.507934],[-70.452834,-33.508198],[-70.453482,-33.508779],[-70.453838,-33.509095],[-70.454776,-33.509859],[-70.455039,-33.51031],[-70.45543,-33.510813],[-70.456368,-33.511577],[-70.456852,-33.511919],[-70.458536,-33.513422],[-70.459057,-33.513761],[-70.4595,-33.514144],[-70.460135,-33.514661],[-70.460712,-33.515084],[-70.46146,-33.515505],[-70.462719,-33.515824],[-70.463292,-33.516008],[-70.463923,-33.516287],[-70.464212,-33.516522],[-70.464558,-33.516757],[-70.464734,-33.517089],[-70.465142,-33.517609],[-70.46584,-33.518459],[-70.466197,-33.519362],[-70.466556,-33.52036],[-70.466621,-33.520836],[-70.466744,-33.521408],[-70.466985,-33.522168],[-70.467111,-33.522883],[-70.467475,-33.524214],[-70.468003,-33.525115],[-70.468182,-33.525302],[-70.468409,-33.52554],[-70.468758,-33.525917],[-70.468877,-33.52625],[-70.469228,-33.526771],[-70.469974,-33.527096],[-70.470547,-33.52728],[-70.471462,-33.52746],[-70.472034,-33.527596],[-70.472663,-33.527732],[-70.473631,-33.528023],[-70.4745,-33.528522],[-70.474902,-33.528708],[-70.475248,-33.528942],[-70.475763,-33.529079],[-70.476165,-33.529265],[-70.476569,-33.529595],[-70.47778,-33.530391],[-70.478184,-33.530721],[-70.478587,-33.530954],[-70.479047,-33.531187],[-70.47945,-33.531421],[-70.479795,-33.531656],[-70.479914,-33.531941],[-70.480035,-33.532321],[-70.479989,-33.53299],[-70.479997,-33.533467],[-70.480005,-33.533944],[-70.480014,-33.534469],[-70.479909,-33.534995],[-70.479805,-33.535569],[-70.479815,-33.536141],[-70.479878,-33.536522],[-70.479998,-33.536855],[-70.480287,-33.53709],[-70.480577,-33.537373],[-70.480923,-33.537655],[-70.481554,-33.537886],[-70.48207,-33.538023],[-70.482585,-33.53816],[-70.4831,-33.538297],[-70.484587,-33.538614],[-70.485219,-33.538892],[-70.485852,-33.539267],[-70.486143,-33.539597],[-70.486318,-33.539787],[-70.486665,-33.540164],[-70.486842,-33.540496],[-70.486849,-33.540925],[-70.486855,-33.541259],[-70.486834,-33.54142],[-70.486754,-33.542024],[-70.486823,-33.542739],[-70.486982,-33.543229],[-70.487545,-33.54343],[-70.487575,-33.543428],[-70.48767,-33.543422],[-70.487973,-33.543402],[-70.488466,-33.543415],[-70.488777,-33.543472],[-70.48915,-33.543616],[-70.489548,-33.543784],[-70.489936,-33.543865],[-70.490307,-33.54391],[-70.490691,-33.544015],[-70.491073,-33.544128],[-70.491461,-33.544214],[-70.491861,-33.544255],[-70.492268,-33.544257],[-70.492662,-33.544208],[-70.493017,-33.544086],[-70.493433,-33.544006],[-70.493818,-33.543903],[-70.494207,-33.543814],[-70.494505,-33.543703],[-70.494995,-33.543676],[-70.495396,-33.543646],[-70.495799,-33.543633],[-70.496217,-33.543522],[-70.49661,-33.543537],[-70.496979,-33.543483],[-70.497404,-33.543525],[-70.497808,-33.543517],[-70.498206,-33.543568],[-70.498581,-33.543685],[-70.498942,-33.543842],[-70.499149,-33.544089],[-70.499475,-33.544366],[-70.499779,-33.544576],[-70.500107,-33.544804],[-70.50036,-33.544989],[-70.500773,-33.545116],[-70.50118,-33.545347],[-70.501435,-33.545492],[-70.501688,-33.545654],[-70.501943,-33.545794],[-70.502116,-33.545998],[-70.502362,-33.546314],[-70.502933,-33.546424],[-70.503533,-33.546464],[-70.504082,-33.546484],[-70.504691,-33.546376],[-70.505326,-33.546246],[-70.507212,-33.545765],[-70.509493,-33.545235],[-70.510503,-33.544966],[-70.511515,-33.544651],[-70.512697,-33.544099],[-70.513579,-33.543758],[-70.514535,-33.543531],[-70.51527,-33.54349],[-70.515907,-33.543338],[-70.516408,-33.543293],[-70.516751,-33.543238],[-70.517077,-33.543227],[-70.517309,-33.543186],[-70.517543,-33.543154],[-70.517777,-33.543126],[-70.518013,-33.543103],[-70.518249,-33.543089],[-70.518486,-33.543075],[-70.518723,-33.54307],[-70.518961,-33.543056],[-70.519198,-33.543052],[-70.519435,-33.543042],[-70.519673,-33.543033],[-70.519909,-33.543014],[-70.520146,-33.542996],[-70.520382,-33.542982],[-70.520618,-33.542959],[-70.520854,-33.542945],[-70.521091,-33.542926],[-70.521327,-33.542913],[-70.521363,-33.542911],[-70.521563,-33.542905],[-70.52256,-33.542972],[-70.523531,-33.543104],[-70.524046,-33.543193],[-70.524674,-33.54328],[-70.525073,-33.543276],[-70.525531,-33.543365],[-70.526048,-33.543598],[-70.52662,-33.543734],[-70.527136,-33.543918],[-70.527879,-33.544052],[-70.528335,-33.544047],[-70.529875,-33.544123],[-70.530446,-33.544164],[-70.531019,-33.544348],[-70.531363,-33.544439],[-70.531823,-33.544719],[-70.532113,-33.545002],[-70.532464,-33.545475],[-70.532698,-33.545854],[-70.532989,-33.546184],[-70.53345,-33.546465],[-70.533967,-33.546697],[-70.534183,-33.546766],[-70.53454,-33.546881],[-70.534755,-33.547228],[-70.535278,-33.547602],[-70.5361,-33.548055],[-70.536789,-33.548332],[-70.537228,-33.5486],[-70.537482,-33.548849],[-70.537999,-33.549081],[-70.538401,-33.549267],[-70.538918,-33.549499],[-70.539376,-33.549589],[-70.539834,-33.549726],[-70.540211,-33.549892],[-70.540567,-33.550205],[-70.541286,-33.550443],[-70.543144,-33.550737],[-70.543778,-33.55087],[-70.544075,-33.551042],[-70.544247,-33.551217],[-70.544756,-33.551457],[-70.545177,-33.551416],[-70.545471,-33.551413],[-70.545894,-33.551513],[-70.546191,-33.551651],[-70.546406,-33.551895],[-70.546787,-33.552031],[-70.547123,-33.551956],[-70.547205,-33.551849],[-70.547242,-33.551567],[-70.547361,-33.551178],[-70.547566,-33.550858],[-70.548066,-33.550534],[-70.548148,-33.550428],[-70.54827,-33.550215],[-70.548392,-33.549966],[-70.548512,-33.549577],[-70.548676,-33.549364],[-70.549007,-33.549042],[-70.549257,-33.548863],[-70.549715,-33.54861],[-70.550383,-33.54832],[-70.550885,-33.548137],[-70.551431,-33.548025],[-70.552062,-33.548017],[-70.552609,-33.54801],[-70.552969,-33.548029],[-70.5544,-33.547913],[-70.556932,-33.547835],[-70.557822,-33.547817],[-70.55981,-33.547773],[-70.56151,-33.547736],[-70.563167,-33.547706],[-70.565383,-33.547649],[-70.568008,-33.547481],[-70.568452,-33.547484],[-70.568259,-33.54774],[-70.568251,-33.547743],[-70.568256,-33.547743],[-70.563888,-33.552926],[-70.562385,-33.554683],[-70.560991,-33.556397],[-70.559991,-33.557608],[-70.55963,-33.558188],[-70.559182,-33.558756],[-70.55878,-33.559236],[-70.557452,-33.560689],[-70.557357,-33.560782],[-70.557761,-33.560858],[-70.56216,-33.561679],[-70.563304,-33.561905],[-70.563684,-33.561948],[-70.564214,-33.562034],[-70.564429,-33.562068],[-70.56443,-33.562072],[-70.566826,-33.562488],[-70.567844,-33.562674],[-70.568199,-33.562725],[-70.568201,-33.562731],[-70.56876,-33.562831],[-70.56908,-33.562888],[-70.569381,-33.562939],[-70.569731,-33.563],[-70.570135,-33.563072],[-70.570522,-33.563137],[-70.570895,-33.563204],[-70.571269,-33.563271],[-70.571942,-33.563386],[-70.573304,-33.563629],[-70.574867,-33.563912],[-70.576238,-33.564156],[-70.577196,-33.564324],[-70.577471,-33.564375],[-70.577745,-33.564426],[-70.578018,-33.564474],[-70.578296,-33.564523],[-70.578573,-33.564573],[-70.578668,-33.564591],[-70.578769,-33.564609],[-70.57905,-33.564659],[-70.579402,-33.564721],[-70.579559,-33.564749],[-70.57992,-33.564803],[-70.580198,-33.564854],[-70.580467,-33.564904],[-70.580748,-33.564955],[-70.58102,-33.565003],[-70.582233,-33.565215],[-70.583871,-33.565519],[-70.584473,-33.565584],[-70.584413,-33.565968],[-70.583858,-33.568874],[-70.583738,-33.569456],[-70.58417,-33.569506],[-70.58417,-33.569506],[-70.584174,-33.569506],[-70.586383,-33.569761],[-70.588466,-33.569995],[-70.588503,-33.569772],[-70.59224,-33.570117],[-70.593381,-33.569682],[-70.594675,-33.569159],[-70.595399,-33.568861],[-70.595812,-33.568693],[-70.596519,-33.568432],[-70.597365,-33.568087],[-70.597732,-33.567911],[-70.598306,-33.567489],[-70.598799,-33.567293],[-70.599327,-33.56725],[-70.599949,-33.567296],[-70.600741,-33.567502],[-70.602206,-33.567936],[-70.603601,-33.568331],[-70.605576,-33.568862],[-70.605901,-33.56888],[-70.606811,-33.569112],[-70.607332,-33.569267],[-70.611144,-33.570546],[-70.611271,-33.570566],[-70.611332,-33.570152],[-70.61144,-33.569432],[-70.611806,-33.566944],[-70.612217,-33.564127],[-70.612502,-33.562232],[-70.612512,-33.562204],[-70.612494,-33.562204],[-70.612516,-33.562184],[-70.610721,-33.562002],[-70.610721,-33.562001],[-70.61044,-33.561963],[-70.610702,-33.561019],[-70.611694,-33.557546],[-70.611916,-33.556772],[-70.612231,-33.555611],[-70.612602,-33.554427],[-70.612691,-33.554064],[-70.612909,-33.553308],[-70.613705,-33.550482],[-70.61403,-33.549339],[-70.614215,-33.548695],[-70.61448,-33.547791],[-70.614572,-33.547478],[-70.614654,-33.547193],[-70.614815,-33.546662],[-70.614809,-33.546663],[-70.614818,-33.546653],[-70.614857,-33.546523],[-70.614824,-33.546397],[-70.614464,-33.546474],[-70.614036,-33.546543],[-70.61371,-33.546569],[-70.61298,-33.546593],[-70.612537,-33.546599],[-70.611391,-33.546631],[-70.610941,-33.546645],[-70.610937,-33.54665],[-70.610559,-33.546654],[-70.61044,-33.54333],[-70.610312,-33.539754],[-70.610318,-33.539019],[-70.610134,-33.537387],[-70.610041,-33.534793],[-70.609986,-33.533153],[-70.609822,-33.52843],[-70.609749,-33.526187],[-70.609984,-33.524118],[-70.610129,-33.522846],[-70.61036,-33.520811],[-70.610655,-33.518477],[-70.610924,-33.51615],[-70.611025,-33.515193],[-70.611309,-33.512669],[-70.611309,-33.512669],[-70.611351,-33.512307],[-70.611529,-33.510875],[-70.611516,-33.510868],[-70.611562,-33.510388],[-70.611642,-33.510297],[-70.612859,-33.509143],[-70.61313,-33.508888],[-70.61355,-33.508474],[-70.613594,-33.508427],[-70.613594,-33.508427],[-70.613663,-33.508351],[-70.612923,-33.508364],[-70.612273,-33.508384],[-70.610634,-33.508414],[-70.604309,-33.508882],[-70.601892,-33.509038],[-70.599304,-33.509298],[-70.597509,-33.50943],[-70.5938,-33.50971],[-70.591987,-33.509829],[-70.591406,-33.509944],[-70.59016,-33.510145],[-70.590003,-33.510157],[-70.588983,-33.510233],[-70.588179,-33.510292],[-70.587954,-33.510168],[-70.5871,-33.510042],[-70.58501,-33.510194],[-70.579929,-33.510642],[-70.576158,-33.510762],[-70.574636,-33.510959],[-70.572593,-33.511181],[-70.571051,-33.511308],[-70.570663,-33.511366],[-70.566434,-33.511637],[-70.56559,-33.511542],[-70.564705,-33.511447],[-70.561552,-33.511628],[-70.560724,-33.511678],[-70.557097,-33.511896],[-70.555078,-33.512081],[-70.554931,-33.512032],[-70.551823,-33.512167],[-70.550676,-33.512208],[-70.548884,-33.512312],[-70.546703,-33.51242],[-70.545075,-33.512483],[-70.544464,-33.512435],[-70.543814,-33.512411],[-70.542676,-33.512485],[-70.542012,-33.512533],[-70.541708,-33.512531],[-70.541444,-33.51244],[-70.541173,-33.512368],[-70.540635,-33.512337],[-70.539916,-33.512271],[-70.539331,-33.512166],[-70.53888,-33.512059],[-70.538337,-33.511802],[-70.537793,-33.511471],[-70.537206,-33.511253],[-70.536125,-33.510966],[-70.532246,-33.509774],[-70.531568,-33.509481],[-70.530847,-33.509302],[-70.529902,-33.509089],[-70.528503,-33.508617],[-70.527737,-33.508439],[-70.527018,-33.508335],[-70.526389,-33.508268],[-70.525671,-33.508277],[-70.525134,-33.508321],[-70.52464,-33.508289],[-70.524141,-33.507995],[-70.523868,-33.507735],[-70.522955,-33.506845],[-70.522136,-33.506178],[-70.519419,-33.504709],[-70.518418,-33.503894],[-70.517828,-33.503488],[-70.517461,-33.503004],[-70.517275,-33.502668],[-70.517046,-33.502408],[-70.516729,-33.502187],[-70.516322,-33.502004],[-70.516007,-33.501932],[-70.515333,-33.501866],[-70.514749,-33.501835],[-70.514164,-33.501692],[-70.513579,-33.501586],[-70.513084,-33.50148],[-70.512498,-33.501337],[-70.5116,-33.50131],[-70.511152,-33.501316],[-70.509984,-33.501179],[-70.509443,-33.501036],[-70.508631,-33.500745],[-70.507324,-33.500423],[-70.506918,-33.500277],[-70.506557,-33.500131],[-70.506016,-33.499988],[-70.504893,-33.499851],[-70.504352,-33.499707],[-70.503499,-33.499643],[-70.502915,-33.499612],[-70.502289,-33.499695],[-70.501621,-33.500003],[-70.501356,-33.500232],[-70.500865,-33.500388],[-70.500503,-33.500205],[-70.500496,-33.499754],[-70.500667,-33.499264],[-70.500657,-33.498738],[-70.500562,-33.498438],[-70.500378,-33.49814],[-70.50015,-33.497917],[-70.499744,-33.497809],[-70.499206,-33.497778],[-70.498404,-33.498089],[-70.497649,-33.498549],[-70.497118,-33.498931],[-70.496541,-33.499276],[-70.495917,-33.499509],[-70.495559,-33.499551],[-70.495021,-33.499557],[-70.494348,-33.499565],[-70.493675,-33.499574],[-70.493228,-33.499654],[-70.492871,-33.499734],[-70.492517,-33.500038],[-70.492388,-33.500378],[-70.492349,-33.500717],[-70.492039,-33.500946],[-70.491727,-33.501062],[-70.491368,-33.501029],[-70.491052,-33.500883],[-70.490735,-33.500736],[-70.490421,-33.500702],[-70.489883,-33.500709],[-70.489438,-33.50094],[-70.489263,-33.501167],[-70.488955,-33.501547],[-70.488374,-33.501666],[-70.486221,-33.501655],[-70.485682,-33.501624],[-70.485231,-33.501441],[-70.48491,-33.501069],[-70.484728,-33.500884],[-70.484722,-33.500545],[-70.484671,-33.500208],[-70.484533,-33.499984],[-70.48435,-33.499761],[-70.484033,-33.499577],[-70.483627,-33.499469],[-70.483176,-33.499324],[-70.482949,-33.499176],[-70.482676,-33.498917],[-70.482493,-33.498731],[-70.482175,-33.498472],[-70.481768,-33.498289],[-70.481451,-33.498105],[-70.481267,-33.497806],[-70.481082,-33.497508],[-70.480765,-33.497324],[-70.480136,-33.497219],[-70.479594,-33.497],[-70.479278,-33.496891],[-70.478916,-33.496707],[-70.478555,-33.496561],[-70.478056,-33.496229],[-70.477872,-33.495968],[-70.477507,-33.495634],[-70.47719,-33.49545],[-70.476785,-33.495342],[-70.475842,-33.495278],[-70.474855,-33.495252],[-70.474315,-33.495184],[-70.473867,-33.495152],[-70.473419,-33.495194],[-70.473015,-33.495162],[-70.472743,-33.495015],[-70.472427,-33.494868],[-70.471978,-33.494836],[-70.47171,-33.494914],[-70.471221,-33.495183],[-70.47064,-33.495303],[-70.470329,-33.495457],[-70.469969,-33.495386],[-70.469517,-33.495166],[-70.469059,-33.494645],[-70.468412,-33.493488],[-70.467907,-33.492817],[-70.467497,-33.492447],[-70.467,-33.492227],[-70.466729,-33.492118],[-70.466281,-33.492123],[-70.46579,-33.492279],[-70.4653,-33.492435],[-70.464494,-33.49252],[-70.463775,-33.492415],[-70.46346,-33.492382],[-70.463101,-33.492386],[-70.462701,-33.492578],[-70.462481,-33.492844],[-70.462218,-33.493185],[-70.461999,-33.493526],[-70.461689,-33.493755],[-70.46111,-33.493987],[-70.460664,-33.494143],[-70.459726,-33.494342],[-70.459278,-33.494347],[-70.458741,-33.494429],[-70.458297,-33.494697],[-70.457721,-33.495117],[-70.457053,-33.495388],[-70.456026,-33.495663],[-70.454547,-33.495718],[-70.453652,-33.495841],[-70.453157,-33.495772],[-70.452708,-33.49574],[-70.452484,-33.495742],[-70.452038,-33.49586],[-70.451635,-33.495902],[-70.451097,-33.495909],[-70.450781,-33.495837],[-70.4506,-33.495689],[-70.450371,-33.495429],[-70.450098,-33.495169],[-70.449826,-33.495022],[-70.44942,-33.494876],[-70.449059,-33.49473],[-70.448606,-33.494473],[-70.448288,-33.494213],[-70.447791,-33.493993],[-70.447339,-33.493811],[-70.4468,-33.493742],[-70.446079,-33.493525],[-70.445491,-33.493231],[-70.444993,-33.492974],[-70.444585,-33.492678],[-70.443954,-33.492498],[-70.443189,-33.492319],[-70.442245,-33.492217],[-70.4413,-33.49204],[-70.440359,-33.492051],[-70.439462,-33.492062]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1311,"DIS_ELEC":26,"NOM_COM":"La Florida","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":71037326.9664,"SHAPE_LENG":49696.426792,"SHAPE_Le_1":49621.402174},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.477235,-33.369502],[-70.475928,-33.369065],[-70.475475,-33.368779],[-70.47553,-33.368419],[-70.475909,-33.367919],[-70.476532,-33.367381],[-70.477775,-33.366716],[-70.478502,-33.366314],[-70.479761,-33.365991],[-70.480876,-33.365635],[-70.482049,-33.365057],[-70.482717,-33.36489],[-70.482917,-33.364918],[-70.48342,-33.36483],[-70.483556,-33.364748],[-70.48391,-33.364446],[-70.484175,-33.364316],[-70.484455,-33.364277],[-70.484655,-33.364302],[-70.484851,-33.364344],[-70.485168,-33.36444],[-70.485431,-33.3645],[-70.485722,-33.364541],[-70.486155,-33.364569],[-70.486834,-33.364613],[-70.487607,-33.364662],[-70.488466,-33.364702],[-70.488489,-33.364711],[-70.488942,-33.364637],[-70.489022,-33.364636],[-70.48933,-33.364564],[-70.489763,-33.364508],[-70.490215,-33.364493],[-70.490746,-33.364479],[-70.490811,-33.364477],[-70.490826,-33.364473],[-70.491287,-33.364468],[-70.491665,-33.364534],[-70.491815,-33.364579],[-70.491869,-33.364567],[-70.492208,-33.364581],[-70.492776,-33.364619],[-70.493059,-33.364715],[-70.493349,-33.364865],[-70.493636,-33.365024],[-70.493905,-33.365183],[-70.494117,-33.365361],[-70.494231,-33.365494],[-70.494489,-33.365807],[-70.494856,-33.366252],[-70.495236,-33.366727],[-70.495402,-33.366851],[-70.495698,-33.366956],[-70.496136,-33.366978],[-70.496774,-33.367003],[-70.497402,-33.367014],[-70.497987,-33.36702],[-70.498395,-33.367034],[-70.498823,-33.367094],[-70.499274,-33.367159],[-70.499633,-33.367329],[-70.499634,-33.367331],[-70.499641,-33.367332],[-70.499667,-33.367345],[-70.500128,-33.367563],[-70.500389,-33.367693],[-70.500851,-33.367926],[-70.50174,-33.368327],[-70.501823,-33.368339],[-70.502137,-33.368518],[-70.502209,-33.368552],[-70.503507,-33.369132],[-70.504398,-33.369556],[-70.504894,-33.36974],[-70.505326,-33.369872],[-70.505724,-33.369979],[-70.506071,-33.370038],[-70.506882,-33.37011],[-70.507884,-33.370172],[-70.508571,-33.370263],[-70.509013,-33.370339],[-70.50986,-33.370483],[-70.510172,-33.370514],[-70.511455,-33.370742],[-70.512634,-33.370998],[-70.512925,-33.371094],[-70.514446,-33.371572],[-70.515042,-33.371752],[-70.515303,-33.371832],[-70.515911,-33.372023],[-70.516413,-33.372206],[-70.517462,-33.372644],[-70.517609,-33.372706],[-70.517689,-33.372578],[-70.518495,-33.371378],[-70.519471,-33.370365],[-70.519922,-33.37033],[-70.520241,-33.370244],[-70.520463,-33.370214],[-70.521085,-33.370145],[-70.52173,-33.370017],[-70.5224,-33.369908],[-70.523045,-33.369739],[-70.523306,-33.369595],[-70.523663,-33.36945],[-70.523999,-33.369426],[-70.524431,-33.36944],[-70.524863,-33.369495],[-70.525513,-33.369648],[-70.526645,-33.369916],[-70.527537,-33.370187],[-70.5285,-33.370356],[-70.529582,-33.370524],[-70.529681,-33.370526],[-70.530326,-33.370603],[-70.531073,-33.370629],[-70.531986,-33.370583],[-70.533065,-33.370569],[-70.534226,-33.37045],[-70.535389,-33.370471],[-70.53622,-33.370495],[-70.538089,-33.370507],[-70.539584,-33.370523],[-70.540618,-33.370267],[-70.541184,-33.370068],[-70.541389,-33.369747],[-70.54251,-33.368557],[-70.543782,-33.367149],[-70.544845,-33.366118],[-70.546905,-33.364803],[-70.547719,-33.363878],[-70.548665,-33.36169],[-70.548903,-33.360468],[-70.54962,-33.359937],[-70.550335,-33.359275],[-70.552771,-33.359201],[-70.55484,-33.35887],[-70.556293,-33.358896],[-70.55742,-33.358881],[-70.557728,-33.3588],[-70.558267,-33.358758],[-70.559345,-33.358675],[-70.560256,-33.358524],[-70.56253,-33.357973],[-70.564142,-33.357604],[-70.5648,-33.357247],[-70.565373,-33.356752],[-70.565697,-33.35633],[-70.566106,-33.355977],[-70.566847,-33.355654],[-70.567591,-33.35547],[-70.56809,-33.355499],[-70.568755,-33.355525],[-70.570253,-33.355715],[-70.57092,-33.355846],[-70.571545,-33.355977],[-70.572126,-33.35597],[-70.57287,-33.355787],[-70.573404,-33.355501],[-70.574094,-33.354621],[-70.574826,-33.353776],[-70.575395,-33.353072],[-70.576134,-33.35261],[-70.577164,-33.352178],[-70.577826,-33.352065],[-70.578531,-33.352022],[-70.578946,-33.352016],[-70.579444,-33.35201],[-70.580149,-33.351966],[-70.580767,-33.351714],[-70.581342,-33.351359],[-70.581961,-33.351177],[-70.582515,-33.350965],[-70.582621,-33.350924],[-70.583115,-33.350674],[-70.583768,-33.350074],[-70.586184,-33.348231],[-70.588107,-33.346708],[-70.588879,-33.345758],[-70.589196,-33.344952],[-70.589872,-33.343306],[-70.590266,-33.342151],[-70.590609,-33.34044],[-70.590928,-33.339739],[-70.591417,-33.33921],[-70.591826,-33.338926],[-70.592403,-33.338675],[-70.592734,-33.338601],[-70.594228,-33.338582],[-70.594971,-33.338398],[-70.59534,-33.338114],[-70.595664,-33.337692],[-70.596093,-33.337058],[-70.596086,-33.337034],[-70.595941,-33.336759],[-70.595472,-33.336611],[-70.594902,-33.336366],[-70.594198,-33.335633],[-70.593858,-33.33504],[-70.593673,-33.334502],[-70.593601,-33.333833],[-70.593683,-33.333259],[-70.593866,-33.332779],[-70.594049,-33.332295],[-70.594074,-33.331809],[-70.594413,-33.331375],[-70.594906,-33.331037],[-70.595408,-33.330523],[-70.595328,-33.33003],[-70.59524,-33.329671],[-70.595372,-33.329144],[-70.595604,-33.328751],[-70.596048,-33.328325],[-70.596439,-33.327938],[-70.596868,-33.327818],[-70.5972,-33.32752],[-70.597544,-33.327],[-70.597779,-33.326522],[-70.597907,-33.326085],[-70.59809,-33.325601],[-70.598379,-33.325124],[-70.598677,-33.324468],[-70.599018,-33.323989],[-70.599259,-33.323421],[-70.599569,-33.3225],[-70.599796,-33.322197],[-70.599975,-33.321803],[-70.600226,-33.321014],[-70.600315,-33.320306],[-70.600401,-33.319642],[-70.600287,-33.318751],[-70.600197,-33.318437],[-70.600122,-33.317812],[-70.600204,-33.317234],[-70.600286,-33.316661],[-70.600844,-33.316104],[-70.601183,-33.31567],[-70.601577,-33.315197],[-70.601808,-33.314805],[-70.601938,-33.314323],[-70.602069,-33.313836],[-70.602668,-33.313502],[-70.603264,-33.313212],[-70.603603,-33.312783],[-70.603857,-33.311945],[-70.603994,-33.311328],[-70.60417,-33.310979],[-70.60444,-33.310853],[-70.604555,-33.310677],[-70.604302,-33.310447],[-70.603725,-33.310337],[-70.603261,-33.310099],[-70.602902,-33.309866],[-70.602498,-33.309496],[-70.60225,-33.309176],[-70.601952,-33.308765],[-70.601711,-33.30831],[-70.601357,-33.307987],[-70.600792,-33.307656],[-70.600059,-33.307499],[-70.599414,-33.307697],[-70.598604,-33.308024],[-70.597952,-33.308357],[-70.59725,-33.308643],[-70.596612,-33.30871],[-70.596203,-33.308426],[-70.595968,-33.307841],[-70.595788,-33.307213],[-70.5957,-33.306854],[-70.595293,-33.306528],[-70.59479,-33.306024],[-70.594284,-33.30556],[-70.593877,-33.305235],[-70.593363,-33.304951],[-70.592947,-33.304801],[-70.592021,-33.304282],[-70.591557,-33.304044],[-70.591255,-33.303723],[-70.591165,-33.303409],[-70.59097,-33.303087],[-70.591054,-33.302468],[-70.59107,-33.302158],[-70.591407,-33.301773],[-70.591691,-33.301382],[-70.592393,-33.301097],[-70.592721,-33.300888],[-70.593005,-33.300497],[-70.593083,-33.300009],[-70.592891,-33.299605],[-70.592383,-33.299186],[-70.591609,-33.298803],[-70.590686,-33.298239],[-70.589968,-33.297767],[-70.589414,-33.297216],[-70.588804,-33.296748],[-70.588241,-33.296372],[-70.58757,-33.296038],[-70.586786,-33.295834],[-70.585684,-33.29566],[-70.585172,-33.295331],[-70.584508,-33.294861],[-70.584216,-33.294364],[-70.583763,-33.293902],[-70.583356,-33.293577],[-70.582786,-33.293336],[-70.582166,-33.293048],[-70.581758,-33.292763],[-70.581188,-33.292522],[-70.5804,-33.292404],[-70.579239,-33.292363],[-70.578722,-33.292124],[-70.578001,-33.291742],[-70.577229,-33.291314],[-70.576249,-33.290837],[-70.575842,-33.290512],[-70.575175,-33.290087],[-70.57452,-33.289442],[-70.574391,-33.288861],[-70.574311,-33.288367],[-70.574503,-33.287708],[-70.574582,-33.287179],[-70.574455,-33.286553],[-70.574211,-33.286143],[-70.573763,-33.285596],[-70.573423,-33.285007],[-70.573137,-33.284375],[-70.573059,-33.283836],[-70.573138,-33.283307],[-70.572956,-33.282724],[-70.572605,-33.282356],[-70.572203,-33.281941],[-70.571908,-33.281484],[-70.571612,-33.281077],[-70.571521,-33.280763],[-70.571283,-33.280264],[-70.571052,-33.279589],[-70.570817,-33.279004],[-70.570734,-33.278555],[-70.570763,-33.27798],[-70.571049,-33.277548],[-70.571327,-33.277288],[-70.571451,-33.276941],[-70.571624,-33.276677],[-70.571956,-33.276378],[-70.57255,-33.276129],[-70.572828,-33.275873],[-70.57285,-33.275433],[-70.572657,-33.27507],[-70.572257,-33.27461],[-70.572018,-33.274115],[-70.571939,-33.273576],[-70.572074,-33.273004],[-70.572517,-33.272619],[-70.57306,-33.272327],[-70.573291,-33.271939],[-70.573313,-33.271494],[-70.573233,-33.271],[-70.573209,-33.270423],[-70.573396,-33.269853],[-70.573428,-33.269232],[-70.57345,-33.268787],[-70.573477,-33.268257],[-70.57355,-33.267858],[-70.57363,-33.26733],[-70.573809,-33.266935],[-70.573836,-33.266405],[-70.573647,-33.265952],[-70.573563,-33.265508],[-70.573322,-33.265053],[-70.572913,-33.264773],[-70.572295,-33.26444],[-70.571845,-33.263933],[-70.5715,-33.263434],[-70.571144,-33.263156],[-70.570632,-33.262826],[-70.570024,-33.262314],[-70.569571,-33.261856],[-70.569283,-33.261265],[-70.56895,-33.260546],[-70.568566,-33.259775],[-70.568278,-33.259188],[-70.568424,-33.258703],[-70.568325,-33.258177],[-70.568284,-33.257756],[-70.568127,-33.257174],[-70.567831,-33.256848],[-70.567476,-33.256466],[-70.567055,-33.25614],[-70.566145,-33.255635],[-70.56528,-33.255446],[-70.564736,-33.255111],[-70.564131,-33.254725],[-70.563597,-33.254179],[-70.563299,-33.253907],[-70.562762,-33.253415],[-70.562149,-33.253186],[-70.561282,-33.253047],[-70.560859,-33.25277],[-70.56038,-33.252388],[-70.56009,-33.251955],[-70.559864,-33.251478],[-70.559956,-33.250905],[-70.560429,-33.250187],[-70.561008,-33.249839],[-70.561403,-33.249434],[-70.561676,-33.248971],[-70.561952,-33.248458],[-70.561973,-33.24804],[-70.56181,-33.247561],[-70.56165,-33.247028],[-70.561368,-33.246442],[-70.560904,-33.245745],[-70.560618,-33.245212],[-70.560201,-33.244828],[-70.559848,-33.244396],[-70.55942,-33.244223],[-70.559122,-33.243952],[-70.558889,-33.243628],[-70.558791,-33.243102],[-70.558617,-33.24283],[-70.558457,-33.242302],[-70.558291,-33.241877],[-70.557996,-33.241551],[-70.557382,-33.241425],[-70.556817,-33.241405],[-70.555994,-33.241637],[-70.555182,-33.241662],[-70.55386,-33.241876],[-70.55236,-33.241926],[-70.551296,-33.241991],[-70.550185,-33.241744],[-70.549085,-33.241286],[-70.547717,-33.241183],[-70.546284,-33.241131],[-70.545242,-33.240779],[-70.5447,-33.240394],[-70.54435,-33.239909],[-70.54408,-33.239512],[-70.543915,-33.239145],[-70.543377,-33.238815],[-70.542457,-33.238782],[-70.541523,-33.239006],[-70.540412,-33.239069],[-70.53911,-33.239284],[-70.538544,-33.23952],[-70.537794,-33.239754],[-70.5371,-33.24009],[-70.536422,-33.240115],[-70.535504,-33.240032],[-70.534529,-33.23984],[-70.533683,-33.239553],[-70.532713,-33.239261],[-70.531427,-33.239161],[-70.530375,-33.23928],[-70.529324,-33.239396],[-70.528768,-33.23943],[-70.527975,-33.239297],[-70.52688,-33.239051],[-70.525647,-33.23911],[-70.524911,-33.239083],[-70.524243,-33.238902],[-70.523522,-33.238565],[-70.522865,-33.238181],[-70.522149,-33.237741],[-70.522053,-33.237219],[-70.52166,-33.236484],[-70.521193,-33.235999],[-70.520538,-33.235566],[-70.519758,-33.235173],[-70.519348,-33.234797],[-70.518824,-33.234211],[-70.518485,-33.233631],[-70.518078,-33.233148],[-70.517429,-33.232611],[-70.516834,-33.232225],[-70.516238,-33.231843],[-70.51564,-33.231511],[-70.515234,-33.231032],[-70.515074,-33.230558],[-70.514919,-33.229985],[-70.514959,-33.229211],[-70.514747,-33.228532],[-70.514461,-33.228108],[-70.513935,-33.227571],[-70.513708,-33.227202],[-70.513428,-33.226674],[-70.513214,-33.226049],[-70.513115,-33.225577],[-70.513213,-33.22486],[-70.513431,-33.224192],[-70.513713,-33.223477],[-70.513937,-33.222711],[-70.513915,-33.221935],[-70.513829,-33.221207],[-70.513551,-33.220629],[-70.51302,-33.220196],[-70.511984,-33.220005],[-70.511136,-33.219767],[-70.510345,-33.219581],[-70.509747,-33.219253],[-70.5092,-33.21913],[-70.508405,-33.219047],[-70.507607,-33.219018],[-70.506801,-33.219146],[-70.505801,-33.219471],[-70.505232,-33.219761],[-70.504173,-33.220033],[-70.50325,-33.220049],[-70.502198,-33.220169],[-70.501256,-33.220545],[-70.500207,-33.22061],[-70.499236,-33.220368],[-70.498272,-33.219973],[-70.497303,-33.219681],[-70.496217,-33.219277],[-70.495504,-33.218787],[-70.494661,-33.218445],[-70.493868,-33.218313],[-70.49276,-33.218327],[-70.491637,-33.218646],[-70.490391,-33.218962],[-70.489838,-33.218941],[-70.48911,-33.218762],[-70.4877,-33.218661],[-70.48654,-33.218515],[-70.485573,-33.218169],[-70.484845,-33.217985],[-70.483308,-33.217983],[-70.482686,-33.218114],[-70.481509,-33.218278],[-70.480762,-33.218463],[-70.479651,-33.218526],[-70.478787,-33.218598],[-70.477975,-33.218825],[-70.476913,-33.219151],[-70.476161,-33.219435],[-70.475464,-33.219819],[-70.474592,-33.220049],[-70.473801,-33.219862],[-70.473449,-33.219701],[-70.473201,-33.219584],[-70.472558,-33.218939],[-70.471725,-33.218395],[-70.471197,-33.217907],[-70.470556,-33.217213],[-70.470158,-33.216577],[-70.470132,-33.215904],[-70.470479,-33.215142],[-70.470505,-33.214625],[-70.470417,-33.213951],[-70.47015,-33.213167],[-70.469939,-33.212488],[-70.469912,-33.211816],[-70.470211,-33.210791],[-70.470176,-33.210271],[-70.470086,-33.209651],[-70.469637,-33.208806],[-70.469186,-33.208015],[-70.468559,-33.207059],[-70.467732,-33.206412],[-70.466841,-33.205808],[-70.466307,-33.205428],[-70.465608,-33.204677],[-70.465157,-33.203886],[-70.465005,-33.203263],[-70.465096,-33.202694],[-70.465247,-33.202133],[-70.465755,-33.20184],[-70.466683,-33.201721],[-70.467307,-33.201537],[-70.467811,-33.201298],[-70.467961,-33.200786],[-70.467929,-33.200217],[-70.467962,-33.199588],[-70.467812,-33.198911],[-70.467617,-33.197922],[-70.467598,-33.197093],[-70.467694,-33.196425],[-70.46754,-33.195852],[-70.467262,-33.19527],[-70.4668,-33.194685],[-70.466267,-33.194305],[-70.465802,-33.193771],[-70.465338,-33.193236],[-70.464564,-33.192743],[-70.463724,-33.192352],[-70.463132,-33.191916],[-70.462414,-33.19153],[-70.46152,-33.190979],[-70.460997,-33.190393],[-70.460528,-33.189961],[-70.459818,-33.189417],[-70.459421,-33.188781],[-70.459405,-33.187902],[-70.459498,-33.187288],[-70.459842,-33.186576],[-70.459954,-33.185598],[-70.459816,-33.184715],[-70.459669,-33.183984],[-70.45953,-33.183101],[-70.459511,-33.182271],[-70.459794,-33.181561],[-70.460068,-33.181003],[-70.460586,-33.180504],[-70.460978,-33.180055],[-70.46168,-33.179562],[-70.462192,-33.179171],[-70.46252,-33.178769],[-70.462608,-33.178254],[-70.462272,-33.17762],[-70.46168,-33.177184],[-70.461146,-33.176804],[-70.460428,-33.176418],[-70.459591,-33.175973],[-70.459001,-33.175487],[-70.458231,-33.174941],[-70.457404,-33.174289],[-70.456449,-33.173736],[-70.455555,-33.17319],[-70.454726,-33.172588],[-70.454192,-33.172208],[-70.453832,-33.172042],[-70.453549,-33.171563],[-70.453702,-33.171001],[-70.454216,-33.170556],[-70.4546,-33.170259],[-70.455054,-33.169812],[-70.455139,-33.169351],[-70.455099,-33.168935],[-70.454648,-33.168144],[-70.454069,-33.167447],[-70.453181,-33.166798],[-70.452414,-33.166197],[-70.451947,-33.165716],[-70.451664,-33.165242],[-70.451563,-33.164824],[-70.451219,-33.164348],[-70.450936,-33.163873],[-70.450522,-33.163547],[-70.449802,-33.16321],[-70.449083,-33.162873],[-70.448424,-33.162534],[-70.447776,-33.161996],[-70.447307,-33.161565],[-70.44672,-33.161025],[-70.44612,-33.160747],[-70.445413,-33.160153],[-70.444824,-33.159663],[-70.44448,-33.159187],[-70.444443,-33.158721],[-70.444664,-33.158004],[-70.444872,-33.157548],[-70.445019,-33.157085],[-70.444923,-33.156568],[-70.444648,-33.155936],[-70.444315,-33.155253],[-70.443793,-33.154666],[-70.443392,-33.15408],[-70.443123,-33.153349],[-70.44291,-33.15272],[-70.442404,-33.151823],[-70.441839,-33.15087],[-70.441452,-33.150031],[-70.441241,-33.149353],[-70.441223,-33.148523],[-70.441503,-33.147862],[-70.441468,-33.147343],[-70.441177,-33.147022],[-70.440586,-33.146585],[-70.439991,-33.146203],[-70.439274,-33.145817],[-70.43837,-33.145473],[-70.43789,-33.145248],[-70.437474,-33.144976],[-70.437061,-33.14465],[-70.436712,-33.144272],[-70.436491,-33.1438],[-70.43628,-33.143121],[-70.436128,-33.142494],[-70.435905,-33.142072],[-70.435622,-33.141597],[-70.435408,-33.140972],[-70.434958,-33.140181],[-70.434561,-33.139545],[-70.434294,-33.13876],[-70.434078,-33.138185],[-70.433926,-33.137558],[-70.433524,-33.137025],[-70.433236,-33.136654],[-70.432825,-33.136279],[-70.432103,-33.135991],[-70.431442,-33.13571],[-70.430968,-33.135382],[-70.430563,-33.134903],[-70.430478,-33.134175],[-70.430443,-33.133655],[-70.430224,-33.133134],[-70.429705,-33.132493],[-70.42942,-33.132068],[-70.429028,-33.131333],[-70.428623,-33.13085],[-70.42834,-33.130376],[-70.427695,-33.129785],[-70.426986,-33.12924],[-70.426091,-33.128744],[-70.425307,-33.128454],[-70.424393,-33.128316],[-70.423659,-33.12824],[-70.422985,-33.128215],[-70.4225,-33.128094],[-70.421836,-33.127862],[-70.421373,-33.127327],[-70.421152,-33.126855],[-70.42093,-33.126383],[-70.420285,-33.125791],[-70.419523,-33.125088],[-70.41882,-33.124445],[-70.417868,-33.123838],[-70.416834,-33.123646],[-70.415983,-33.123462],[-70.415203,-33.123122],[-70.414411,-33.12299],[-70.413604,-33.123167],[-70.412559,-33.123178],[-70.411773,-33.122942],[-70.410746,-33.122593],[-70.409709,-33.122451],[-70.40897,-33.122487],[-70.407933,-33.122345],[-70.406897,-33.122203],[-70.405851,-33.122219],[-70.404918,-33.122441],[-70.40393,-33.122558],[-70.403314,-33.122589],[-70.402152,-33.122492],[-70.401485,-33.122314],[-70.400827,-33.121979],[-70.39998,-33.12174],[-70.3993,-33.121819],[-70.398503,-33.121789],[-70.397956,-33.121666],[-70.397427,-33.121232],[-70.396957,-33.120804],[-70.395942,-33.120249],[-70.395225,-33.119857],[-70.39446,-33.119212],[-70.393997,-33.118677],[-70.393467,-33.118243],[-70.392862,-33.118067],[-70.391812,-33.118182],[-70.391148,-33.11795],[-70.390501,-33.117408],[-70.389915,-33.116873],[-70.389198,-33.116481],[-70.388657,-33.116259],[-70.38781,-33.11602],[-70.387144,-33.115838],[-70.386787,-33.115617],[-70.386374,-33.115291],[-70.386087,-33.11492],[-70.385927,-33.11445],[-70.385647,-33.113922],[-70.38536,-33.113551],[-70.384944,-33.113274],[-70.384475,-33.112847],[-70.384255,-33.11237],[-70.384175,-33.111543],[-70.384202,-33.111026],[-70.383869,-33.110343],[-70.383339,-33.109909],[-70.382874,-33.109428],[-70.382095,-33.109034],[-70.381365,-33.108903],[-70.380262,-33.108862],[-70.379095,-33.108873],[-70.378228,-33.108994],[-70.377626,-33.108764],[-70.376851,-33.108326],[-70.37626,-33.107889],[-70.375613,-33.107347],[-70.374963,-33.106859],[-70.374497,-33.106373],[-70.373903,-33.105991],[-70.373573,-33.105725],[-70.373418,-33.105775],[-70.373163,-33.105809],[-70.372762,-33.105783],[-70.37236,-33.105726],[-70.371812,-33.105701],[-70.371485,-33.105735],[-70.370544,-33.106175],[-70.369856,-33.106459],[-70.369094,-33.106743],[-70.368475,-33.106781],[-70.367892,-33.106818],[-70.36742,-33.106946],[-70.366585,-33.107108],[-70.365383,-33.107214],[-70.364069,-33.107136],[-70.362828,-33.107027],[-70.361953,-33.107006],[-70.361333,-33.106982],[-70.358645,-33.106474],[-70.357985,-33.106175],[-70.357361,-33.105936],[-70.35685,-33.105849],[-70.356119,-33.105765],[-70.355498,-33.105649],[-70.354144,-33.105327],[-70.353521,-33.105149],[-70.352725,-33.105104],[-70.352609,-33.105098],[-70.352098,-33.105073],[-70.351479,-33.105079],[-70.350932,-33.105085],[-70.35042,-33.104968],[-70.349649,-33.104639],[-70.349244,-33.104367],[-70.348766,-33.104127],[-70.34829,-33.103948],[-70.347778,-33.103831],[-70.346629,-33.103797],[-70.346154,-33.103741],[-70.345824,-33.103652],[-70.345385,-33.103504],[-70.344981,-33.103324],[-70.344574,-33.10296],[-70.344279,-33.102718],[-70.343837,-33.102416],[-70.343283,-33.101931],[-70.343203,-33.101441],[-70.343161,-33.101104],[-70.343189,-33.100551],[-70.343292,-33.100151],[-70.343354,-33.099445],[-70.343347,-33.098954],[-70.343303,-33.098464],[-70.34326,-33.098004],[-70.343219,-33.097728],[-70.343103,-33.097331],[-70.342843,-33.096996],[-70.34255,-33.096907],[-70.34127,-33.096645],[-70.340322,-33.096593],[-70.339372,-33.096481],[-70.338752,-33.096426],[-70.337841,-33.096467],[-70.337332,-33.096564],[-70.33668,-33.096786],[-70.334724,-33.097605],[-70.33389,-33.097951],[-70.333081,-33.098681],[-70.332543,-33.099239],[-70.332076,-33.099735],[-70.331645,-33.100138],[-70.331287,-33.100602],[-70.331001,-33.100943],[-70.330608,-33.101469],[-70.330067,-33.101873],[-70.329487,-33.102094],[-70.328686,-33.102133],[-70.327993,-33.102141],[-70.327555,-33.102084],[-70.32679,-33.102123],[-70.325951,-33.102071],[-70.324966,-33.10205],[-70.324091,-33.10206],[-70.323473,-33.102158],[-70.322565,-33.102352],[-70.322058,-33.102603],[-70.32119,-33.103072],[-70.320685,-33.103415],[-70.320544,-33.103754],[-70.320592,-33.105702],[-70.320458,-33.106532],[-70.32025,-33.10727],[-70.320005,-33.107887],[-70.319685,-33.108442],[-70.3194,-33.108906],[-70.318859,-33.10931],[-70.318208,-33.109624],[-70.317663,-33.109783],[-70.317081,-33.109881],[-70.31628,-33.109951],[-70.315515,-33.109959],[-70.314857,-33.109874],[-70.31387,-33.10967],[-70.313027,-33.109372],[-70.312622,-33.109131],[-70.31229,-33.108889],[-70.311923,-33.108708],[-70.311483,-33.10856],[-70.311081,-33.108441],[-70.31048,-33.108524],[-70.30961,-33.10884],[-70.308854,-33.109462],[-70.308278,-33.109959],[-70.307413,-33.110673],[-70.306728,-33.111141],[-70.30597,-33.11167],[-70.304958,-33.112295],[-70.304344,-33.1127],[-70.30373,-33.113044],[-70.302857,-33.113176],[-70.302201,-33.113213],[-70.301652,-33.113096],[-70.301249,-33.112978],[-70.300811,-33.11289],[-70.300117,-33.112806],[-70.299917,-33.112854],[-70.299775,-33.113162],[-70.299816,-33.113438],[-70.299785,-33.113806],[-70.299645,-33.114176],[-70.29925,-33.114609],[-70.298891,-33.115012],[-70.298459,-33.115385],[-70.298318,-33.115693],[-70.298143,-33.116217],[-70.298147,-33.116493],[-70.298299,-33.116859],[-70.298305,-33.117319],[-70.298241,-33.117934],[-70.298101,-33.118273],[-70.297926,-33.118796],[-70.297421,-33.1192],[-70.297097,-33.119418],[-70.296882,-33.119728],[-70.296814,-33.120035],[-70.296978,-33.121291],[-70.296989,-33.122028],[-70.296998,-33.12261],[-70.297005,-33.123132],[-70.296794,-33.123656],[-70.296285,-33.124996],[-70.296111,-33.125519],[-70.295827,-33.126044],[-70.295398,-33.126631],[-70.29493,-33.127066],[-70.294391,-33.127593],[-70.293959,-33.127996],[-70.293529,-33.128522],[-70.292955,-33.129173],[-70.292307,-33.129732],[-70.290824,-33.130575],[-70.289521,-33.131202],[-70.288541,-33.131581],[-70.287944,-33.131848],[-70.286888,-33.131981],[-70.286268,-33.131957],[-70.285792,-33.131839],[-70.285206,-33.131692],[-70.284914,-33.131634],[-70.284476,-33.131638],[-70.284039,-33.131643],[-70.283527,-33.131556],[-70.283015,-33.131469],[-70.2817,-33.131298],[-70.281007,-33.131306],[-70.280497,-33.131311],[-70.279878,-33.131379],[-70.279221,-33.131385],[-70.278674,-33.131391],[-70.278053,-33.131305],[-70.275407,-33.131133],[-70.274822,-33.131047],[-70.274129,-33.131023],[-70.273545,-33.131029],[-70.27289,-33.131067],[-70.272346,-33.131287],[-70.271913,-33.131598],[-70.271408,-33.132002],[-70.270941,-33.132498],[-70.270693,-33.132991],[-70.270483,-33.133607],[-70.270309,-33.134192],[-70.269846,-33.134933],[-70.269671,-33.135487],[-70.26961,-33.136286],[-70.269619,-33.13696],[-70.269865,-33.140072],[-70.269838,-33.140717],[-70.269846,-33.1413],[-70.26982,-33.142036],[-70.269902,-33.142619],[-70.270017,-33.143016],[-70.270281,-33.143658],[-70.270659,-33.144544],[-70.270814,-33.145217],[-70.271296,-33.147007],[-70.27145,-33.147558],[-70.271423,-33.148203],[-70.271358,-33.148786],[-70.271182,-33.149218],[-70.271079,-33.149648],[-70.27105,-33.150201],[-70.271093,-33.15063],[-70.271246,-33.151089],[-70.271325,-33.151548],[-70.27133,-33.151855],[-70.271263,-33.152285],[-70.271116,-33.153468],[-70.271122,-33.153897],[-70.271055,-33.154297],[-70.270879,-33.15479],[-70.270377,-33.155347],[-70.269982,-33.155781],[-70.269621,-33.156091],[-70.269335,-33.156462],[-70.269166,-33.157415],[-70.268993,-33.15803],[-70.269038,-33.158613],[-70.269116,-33.15898],[-70.269257,-33.159915],[-70.2693,-33.160375],[-70.269273,-33.160988],[-70.269061,-33.161512],[-70.268815,-33.162128],[-70.26857,-33.162867],[-70.268394,-33.163299],[-70.268145,-33.163731],[-70.267861,-33.164286],[-70.26743,-33.16475],[-70.266707,-33.165187],[-70.266093,-33.165685],[-70.265661,-33.166088],[-70.26534,-33.166551],[-70.265162,-33.16686],[-70.265097,-33.168717],[-70.265117,-33.170097],[-70.265169,-33.171201],[-70.265181,-33.17203],[-70.265191,-33.172735],[-70.265127,-33.173288],[-70.265081,-33.173948],[-70.265238,-33.174683],[-70.265356,-33.175296],[-70.265398,-33.175663],[-70.265443,-33.176277],[-70.265704,-33.176673],[-70.265857,-33.177162],[-70.266012,-33.177774],[-70.266125,-33.178019],[-70.266582,-33.179364],[-70.266809,-33.179945],[-70.267033,-33.180249],[-70.266986,-33.180787],[-70.266992,-33.181216],[-70.266923,-33.181524],[-70.266565,-33.181957],[-70.266277,-33.182236],[-70.265699,-33.182671],[-70.264758,-33.183202],[-70.264178,-33.183454],[-70.263596,-33.183582],[-70.263087,-33.18368],[-70.262615,-33.183869],[-70.261999,-33.184151],[-70.261309,-33.184434],[-70.260583,-33.184656],[-70.26,-33.184754],[-70.259345,-33.184884],[-70.258763,-33.184982],[-70.258217,-33.185048],[-70.257706,-33.185054],[-70.257049,-33.18506],[-70.256648,-33.185064],[-70.256173,-33.185069],[-70.255626,-33.185075],[-70.255006,-33.18505],[-70.254204,-33.18512],[-70.253804,-33.185246],[-70.25355,-33.18531],[-70.253224,-33.185528],[-70.252826,-33.185778],[-70.251791,-33.18611],[-70.251354,-33.186176],[-70.250808,-33.186212],[-70.250187,-33.186219],[-70.249786,-33.186253],[-70.249279,-33.186504],[-70.24899,-33.186722],[-70.248664,-33.186878],[-70.248264,-33.186944],[-70.247645,-33.187042],[-70.247207,-33.187077],[-70.246806,-33.187111],[-70.246369,-33.187116],[-70.245821,-33.187091],[-70.245493,-33.187125],[-70.245168,-33.187373],[-70.244805,-33.18753],[-70.244477,-33.187564],[-70.244149,-33.187568],[-70.243891,-33.187386],[-70.243742,-33.187142],[-70.24373,-33.186996],[-70.243014,-33.187398],[-70.242654,-33.188068],[-70.242431,-33.188911],[-70.242353,-33.189539],[-70.242156,-33.189905],[-70.241624,-33.190776],[-70.240889,-33.191302],[-70.240159,-33.19172],[-70.239827,-33.192153],[-70.239753,-33.193524],[-70.239961,-33.194572],[-70.240099,-33.195284],[-70.240197,-33.196734],[-70.23982,-33.19798],[-70.238802,-33.199653],[-70.237986,-33.200847],[-70.237325,-33.201636],[-70.236452,-33.202269],[-70.235591,-33.202682],[-70.234472,-33.202936],[-70.233276,-33.203003],[-70.231991,-33.203102],[-70.231139,-33.203331],[-70.230724,-33.203648],[-70.230439,-33.204007],[-70.230055,-33.204586],[-70.229574,-33.205311],[-70.229045,-33.20611],[-70.228559,-33.206907],[-70.228081,-33.207595],[-70.227381,-33.209091],[-70.226838,-33.210146],[-70.226152,-33.211381],[-70.225034,-33.21245],[-70.223737,-33.213553],[-70.222547,-33.214323],[-70.221539,-33.214991],[-70.220359,-33.215576],[-70.219441,-33.216207],[-70.218391,-33.216838],[-70.218158,-33.217049],[-70.217872,-33.217448],[-70.217717,-33.217852],[-70.217677,-33.218589],[-70.217725,-33.219334],[-70.217632,-33.220222],[-70.217642,-33.220853],[-70.217481,-33.221369],[-70.217365,-33.221883],[-70.217402,-33.222812],[-70.217498,-33.223487],[-70.217149,-33.224356],[-70.216255,-33.225164],[-70.214455,-33.226103],[-70.212777,-33.227552],[-70.212071,-33.228574],[-70.211919,-33.229532],[-70.212168,-33.230464],[-70.212562,-33.231488],[-70.21313,-33.232983],[-70.213757,-33.234309],[-70.214099,-33.235371],[-70.214101,-33.236254],[-70.213921,-33.236792],[-70.214098,-33.237218],[-70.215013,-33.237843],[-70.215936,-33.238338],[-70.216657,-33.23887],[-70.216939,-33.23939],[-70.216426,-33.240707],[-70.215632,-33.242312],[-70.214645,-33.244201],[-70.213417,-33.24564],[-70.21286,-33.246141],[-70.211601,-33.246534],[-70.210422,-33.247083],[-70.209403,-33.247935],[-70.208625,-33.249243],[-70.208223,-33.250119],[-70.208516,-33.251242],[-70.209068,-33.252453],[-70.209989,-33.25338],[-70.210274,-33.254652],[-70.210453,-33.256217],[-70.21038,-33.257552],[-70.210772,-33.258459],[-70.210547,-33.259342],[-70.20944,-33.260191],[-70.208803,-33.260535],[-70.207171,-33.261292],[-70.205719,-33.261974],[-70.204989,-33.262392],[-70.204532,-33.262671],[-70.204235,-33.263254],[-70.203552,-33.264417],[-70.202706,-33.265348],[-70.201787,-33.265984],[-70.200861,-33.266763],[-70.20009,-33.267922],[-70.199459,-33.269753],[-70.198877,-33.270694],[-70.198391,-33.271495],[-70.198254,-33.272381],[-70.198895,-33.273591],[-70.19952,-33.275101],[-70.20022,-33.276835],[-70.200475,-33.278628],[-70.199885,-33.279718],[-70.199487,-33.280522],[-70.199346,-33.28148],[-70.199161,-33.283256],[-70.199118,-33.285628],[-70.199029,-33.287259],[-70.199212,-33.288753],[-70.199304,-33.290314],[-70.198881,-33.291559],[-70.19795,-33.292415],[-70.197107,-33.293274],[-70.196135,-33.294871],[-70.195008,-33.296088],[-70.193904,-33.296865],[-70.192901,-33.297416],[-70.192134,-33.298503],[-70.191535,-33.299741],[-70.190668,-33.301045],[-70.190073,-33.302211],[-70.189125,-33.303358],[-70.188363,-33.304369],[-70.187973,-33.305025],[-70.187744,-33.30598],[-70.187329,-33.307076],[-70.186928,-33.307952],[-70.186525,-33.308828],[-70.18662,-33.310318],[-70.18674,-33.311363],[-70.186325,-33.312459],[-70.185458,-33.313763],[-70.184867,-33.314853],[-70.184465,-33.315729],[-70.18403,-33.317198],[-70.183616,-33.318294],[-70.183126,-33.319167],[-70.182632,-33.320111],[-70.182318,-33.320991],[-70.18208,-33.322094],[-70.182115,-33.323063],[-70.182411,-33.324111],[-70.182694,-33.325387],[-70.182693,-33.327017],[-70.182559,-33.327832],[-70.18184,-33.329659],[-70.181585,-33.331059],[-70.181588,-33.332622],[-70.181855,-33.33419],[-70.182134,-33.335539],[-70.182338,-33.336659],[-70.182084,-33.338059],[-70.181228,-33.339138],[-70.180372,-33.340221],[-70.179163,-33.341287],[-70.17848,-33.342449],[-70.178045,-33.343918],[-70.177201,-33.344777],[-70.175917,-33.345614],[-70.175868,-33.346504],[-70.176179,-33.347259],[-70.177029,-33.347887],[-70.179091,-33.349007],[-70.179748,-33.349924],[-70.180236,-33.350687],[-70.179818,-33.351855],[-70.179042,-33.35309],[-70.178363,-33.354176],[-70.177603,-33.35511],[-70.177314,-33.355545],[-70.177197,-33.356062],[-70.17726,-33.356511],[-70.178372,-33.35722],[-70.179559,-33.358158],[-70.180565,-33.359161],[-70.181222,-33.360078],[-70.181454,-33.360682],[-70.181541,-33.361212],[-70.181501,-33.361945],[-70.181625,-33.362463],[-70.182181,-33.362741],[-70.182973,-33.362867],[-70.183961,-33.362905],[-70.184647,-33.3629],[-70.18552,-33.362966],[-70.186202,-33.363024],[-70.186921,-33.363115],[-70.187551,-33.363427],[-70.188851,-33.364023],[-70.189996,-33.364675],[-70.190614,-33.365208],[-70.191227,-33.36584],[-70.191831,-33.366629],[-70.192099,-33.367279],[-70.192217,-33.367923],[-70.192142,-33.368591],[-70.192079,-33.369039],[-70.192065,-33.369291],[-70.192199,-33.369616],[-70.192486,-33.369946],[-70.19293,-33.370189],[-70.193589,-33.37066],[-70.193941,-33.371187],[-70.194183,-33.371643],[-70.194404,-33.372453],[-70.194432,-33.373345],[-70.194239,-33.374077],[-70.193867,-33.374603],[-70.193547,-33.374878],[-70.193341,-33.375159],[-70.193208,-33.375505],[-70.193214,-33.376081],[-70.193448,-33.376667],[-70.194024,-33.377293],[-70.194621,-33.37751],[-70.195258,-33.377692],[-70.195959,-33.378106],[-70.19665,-33.378705],[-70.197339,-33.37934],[-70.197947,-33.380066],[-70.198438,-33.380824],[-70.198736,-33.381632],[-70.198886,-33.382372],[-70.198917,-33.383206],[-70.198933,-33.384292],[-70.199055,-33.384842],[-70.199517,-33.385432],[-70.200016,-33.386059],[-70.200552,-33.386719],[-70.200828,-33.387244],[-70.201137,-33.387859],[-70.201692,-33.38884],[-70.202177,-33.389723],[-70.202562,-33.390346],[-70.202689,-33.390797],[-70.202791,-33.391026],[-70.203181,-33.39155],[-70.203806,-33.391961],[-70.205041,-33.392361],[-70.206199,-33.392788],[-70.207201,-33.393273],[-70.208305,-33.393987],[-70.209043,-33.394429],[-70.210162,-33.39486],[-70.211213,-33.395153],[-70.212456,-33.395395],[-70.21331,-33.39581],[-70.214003,-33.396382],[-70.214723,-33.397144],[-70.215296,-33.397806],[-70.215877,-33.398337],[-70.216455,-33.398904],[-70.217023,-33.39966],[-70.217417,-33.400126],[-70.217771,-33.400617],[-70.217971,-33.401138],[-70.218157,-33.401911],[-70.218081,-33.402611],[-70.21775,-33.40308],[-70.217143,-33.403727],[-70.216953,-33.404422],[-70.216951,-33.405827],[-70.217003,-33.406978],[-70.217218,-33.407914],[-70.217433,-33.40885],[-70.217663,-33.40953],[-70.218114,-33.410669],[-70.218526,-33.411513],[-70.21898,-33.412265],[-70.219413,-33.4127],[-70.220225,-33.413177],[-70.220814,-33.413552],[-70.221509,-33.414087],[-70.222482,-33.414413],[-70.223343,-33.414703],[-70.224131,-33.414927],[-70.22509,-33.415504],[-70.226001,-33.416278],[-70.226567,-33.417066],[-70.227322,-33.417892],[-70.228221,-33.418886],[-70.228837,-33.419454],[-70.229317,-33.41973],[-70.230133,-33.420144],[-70.231165,-33.420792],[-70.232123,-33.4214],[-70.232855,-33.421942],[-70.233584,-33.422547],[-70.234245,-33.423018],[-70.234916,-33.423269],[-70.235816,-33.423556],[-70.236175,-33.423957],[-70.236251,-33.424662],[-70.236064,-33.425295],[-70.236249,-33.426099],[-70.236526,-33.426591],[-70.236951,-33.42718],[-70.237514,-33.428035],[-70.238314,-33.429439],[-70.238855,-33.430005],[-70.239372,-33.430308],[-70.240389,-33.430541],[-70.241247,-33.430862],[-70.241488,-33.431349],[-70.241761,-33.431936],[-70.242314,-33.432277],[-70.24282,-33.432778],[-70.243152,-33.433683],[-70.243444,-33.434622],[-70.243684,-33.435113],[-70.244179,-33.435803],[-70.245027,-33.436344],[-70.245996,-33.436733],[-70.247767,-33.437121],[-70.248594,-33.437346],[-70.249475,-33.437952],[-70.250058,-33.438456],[-70.250951,-33.438842],[-70.251973,-33.438975],[-70.252809,-33.439039],[-70.253602,-33.439169],[-70.254124,-33.439378],[-70.254522,-33.439776],[-70.254729,-33.440171],[-70.25493,-33.440688],[-70.255058,-33.441138],[-70.255158,-33.441485],[-70.255326,-33.441802],[-70.255483,-33.442127],[-70.255694,-33.442419],[-70.255981,-33.442669],[-70.256303,-33.442897],[-70.256622,-33.443117],[-70.256946,-33.443337],[-70.257283,-33.443539],[-70.257636,-33.443723],[-70.25801,-33.443877],[-70.258402,-33.443987],[-70.258804,-33.444074],[-70.259203,-33.444171],[-70.259612,-33.444218],[-70.260028,-33.44422],[-70.260438,-33.444267],[-70.260851,-33.444297],[-70.261265,-33.444295],[-70.26168,-33.444283],[-70.262094,-33.444277],[-70.26251,-33.444261],[-70.262925,-33.444246],[-70.263335,-33.444275],[-70.263733,-33.444371],[-70.264124,-33.44449],[-70.264513,-33.444608],[-70.264902,-33.444731],[-70.265293,-33.44485],[-70.265689,-33.44495],[-70.26608,-33.445069],[-70.266462,-33.445205],[-70.266824,-33.445372],[-70.267176,-33.445561],[-70.267522,-33.44575],[-70.267862,-33.445948],[-70.268195,-33.446154],[-70.268521,-33.446365],[-70.268843,-33.446589],[-70.269159,-33.446817],[-70.269472,-33.447041],[-70.269783,-33.447273],[-70.270097,-33.447501],[-70.270416,-33.447721],[-70.270743,-33.44794],[-70.271081,-33.448138],[-70.271425,-33.448336],[-70.27177,-33.448529],[-70.272109,-33.448727],[-70.272442,-33.448933],[-70.272765,-33.449148],[-70.273062,-33.449394],[-70.273326,-33.449665],[-70.273494,-33.449838],[-70.274553,-33.450869],[-70.275301,-33.451776],[-70.275911,-33.452466],[-70.276191,-33.45281],[-70.277101,-33.453425],[-70.278233,-33.45387],[-70.279684,-33.454573],[-70.280654,-33.45507],[-70.281646,-33.455423],[-70.282551,-33.455642],[-70.28278,-33.455178],[-70.282983,-33.45456],[-70.283455,-33.453695],[-70.284314,-33.452827],[-70.285336,-33.452366],[-70.286592,-33.452162],[-70.288242,-33.452058],[-70.289343,-33.451978],[-70.290562,-33.451561],[-70.291276,-33.451255],[-70.292284,-33.451045],[-70.292881,-33.451068],[-70.293371,-33.451087],[-70.293515,-33.451101],[-70.293926,-33.451139],[-70.294335,-33.4512],[-70.294742,-33.451269],[-70.295149,-33.451334],[-70.295557,-33.451404],[-70.295962,-33.451478],[-70.296368,-33.451547],[-70.296774,-33.451626],[-70.297177,-33.451713],[-70.297575,-33.451805],[-70.297967,-33.451919],[-70.298355,-33.45206],[-70.298704,-33.452244],[-70.29899,-33.452498],[-70.299188,-33.452817],[-70.29927,-33.453148],[-70.29933,-33.453497],[-70.299376,-33.453842],[-70.299411,-33.45419],[-70.299433,-33.454542],[-70.299443,-33.454893],[-70.299442,-33.45524],[-70.299437,-33.455582],[-70.299375,-33.455886],[-70.299289,-33.456212],[-70.299181,-33.456496],[-70.299039,-33.456932],[-70.298985,-33.457177],[-70.298987,-33.45756],[-70.29904,-33.457851],[-70.2992,-33.45828],[-70.299408,-33.458653],[-70.299574,-33.458965],[-70.299806,-33.459339],[-70.299979,-33.459575],[-70.300168,-33.459889],[-70.30037,-33.460189],[-70.30059,-33.460477],[-70.300832,-33.46076],[-70.301086,-33.461036],[-70.301342,-33.461311],[-70.301596,-33.461591],[-70.301853,-33.461862],[-70.302114,-33.462133],[-70.302382,-33.462396],[-70.302662,-33.462649],[-70.302949,-33.462899],[-70.303235,-33.463153],[-70.30352,-33.463407],[-70.303807,-33.463657],[-70.304045,-33.463913],[-70.304349,-33.464231],[-70.304653,-33.464531],[-70.304927,-33.464686],[-70.305254,-33.464842],[-70.30559,-33.46499],[-70.305928,-33.465079],[-70.306288,-33.465188],[-70.306603,-33.465294],[-70.306989,-33.465367],[-70.307308,-33.465397],[-70.307647,-33.465469],[-70.308032,-33.465542],[-70.308485,-33.465636],[-70.308916,-33.465711],[-70.309344,-33.46574],[-70.309758,-33.465743],[-70.310173,-33.465754],[-70.310588,-33.465774],[-70.311003,-33.46579],[-70.31141,-33.465841],[-70.311813,-33.465929],[-70.312216,-33.466016],[-70.312622,-33.466085],[-70.313023,-33.466173],[-70.313419,-33.466278],[-70.313831,-33.466347],[-70.314266,-33.466377],[-70.314684,-33.466429],[-70.315044,-33.466564],[-70.315351,-33.466779],[-70.315644,-33.467015],[-70.315925,-33.467269],[-70.316197,-33.467536],[-70.316462,-33.467807],[-70.316721,-33.468092],[-70.316978,-33.468372],[-70.317236,-33.468652],[-70.31749,-33.468927],[-70.317726,-33.469211],[-70.317952,-33.469503],[-70.318174,-33.469795],[-70.318399,-33.470087],[-70.318621,-33.470384],[-70.318841,-33.47068],[-70.31907,-33.470968],[-70.319314,-33.471252],[-70.319578,-33.471519],[-70.319861,-33.471773],[-70.320161,-33.472014],[-70.320481,-33.472233],[-70.320816,-33.472449],[-70.321173,-33.472629],[-70.321558,-33.472742],[-70.32196,-33.472821],[-70.32237,-33.472877],[-70.322784,-33.472928],[-70.323198,-33.472975],[-70.323607,-33.473032],[-70.324018,-33.473079],[-70.324431,-33.473112],[-70.324847,-33.473114],[-70.325261,-33.473126],[-70.32567,-33.473186],[-70.326077,-33.473264],[-70.326469,-33.473369],[-70.326849,-33.47351],[-70.3272,-33.473613],[-70.327561,-33.473775],[-70.327918,-33.473987],[-70.328278,-33.474163],[-70.328641,-33.474289],[-70.329005,-33.474375],[-70.329369,-33.474479],[-70.329795,-33.474639],[-70.330156,-33.474783],[-70.330538,-33.474942],[-70.330856,-33.475098],[-70.331215,-33.475296],[-70.331488,-33.475451],[-70.3318,-33.475719],[-70.332179,-33.475931],[-70.332607,-33.476056],[-70.333027,-33.476189],[-70.333427,-33.476285],[-70.333826,-33.476394],[-70.334207,-33.47653],[-70.334547,-33.476719],[-70.334832,-33.476977],[-70.335094,-33.477249],[-70.335342,-33.477528],[-70.335574,-33.477816],[-70.335792,-33.478112],[-70.335998,-33.478413],[-70.336193,-33.478722],[-70.336375,-33.479031],[-70.336535,-33.479352],[-70.336713,-33.47967],[-70.336919,-33.47997],[-70.337147,-33.480258],[-70.337399,-33.480533],[-70.33766,-33.480809],[-70.33792,-33.48108],[-70.338166,-33.481355],[-70.338401,-33.481643],[-70.338632,-33.481931],[-70.338861,-33.482219],[-70.339088,-33.482511],[-70.339314,-33.482803],[-70.339539,-33.483095],[-70.339764,-33.483388],[-70.339991,-33.48368],[-70.340204,-33.483981],[-70.340418,-33.484281],[-70.340673,-33.484552],[-70.340972,-33.484789],[-70.341292,-33.485017],[-70.341616,-33.485232],[-70.341937,-33.485456],[-70.342264,-33.485666],[-70.342593,-33.485881],[-70.342939,-33.486074],[-70.343271,-33.486285],[-70.343557,-33.486534],[-70.343818,-33.486806],[-70.344078,-33.487077],[-70.344349,-33.487339],[-70.344624,-33.487602],[-70.344913,-33.487847],[-70.345228,-33.488075],[-70.345545,-33.488303],[-70.34585,-33.488539],[-70.346157,-33.488772],[-70.346478,-33.488986],[-70.346817,-33.489188],[-70.347162,-33.489386],[-70.34751,-33.489575],[-70.347862,-33.489755],[-70.348215,-33.489939],[-70.348579,-33.490092],[-70.349065,-33.490273],[-70.349772,-33.490484],[-70.35047,-33.490857],[-70.351401,-33.491608],[-70.35137,-33.491067],[-70.351299,-33.490577],[-70.351372,-33.48999],[-70.351446,-33.489633],[-70.351518,-33.489311],[-70.351639,-33.488969],[-70.351746,-33.488631],[-70.351882,-33.488307],[-70.352099,-33.487991],[-70.352298,-33.487724],[-70.352603,-33.487303],[-70.352879,-33.486944],[-70.35334,-33.48661],[-70.353816,-33.486429],[-70.354191,-33.486385],[-70.354543,-33.48634],[-70.354941,-33.486314],[-70.355293,-33.486269],[-70.355735,-33.486285],[-70.356315,-33.48633],[-70.356758,-33.486346],[-70.357104,-33.486395],[-70.35738,-33.486487],[-70.357606,-33.486612],[-70.35813,-33.486848],[-70.35847,-33.487014],[-70.358884,-33.487129],[-70.359253,-33.487201],[-70.359579,-33.487213],[-70.360137,-33.487234],[-70.360604,-33.487211],[-70.361051,-33.487151],[-70.361419,-33.48703],[-70.361744,-33.486804],[-70.362084,-33.486605],[-70.362431,-33.486419],[-70.362784,-33.486235],[-70.363144,-33.486063],[-70.363512,-33.485902],[-70.363886,-33.485753],[-70.364266,-33.48561],[-70.364653,-33.48548],[-70.365044,-33.485364],[-70.365437,-33.485253],[-70.36583,-33.485142],[-70.366221,-33.485021],[-70.366605,-33.484896],[-70.366973,-33.484734],[-70.36733,-33.484554],[-70.367698,-33.484396],[-70.368096,-33.484299],[-70.368501,-33.484215],[-70.368882,-33.484081],[-70.369243,-33.483909],[-70.369601,-33.483734],[-70.369964,-33.483563],[-70.370331,-33.483401],[-70.370716,-33.483275],[-70.371118,-33.483182],[-70.371522,-33.483107],[-70.371927,-33.483023],[-70.372332,-33.482953],[-70.37274,-33.482892],[-70.373152,-33.482853],[-70.373567,-33.482837],[-70.37398,-33.482794],[-70.374392,-33.482755],[-70.374805,-33.482712],[-70.375217,-33.482692],[-70.375632,-33.482685],[-70.376047,-33.482696],[-70.376462,-33.482711],[-70.376972,-33.482816],[-70.377455,-33.482929],[-70.377801,-33.483],[-70.378219,-33.483038],[-70.378497,-33.483066],[-70.378871,-33.48304],[-70.379299,-33.483083],[-70.379652,-33.483267],[-70.379993,-33.483474],[-70.380328,-33.48368],[-70.380651,-33.483899],[-70.380978,-33.484109],[-70.381321,-33.484307],[-70.38167,-33.484496],[-70.38201,-33.484688],[-70.382333,-33.484908],[-70.38266,-33.485123],[-70.383007,-33.48532],[-70.383381,-33.485465],[-70.383767,-33.485592],[-70.384158,-33.48571],[-70.384551,-33.485824],[-70.384946,-33.485929],[-70.385346,-33.486025],[-70.385775,-33.486144],[-70.386249,-33.486292],[-70.386729,-33.486324],[-70.387264,-33.486411],[-70.387532,-33.486435],[-70.387836,-33.486514],[-70.388159,-33.486589],[-70.388507,-33.486705],[-70.388851,-33.486903],[-70.389184,-33.487114],[-70.389505,-33.487328],[-70.38982,-33.487556],[-70.390129,-33.487788],[-70.390433,-33.488029],[-70.390734,-33.488266],[-70.391034,-33.488507],[-70.391333,-33.488748],[-70.391627,-33.488997],[-70.391907,-33.489255],[-70.392182,-33.489513],[-70.392453,-33.489776],[-70.392726,-33.490038],[-70.393016,-33.490287],[-70.393353,-33.490503],[-70.393724,-33.490665],[-70.394115,-33.490644],[-70.394517,-33.490524],[-70.394905,-33.49038],[-70.395263,-33.4902],[-70.395633,-33.490052],[-70.39603,-33.489949],[-70.396438,-33.489874],[-70.396848,-33.489827],[-70.397262,-33.489797],[-70.397676,-33.489772],[-70.39809,-33.489747],[-70.398505,-33.489735],[-70.398918,-33.489755],[-70.399332,-33.489793],[-70.399741,-33.489844],[-70.40015,-33.489913],[-70.400559,-33.489965],[-70.400978,-33.48998],[-70.401395,-33.48996],[-70.401794,-33.489876],[-70.402191,-33.489769],[-70.402585,-33.489653],[-70.402976,-33.489528],[-70.403359,-33.489393],[-70.403732,-33.48924],[-70.404089,-33.489069],[-70.404416,-33.488856],[-70.404721,-33.48862],[-70.405024,-33.488379],[-70.405342,-33.488152],[-70.405697,-33.487976],[-70.406081,-33.487837],[-70.406448,-33.487675],[-70.406732,-33.487415],[-70.407077,-33.487239],[-70.40746,-33.487109],[-70.407852,-33.486993],[-70.408244,-33.486872],[-70.408626,-33.486729],[-70.40899,-33.486562],[-70.409345,-33.486386],[-70.409692,-33.486196],[-70.410036,-33.485997],[-70.410379,-33.485799],[-70.41072,-33.485604],[-70.411055,-33.485396],[-70.411388,-33.485183],[-70.411722,-33.484984],[-70.412062,-33.48478],[-70.412413,-33.484599],[-70.412781,-33.484442],[-70.413161,-33.484303],[-70.413542,-33.484164],[-70.413911,-33.484002],[-70.414261,-33.483817],[-70.414603,-33.483618],[-70.414946,-33.483423],[-70.415302,-33.483243],[-70.415668,-33.483076],[-70.416042,-33.482932],[-70.416429,-33.482803],[-70.416821,-33.482686],[-70.417208,-33.482566],[-70.417587,-33.482422],[-70.417963,-33.482278],[-70.418342,-33.482135],[-70.418727,-33.482],[-70.419134,-33.481898],[-70.419539,-33.4819],[-70.419936,-33.481987],[-70.420331,-33.482105],[-70.42073,-33.482219],[-70.421132,-33.482301],[-70.421537,-33.482379],[-70.421942,-33.482457],[-70.422345,-33.482535],[-70.422749,-33.482613],[-70.423152,-33.482696],[-70.423554,-33.482783],[-70.423955,-33.482874],[-70.424356,-33.482965],[-70.424756,-33.483061],[-70.425151,-33.483166],[-70.425541,-33.483284],[-70.425919,-33.483424],[-70.426289,-33.483577],[-70.426656,-33.483749],[-70.427026,-33.483902],[-70.427396,-33.48406],[-70.427768,-33.484218],[-70.428131,-33.484308],[-70.428487,-33.484334],[-70.428805,-33.484242],[-70.429174,-33.484044],[-70.429375,-33.483777],[-70.42939,-33.483489],[-70.429287,-33.483071],[-70.429216,-33.48265],[-70.429316,-33.482234],[-70.429642,-33.481958],[-70.430104,-33.481782],[-70.430694,-33.481826],[-70.431186,-33.481849],[-70.431592,-33.481819],[-70.432085,-33.481702],[-70.432471,-33.481558],[-70.432883,-33.481438],[-70.433347,-33.481339],[-70.434416,-33.48097],[-70.434163,-33.480743],[-70.434013,-33.480269],[-70.433999,-33.479377],[-70.433988,-33.478723],[-70.433972,-33.477771],[-70.433731,-33.476049],[-70.433635,-33.474504],[-70.433403,-33.473376],[-70.433526,-33.472245],[-70.434563,-33.470567],[-70.435323,-33.469309],[-70.435454,-33.468653],[-70.435445,-33.468059],[-70.435224,-33.467585],[-70.434857,-33.466876],[-70.434632,-33.466105],[-70.434125,-33.465516],[-70.43326,-33.464693],[-70.432401,-33.464227],[-70.431612,-33.463761],[-70.430686,-33.463533],[-70.4296,-33.462237],[-70.428421,-33.459574],[-70.428114,-33.45815],[-70.428172,-33.457376],[-70.428366,-33.456184],[-70.428913,-33.454929],[-70.429181,-33.453974],[-70.429098,-33.453261],[-70.428802,-33.452491],[-70.428647,-33.45172],[-70.4287,-33.450589],[-70.428897,-33.449635],[-70.429377,-33.448618],[-70.430699,-33.447057],[-70.431468,-33.446334],[-70.431881,-33.445556],[-70.432151,-33.44472],[-70.432136,-33.443828],[-70.431908,-33.442879],[-70.431604,-33.441633],[-70.431524,-33.441099],[-70.431298,-33.440328],[-70.431002,-33.439558],[-70.430917,-33.438727],[-70.431188,-33.43795],[-70.431599,-33.437053],[-70.43187,-33.436277],[-70.43221,-33.435381],[-70.433108,-33.433883],[-70.433658,-33.432806],[-70.43378,-33.431615],[-70.433764,-33.430604],[-70.433893,-33.429829],[-70.434017,-33.428757],[-70.43443,-33.427979],[-70.434882,-33.427343],[-70.434984,-33.427199],[-70.435547,-33.426895],[-70.435997,-33.426721],[-70.436181,-33.42665],[-70.437381,-33.426279],[-70.438582,-33.425968],[-70.442822,-33.424967],[-70.444869,-33.424348],[-70.445993,-33.423681],[-70.447323,-33.422654],[-70.448726,-33.421686],[-70.450053,-33.420422],[-70.451523,-33.419274],[-70.453055,-33.417531],[-70.453534,-33.416514],[-70.453656,-33.415323],[-70.453811,-33.411812],[-70.453936,-33.410799],[-70.45399,-33.409788],[-70.45405,-33.409133],[-70.453756,-33.408541],[-70.453743,-33.407768],[-70.453731,-33.407054],[-70.453648,-33.406342],[-70.453421,-33.405452],[-70.453235,-33.402837],[-70.453227,-33.402302],[-70.453359,-33.401705],[-70.453418,-33.400991],[-70.453411,-33.400575],[-70.453401,-33.39998],[-70.453888,-33.399439],[-70.454235,-33.398959],[-70.454362,-33.398065],[-70.454491,-33.39735],[-70.45466,-33.397253],[-70.454913,-33.397107],[-70.455409,-33.397101],[-70.455906,-33.397095],[-70.456544,-33.397088],[-70.457604,-33.396897],[-70.459372,-33.396579],[-70.460571,-33.396208],[-70.461697,-33.395659],[-70.462826,-33.395348],[-70.464808,-33.395147],[-70.466651,-33.395125],[-70.467431,-33.395115],[-70.468279,-33.394927],[-70.46941,-33.394676],[-70.470118,-33.394667],[-70.47097,-33.394717],[-70.471681,-33.394827],[-70.472532,-33.394817],[-70.473454,-33.394806],[-70.474088,-33.394561],[-70.474938,-33.394491],[-70.475787,-33.394422],[-70.476425,-33.394414],[-70.477133,-33.394346],[-70.477551,-33.393865],[-70.477544,-33.393449],[-70.477317,-33.392619],[-70.477168,-33.392204],[-70.477159,-33.391669],[-70.477295,-33.391311],[-70.477715,-33.391008],[-70.477995,-33.390767],[-70.478485,-33.390404],[-70.479176,-33.389325],[-70.479307,-33.388729],[-70.479788,-33.387831],[-70.480122,-33.386578],[-70.480037,-33.385746],[-70.479815,-33.385213],[-70.479522,-33.384681],[-70.479583,-33.384086],[-70.479662,-33.383977],[-70.47993,-33.383606],[-70.48056,-33.383182],[-70.481053,-33.382938],[-70.482029,-33.381975],[-70.482929,-33.380715],[-70.483612,-33.37916],[-70.483731,-33.377791],[-70.483502,-33.376842],[-70.483065,-33.376193],[-70.482702,-33.375662],[-70.48241,-33.375189],[-70.482331,-33.374714],[-70.482251,-33.37418],[-70.481816,-33.37359],[-70.481526,-33.373237],[-70.481307,-33.372823],[-70.481366,-33.372168],[-70.481356,-33.371573],[-70.480996,-33.371221],[-70.480568,-33.371047],[-70.479997,-33.370876],[-70.478713,-33.370356],[-70.478141,-33.370065],[-70.477425,-33.369657],[-70.477235,-33.369502]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1311,"DIS_ELEC":23,"NOM_COM":"Lo Barnechea","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":1024734933.53,"SHAPE_LENG":149539.074262,"SHAPE_Le_1":149865.511039},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.694105,-33.502432],[-70.692679,-33.502923],[-70.690763,-33.503587],[-70.688841,-33.504251],[-70.687495,-33.504723],[-70.684567,-33.505737],[-70.683902,-33.505908],[-70.682675,-33.506354],[-70.681141,-33.507073],[-70.679821,-33.507614],[-70.67852,-33.508173],[-70.678133,-33.508295],[-70.676671,-33.508365],[-70.67594,-33.508671],[-70.674703,-33.509216],[-70.671787,-33.510478],[-70.67123,-33.51069],[-70.671331,-33.510902],[-70.671894,-33.512091],[-70.673326,-33.515331],[-70.675096,-33.519335],[-70.676105,-33.52133],[-70.677023,-33.523146],[-70.681909,-33.531975],[-70.682732,-33.533461],[-70.685763,-33.538973],[-70.686614,-33.538667],[-70.687831,-33.538218],[-70.689831,-33.53748],[-70.693872,-33.536007],[-70.695272,-33.535501],[-70.696803,-33.534912],[-70.698781,-33.534172],[-70.699925,-33.533756],[-70.701513,-33.533152],[-70.702988,-33.532627],[-70.704359,-33.53213],[-70.706273,-33.531414],[-70.706739,-33.531225],[-70.706233,-33.525378],[-70.706116,-33.52469],[-70.706002,-33.524131],[-70.703983,-33.520015],[-70.702341,-33.516668],[-70.702114,-33.516207],[-70.699911,-33.511764],[-70.696889,-33.505671],[-70.696599,-33.505035],[-70.695409,-33.502433],[-70.695286,-33.502472],[-70.695281,-33.502469],[-70.694919,-33.502354],[-70.694602,-33.502298],[-70.694105,-33.502432]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1311,"DIS_ELEC":28,"NOM_COM":"Lo Espejo","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":8181654.72938,"SHAPE_LENG":11405.976038,"SHAPE_Le_1":11389.045242},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.705586,-33.45716],[-70.706205,-33.457282],[-70.708961,-33.457964],[-70.710415,-33.45829],[-70.711898,-33.458432],[-70.712956,-33.458445],[-70.713456,-33.458365],[-70.71494,-33.458068],[-70.719196,-33.457248],[-70.724882,-33.456148],[-70.728684,-33.455413],[-70.731581,-33.454858],[-70.73773,-33.453674],[-70.738928,-33.453442],[-70.739013,-33.453241],[-70.739081,-33.452633],[-70.739203,-33.450237],[-70.739254,-33.44891],[-70.739446,-33.446633],[-70.740002,-33.446166],[-70.740638,-33.445589],[-70.740479,-33.444769],[-70.740566,-33.442872],[-70.740526,-33.440824],[-70.740713,-33.437999],[-70.740804,-33.436389],[-70.737694,-33.436398],[-70.734734,-33.436449],[-70.733896,-33.436381],[-70.733241,-33.436363],[-70.732682,-33.436344],[-70.732112,-33.436316],[-70.731458,-33.436298],[-70.730865,-33.436279],[-70.73021,-33.436252],[-70.729939,-33.436276],[-70.729459,-33.436353],[-70.728939,-33.436369],[-70.728705,-33.436435],[-70.728218,-33.436647],[-70.727154,-33.437124],[-70.726521,-33.437241],[-70.725982,-33.437322],[-70.725538,-33.437392],[-70.725108,-33.437466],[-70.724569,-33.437584],[-70.724208,-33.437686],[-70.724152,-33.437769],[-70.723869,-33.438271],[-70.723665,-33.438566],[-70.722986,-33.438788],[-70.722564,-33.438913],[-70.722558,-33.438921],[-70.722555,-33.438914],[-70.722405,-33.438934],[-70.722278,-33.438593],[-70.722163,-33.438324],[-70.722007,-33.437938],[-70.721868,-33.437597],[-70.721699,-33.437185],[-70.721646,-33.437026],[-70.721557,-33.436709],[-70.721461,-33.436629],[-70.719651,-33.436889],[-70.718435,-33.437077],[-70.717047,-33.437258],[-70.71583,-33.43742],[-70.714761,-33.437558],[-70.714085,-33.437655],[-70.712958,-33.437818],[-70.712749,-33.437848],[-70.712262,-33.437955],[-70.711563,-33.438016],[-70.710977,-33.438103],[-70.71021,-33.43813],[-70.709362,-33.438131],[-70.708724,-33.438104],[-70.707292,-33.43806],[-70.70707,-33.438054],[-70.707078,-33.438515],[-70.707175,-33.439885],[-70.707257,-33.440927],[-70.707309,-33.441521],[-70.707346,-33.442001],[-70.707352,-33.442758],[-70.707345,-33.443191],[-70.707329,-33.444003],[-70.707331,-33.444869],[-70.707326,-33.445924],[-70.707262,-33.447449],[-70.70719,-33.448189],[-70.707148,-33.448478],[-70.707141,-33.448785],[-70.707139,-33.448795],[-70.707092,-33.448793],[-70.70709,-33.448804],[-70.70706,-33.449084],[-70.707019,-33.449472],[-70.706912,-33.450114],[-70.706834,-33.450602],[-70.706815,-33.450801],[-70.706501,-33.451616],[-70.70638,-33.451907],[-70.706351,-33.452079],[-70.706234,-33.452369],[-70.70619,-33.452631],[-70.706024,-33.453697],[-70.705753,-33.455497],[-70.705718,-33.456055],[-70.705575,-33.456773],[-70.705586,-33.45716]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1311,"DIS_ELEC":18,"NOM_COM":"Lo Prado","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":6535087.54588,"SHAPE_LENG":10795.433315,"SHAPE_Le_1":10691.67249},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.67123,-33.51069],[-70.671787,-33.510478],[-70.674703,-33.509216],[-70.67594,-33.508671],[-70.676671,-33.508365],[-70.678133,-33.508295],[-70.67852,-33.508173],[-70.679821,-33.507614],[-70.681141,-33.507073],[-70.682675,-33.506354],[-70.683902,-33.505908],[-70.684567,-33.505737],[-70.687495,-33.504723],[-70.688841,-33.504251],[-70.690763,-33.503587],[-70.692679,-33.502923],[-70.694105,-33.502432],[-70.694602,-33.502298],[-70.694919,-33.502354],[-70.695281,-33.502469],[-70.695286,-33.502472],[-70.695409,-33.502433],[-70.694185,-33.499758],[-70.694136,-33.49977],[-70.693236,-33.49787],[-70.693105,-33.497599],[-70.691897,-33.495178],[-70.691201,-33.493745],[-70.690968,-33.493243],[-70.690607,-33.492331],[-70.689946,-33.49062],[-70.689648,-33.489879],[-70.689157,-33.488909],[-70.688887,-33.488272],[-70.688542,-33.487532],[-70.688168,-33.486827],[-70.686889,-33.483615],[-70.686137,-33.482058],[-70.68563,-33.479779],[-70.685556,-33.478616],[-70.685696,-33.478111],[-70.682324,-33.478325],[-70.681322,-33.478363],[-70.681343,-33.478553],[-70.681189,-33.478463],[-70.671688,-33.478469],[-70.671682,-33.47847],[-70.671728,-33.476387],[-70.671198,-33.476283],[-70.670571,-33.476226],[-70.669944,-33.476202],[-70.669514,-33.476175],[-70.668887,-33.47615],[-70.668301,-33.476158],[-70.667676,-33.476232],[-70.665207,-33.47617],[-70.665132,-33.476168],[-70.663566,-33.476124],[-70.661689,-33.476116],[-70.661063,-33.476124],[-70.660321,-33.4762],[-70.65829,-33.476358],[-70.657235,-33.476438],[-70.656416,-33.476547],[-70.655596,-33.476657],[-70.655067,-33.476724],[-70.655433,-33.477599],[-70.656287,-33.479183],[-70.65819,-33.483211],[-70.661665,-33.490116],[-70.661747,-33.490278],[-70.663423,-33.494482],[-70.666085,-33.50044],[-70.666233,-33.500716],[-70.668648,-33.505235],[-70.670393,-33.508921],[-70.67123,-33.51069]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1312,"DIS_ELEC":28,"NOM_COM":"Pedro Aguirre Cerda","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":8501305.47498,"SHAPE_LENG":13054.563524,"SHAPE_Le_1":12493.791334},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.789777,-33.360476],[-70.784004,-33.36482],[-70.779611,-33.367899],[-70.774804,-33.37187],[-70.770779,-33.37492],[-70.768771,-33.376275],[-70.768422,-33.376453],[-70.767168,-33.377002],[-70.764834,-33.378193],[-70.763412,-33.378985],[-70.760862,-33.380855],[-70.758027,-33.382873],[-70.756567,-33.38378],[-70.764148,-33.389782],[-70.776029,-33.399889],[-70.782372,-33.405248],[-70.782364,-33.405431],[-70.782524,-33.406214],[-70.782325,-33.412818],[-70.782244,-33.413949],[-70.782571,-33.413958],[-70.782453,-33.416888],[-70.781694,-33.417047],[-70.781356,-33.417179],[-70.78102,-33.417405],[-70.780725,-33.417759],[-70.780541,-33.418047],[-70.780435,-33.418366],[-70.780433,-33.418375],[-70.780398,-33.41843],[-70.780326,-33.418589],[-70.780256,-33.418908],[-70.780111,-33.419195],[-70.779927,-33.419452],[-70.779372,-33.420063],[-70.778999,-33.420322],[-70.778548,-33.420487],[-70.778251,-33.420745],[-70.777918,-33.42113],[-70.777811,-33.421449],[-70.777811,-33.421469],[-70.777723,-33.421528],[-70.777456,-33.422237],[-70.777125,-33.423094],[-70.776808,-33.423626],[-70.776541,-33.423919],[-70.776021,-33.424306],[-70.775655,-33.424495],[-70.775096,-33.424686],[-70.773637,-33.425153],[-70.772873,-33.425401],[-70.772094,-33.425655],[-70.771252,-33.425725],[-70.770265,-33.425776],[-70.769731,-33.425806],[-70.768698,-33.426408],[-70.767446,-33.426879],[-70.767096,-33.426842],[-70.766855,-33.426389],[-70.766651,-33.425894],[-70.766557,-33.42593],[-70.766085,-33.426187],[-70.765326,-33.426594],[-70.764811,-33.426867],[-70.763862,-33.427318],[-70.763274,-33.427581],[-70.762878,-33.427697],[-70.762347,-33.427723],[-70.7618,-33.427731],[-70.761084,-33.427684],[-70.760492,-33.427556],[-70.760054,-33.427465],[-70.759213,-33.42742],[-70.758629,-33.427393],[-70.758268,-33.427377],[-70.757336,-33.427335],[-70.756949,-33.427317],[-70.756536,-33.427363],[-70.756407,-33.427353],[-70.756048,-33.427401],[-70.755921,-33.427433],[-70.75554,-33.427477],[-70.75517,-33.427622],[-70.754528,-33.427955],[-70.754383,-33.428003],[-70.753732,-33.428078],[-70.753022,-33.428161],[-70.752372,-33.428249],[-70.752236,-33.428309],[-70.75204,-33.428438],[-70.752053,-33.428441],[-70.751802,-33.428539],[-70.751781,-33.428561],[-70.751115,-33.428884],[-70.750544,-33.429119],[-70.749921,-33.429245],[-70.749639,-33.429302],[-70.748878,-33.429551],[-70.74861,-33.4296],[-70.748108,-33.429693],[-70.747646,-33.429781],[-70.74682,-33.429941],[-70.746686,-33.429974],[-70.745451,-33.429978],[-70.744137,-33.429961],[-70.743389,-33.429958],[-70.742781,-33.429916],[-70.741474,-33.429967],[-70.74077,-33.4299],[-70.740728,-33.430423],[-70.740819,-33.432122],[-70.740837,-33.433732],[-70.740901,-33.43639],[-70.740872,-33.436389],[-70.740804,-33.436389],[-70.740713,-33.437999],[-70.740526,-33.440824],[-70.740566,-33.442872],[-70.740479,-33.444769],[-70.740638,-33.445589],[-70.740002,-33.446166],[-70.739446,-33.446633],[-70.739254,-33.44891],[-70.739203,-33.450237],[-70.739081,-33.452633],[-70.739013,-33.453241],[-70.738928,-33.453442],[-70.73773,-33.453674],[-70.731581,-33.454858],[-70.731292,-33.454913],[-70.731331,-33.455305],[-70.731303,-33.45531],[-70.731289,-33.455869],[-70.731312,-33.455871],[-70.731333,-33.459359],[-70.731339,-33.461098],[-70.731345,-33.461702],[-70.731365,-33.463736],[-70.731378,-33.466494],[-70.731403,-33.467844],[-70.731405,-33.46814],[-70.733858,-33.469657],[-70.734426,-33.46997],[-70.734817,-33.470185],[-70.735599,-33.470625],[-70.736193,-33.470969],[-70.736946,-33.47141],[-70.737034,-33.471471],[-70.737087,-33.471215],[-70.737143,-33.470738],[-70.737157,-33.470609],[-70.737218,-33.470415],[-70.737232,-33.470248],[-70.73728,-33.469664],[-70.73737,-33.468709],[-70.737544,-33.468642],[-70.737762,-33.468524],[-70.737915,-33.468452],[-70.738449,-33.468363],[-70.740185,-33.468049],[-70.741938,-33.467737],[-70.743975,-33.467385],[-70.745583,-33.46708],[-70.746154,-33.466979],[-70.747386,-33.466756],[-70.748258,-33.466598],[-70.749448,-33.466388],[-70.750567,-33.466195],[-70.752113,-33.465925],[-70.753674,-33.465647],[-70.754762,-33.465437],[-70.755092,-33.465374],[-70.755468,-33.465299],[-70.755791,-33.465236],[-70.756114,-33.465172],[-70.756454,-33.465109],[-70.756803,-33.465039],[-70.757004,-33.464995],[-70.757201,-33.464957],[-70.75808,-33.464803],[-70.75994,-33.464479],[-70.763462,-33.463821],[-70.763715,-33.462983],[-70.763842,-33.462526],[-70.764744,-33.459776],[-70.764937,-33.459259],[-70.76505,-33.45926],[-70.765051,-33.459258],[-70.775809,-33.45821],[-70.777196,-33.462896],[-70.777468,-33.462887],[-70.777484,-33.462894],[-70.777667,-33.462892],[-70.777787,-33.462894],[-70.777831,-33.462895],[-70.777992,-33.462943],[-70.778191,-33.463013],[-70.778335,-33.463053],[-70.778413,-33.463065],[-70.778597,-33.463074],[-70.778767,-33.463069],[-70.778882,-33.463052],[-70.779103,-33.463014],[-70.779295,-33.462957],[-70.779574,-33.462868],[-70.77973,-33.462821],[-70.779795,-33.462802],[-70.779796,-33.4628],[-70.779829,-33.462798],[-70.779831,-33.462791],[-70.780239,-33.462676],[-70.780515,-33.462641],[-70.781076,-33.462701],[-70.781158,-33.462715],[-70.781514,-33.462693],[-70.7823,-33.462681],[-70.782918,-33.462672],[-70.783868,-33.462471],[-70.796661,-33.46044],[-70.79648,-33.461183],[-70.796162,-33.462537],[-70.796087,-33.462783],[-70.796263,-33.462882],[-70.796525,-33.46292],[-70.796637,-33.463084],[-70.796626,-33.463133],[-70.804705,-33.463071],[-70.80471,-33.462914],[-70.804831,-33.462695],[-70.805002,-33.462356],[-70.805525,-33.461788],[-70.805963,-33.46137],[-70.806302,-33.461035],[-70.806449,-33.460978],[-70.808088,-33.461631],[-70.809741,-33.462536],[-70.810807,-33.463255],[-70.811581,-33.463929],[-70.813539,-33.465418],[-70.814544,-33.466039],[-70.815777,-33.466315],[-70.817011,-33.466688],[-70.818533,-33.466862],[-70.820988,-33.466972],[-70.824259,-33.467022],[-70.826769,-33.466985],[-70.827637,-33.466581],[-70.828326,-33.466032],[-70.829194,-33.465628],[-70.829896,-33.465716],[-70.830837,-33.465995],[-70.832535,-33.466215],[-70.833826,-33.466538],[-70.834943,-33.466865],[-70.836405,-33.46699],[-70.837749,-33.467019],[-70.838799,-33.466954],[-70.839731,-33.466843],[-70.840667,-33.466926],[-70.841138,-33.467115],[-70.841612,-33.467402],[-70.842144,-33.467737],[-70.842512,-33.468563],[-70.843357,-33.469872],[-70.843549,-33.470652],[-70.843857,-33.471382],[-70.844399,-33.472157],[-70.846019,-33.474189],[-70.847523,-33.476271],[-70.847943,-33.476803],[-70.848014,-33.477389],[-70.847973,-33.478222],[-70.848161,-33.478806],[-70.848346,-33.479293],[-70.848762,-33.479629],[-70.849528,-33.479912],[-70.850288,-33.479949],[-70.852797,-33.479863],[-70.854316,-33.479889],[-70.855776,-33.479867],[-70.858525,-33.480022],[-70.860157,-33.479899],[-70.862832,-33.479321],[-70.867086,-33.478865],[-70.868891,-33.478642],[-70.870173,-33.478476],[-70.871679,-33.477915],[-70.873075,-33.477649],[-70.874879,-33.477328],[-70.876736,-33.476762],[-70.878076,-33.476644],[-70.879128,-33.476677],[-70.879774,-33.476814],[-70.880774,-33.477141],[-70.882128,-33.477659],[-70.883715,-33.478124],[-70.885822,-33.478337],[-70.887049,-33.478318],[-70.888449,-33.478248],[-70.889671,-33.478033],[-70.89078,-33.478017],[-70.891949,-33.478048],[-70.893413,-33.478221],[-70.894995,-33.47849],[-70.898058,-33.479667],[-70.899885,-33.480422],[-70.903599,-33.48198],[-70.906073,-33.482921],[-70.908887,-33.483416],[-70.910825,-33.483876],[-70.91165,-33.484206],[-70.912362,-33.484733],[-70.912664,-33.485169],[-70.912849,-33.485607],[-70.913275,-33.486383],[-70.91393,-33.48696],[-70.915168,-33.48748],[-70.915684,-33.487648],[-70.916093,-33.487704],[-70.9165,-33.487698],[-70.916983,-33.487721],[-70.91741,-33.487784],[-70.918139,-33.487828],[-70.919335,-33.487976],[-70.920133,-33.48813],[-70.921195,-33.488225],[-70.921425,-33.488317],[-70.921638,-33.48733],[-70.922154,-33.486712],[-70.9228,-33.48598],[-70.923249,-33.485307],[-70.924609,-33.483899],[-70.926025,-33.482046],[-70.926864,-33.481089],[-70.927569,-33.480024],[-70.928782,-33.478008],[-70.929295,-33.477223],[-70.930009,-33.476601],[-70.93073,-33.476257],[-70.931978,-33.475794],[-70.932568,-33.475507],[-70.933293,-33.475385],[-70.934152,-33.475316],[-70.934749,-33.475362],[-70.935283,-33.47552],[-70.935816,-33.475678],[-70.936413,-33.475724],[-70.937271,-33.4756],[-70.937729,-33.475371],[-70.938116,-33.474921],[-70.938305,-33.474474],[-70.938824,-33.473967],[-70.939609,-33.473566],[-70.940392,-33.473054],[-70.941046,-33.472656],[-70.941498,-33.472149],[-70.942022,-33.471919],[-70.942413,-33.471635],[-70.942943,-33.471627],[-70.943868,-33.471557],[-70.94459,-33.471268],[-70.945308,-33.470813],[-70.946226,-33.47041],[-70.947149,-33.470229],[-70.948062,-33.469604],[-70.948514,-33.469098],[-70.9487,-33.46854],[-70.948752,-33.467873],[-70.948735,-33.467152],[-70.948722,-33.466542],[-70.948503,-33.465658],[-70.948481,-33.464659],[-70.948863,-33.463987],[-70.949579,-33.463421],[-70.949839,-33.463195],[-70.950422,-33.462631],[-70.950676,-33.462183],[-70.950667,-33.462116],[-70.950598,-33.46163],[-70.950522,-33.461187],[-70.94976,-33.459701],[-70.949348,-33.459041],[-70.949268,-33.458432],[-70.949326,-33.458043],[-70.949774,-33.45737],[-70.949753,-33.456427],[-70.949793,-33.455261],[-70.949776,-33.454484],[-70.949887,-33.453539],[-70.950394,-33.452532],[-70.951493,-33.45135],[-70.952864,-33.450496],[-70.953842,-33.449815],[-70.954548,-33.44886],[-70.954925,-33.447966],[-70.955135,-33.445521],[-70.955118,-33.444745],[-70.954899,-33.44386],[-70.954753,-33.443252],[-70.954473,-33.442535],[-70.954322,-33.441705],[-70.954239,-33.440985],[-70.954328,-33.439042],[-70.95434,-33.438709],[-70.95433,-33.438245],[-70.954097,-33.437722],[-70.953793,-33.437386],[-70.953048,-33.437119],[-70.952455,-33.437004],[-70.951751,-33.436953],[-70.951086,-33.436964],[-70.950419,-33.43685],[-70.949932,-33.436579],[-70.949667,-33.436274],[-70.949577,-33.435562],[-70.949375,-33.434791],[-70.948635,-33.433099],[-70.94831,-33.431803],[-70.94831,-33.43013],[-70.948423,-33.428579],[-70.948358,-33.42734],[-70.947519,-33.424503],[-70.947103,-33.422403],[-70.947054,-33.421877],[-70.947137,-33.418964],[-70.946969,-33.418068],[-70.946773,-33.417575],[-70.946764,-33.417173],[-70.946979,-33.416859],[-70.9472,-33.416825],[-70.948189,-33.416469],[-70.948881,-33.415993],[-70.949346,-33.415335],[-70.949817,-33.414894],[-70.950247,-33.414329],[-70.950712,-33.41361],[-70.950999,-33.413264],[-70.951443,-33.412967],[-70.951096,-33.411962],[-70.950801,-33.41111],[-70.950534,-33.409651],[-70.950237,-33.408844],[-70.95012,-33.407763],[-70.950277,-33.406786],[-70.950329,-33.405666],[-70.95036,-33.405014],[-70.950474,-33.403751],[-70.950847,-33.402921],[-70.951434,-33.402287],[-70.952026,-33.401558],[-70.952168,-33.400905],[-70.952263,-33.400066],[-70.952015,-33.399404],[-70.951432,-33.398732],[-70.950957,-33.398154],[-70.950433,-33.397434],[-70.950409,-33.396734],[-70.950118,-33.395828],[-70.949969,-33.39545],[-70.949633,-33.394272],[-70.948936,-33.392469],[-70.948746,-33.39176],[-70.9488,-33.390595],[-70.948868,-33.390496],[-70.948861,-33.39021],[-70.948739,-33.38983],[-70.948589,-33.389474],[-70.948499,-33.389261],[-70.948313,-33.388596],[-70.948297,-33.38788],[-70.948283,-33.38726],[-70.948329,-33.386735],[-70.948319,-33.386305],[-70.948024,-33.385833],[-70.947259,-33.385242],[-70.946664,-33.384909],[-70.946582,-33.384863],[-70.94594,-33.384195],[-70.945892,-33.384142],[-70.945473,-33.383678],[-70.945239,-33.383395],[-70.945006,-33.383112],[-70.944771,-33.382782],[-70.944593,-33.382451],[-70.944415,-33.38212],[-70.944068,-33.381886],[-70.943662,-33.381511],[-70.943317,-33.381373],[-70.942745,-33.381191],[-70.941999,-33.380917],[-70.9412,-33.380786],[-70.940285,-33.380562],[-70.939829,-33.380521],[-70.938568,-33.380111],[-70.937939,-33.37993],[-70.937421,-33.379652],[-70.936905,-33.379469],[-70.936561,-33.379379],[-70.935819,-33.379248],[-70.935023,-33.37926],[-70.934452,-33.379174],[-70.933882,-33.379087],[-70.933308,-33.378857],[-70.932959,-33.378529],[-70.932666,-33.378151],[-70.932317,-33.377775],[-70.932083,-33.377493],[-70.931794,-33.377258],[-70.931278,-33.377076],[-70.930879,-33.377034],[-70.930139,-33.377046],[-70.929881,-33.37705],[-70.929571,-33.377054],[-70.928714,-33.376877],[-70.928139,-33.3766],[-70.928032,-33.376523],[-70.927619,-33.376226],[-70.927389,-33.376134],[-70.927046,-33.376044],[-70.92636,-33.375864],[-70.925676,-33.375827],[-70.925105,-33.375795],[-70.924481,-33.375693],[-70.924339,-33.37567],[-70.923507,-33.375478],[-70.92293,-33.375106],[-70.92213,-33.374927],[-70.921093,-33.374323],[-70.920117,-33.373908],[-70.919315,-33.373635],[-70.918512,-33.373313],[-70.918051,-33.373081],[-70.91742,-33.372805],[-70.916899,-33.372383],[-70.916261,-33.371821],[-70.915488,-33.370598],[-70.915441,-33.370565],[-70.914967,-33.370225],[-70.914401,-33.369988],[-70.913962,-33.369804],[-70.912851,-33.369686],[-70.911979,-33.369423],[-70.911105,-33.369201],[-70.910257,-33.368429],[-70.909845,-33.368299],[-70.908962,-33.36827],[-70.907325,-33.36845],[-70.905887,-33.369339],[-70.904644,-33.370042],[-70.903784,-33.370522],[-70.901993,-33.371008],[-70.901389,-33.371966],[-70.90052,-33.37264],[-70.899702,-33.373199],[-70.89759,-33.373597],[-70.895796,-33.374124],[-70.894648,-33.374788],[-70.892476,-33.375464],[-70.891039,-33.37534],[-70.889696,-33.375178],[-70.887741,-33.37519],[-70.88526,-33.3755],[-70.884221,-33.375817],[-70.88151,-33.376078],[-70.879603,-33.375852],[-70.877969,-33.375401],[-70.877114,-33.374926],[-70.876522,-33.374448],[-70.876304,-33.374141],[-70.876032,-33.373746],[-70.875658,-33.373574],[-70.875129,-33.373538],[-70.87439,-33.373593],[-70.873815,-33.373868],[-70.872618,-33.374728],[-70.871622,-33.375098],[-70.87089,-33.375464],[-70.870152,-33.375519],[-70.867724,-33.375644],[-70.864447,-33.375605],[-70.863708,-33.375616],[-70.862917,-33.375717],[-70.860135,-33.376556],[-70.857097,-33.377799],[-70.855728,-33.378448],[-70.855698,-33.378453],[-70.855414,-33.378573],[-70.855078,-33.378716],[-70.854875,-33.378803],[-70.854711,-33.378882],[-70.8545,-33.378972],[-70.854187,-33.379105],[-70.853961,-33.379208],[-70.853641,-33.379362],[-70.853286,-33.379532],[-70.853118,-33.379627],[-70.852917,-33.379755],[-70.852799,-33.379838],[-70.852755,-33.379859],[-70.852702,-33.379885],[-70.852695,-33.379911],[-70.85226,-33.380245],[-70.852056,-33.380436],[-70.851797,-33.38066],[-70.851611,-33.380777],[-70.851432,-33.380883],[-70.850998,-33.381088],[-70.850657,-33.381212],[-70.850585,-33.381236],[-70.850495,-33.381223],[-70.850405,-33.38126],[-70.850223,-33.381294],[-70.849381,-33.381462],[-70.848509,-33.381676],[-70.848255,-33.381754],[-70.848117,-33.381615],[-70.848015,-33.38152],[-70.847603,-33.381732],[-70.846734,-33.382047],[-70.846003,-33.382327],[-70.845319,-33.382593],[-70.844946,-33.382784],[-70.844723,-33.382918],[-70.844275,-33.383195],[-70.843712,-33.38358],[-70.843189,-33.383912],[-70.842959,-33.384013],[-70.842262,-33.384222],[-70.841472,-33.384469],[-70.841109,-33.384553],[-70.840305,-33.38473],[-70.839817,-33.384884],[-70.839508,-33.385083],[-70.839228,-33.38527],[-70.839194,-33.385288],[-70.838467,-33.385147],[-70.837934,-33.384933],[-70.837557,-33.384584],[-70.837498,-33.384275],[-70.83744,-33.384054],[-70.837433,-33.383699],[-70.837532,-33.383388],[-70.83758,-33.383165],[-70.837413,-33.382769],[-70.836982,-33.382376],[-70.836502,-33.382161],[-70.835066,-33.381695],[-70.834006,-33.381534],[-70.833369,-33.38141],[-70.832836,-33.381196],[-70.832565,-33.38089],[-70.832611,-33.380534],[-70.832815,-33.380177],[-70.832913,-33.379821],[-70.832902,-33.379289],[-70.832892,-33.378846],[-70.832619,-33.378407],[-70.832401,-33.378099],[-70.832236,-33.377791],[-70.831649,-33.377534],[-70.831223,-33.377363],[-70.830368,-33.376888],[-70.829939,-33.376584],[-70.829508,-33.376192],[-70.82939,-33.375617],[-70.829322,-33.374909],[-70.829321,-33.374907],[-70.829327,-33.374898],[-70.829339,-33.37475],[-70.829244,-33.374535],[-70.829197,-33.374326],[-70.82909,-33.374123],[-70.828942,-33.373924],[-70.828742,-33.373657],[-70.828636,-33.373461],[-70.828586,-33.373186],[-70.828508,-33.372889],[-70.828441,-33.37274],[-70.828181,-33.372356],[-70.828008,-33.372122],[-70.827746,-33.371789],[-70.827572,-33.371643],[-70.827253,-33.371433],[-70.826787,-33.37117],[-70.826528,-33.371082],[-70.826318,-33.371054],[-70.82617,-33.371067],[-70.825805,-33.371112],[-70.825443,-33.371104],[-70.825138,-33.371005],[-70.825012,-33.370908],[-70.824818,-33.370666],[-70.824709,-33.370381],[-70.824636,-33.370179],[-70.824524,-33.369982],[-70.824272,-33.36976],[-70.823983,-33.369504],[-70.823908,-33.369346],[-70.82385,-33.36918],[-70.823747,-33.368895],[-70.82355,-33.36847],[-70.823515,-33.368463],[-70.823459,-33.368166],[-70.823168,-33.367363],[-70.822905,-33.366868],[-70.82276,-33.366453],[-70.822701,-33.36618],[-70.822819,-33.366065],[-70.82285,-33.36573],[-70.822687,-33.365447],[-70.822328,-33.365036],[-70.821869,-33.364377],[-70.821499,-33.363555],[-70.821249,-33.363129],[-70.82077,-33.362689],[-70.820585,-33.362741],[-70.820489,-33.362695],[-70.820378,-33.362666],[-70.82016,-33.362632],[-70.819899,-33.362611],[-70.819751,-33.362613],[-70.819532,-33.362709],[-70.81935,-33.362773],[-70.819129,-33.362777],[-70.818876,-33.362667],[-70.818793,-33.362647],[-70.818646,-33.362568],[-70.81831,-33.362387],[-70.818139,-33.362313],[-70.817936,-33.362084],[-70.81769,-33.36192],[-70.81749,-33.361874],[-70.817194,-33.361847],[-70.81701,-33.361819],[-70.816677,-33.361762],[-70.816122,-33.361647],[-70.815714,-33.361498],[-70.815376,-33.361163],[-70.815113,-33.36095],[-70.814926,-33.360768],[-70.814738,-33.360616],[-70.814514,-33.360434],[-70.814364,-33.360343],[-70.81381,-33.360259],[-70.813256,-33.360143],[-70.812663,-33.359997],[-70.812107,-33.359789],[-70.811772,-33.35964],[-70.811512,-33.35952],[-70.811214,-33.359339],[-70.811135,-33.359093],[-70.81113,-33.358846],[-70.811192,-33.358568],[-70.81122,-33.358443],[-70.811222,-33.358164],[-70.811223,-33.358021],[-70.811193,-33.357923],[-70.811125,-33.357699],[-70.810813,-33.357451],[-70.810415,-33.357242],[-70.810336,-33.357198],[-70.809778,-33.35696],[-70.809749,-33.356947],[-70.80964,-33.356723],[-70.809569,-33.356613],[-70.809514,-33.356461],[-70.809505,-33.356419],[-70.809382,-33.356244],[-70.809193,-33.356],[-70.808967,-33.355787],[-70.808557,-33.355515],[-70.808144,-33.35515],[-70.807916,-33.354813],[-70.807615,-33.354478],[-70.807499,-33.354232],[-70.807383,-33.353956],[-70.807356,-33.353816],[-70.807342,-33.35374],[-70.807189,-33.353495],[-70.806939,-33.353374],[-70.806817,-33.353315],[-70.806482,-33.353135],[-70.80574,-33.352867],[-70.805329,-33.352564],[-70.805031,-33.352383],[-70.804731,-33.35214],[-70.80447,-33.351959],[-70.804131,-33.351624],[-70.803922,-33.351144],[-70.803783,-33.350825],[-70.803683,-33.350581],[-70.80364,-33.350476],[-70.803288,-33.350716],[-70.802189,-33.35126],[-70.799649,-33.353041],[-70.797255,-33.354841],[-70.795538,-33.356131],[-70.792973,-33.358053],[-70.789777,-33.360476]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1312,"DIS_ELEC":16,"NOM_COM":"Pudahuel","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":198106991.661,"SHAPE_LENG":72008.88548,"SHAPE_Le_1":71971.661505},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.623415,-33.473379],[-70.622924,-33.475213],[-70.622951,-33.475214],[-70.622945,-33.475221],[-70.622103,-33.478281],[-70.621922,-33.478941],[-70.621798,-33.479412],[-70.621525,-33.480443],[-70.621193,-33.481674],[-70.620571,-33.483984],[-70.620542,-33.484457],[-70.620503,-33.484605],[-70.62035,-33.485179],[-70.620296,-33.485374],[-70.620223,-33.485564],[-70.620082,-33.485837],[-70.619896,-33.486085],[-70.619634,-33.486358],[-70.619126,-33.486864],[-70.618698,-33.487292],[-70.618487,-33.487526],[-70.617537,-33.491586],[-70.617461,-33.492006],[-70.616558,-33.49611],[-70.616274,-33.497322],[-70.616002,-33.498534],[-70.615419,-33.501096],[-70.61481,-33.503882],[-70.614639,-33.505118],[-70.61436,-33.506411],[-70.614165,-33.507314],[-70.614038,-33.507797],[-70.613837,-33.508159],[-70.613746,-33.508261],[-70.613594,-33.508427],[-70.613594,-33.508427],[-70.61355,-33.508474],[-70.61313,-33.508888],[-70.612859,-33.509143],[-70.611642,-33.510297],[-70.611562,-33.510388],[-70.611516,-33.510868],[-70.611529,-33.510875],[-70.611351,-33.512307],[-70.611309,-33.512669],[-70.611309,-33.512669],[-70.611265,-33.513058],[-70.611301,-33.513059],[-70.613646,-33.513085],[-70.614084,-33.513098],[-70.615015,-33.513107],[-70.615855,-33.513328],[-70.615948,-33.51333],[-70.616075,-33.513386],[-70.617931,-33.513813],[-70.619925,-33.514328],[-70.620755,-33.514713],[-70.62086,-33.514794],[-70.622665,-33.515627],[-70.624159,-33.516323],[-70.624868,-33.516653],[-70.625472,-33.516934],[-70.625647,-33.517021],[-70.626105,-33.517223],[-70.626595,-33.51746],[-70.626727,-33.517519],[-70.626919,-33.517595],[-70.627125,-33.517669],[-70.627252,-33.517704],[-70.627455,-33.517737],[-70.627935,-33.517789],[-70.62867,-33.517869],[-70.629091,-33.517911],[-70.629647,-33.517965],[-70.630104,-33.518017],[-70.630605,-33.518072],[-70.631175,-33.518137],[-70.631756,-33.5182],[-70.632363,-33.518248],[-70.632899,-33.518329],[-70.63355,-33.518393],[-70.634174,-33.518465],[-70.634836,-33.518532],[-70.63546,-33.518567],[-70.635866,-33.518641],[-70.636098,-33.518669],[-70.636586,-33.518727],[-70.63671,-33.517976],[-70.636803,-33.517055],[-70.636909,-33.516107],[-70.637003,-33.515176],[-70.637029,-33.514852],[-70.637129,-33.514102],[-70.63715,-33.513849],[-70.637214,-33.513223],[-70.637223,-33.513135],[-70.637668,-33.511218],[-70.638126,-33.509192],[-70.638365,-33.508171],[-70.638606,-33.5073],[-70.638627,-33.507081],[-70.63863,-33.506382],[-70.638646,-33.506314],[-70.638751,-33.505549],[-70.638897,-33.504014],[-70.63902,-33.502586],[-70.639154,-33.501098],[-70.639311,-33.499617],[-70.639329,-33.499445],[-70.639423,-33.498578],[-70.639493,-33.497883],[-70.639559,-33.497284],[-70.639681,-33.496338],[-70.639748,-33.495814],[-70.639803,-33.495317],[-70.639947,-33.494324],[-70.64004,-33.493628],[-70.640086,-33.493332],[-70.640276,-33.492084],[-70.640417,-33.490972],[-70.640582,-33.48968],[-70.640772,-33.488071],[-70.641023,-33.486247],[-70.641163,-33.485367],[-70.641302,-33.484217],[-70.641512,-33.482617],[-70.641652,-33.481451],[-70.641714,-33.480917],[-70.641775,-33.480033],[-70.641849,-33.478868],[-70.641759,-33.478801],[-70.641848,-33.477649],[-70.641932,-33.477177],[-70.641946,-33.476882],[-70.64183,-33.476872],[-70.640615,-33.476725],[-70.63743,-33.475849],[-70.634628,-33.47466],[-70.633874,-33.474388],[-70.632341,-33.473858],[-70.632031,-33.473749],[-70.631909,-33.473808],[-70.631697,-33.473733],[-70.630003,-33.47314],[-70.627906,-33.472357],[-70.62789,-33.472318],[-70.627146,-33.471886],[-70.626196,-33.471342],[-70.625522,-33.470859],[-70.624865,-33.470324],[-70.624868,-33.470322],[-70.624578,-33.469956],[-70.624512,-33.469997],[-70.624346,-33.470162],[-70.624217,-33.470452],[-70.624023,-33.471302],[-70.623966,-33.47152],[-70.623415,-33.473379]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1312,"DIS_ELEC":25,"NOM_COM":"San Joaquín","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":9876876.69845,"SHAPE_LENG":13987.32678,"SHAPE_Le_1":13986.827394},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.638107,-33.51868],[-70.637404,-33.518786],[-70.636594,-33.518728],[-70.636586,-33.518886],[-70.636576,-33.518885],[-70.63606,-33.523219],[-70.635855,-33.525516],[-70.635653,-33.527314],[-70.635552,-33.528157],[-70.635462,-33.529148],[-70.635321,-33.529752],[-70.635079,-33.530532],[-70.63476,-33.532888],[-70.634672,-33.533946],[-70.634607,-33.5347],[-70.634576,-33.535974],[-70.634511,-33.537291],[-70.634473,-33.537785],[-70.634156,-33.541961],[-70.634131,-33.542329],[-70.634102,-33.542665],[-70.633266,-33.547571],[-70.632926,-33.549345],[-70.632483,-33.551455],[-70.631792,-33.554186],[-70.631872,-33.554266],[-70.631697,-33.555034],[-70.631494,-33.555977],[-70.631179,-33.557428],[-70.631034,-33.557973],[-70.631019,-33.558066],[-70.631411,-33.558098],[-70.631407,-33.558112],[-70.632073,-33.558165],[-70.632463,-33.558142],[-70.63316,-33.55804],[-70.63364,-33.557973],[-70.634074,-33.557859],[-70.634648,-33.557829],[-70.635277,-33.55774],[-70.635853,-33.557661],[-70.636657,-33.557546],[-70.637466,-33.557436],[-70.638057,-33.557356],[-70.63845,-33.557296],[-70.638851,-33.557246],[-70.63935,-33.557176],[-70.639673,-33.557129],[-70.64049,-33.557008],[-70.641366,-33.556897],[-70.641808,-33.556855],[-70.643083,-33.556694],[-70.643858,-33.556592],[-70.64406,-33.556566],[-70.644503,-33.556504],[-70.644936,-33.556444],[-70.645504,-33.556355],[-70.645922,-33.556295],[-70.646258,-33.556237],[-70.646596,-33.556178],[-70.646989,-33.556119],[-70.64741,-33.55605],[-70.648441,-33.555901],[-70.649178,-33.555792],[-70.65022,-33.555634],[-70.650647,-33.555574],[-70.651121,-33.555505],[-70.65151,-33.555446],[-70.651907,-33.555395],[-70.652429,-33.555325],[-70.653217,-33.555206],[-70.65343,-33.555175],[-70.65382,-33.555117],[-70.654708,-33.555],[-70.653793,-33.551134],[-70.653545,-33.550019],[-70.652861,-33.547608],[-70.652093,-33.544879],[-70.651776,-33.54362],[-70.650987,-33.540844],[-70.650915,-33.540186],[-70.651107,-33.539786],[-70.650859,-33.53891],[-70.648002,-33.528614],[-70.647708,-33.528234],[-70.647605,-33.527857],[-70.647098,-33.526054],[-70.64677,-33.52485],[-70.646622,-33.524293],[-70.646256,-33.523251],[-70.646191,-33.523032],[-70.645977,-33.522308],[-70.645709,-33.521311],[-70.645441,-33.520322],[-70.645343,-33.520025],[-70.645125,-33.51919],[-70.644893,-33.518364],[-70.644782,-33.517973],[-70.644675,-33.51757],[-70.644621,-33.517366],[-70.643279,-33.517636],[-70.641055,-33.51809],[-70.638867,-33.518525],[-70.638107,-33.51868]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1313,"DIS_ELEC":27,"NOM_COM":"San Ramón","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":6273609.9684,"SHAPE_LENG":11733.486709,"SHAPE_Le_1":11691.258791},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.712278,-33.482044],[-70.712003,-33.482447],[-70.712001,-33.482446],[-70.712001,-33.482448],[-70.711877,-33.482664],[-70.708856,-33.481982],[-70.708807,-33.481933],[-70.708654,-33.481936],[-70.705473,-33.481211],[-70.70315,-33.480627],[-70.702466,-33.480481],[-70.701918,-33.480374],[-70.701592,-33.480324],[-70.701246,-33.480271],[-70.700793,-33.480222],[-70.700227,-33.480154],[-70.699624,-33.480035],[-70.699072,-33.479922],[-70.698611,-33.479783],[-70.697924,-33.479567],[-70.697346,-33.479389],[-70.696587,-33.479154],[-70.695812,-33.478928],[-70.695005,-33.478725],[-70.693352,-33.478348],[-70.692154,-33.478099],[-70.691675,-33.478122],[-70.691673,-33.47812],[-70.691574,-33.478127],[-70.690741,-33.478223],[-70.687577,-33.478194],[-70.685697,-33.478108],[-70.685556,-33.478616],[-70.68563,-33.479779],[-70.686137,-33.482058],[-70.686889,-33.483615],[-70.688168,-33.486827],[-70.688542,-33.487532],[-70.688887,-33.488272],[-70.689157,-33.488909],[-70.689648,-33.489879],[-70.689946,-33.49062],[-70.690607,-33.492331],[-70.690968,-33.493243],[-70.691201,-33.493745],[-70.691897,-33.495178],[-70.693105,-33.497599],[-70.693236,-33.49787],[-70.694136,-33.49977],[-70.694185,-33.499758],[-70.695409,-33.502433],[-70.696599,-33.505035],[-70.696889,-33.505671],[-70.699911,-33.511764],[-70.702114,-33.516207],[-70.702341,-33.516668],[-70.703983,-33.520015],[-70.706002,-33.524131],[-70.706116,-33.52469],[-70.706233,-33.525378],[-70.706741,-33.531239],[-70.707298,-33.53103],[-70.715996,-33.527779],[-70.718247,-33.526942],[-70.718373,-33.526914],[-70.721796,-33.525636],[-70.724713,-33.524559],[-70.726397,-33.523914],[-70.723916,-33.520757],[-70.719855,-33.516129],[-70.718522,-33.514083],[-70.723336,-33.510035],[-70.730661,-33.509809],[-70.731296,-33.5098],[-70.732883,-33.509778],[-70.733927,-33.509764],[-70.740087,-33.510122],[-70.736833,-33.503535],[-70.735226,-33.499943],[-70.733924,-33.497354],[-70.733336,-33.496375],[-70.732236,-33.495329],[-70.731547,-33.494906],[-70.731456,-33.482758],[-70.731139,-33.482738],[-70.730593,-33.482844],[-70.730282,-33.482914],[-70.729817,-33.48315],[-70.729468,-33.483319],[-70.728999,-33.483358],[-70.72857,-33.483397],[-70.728099,-33.483305],[-70.727623,-33.483017],[-70.727305,-33.482759],[-70.726986,-33.482435],[-70.726631,-33.482276],[-70.726083,-33.482284],[-70.72581,-33.482321],[-70.725148,-33.482494],[-70.725145,-33.482486],[-70.72514,-33.482488],[-70.724673,-33.482679],[-70.724649,-33.481994],[-70.724522,-33.481493],[-70.724359,-33.481222],[-70.724164,-33.480964],[-70.723734,-33.480465],[-70.72354,-33.479949],[-70.723481,-33.47964],[-70.723299,-33.479199],[-70.723155,-33.477845],[-70.722961,-33.47682],[-70.722703,-33.475453],[-70.722495,-33.474344],[-70.722413,-33.47395],[-70.722312,-33.473602],[-70.722231,-33.473485],[-70.722321,-33.47341],[-70.722372,-33.473394],[-70.722406,-33.473384],[-70.722323,-33.473361],[-70.722006,-33.473448],[-70.721273,-33.474032],[-70.720149,-33.474935],[-70.719506,-33.475533],[-70.71873,-33.47625],[-70.717845,-33.477085],[-70.71775,-33.477221],[-70.716955,-33.477883],[-70.714866,-33.479742],[-70.712278,-33.482044]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1310,"DIS_ELEC":20,"NOM_COM":"Cerrillos","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":16615883.088,"SHAPE_LENG":20923.859235,"SHAPE_Le_1":20711.64664},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.719395,-33.413224],[-70.717425,-33.414454],[-70.716741,-33.414846],[-70.715919,-33.415124],[-70.716227,-33.415669],[-70.716358,-33.415877],[-70.716473,-33.416056],[-70.71657,-33.416215],[-70.716691,-33.416407],[-70.716709,-33.416574],[-70.716944,-33.41746],[-70.717067,-33.417962],[-70.717204,-33.418561],[-70.717815,-33.421159],[-70.71796,-33.421763],[-70.718097,-33.422373],[-70.718451,-33.423855],[-70.718487,-33.424002],[-70.718535,-33.424085],[-70.718592,-33.424254],[-70.719241,-33.426729],[-70.720003,-33.429636],[-70.720249,-33.430625],[-70.720509,-33.431832],[-70.720772,-33.433086],[-70.720903,-33.43367],[-70.720958,-33.433917],[-70.720987,-33.434048],[-70.721013,-33.434164],[-70.721237,-33.435216],[-70.721448,-33.436204],[-70.72154,-33.436637],[-70.721544,-33.436651],[-70.721461,-33.436629],[-70.721557,-33.436709],[-70.721646,-33.437026],[-70.721699,-33.437185],[-70.721868,-33.437597],[-70.722007,-33.437938],[-70.722163,-33.438324],[-70.722278,-33.438593],[-70.722405,-33.438934],[-70.722555,-33.438914],[-70.722558,-33.438921],[-70.722564,-33.438913],[-70.722986,-33.438788],[-70.723665,-33.438566],[-70.723869,-33.438271],[-70.724152,-33.437769],[-70.724208,-33.437686],[-70.724569,-33.437584],[-70.725108,-33.437466],[-70.725538,-33.437392],[-70.725982,-33.437322],[-70.726521,-33.437241],[-70.727154,-33.437124],[-70.728218,-33.436647],[-70.728705,-33.436435],[-70.728939,-33.436369],[-70.729459,-33.436353],[-70.729939,-33.436276],[-70.73021,-33.436252],[-70.730865,-33.436279],[-70.731458,-33.436298],[-70.732112,-33.436316],[-70.732682,-33.436344],[-70.733241,-33.436363],[-70.733896,-33.436381],[-70.734734,-33.436449],[-70.737694,-33.436398],[-70.740872,-33.436389],[-70.740901,-33.43639],[-70.740837,-33.433732],[-70.740819,-33.432122],[-70.740728,-33.430423],[-70.74077,-33.4299],[-70.741474,-33.429967],[-70.742781,-33.429916],[-70.743389,-33.429958],[-70.744137,-33.429961],[-70.745451,-33.429978],[-70.746686,-33.429974],[-70.74682,-33.429941],[-70.747646,-33.429781],[-70.748108,-33.429693],[-70.74861,-33.4296],[-70.748878,-33.429551],[-70.749639,-33.429302],[-70.749921,-33.429245],[-70.750544,-33.429119],[-70.751115,-33.428884],[-70.751781,-33.428561],[-70.751802,-33.428539],[-70.751935,-33.428487],[-70.752053,-33.428441],[-70.75204,-33.428438],[-70.752236,-33.428309],[-70.752372,-33.428249],[-70.753022,-33.428161],[-70.753732,-33.428078],[-70.754383,-33.428003],[-70.754528,-33.427955],[-70.75517,-33.427622],[-70.75554,-33.427477],[-70.755921,-33.427433],[-70.756048,-33.427401],[-70.756407,-33.427353],[-70.756536,-33.427363],[-70.756949,-33.427317],[-70.757336,-33.427335],[-70.758268,-33.427377],[-70.758629,-33.427393],[-70.759213,-33.42742],[-70.760054,-33.427465],[-70.760492,-33.427556],[-70.761084,-33.427684],[-70.7618,-33.427731],[-70.762347,-33.427723],[-70.762878,-33.427697],[-70.763274,-33.427581],[-70.763862,-33.427318],[-70.764811,-33.426867],[-70.765326,-33.426594],[-70.766085,-33.426187],[-70.766557,-33.42593],[-70.766651,-33.425894],[-70.766855,-33.426389],[-70.767096,-33.426842],[-70.767446,-33.426879],[-70.768698,-33.426408],[-70.769731,-33.425806],[-70.770265,-33.425776],[-70.771252,-33.425725],[-70.772094,-33.425655],[-70.772873,-33.425401],[-70.773637,-33.425153],[-70.775096,-33.424686],[-70.775655,-33.424495],[-70.776021,-33.424306],[-70.776541,-33.423919],[-70.776808,-33.423626],[-70.777125,-33.423094],[-70.777456,-33.422237],[-70.777723,-33.421528],[-70.777811,-33.421469],[-70.777811,-33.421449],[-70.777918,-33.42113],[-70.778251,-33.420745],[-70.778548,-33.420487],[-70.778999,-33.420322],[-70.779372,-33.420063],[-70.779927,-33.419452],[-70.780111,-33.419195],[-70.780256,-33.418908],[-70.780326,-33.418589],[-70.780398,-33.41843],[-70.780433,-33.418375],[-70.780435,-33.418366],[-70.780541,-33.418047],[-70.780725,-33.417759],[-70.78102,-33.417405],[-70.781356,-33.417179],[-70.781694,-33.417047],[-70.782453,-33.416888],[-70.782571,-33.413958],[-70.781584,-33.413931],[-70.780674,-33.413914],[-70.780093,-33.413922],[-70.779658,-33.413989],[-70.77926,-33.414086],[-70.778861,-33.414153],[-70.778389,-33.41419],[-70.777806,-33.414138],[-70.777404,-33.414052],[-70.77613,-33.413948],[-70.775257,-33.41393],[-70.774566,-33.41394],[-70.774096,-33.414069],[-70.773735,-33.414226],[-70.773304,-33.414477],[-70.77284,-33.41488],[-70.772515,-33.415006],[-70.772188,-33.415041],[-70.771823,-33.414955],[-70.771455,-33.414717],[-70.771123,-33.414508],[-70.770864,-33.414267],[-70.77068,-33.414179],[-70.770355,-33.414275],[-70.770323,-33.414519],[-70.770253,-33.414642],[-70.769964,-33.414707],[-70.769564,-33.414713],[-70.767739,-33.414404],[-70.767007,-33.41417],[-70.766312,-33.413936],[-70.765653,-33.413732],[-70.76452,-33.413443],[-70.76401,-33.413389],[-70.763462,-33.413275],[-70.762805,-33.413132],[-70.762294,-33.413048],[-70.761857,-33.413054],[-70.761384,-33.413],[-70.761005,-33.412926],[-70.760946,-33.412914],[-70.760397,-33.412739],[-70.759924,-33.412746],[-70.759888,-33.412747],[-70.75878,-33.412808],[-70.757439,-33.41301],[-70.756604,-33.413083],[-70.756168,-33.413089],[-70.755659,-33.413096],[-70.755039,-33.413013],[-70.754683,-33.412933],[-70.754527,-33.412899],[-70.754052,-33.412753],[-70.753251,-33.412703],[-70.751505,-33.412697],[-70.750524,-33.412742],[-70.748996,-33.412702],[-70.74816,-33.412714],[-70.746672,-33.412827],[-70.746382,-33.412892],[-70.745982,-33.412897],[-70.745652,-33.412749],[-70.745499,-33.412661],[-70.745395,-33.412601],[-70.745138,-33.412513],[-70.744446,-33.412431],[-70.743791,-33.41241],[-70.743277,-33.412441],[-70.740559,-33.412608],[-70.738374,-33.412455],[-70.737498,-33.412315],[-70.737097,-33.41226],[-70.736516,-33.412268],[-70.736262,-33.412332],[-70.735301,-33.412422],[-70.733848,-33.412534],[-70.733643,-33.412555],[-70.732506,-33.412675],[-70.731961,-33.412713],[-70.730295,-33.413041],[-70.72961,-33.413325],[-70.729107,-33.413667],[-70.728855,-33.413793],[-70.728384,-33.413891],[-70.727876,-33.413898],[-70.727436,-33.413721],[-70.725458,-33.412986],[-70.724065,-33.412457],[-70.723186,-33.412134],[-70.722814,-33.411924],[-70.722499,-33.411746],[-70.722147,-33.412077],[-70.721047,-33.412552],[-70.719395,-33.413224]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1310,"DIS_ELEC":18,"NOM_COM":"Cerro Navia","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":11066725.0326,"SHAPE_LENG":16740.508943,"SHAPE_Le_1":16760.796703},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.691403,-33.36596],[-70.691046,-33.365987],[-70.690859,-33.366018],[-70.69067,-33.366049],[-70.690313,-33.366108],[-70.68999,-33.366162],[-70.689723,-33.366204],[-70.689652,-33.36621],[-70.68953,-33.366219],[-70.689209,-33.366242],[-70.688903,-33.366272],[-70.688632,-33.366292],[-70.688507,-33.366294],[-70.688247,-33.366294],[-70.688117,-33.366292],[-70.687986,-33.366307],[-70.687868,-33.366275],[-70.687612,-33.366271],[-70.6864,-33.366351],[-70.685429,-33.366413],[-70.684889,-33.366457],[-70.68449,-33.36649],[-70.684136,-33.366517],[-70.683836,-33.366554],[-70.683581,-33.366596],[-70.683191,-33.366666],[-70.682932,-33.366722],[-70.682597,-33.366806],[-70.682245,-33.366904],[-70.681802,-33.367046],[-70.681452,-33.36718],[-70.680998,-33.367354],[-70.680725,-33.367459],[-70.680396,-33.367584],[-70.679668,-33.367853],[-70.679032,-33.368094],[-70.678303,-33.368364],[-70.677834,-33.368545],[-70.677226,-33.368774],[-70.675694,-33.369346],[-70.675265,-33.369507],[-70.673863,-33.370033],[-70.673102,-33.370322],[-70.672848,-33.370443],[-70.672328,-33.370692],[-70.672056,-33.370828],[-70.671821,-33.370916],[-70.671348,-33.371092],[-70.670935,-33.371258],[-70.670513,-33.371413],[-70.670022,-33.371583],[-70.669815,-33.37165],[-70.669641,-33.371706],[-70.669496,-33.371735],[-70.669341,-33.371766],[-70.66893,-33.371885],[-70.668182,-33.372158],[-70.6665,-33.372809],[-70.665026,-33.373359],[-70.662478,-33.374325],[-70.661726,-33.374611],[-70.66094,-33.374896],[-70.660467,-33.375063],[-70.660059,-33.37521],[-70.659244,-33.375517],[-70.658457,-33.375834],[-70.657643,-33.376225],[-70.656824,-33.376536],[-70.657034,-33.376885],[-70.657038,-33.376883],[-70.657625,-33.378027],[-70.657625,-33.37803],[-70.657673,-33.378183],[-70.657712,-33.378308],[-70.657733,-33.378398],[-70.65773,-33.378508],[-70.657726,-33.378768],[-70.657678,-33.379454],[-70.657629,-33.380483],[-70.657602,-33.380774],[-70.657571,-33.381469],[-70.657537,-33.382127],[-70.657485,-33.382853],[-70.657462,-33.383166],[-70.657339,-33.384322],[-70.657275,-33.384747],[-70.657229,-33.385115],[-70.657187,-33.385463],[-70.657169,-33.385832],[-70.657131,-33.38631],[-70.65712,-33.386782],[-70.657239,-33.387588],[-70.65727,-33.387811],[-70.657382,-33.388596],[-70.657403,-33.388839],[-70.657389,-33.389254],[-70.657341,-33.390496],[-70.657317,-33.391041],[-70.657258,-33.391637],[-70.657328,-33.391699],[-70.657155,-33.392071],[-70.657213,-33.392258],[-70.657203,-33.392512],[-70.657186,-33.392937],[-70.657259,-33.393418],[-70.657328,-33.393927],[-70.657426,-33.394819],[-70.657545,-33.395737],[-70.657556,-33.395944],[-70.657637,-33.396655],[-70.657655,-33.39685],[-70.657747,-33.397655],[-70.657865,-33.398429],[-70.657995,-33.398481],[-70.658021,-33.398582],[-70.658166,-33.399142],[-70.658274,-33.399559],[-70.658279,-33.399559],[-70.658289,-33.399705],[-70.661052,-33.399406],[-70.66261,-33.399252],[-70.663282,-33.399229],[-70.663672,-33.399337],[-70.663696,-33.399403],[-70.663717,-33.399401],[-70.664002,-33.399153],[-70.664461,-33.399116],[-70.665961,-33.398999],[-70.666704,-33.398954],[-70.667284,-33.399003],[-70.668154,-33.399126],[-70.667857,-33.399382],[-70.667078,-33.400055],[-70.667075,-33.400136],[-70.668363,-33.400146],[-70.668598,-33.400138],[-70.669504,-33.400156],[-70.671901,-33.400287],[-70.671934,-33.400219],[-70.671934,-33.400219],[-70.672176,-33.399716],[-70.673416,-33.400159],[-70.67495,-33.400724],[-70.676456,-33.401263],[-70.678045,-33.401846],[-70.678283,-33.401924],[-70.678983,-33.402185],[-70.680973,-33.40278],[-70.68167,-33.40294],[-70.681859,-33.403],[-70.683621,-33.400309],[-70.687325,-33.394163],[-70.689931,-33.389387],[-70.691197,-33.386577],[-70.693292,-33.381925],[-70.694549,-33.379115],[-70.695472,-33.377006],[-70.69611,-33.37558],[-70.69693,-33.37377],[-70.697697,-33.372403],[-70.697887,-33.371984],[-70.697949,-33.371626],[-70.699064,-33.369012],[-70.699592,-33.367913],[-70.699888,-33.367152],[-70.700292,-33.366223],[-70.700293,-33.366222],[-70.700316,-33.366169],[-70.700196,-33.366133],[-70.699667,-33.365994],[-70.699372,-33.365939],[-70.698601,-33.365888],[-70.698265,-33.365888],[-70.697845,-33.365897],[-70.697785,-33.365906],[-70.697647,-33.365916],[-70.695806,-33.365908],[-70.695113,-33.365901],[-70.694852,-33.365898],[-70.694683,-33.365896],[-70.694549,-33.365913],[-70.694466,-33.365923],[-70.693637,-33.365914],[-70.692965,-33.365907],[-70.692569,-33.365903],[-70.691839,-33.365918],[-70.691403,-33.36596]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1310,"DIS_ELEC":17,"NOM_COM":"Conchalí","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":10995118.1726,"SHAPE_LENG":13816.634388,"SHAPE_Le_1":13929.214753},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.66324,-33.585164],[-70.663398,-33.5851],[-70.666637,-33.584461],[-70.670776,-33.58363],[-70.671112,-33.583559],[-70.674839,-33.582802],[-70.675866,-33.582596],[-70.676674,-33.582439],[-70.67835,-33.581841],[-70.67983,-33.581244],[-70.680817,-33.580834],[-70.682869,-33.580057],[-70.685202,-33.579097],[-70.687128,-33.578358],[-70.689298,-33.577496],[-70.691061,-33.576789],[-70.692128,-33.576342],[-70.694675,-33.575404],[-70.69558,-33.574987],[-70.696254,-33.574725],[-70.696418,-33.574658],[-70.696942,-33.574445],[-70.697325,-33.574314],[-70.697718,-33.574164],[-70.698793,-33.573752],[-70.69974,-33.573379],[-70.700792,-33.572967],[-70.700798,-33.572966],[-70.700478,-33.572304],[-70.700267,-33.571829],[-70.700055,-33.571372],[-70.699851,-33.570912],[-70.699626,-33.570413],[-70.699346,-33.569858],[-70.69925,-33.569558],[-70.698975,-33.56897],[-70.698686,-33.568337],[-70.69802,-33.566888],[-70.69741,-33.565529],[-70.697432,-33.565493],[-70.697093,-33.56483],[-70.696819,-33.563818],[-70.69705,-33.563721],[-70.697018,-33.563154],[-70.696664,-33.561102],[-70.696287,-33.559773],[-70.69603,-33.55857],[-70.695673,-33.5569],[-70.69546,-33.555897],[-70.69441,-33.555968],[-70.693071,-33.55613],[-70.692918,-33.55613],[-70.691948,-33.553601],[-70.691926,-33.553611],[-70.691384,-33.552427],[-70.691195,-33.552006],[-70.691004,-33.551576],[-70.690715,-33.550975],[-70.690449,-33.550357],[-70.690254,-33.549935],[-70.690063,-33.549496],[-70.689907,-33.549156],[-70.689585,-33.548448],[-70.68944,-33.548125],[-70.689042,-33.547256],[-70.688012,-33.544941],[-70.687902,-33.544704],[-70.687397,-33.543617],[-70.68688,-33.54253],[-70.686596,-33.541968],[-70.686574,-33.541806],[-70.686403,-33.541574],[-70.686248,-33.541252],[-70.68624,-33.541171],[-70.686304,-33.541179],[-70.686481,-33.541294],[-70.686595,-33.541391],[-70.686872,-33.541668],[-70.687054,-33.541836],[-70.687397,-33.542039],[-70.687611,-33.542144],[-70.687395,-33.541921],[-70.687356,-33.541888],[-70.687355,-33.541885],[-70.687352,-33.541884],[-70.68727,-33.541815],[-70.687248,-33.541734],[-70.687087,-33.541575],[-70.686769,-33.541263],[-70.686607,-33.54108],[-70.686499,-33.540959],[-70.686385,-33.540809],[-70.686118,-33.54046],[-70.686038,-33.540371],[-70.68589,-33.540066],[-70.685536,-33.539398],[-70.685533,-33.539399],[-70.685382,-33.539118],[-70.68456,-33.539429],[-70.683713,-33.539726],[-70.682075,-33.540334],[-70.681118,-33.540672],[-70.680424,-33.540934],[-70.680039,-33.541075],[-70.679369,-33.541327],[-70.67864,-33.54159],[-70.678129,-33.541777],[-70.677628,-33.541964],[-70.677137,-33.542142],[-70.676632,-33.542313],[-70.676074,-33.54251],[-70.675778,-33.542618],[-70.675357,-33.542775],[-70.674779,-33.542984],[-70.674588,-33.543053],[-70.673582,-33.543416],[-70.672624,-33.543763],[-70.672102,-33.54396],[-70.671413,-33.544214],[-70.671091,-33.544333],[-70.670305,-33.544624],[-70.669683,-33.544859],[-70.668761,-33.545206],[-70.668385,-33.545348],[-70.66825,-33.545399],[-70.668086,-33.545615],[-70.667726,-33.54581],[-70.66695,-33.546232],[-70.666665,-33.546369],[-70.665527,-33.546566],[-70.664653,-33.546713],[-70.664133,-33.546801],[-70.663978,-33.54683],[-70.663097,-33.546975],[-70.661513,-33.547241],[-70.659083,-33.547649],[-70.657957,-33.547826],[-70.657548,-33.547892],[-70.65678,-33.548023],[-70.656816,-33.548169],[-70.656804,-33.54817],[-70.656805,-33.548218],[-70.654688,-33.548573],[-70.65453,-33.548577],[-70.653508,-33.548761],[-70.653503,-33.548744],[-70.653197,-33.548791],[-70.653545,-33.550019],[-70.653793,-33.551134],[-70.654708,-33.555],[-70.654881,-33.554977],[-70.654938,-33.554955],[-70.655131,-33.555839],[-70.65579,-33.558175],[-70.656788,-33.562547],[-70.658609,-33.56875],[-70.659299,-33.571517],[-70.659933,-33.573778],[-70.660113,-33.573881],[-70.660685,-33.575667],[-70.661861,-33.580188],[-70.66251,-33.582413],[-70.662819,-33.583885],[-70.66324,-33.585164]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1310,"DIS_ELEC":27,"NOM_COM":"El Bosque","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":14269674.911,"SHAPE_LENG":15584.863877,"SHAPE_Le_1":15718.802301},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.541708,-33.512531],[-70.542012,-33.512533],[-70.542676,-33.512485],[-70.543814,-33.512411],[-70.544464,-33.512435],[-70.545075,-33.512483],[-70.546703,-33.51242],[-70.548884,-33.512312],[-70.550676,-33.512208],[-70.551823,-33.512167],[-70.554931,-33.512032],[-70.555078,-33.512081],[-70.557097,-33.511896],[-70.560724,-33.511678],[-70.561552,-33.511628],[-70.564705,-33.511447],[-70.56559,-33.511542],[-70.566434,-33.511637],[-70.570663,-33.511366],[-70.571051,-33.511308],[-70.572593,-33.511181],[-70.574636,-33.510959],[-70.576158,-33.510762],[-70.579929,-33.510642],[-70.58501,-33.510194],[-70.5871,-33.510042],[-70.587954,-33.510168],[-70.588179,-33.510292],[-70.588983,-33.510233],[-70.590003,-33.510157],[-70.589948,-33.509182],[-70.589907,-33.508931],[-70.589655,-33.506851],[-70.589534,-33.50609],[-70.587262,-33.50031],[-70.584109,-33.495375],[-70.584082,-33.495335],[-70.582695,-33.493124],[-70.581662,-33.491475],[-70.5811,-33.490625],[-70.580775,-33.489989],[-70.580844,-33.489858],[-70.580585,-33.489216],[-70.580552,-33.488975],[-70.580433,-33.4881],[-70.580369,-33.488019],[-70.579959,-33.485573],[-70.579553,-33.483631],[-70.578651,-33.47934],[-70.577826,-33.475389],[-70.576819,-33.470265],[-70.576298,-33.468807],[-70.57491,-33.465335],[-70.57407,-33.463398],[-70.573851,-33.462811],[-70.572592,-33.460034],[-70.57225,-33.459013],[-70.572135,-33.459057],[-70.571464,-33.459264],[-70.571184,-33.459362],[-70.570565,-33.459573],[-70.570019,-33.459781],[-70.569773,-33.459881],[-70.569199,-33.460104],[-70.568946,-33.460212],[-70.568199,-33.460487],[-70.567742,-33.460656],[-70.567172,-33.46087],[-70.56581,-33.461326],[-70.565397,-33.461469],[-70.565196,-33.461574],[-70.565111,-33.461568],[-70.564505,-33.46176],[-70.56402,-33.461931],[-70.563567,-33.462087],[-70.563076,-33.462256],[-70.562963,-33.462294],[-70.56256,-33.462425],[-70.562347,-33.462482],[-70.562222,-33.462501],[-70.56204,-33.462522],[-70.561481,-33.462529],[-70.561218,-33.462529],[-70.560906,-33.462532],[-70.56048,-33.462532],[-70.560183,-33.462545],[-70.559431,-33.462569],[-70.55783,-33.462575],[-70.556579,-33.462598],[-70.556362,-33.462602],[-70.5549,-33.4626],[-70.553537,-33.462608],[-70.552946,-33.462615],[-70.551662,-33.462632],[-70.550898,-33.462639],[-70.550567,-33.462713],[-70.549893,-33.462835],[-70.548678,-33.463043],[-70.547613,-33.463223],[-70.546061,-33.463435],[-70.54549,-33.463505],[-70.54482,-33.463591],[-70.544206,-33.463644],[-70.54417,-33.463658],[-70.543465,-33.463389],[-70.543406,-33.463376],[-70.543202,-33.463284],[-70.543031,-33.463207],[-70.542754,-33.463082],[-70.542392,-33.462918],[-70.542268,-33.462868],[-70.542005,-33.46286],[-70.541687,-33.462867],[-70.541506,-33.462864],[-70.540351,-33.462962],[-70.540054,-33.462994],[-70.539789,-33.463067],[-70.538987,-33.463288],[-70.538524,-33.463428],[-70.538077,-33.463553],[-70.537614,-33.46369],[-70.537114,-33.463828],[-70.536691,-33.463954],[-70.536012,-33.464143],[-70.535878,-33.464181],[-70.535666,-33.464237],[-70.53436,-33.464614],[-70.533087,-33.464973],[-70.532369,-33.465171],[-70.531994,-33.465275],[-70.531425,-33.465446],[-70.531424,-33.465445],[-70.531423,-33.465447],[-70.531246,-33.465439],[-70.531092,-33.465185],[-70.531006,-33.465044],[-70.530956,-33.464925],[-70.53087,-33.464679],[-70.53064,-33.464008],[-70.530562,-33.463748],[-70.530564,-33.463409],[-70.53056,-33.463315],[-70.530546,-33.462992],[-70.530511,-33.462794],[-70.530405,-33.462292],[-70.53037,-33.462051],[-70.530305,-33.461694],[-70.53021,-33.461314],[-70.530038,-33.460875],[-70.529938,-33.460638],[-70.529911,-33.460333],[-70.529904,-33.460196],[-70.529881,-33.46011],[-70.52981,-33.459974],[-70.529713,-33.45981],[-70.529637,-33.459682],[-70.529579,-33.459542],[-70.529563,-33.45945],[-70.529538,-33.459451],[-70.529547,-33.459431],[-70.529536,-33.459294],[-70.529549,-33.459141],[-70.529341,-33.459134],[-70.529031,-33.459147],[-70.527749,-33.459233],[-70.526964,-33.459286],[-70.526415,-33.459316],[-70.525859,-33.459352],[-70.525463,-33.459376],[-70.524625,-33.459426],[-70.523856,-33.459469],[-70.523099,-33.459511],[-70.522418,-33.45956],[-70.522013,-33.45959],[-70.521918,-33.459596],[-70.521401,-33.459599],[-70.51872,-33.459925],[-70.518444,-33.459982],[-70.518204,-33.460011],[-70.516039,-33.460037],[-70.511485,-33.46034],[-70.507286,-33.460815],[-70.507116,-33.460842],[-70.503684,-33.461093],[-70.493726,-33.461566],[-70.486946,-33.461752],[-70.486934,-33.46201],[-70.486786,-33.462503],[-70.486485,-33.463195],[-70.485793,-33.463859],[-70.484316,-33.464434],[-70.483543,-33.465001],[-70.482541,-33.465865],[-70.481886,-33.466463],[-70.478802,-33.469123],[-70.477919,-33.470084],[-70.477498,-33.470647],[-70.477234,-33.471207],[-70.477043,-33.471504],[-70.476738,-33.471934],[-70.476044,-33.472565],[-70.475044,-33.473593],[-70.474271,-33.474095],[-70.473576,-33.47466],[-70.472956,-33.474995],[-70.472413,-33.475297],[-70.472063,-33.475408],[-70.471985,-33.475433],[-70.471633,-33.475404],[-70.47128,-33.475376],[-70.470693,-33.47535],[-70.469598,-33.475396],[-70.468853,-33.475306],[-70.468384,-33.475312],[-70.467993,-33.475316],[-70.467563,-33.475354],[-70.467212,-33.475391],[-70.466742,-33.475397],[-70.466156,-33.475404],[-70.465725,-33.475409],[-70.464906,-33.47555],[-70.464048,-33.475691],[-70.463345,-33.475765],[-70.46229,-33.47581],[-70.461704,-33.475883],[-70.46112,-33.476053],[-70.460695,-33.476353],[-70.460076,-33.476754],[-70.459305,-33.477484],[-70.458533,-33.478084],[-70.457216,-33.478886],[-70.456522,-33.479451],[-70.455942,-33.479884],[-70.455128,-33.48032],[-70.454392,-33.480755],[-70.453542,-33.481388],[-70.452962,-33.481788],[-70.452112,-33.482454],[-70.451295,-33.482758],[-70.450594,-33.482931],[-70.449972,-33.483167],[-70.449701,-33.483334],[-70.448887,-33.483803],[-70.447959,-33.484469],[-70.446873,-33.485039],[-70.445862,-33.485412],[-70.444846,-33.485489],[-70.443948,-33.485598],[-70.443208,-33.485803],[-70.442624,-33.485941],[-70.441651,-33.486281],[-70.440714,-33.486423],[-70.439778,-33.486597],[-70.439152,-33.486605],[-70.439024,-33.487111],[-70.439035,-33.487765],[-70.439046,-33.488419],[-70.438773,-33.489077],[-70.438355,-33.489557],[-70.437939,-33.490157],[-70.437881,-33.490931],[-70.437901,-33.492155],[-70.438253,-33.492151],[-70.439462,-33.492062],[-70.440359,-33.492051],[-70.4413,-33.49204],[-70.442245,-33.492217],[-70.443189,-33.492319],[-70.443954,-33.492498],[-70.444585,-33.492678],[-70.444993,-33.492974],[-70.445491,-33.493231],[-70.446079,-33.493525],[-70.4468,-33.493742],[-70.447339,-33.493811],[-70.447791,-33.493993],[-70.448288,-33.494213],[-70.448606,-33.494473],[-70.449059,-33.49473],[-70.44942,-33.494876],[-70.449826,-33.495022],[-70.450098,-33.495169],[-70.450371,-33.495429],[-70.4506,-33.495689],[-70.450781,-33.495837],[-70.451097,-33.495909],[-70.451635,-33.495902],[-70.452038,-33.49586],[-70.452484,-33.495742],[-70.452708,-33.49574],[-70.453157,-33.495772],[-70.453652,-33.495841],[-70.454547,-33.495718],[-70.456026,-33.495663],[-70.457053,-33.495388],[-70.457721,-33.495117],[-70.458297,-33.494697],[-70.458741,-33.494429],[-70.459278,-33.494347],[-70.459726,-33.494342],[-70.460664,-33.494143],[-70.46111,-33.493987],[-70.461689,-33.493755],[-70.461999,-33.493526],[-70.462218,-33.493185],[-70.462481,-33.492844],[-70.462701,-33.492578],[-70.463101,-33.492386],[-70.46346,-33.492382],[-70.463775,-33.492415],[-70.464494,-33.49252],[-70.4653,-33.492435],[-70.46579,-33.492279],[-70.466281,-33.492123],[-70.466729,-33.492118],[-70.467,-33.492227],[-70.467497,-33.492447],[-70.467907,-33.492817],[-70.468412,-33.493488],[-70.469059,-33.494645],[-70.469517,-33.495166],[-70.469969,-33.495386],[-70.470329,-33.495457],[-70.47064,-33.495303],[-70.471221,-33.495183],[-70.47171,-33.494914],[-70.471978,-33.494836],[-70.472427,-33.494868],[-70.472743,-33.495015],[-70.473015,-33.495162],[-70.473419,-33.495194],[-70.473867,-33.495152],[-70.474315,-33.495184],[-70.474855,-33.495252],[-70.475842,-33.495278],[-70.476785,-33.495342],[-70.47719,-33.49545],[-70.477507,-33.495634],[-70.477872,-33.495968],[-70.478056,-33.496229],[-70.478555,-33.496561],[-70.478916,-33.496707],[-70.479278,-33.496891],[-70.479594,-33.497],[-70.480136,-33.497219],[-70.480765,-33.497324],[-70.481082,-33.497508],[-70.481267,-33.497806],[-70.481451,-33.498105],[-70.481768,-33.498289],[-70.482175,-33.498472],[-70.482493,-33.498731],[-70.482676,-33.498917],[-70.482949,-33.499176],[-70.483176,-33.499324],[-70.483627,-33.499469],[-70.484033,-33.499577],[-70.48435,-33.499761],[-70.484533,-33.499984],[-70.484671,-33.500208],[-70.484722,-33.500545],[-70.484728,-33.500884],[-70.48491,-33.501069],[-70.485231,-33.501441],[-70.485682,-33.501624],[-70.486221,-33.501655],[-70.488374,-33.501666],[-70.488955,-33.501547],[-70.489263,-33.501167],[-70.489438,-33.50094],[-70.489883,-33.500709],[-70.490421,-33.500702],[-70.490735,-33.500736],[-70.491052,-33.500883],[-70.491368,-33.501029],[-70.491727,-33.501062],[-70.492039,-33.500946],[-70.492349,-33.500717],[-70.492388,-33.500378],[-70.492517,-33.500038],[-70.492871,-33.499734],[-70.493228,-33.499654],[-70.493675,-33.499574],[-70.494348,-33.499565],[-70.495021,-33.499557],[-70.495559,-33.499551],[-70.495917,-33.499509],[-70.496541,-33.499276],[-70.497118,-33.498931],[-70.497649,-33.498549],[-70.498404,-33.498089],[-70.499206,-33.497778],[-70.499744,-33.497809],[-70.50015,-33.497917],[-70.500378,-33.49814],[-70.500562,-33.498438],[-70.500657,-33.498738],[-70.500667,-33.499264],[-70.500496,-33.499754],[-70.500503,-33.500205],[-70.500865,-33.500388],[-70.501356,-33.500232],[-70.501621,-33.500003],[-70.502289,-33.499695],[-70.502915,-33.499612],[-70.503499,-33.499643],[-70.504352,-33.499707],[-70.504893,-33.499851],[-70.506016,-33.499988],[-70.506557,-33.500131],[-70.506918,-33.500277],[-70.507324,-33.500423],[-70.508631,-33.500745],[-70.509443,-33.501036],[-70.509984,-33.501179],[-70.511152,-33.501316],[-70.5116,-33.50131],[-70.512498,-33.501337],[-70.513084,-33.50148],[-70.513579,-33.501586],[-70.514164,-33.501692],[-70.514749,-33.501835],[-70.515333,-33.501866],[-70.516007,-33.501932],[-70.516322,-33.502004],[-70.516729,-33.502187],[-70.517046,-33.502408],[-70.517275,-33.502668],[-70.517461,-33.503004],[-70.517828,-33.503488],[-70.518418,-33.503894],[-70.519419,-33.504709],[-70.522136,-33.506178],[-70.522955,-33.506845],[-70.523868,-33.507735],[-70.524141,-33.507995],[-70.52464,-33.508289],[-70.525134,-33.508321],[-70.525671,-33.508277],[-70.526389,-33.508268],[-70.527018,-33.508335],[-70.527737,-33.508439],[-70.528503,-33.508617],[-70.529902,-33.509089],[-70.530847,-33.509302],[-70.531568,-33.509481],[-70.532246,-33.509774],[-70.536125,-33.510966],[-70.537206,-33.511253],[-70.537793,-33.511471],[-70.538337,-33.511802],[-70.53888,-33.512059],[-70.539331,-33.512166],[-70.539916,-33.512271],[-70.540635,-33.512337],[-70.541173,-33.512368],[-70.541444,-33.51244],[-70.541708,-33.512531]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1312,"DIS_ELEC":24,"NOM_COM":"Peñalolén","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":53468188.467,"SHAPE_LENG":36618.971694,"SHAPE_Le_1":36636.812998},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.584838,-33.431258],[-70.584445,-33.431783],[-70.584433,-33.431783],[-70.584312,-33.431963],[-70.583932,-33.432442],[-70.583515,-33.432833],[-70.582749,-33.43345],[-70.582241,-33.433775],[-70.582247,-33.433785],[-70.582464,-33.434107],[-70.582587,-33.434245],[-70.582611,-33.434273],[-70.582716,-33.434391],[-70.582984,-33.434692],[-70.583099,-33.434821],[-70.58385,-33.435677],[-70.584619,-33.436533],[-70.58508,-33.437032],[-70.585366,-33.437371],[-70.58604,-33.43812],[-70.586663,-33.438822],[-70.586816,-33.438998],[-70.587,-33.439208],[-70.587059,-33.439283],[-70.587175,-33.439431],[-70.587273,-33.439581],[-70.587348,-33.439692],[-70.587447,-33.439841],[-70.587531,-33.439967],[-70.587622,-33.440103],[-70.587675,-33.440183],[-70.587781,-33.440357],[-70.587847,-33.440456],[-70.587915,-33.440558],[-70.587959,-33.440624],[-70.588066,-33.440783],[-70.588196,-33.440978],[-70.588603,-33.441631],[-70.588655,-33.441694],[-70.58872,-33.441797],[-70.588952,-33.442163],[-70.589509,-33.443044],[-70.589937,-33.443721],[-70.59048,-33.444571],[-70.590831,-33.445176],[-70.591068,-33.445508],[-70.591093,-33.445555],[-70.591125,-33.445615],[-70.591155,-33.445675],[-70.591166,-33.445714],[-70.591172,-33.445741],[-70.591233,-33.445784],[-70.591261,-33.445803],[-70.591312,-33.445873],[-70.591331,-33.445907],[-70.591351,-33.445943],[-70.591364,-33.445963],[-70.591402,-33.446021],[-70.591442,-33.446082],[-70.591491,-33.446156],[-70.591618,-33.44635],[-70.591697,-33.44647],[-70.591763,-33.446547],[-70.592027,-33.446857],[-70.592035,-33.446858],[-70.59207,-33.446907],[-70.592261,-33.44713],[-70.592385,-33.447275],[-70.592552,-33.447471],[-70.592718,-33.447666],[-70.592792,-33.447771],[-70.594188,-33.44702],[-70.594495,-33.446858],[-70.596105,-33.44599],[-70.596697,-33.445618],[-70.596989,-33.445435],[-70.59724,-33.445245],[-70.597425,-33.445143],[-70.597953,-33.444839],[-70.5981,-33.444801],[-70.598263,-33.444835],[-70.598871,-33.444896],[-70.599137,-33.444923],[-70.599183,-33.444679],[-70.599963,-33.444749],[-70.600409,-33.44479],[-70.600606,-33.444808],[-70.601095,-33.444852],[-70.601657,-33.444899],[-70.602211,-33.444955],[-70.602895,-33.445027],[-70.603868,-33.445127],[-70.60437,-33.445177],[-70.605219,-33.445296],[-70.606161,-33.445428],[-70.606375,-33.445452],[-70.607163,-33.44554],[-70.608128,-33.445645],[-70.608765,-33.445744],[-70.609457,-33.445929],[-70.609471,-33.445949],[-70.60975,-33.446011],[-70.609779,-33.44602],[-70.610347,-33.44619],[-70.610753,-33.446307],[-70.611211,-33.44644],[-70.611311,-33.446452],[-70.612311,-33.446599],[-70.612592,-33.446641],[-70.612744,-33.446663],[-70.612984,-33.446699],[-70.613151,-33.446723],[-70.613244,-33.446737],[-70.613471,-33.446771],[-70.61389,-33.446833],[-70.613826,-33.447172],[-70.613809,-33.447252],[-70.613744,-33.447565],[-70.614031,-33.447611],[-70.614031,-33.447611],[-70.614031,-33.447614],[-70.616516,-33.448034],[-70.617101,-33.448135],[-70.617814,-33.448266],[-70.618432,-33.448377],[-70.618637,-33.447646],[-70.618764,-33.447265],[-70.61985,-33.447486],[-70.620901,-33.447688],[-70.622248,-33.447959],[-70.623237,-33.448163],[-70.623719,-33.448256],[-70.625131,-33.44854],[-70.625359,-33.448574],[-70.62624,-33.448791],[-70.626766,-33.448919],[-70.626879,-33.448936],[-70.627983,-33.449147],[-70.628945,-33.449341],[-70.630253,-33.449593],[-70.631355,-33.449808],[-70.631526,-33.449836],[-70.632851,-33.445412],[-70.634578,-33.439573],[-70.634764,-33.438885],[-70.635288,-33.436885],[-70.63538,-33.436424],[-70.635354,-33.436217],[-70.635371,-33.435702],[-70.635411,-33.435474],[-70.635526,-33.434824],[-70.635645,-33.434172],[-70.635793,-33.433361],[-70.635951,-33.43246],[-70.636048,-33.431913],[-70.636219,-33.430893],[-70.636242,-33.430767],[-70.636055,-33.43012],[-70.636014,-33.429796],[-70.636144,-33.429595],[-70.63611,-33.429527],[-70.635773,-33.429287],[-70.63552,-33.429082],[-70.635222,-33.428667],[-70.635049,-33.428321],[-70.634914,-33.427766],[-70.634776,-33.427071],[-70.634727,-33.426688],[-70.634378,-33.425787],[-70.633558,-33.42416],[-70.632692,-33.42229],[-70.63252,-33.421944],[-70.632347,-33.421598],[-70.632269,-33.421526],[-70.632051,-33.421323],[-70.631713,-33.421014],[-70.630746,-33.4204],[-70.630323,-33.420022],[-70.629738,-33.419821],[-70.629404,-33.419755],[-70.628906,-33.419762],[-70.628447,-33.419698],[-70.627656,-33.419604],[-70.627113,-33.419437],[-70.625308,-33.418415],[-70.622401,-33.416259],[-70.620203,-33.414267],[-70.6191,-33.413027],[-70.61829,-33.411888],[-70.617906,-33.411335],[-70.617441,-33.410923],[-70.61722,-33.41071],[-70.616764,-33.41027],[-70.614542,-33.409165],[-70.605924,-33.409277],[-70.605869,-33.409278],[-70.606527,-33.410696],[-70.607306,-33.413491],[-70.607872,-33.415484],[-70.606608,-33.416047],[-70.606228,-33.416264],[-70.605005,-33.416899],[-70.604668,-33.417057],[-70.604253,-33.417125],[-70.603749,-33.417186],[-70.603412,-33.417208],[-70.602567,-33.417372],[-70.602233,-33.417503],[-70.601722,-33.417762],[-70.601555,-33.417981],[-70.60139,-33.418307],[-70.601028,-33.418664],[-70.600562,-33.419023],[-70.600059,-33.419401],[-70.599161,-33.420032],[-70.597881,-33.42077],[-70.595826,-33.422328],[-70.593279,-33.424377],[-70.5913,-33.42587],[-70.589373,-33.427404],[-70.58742,-33.428939],[-70.586029,-33.430251],[-70.585394,-33.430712],[-70.584838,-33.431258]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1312,"DIS_ELEC":21,"NOM_COM":"Providencia","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":14396522.8137,"SHAPE_LENG":16072.408275,"SHAPE_Le_1":16020.575436},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.768771,-33.376275],[-70.770779,-33.37492],[-70.774804,-33.37187],[-70.779611,-33.367899],[-70.784004,-33.36482],[-70.789777,-33.360476],[-70.792973,-33.358053],[-70.795538,-33.356131],[-70.797255,-33.354841],[-70.799649,-33.353041],[-70.802189,-33.35126],[-70.803288,-33.350716],[-70.80364,-33.350476],[-70.8036,-33.350377],[-70.803284,-33.349844],[-70.802109,-33.348192],[-70.801878,-33.347701],[-70.801465,-33.347336],[-70.801063,-33.347057],[-70.800942,-33.346973],[-70.800308,-33.346451],[-70.79942,-33.345696],[-70.79932,-33.345611],[-70.798794,-33.344902],[-70.798543,-33.343761],[-70.798469,-33.342951],[-70.798037,-33.341287],[-70.797784,-33.340049],[-70.797771,-33.339411],[-70.797762,-33.338952],[-70.797876,-33.338472],[-70.793499,-33.341265],[-70.79349,-33.341266],[-70.766188,-33.335199],[-70.759903,-33.333701],[-70.756943,-33.333033],[-70.756908,-33.333015],[-70.756869,-33.333044],[-70.75279,-33.332092],[-70.75279,-33.332092],[-70.745582,-33.330426],[-70.732218,-33.32739],[-70.732092,-33.327329],[-70.731646,-33.327335],[-70.730174,-33.327053],[-70.729346,-33.326843],[-70.729274,-33.326824],[-70.72925,-33.326812],[-70.728967,-33.326721],[-70.727929,-33.326311],[-70.726943,-33.326343],[-70.726563,-33.326254],[-70.726509,-33.326271],[-70.726513,-33.326242],[-70.723959,-33.325667],[-70.719484,-33.324811],[-70.718833,-33.324609],[-70.718258,-33.325887],[-70.715983,-33.325192],[-70.713172,-33.324298],[-70.710405,-33.323426],[-70.708496,-33.322818],[-70.708285,-33.322698],[-70.708987,-33.32114],[-70.709614,-33.320148],[-70.70975,-33.319993],[-70.710281,-33.319661],[-70.710999,-33.319219],[-70.711057,-33.319101],[-70.710731,-33.318969],[-70.709898,-33.318927],[-70.708935,-33.318833],[-70.707975,-33.318846],[-70.707272,-33.318909],[-70.706508,-33.319135],[-70.704916,-33.319587],[-70.703383,-33.319823],[-70.702299,-33.320053],[-70.70083,-33.320234],[-70.69949,-33.320468],[-70.698155,-33.32097],[-70.696603,-33.322002],[-70.69626,-33.322386],[-70.695807,-33.322927],[-70.695179,-33.323422],[-70.694662,-33.323672],[-70.693365,-33.323982],[-70.692669,-33.323991],[-70.692091,-33.324048],[-70.691573,-33.324201],[-70.690942,-33.32455],[-70.690604,-33.325041],[-70.690438,-33.325432],[-70.690446,-33.32587],[-70.690185,-33.327381],[-70.689966,-33.328017],[-70.68974,-33.328312],[-70.689398,-33.328608],[-70.689053,-33.328759],[-70.688534,-33.328863],[-70.688128,-33.328869],[-70.687839,-33.328873],[-70.68743,-33.328732],[-70.687025,-33.328738],[-70.686678,-33.328791],[-70.68622,-33.329089],[-70.68582,-33.329338],[-70.685418,-33.329538],[-70.685014,-33.329641],[-70.684608,-33.329598],[-70.684371,-33.329358],[-70.684079,-33.329216],[-70.683731,-33.32922],[-70.683446,-33.329467],[-70.683298,-33.329651],[-70.683247,-33.329662],[-70.682767,-33.329736],[-70.682592,-33.330085],[-70.682407,-33.33061],[-70.682077,-33.330865],[-70.6817,-33.330987],[-70.681291,-33.330999],[-70.681408,-33.331359],[-70.681518,-33.331764],[-70.681548,-33.332058],[-70.681442,-33.332424],[-70.681297,-33.332711],[-70.681199,-33.332929],[-70.681052,-33.333252],[-70.680939,-33.333762],[-70.680876,-33.334165],[-70.680896,-33.334639],[-70.680965,-33.335011],[-70.681163,-33.335419],[-70.681147,-33.335751],[-70.680999,-33.336075],[-70.680851,-33.336435],[-70.680614,-33.336796],[-70.680289,-33.337186],[-70.680097,-33.337548],[-70.680088,-33.337733],[-70.680202,-33.338074],[-70.680406,-33.338379],[-70.680859,-33.338669],[-70.68135,-33.338993],[-70.681764,-33.339246],[-70.682225,-33.339577],[-70.682688,-33.339873],[-70.683205,-33.340089],[-70.683906,-33.340294],[-70.684628,-33.340472],[-70.685248,-33.340678],[-70.685622,-33.340916],[-70.685854,-33.341145],[-70.686161,-33.341408],[-70.686446,-33.341706],[-70.686824,-33.342012],[-70.687204,-33.342282],[-70.687445,-33.342552],[-70.68758,-33.342904],[-70.687618,-33.343171],[-70.687605,-33.343431],[-70.6876,-33.343742],[-70.687607,-33.344004],[-70.687652,-33.344321],[-70.687694,-33.3447],[-70.687764,-33.345135],[-70.687845,-33.345557],[-70.687952,-33.345858],[-70.688098,-33.346178],[-70.688343,-33.346579],[-70.688552,-33.346906],[-70.688691,-33.347491],[-70.690346,-33.349171],[-70.692523,-33.350892],[-70.693358,-33.351607],[-70.693193,-33.351988],[-70.692979,-33.352462],[-70.6928,-33.352915],[-70.692554,-33.353762],[-70.692447,-33.354294],[-70.692269,-33.355255],[-70.692175,-33.35563],[-70.692045,-33.355858],[-70.691931,-33.356347],[-70.691475,-33.357769],[-70.690996,-33.35911],[-70.690701,-33.359926],[-70.690542,-33.360397],[-70.690116,-33.361548],[-70.689438,-33.363803],[-70.689281,-33.3648],[-70.689206,-33.365574],[-70.689282,-33.366237],[-70.68953,-33.366219],[-70.689652,-33.36621],[-70.689723,-33.366204],[-70.68999,-33.366162],[-70.690313,-33.366108],[-70.69067,-33.366049],[-70.690859,-33.366018],[-70.691046,-33.365987],[-70.691403,-33.36596],[-70.691839,-33.365918],[-70.692569,-33.365903],[-70.692965,-33.365907],[-70.693637,-33.365914],[-70.694466,-33.365923],[-70.694549,-33.365913],[-70.694683,-33.365896],[-70.694852,-33.365898],[-70.695113,-33.365901],[-70.695806,-33.365908],[-70.697647,-33.365916],[-70.697785,-33.365906],[-70.697845,-33.365897],[-70.698265,-33.365888],[-70.698601,-33.365888],[-70.699372,-33.365939],[-70.699667,-33.365994],[-70.700196,-33.366133],[-70.700316,-33.366169],[-70.700293,-33.366222],[-70.700292,-33.366223],[-70.699888,-33.367152],[-70.699592,-33.367913],[-70.699064,-33.369012],[-70.697949,-33.371626],[-70.697887,-33.371984],[-70.697697,-33.372403],[-70.69693,-33.37377],[-70.69611,-33.37558],[-70.695472,-33.377006],[-70.694549,-33.379115],[-70.693552,-33.381344],[-70.694689,-33.381689],[-70.694322,-33.382718],[-70.696554,-33.383115],[-70.699286,-33.383535],[-70.70049,-33.383675],[-70.700736,-33.383774],[-70.701275,-33.383808],[-70.701763,-33.38376],[-70.7022,-33.383549],[-70.70254,-33.383462],[-70.703224,-33.383412],[-70.703763,-33.383446],[-70.704351,-33.38352],[-70.704893,-33.383717],[-70.705337,-33.383916],[-70.705588,-33.384241],[-70.705989,-33.384728],[-70.706341,-33.385216],[-70.70684,-33.385742],[-70.707139,-33.386026],[-70.707538,-33.386389],[-70.707839,-33.386796],[-70.707992,-33.387081],[-70.708096,-33.387408],[-70.708202,-33.387816],[-70.708502,-33.388182],[-70.708998,-33.388503],[-70.709445,-33.388866],[-70.710098,-33.38976],[-70.710599,-33.390328],[-70.711239,-33.391158],[-70.711932,-33.390966],[-70.713294,-33.390578],[-70.714705,-33.390189],[-70.715634,-33.390176],[-70.716222,-33.390209],[-70.716764,-33.390407],[-70.717307,-33.390645],[-70.718197,-33.391125],[-70.719533,-33.391928],[-70.720321,-33.392204],[-70.721207,-33.392438],[-70.722381,-33.392463],[-70.723407,-33.392407],[-70.724232,-33.392068],[-70.724472,-33.391818],[-70.725196,-33.391316],[-70.725876,-33.391101],[-70.726415,-33.391134],[-70.727052,-33.391167],[-70.727546,-33.391447],[-70.727702,-33.391896],[-70.727567,-33.392473],[-70.727718,-33.392717],[-70.728062,-33.392794],[-70.728453,-33.392747],[-70.728791,-33.392538],[-70.729223,-33.392121],[-70.729607,-33.391747],[-70.730188,-33.391451],[-70.730773,-33.391361],[-70.731459,-33.391392],[-70.732049,-33.391548],[-70.732544,-33.39187],[-70.732892,-33.392152],[-70.733435,-33.392391],[-70.734025,-33.392506],[-70.734564,-33.39258],[-70.735056,-33.392696],[-70.735596,-33.392812],[-70.735991,-33.392971],[-70.736337,-33.393171],[-70.736635,-33.393372],[-70.736943,-33.393672],[-70.737139,-33.393343],[-70.738817,-33.391442],[-70.739719,-33.390513],[-70.74023,-33.390033],[-70.740396,-33.389876],[-70.741713,-33.389568],[-70.74286,-33.389408],[-70.744239,-33.38934],[-70.746194,-33.389312],[-70.748493,-33.389232],[-70.749867,-33.388923],[-70.75032,-33.388579],[-70.750773,-33.388187],[-70.750986,-33.387363],[-70.751088,-33.386686],[-70.75108,-33.3863],[-70.751009,-33.385626],[-70.75164,-33.385569],[-70.752384,-33.385365],[-70.754157,-33.384858],[-70.756039,-33.384108],[-70.756567,-33.38378],[-70.758027,-33.382873],[-70.760862,-33.380855],[-70.763412,-33.378985],[-70.764834,-33.378193],[-70.767168,-33.377002],[-70.768422,-33.376453],[-70.768771,-33.376275]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1312,"DIS_ELEC":16,"NOM_COM":"Quilicura","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":56764072.6002,"SHAPE_LENG":35236.920632,"SHAPE_Le_1":34891.086729},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.579444,-33.35201],[-70.578946,-33.352016],[-70.578531,-33.352022],[-70.577826,-33.352065],[-70.577164,-33.352178],[-70.576134,-33.35261],[-70.575395,-33.353072],[-70.574826,-33.353776],[-70.574094,-33.354621],[-70.573404,-33.355501],[-70.57287,-33.355787],[-70.572126,-33.35597],[-70.571545,-33.355977],[-70.57092,-33.355846],[-70.570253,-33.355715],[-70.568755,-33.355525],[-70.56809,-33.355499],[-70.567591,-33.35547],[-70.566847,-33.355654],[-70.566106,-33.355977],[-70.565697,-33.35633],[-70.565373,-33.356752],[-70.5648,-33.357247],[-70.564142,-33.357604],[-70.56253,-33.357973],[-70.560256,-33.358524],[-70.559345,-33.358675],[-70.558267,-33.358758],[-70.557728,-33.3588],[-70.55742,-33.358881],[-70.556293,-33.358896],[-70.55484,-33.35887],[-70.552771,-33.359201],[-70.550335,-33.359275],[-70.54962,-33.359937],[-70.548903,-33.360468],[-70.548665,-33.36169],[-70.547719,-33.363878],[-70.546905,-33.364803],[-70.544845,-33.366118],[-70.543782,-33.367149],[-70.54251,-33.368557],[-70.541389,-33.369747],[-70.541184,-33.370068],[-70.540618,-33.370267],[-70.539584,-33.370523],[-70.538089,-33.370507],[-70.53622,-33.370495],[-70.535389,-33.370471],[-70.534226,-33.37045],[-70.533065,-33.370569],[-70.531986,-33.370583],[-70.531073,-33.370629],[-70.530326,-33.370603],[-70.529681,-33.370526],[-70.529582,-33.370524],[-70.5285,-33.370356],[-70.527537,-33.370187],[-70.526645,-33.369916],[-70.525513,-33.369648],[-70.524863,-33.369495],[-70.524431,-33.36944],[-70.523999,-33.369426],[-70.523663,-33.36945],[-70.523306,-33.369595],[-70.523045,-33.369739],[-70.5224,-33.369908],[-70.52173,-33.370017],[-70.521085,-33.370145],[-70.520463,-33.370214],[-70.520241,-33.370244],[-70.519922,-33.37033],[-70.519471,-33.370365],[-70.518495,-33.371378],[-70.517689,-33.372578],[-70.517573,-33.372763],[-70.517867,-33.372897],[-70.52241,-33.37496],[-70.524944,-33.375874],[-70.525325,-33.376205],[-70.525986,-33.376516],[-70.527093,-33.377147],[-70.527613,-33.377565],[-70.527941,-33.377888],[-70.528748,-33.378649],[-70.529351,-33.379516],[-70.5301,-33.380073],[-70.530844,-33.380758],[-70.532348,-33.382167],[-70.532351,-33.382168],[-70.533885,-33.383816],[-70.534942,-33.384142],[-70.53734,-33.385364],[-70.541796,-33.387349],[-70.543428,-33.388143],[-70.54379,-33.388282],[-70.545223,-33.388797],[-70.545957,-33.389023],[-70.547234,-33.389508],[-70.547435,-33.389701],[-70.548278,-33.390077],[-70.549436,-33.39052],[-70.549683,-33.390616],[-70.550802,-33.391062],[-70.551394,-33.39129],[-70.552489,-33.391711],[-70.552536,-33.391772],[-70.553318,-33.39198],[-70.554137,-33.392324],[-70.554501,-33.392456],[-70.556616,-33.393193],[-70.558735,-33.393915],[-70.561534,-33.394896],[-70.561611,-33.394955],[-70.565831,-33.39632],[-70.569749,-33.397489],[-70.571614,-33.398045],[-70.571943,-33.398143],[-70.586508,-33.404113],[-70.586644,-33.404168],[-70.58685,-33.404228],[-70.594149,-33.406338],[-70.59595,-33.407],[-70.59778,-33.407672],[-70.59861,-33.408056],[-70.599163,-33.408246],[-70.599674,-33.408338],[-70.600341,-33.408363],[-70.601165,-33.408385],[-70.601674,-33.408378],[-70.602263,-33.408404],[-70.603759,-33.408779],[-70.604587,-33.408998],[-70.605493,-33.409282],[-70.605869,-33.409278],[-70.605924,-33.409277],[-70.614542,-33.409165],[-70.614374,-33.409082],[-70.612617,-33.408373],[-70.612111,-33.407996],[-70.611771,-33.407583],[-70.611473,-33.407169],[-70.610962,-33.406478],[-70.610784,-33.405853],[-70.610561,-33.40502],[-70.610561,-33.405017],[-70.61054,-33.403906],[-70.610486,-33.40321],[-70.610391,-33.402584],[-70.610071,-33.400985],[-70.60929,-33.399184],[-70.608937,-33.398038],[-70.608541,-33.396859],[-70.60743,-33.395166],[-70.605856,-33.393166],[-70.602984,-33.39052],[-70.602265,-33.389833],[-70.601712,-33.389143],[-70.601451,-33.388485],[-70.601521,-33.387752],[-70.602,-33.386736],[-70.602456,-33.386322],[-70.602817,-33.385993],[-70.603262,-33.385326],[-70.603658,-33.384275],[-70.60389,-33.383366],[-70.603883,-33.382948],[-70.603618,-33.382116],[-70.602895,-33.381184],[-70.601001,-33.379815],[-70.600496,-33.379404],[-70.600156,-33.37899],[-70.60002,-33.378365],[-70.600002,-33.377424],[-70.600103,-33.376134],[-70.600089,-33.375333],[-70.599821,-33.374326],[-70.599087,-33.372802],[-70.598198,-33.371873],[-70.597777,-33.371565],[-70.597605,-33.371219],[-70.597556,-33.370801],[-70.597623,-33.369929],[-70.597466,-33.368189],[-70.597448,-33.367179],[-70.597354,-33.366553],[-70.597345,-33.3661],[-70.59734,-33.365787],[-70.597746,-33.365294],[-70.598688,-33.364585],[-70.599588,-33.363876],[-70.600611,-33.363027],[-70.601062,-33.362708],[-70.600139,-33.362232],[-70.59909,-33.361583],[-70.598334,-33.361105],[-70.597367,-33.360456],[-70.596898,-33.3598],[-70.596723,-33.359314],[-70.596383,-33.358866],[-70.595837,-33.358525],[-70.595038,-33.357977],[-70.594488,-33.357392],[-70.594024,-33.357015],[-70.593602,-33.356637],[-70.593264,-33.356293],[-70.593008,-33.355913],[-70.592627,-33.355535],[-70.59204,-33.355229],[-70.590829,-33.354861],[-70.589787,-33.35463],[-70.589081,-33.35457],[-70.588375,-33.354579],[-70.587793,-33.354551],[-70.587252,-33.354454],[-70.586833,-33.35425],[-70.586368,-33.353803],[-70.586028,-33.353389],[-70.585817,-33.353148],[-70.585606,-33.353012],[-70.585147,-33.352878],[-70.584689,-33.352779],[-70.584188,-33.352611],[-70.58381,-33.352407],[-70.583471,-33.351994],[-70.583133,-33.351684],[-70.582754,-33.351376],[-70.582624,-33.351098],[-70.582515,-33.350965],[-70.581961,-33.351177],[-70.581342,-33.351359],[-70.580767,-33.351714],[-70.580149,-33.351966],[-70.579444,-33.35201]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1313,"DIS_ELEC":23,"NOM_COM":"Vitacura","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":28668485.1847,"SHAPE_LENG":25316.04602,"SHAPE_Le_1":25555.323821},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.704853,-33.408057],[-70.704457,-33.408245],[-70.702769,-33.409336],[-70.700643,-33.410341],[-70.699889,-33.410808],[-70.699531,-33.411118],[-70.699484,-33.411151],[-70.698814,-33.411616],[-70.696282,-33.413252],[-70.694987,-33.414001],[-70.694521,-33.414343],[-70.69402,-33.414746],[-70.693701,-33.415178],[-70.693455,-33.415638],[-70.69275,-33.416776],[-70.692362,-33.417391],[-70.691756,-33.41801],[-70.691077,-33.418598],[-70.689913,-33.419544],[-70.689371,-33.419735],[-70.68861,-33.419867],[-70.68792,-33.419937],[-70.687485,-33.420004],[-70.686763,-33.420258],[-70.686294,-33.420447],[-70.686266,-33.420462],[-70.685466,-33.420886],[-70.682695,-33.422387],[-70.678975,-33.423718],[-70.677909,-33.424083],[-70.677368,-33.424335],[-70.676901,-33.424646],[-70.675893,-33.425178],[-70.672645,-33.426472],[-70.671833,-33.426757],[-70.671533,-33.426861],[-70.671825,-33.428308],[-70.671989,-33.428151],[-70.672001,-33.428262],[-70.673636,-33.427743],[-70.675472,-33.427123],[-70.676656,-33.426827],[-70.677059,-33.426795],[-70.677705,-33.426849],[-70.678166,-33.426855],[-70.679018,-33.427294],[-70.679255,-33.427384],[-70.679344,-33.42746],[-70.679875,-33.427911],[-70.680145,-33.428196],[-70.680368,-33.428535],[-70.680594,-33.429019],[-70.680717,-33.429816],[-70.68068,-33.430353],[-70.680594,-33.431671],[-70.680581,-33.432762],[-70.680437,-33.434245],[-70.680184,-33.437139],[-70.680071,-33.438445],[-70.680071,-33.43845],[-70.680142,-33.438449],[-70.680177,-33.438449],[-70.680381,-33.438463],[-70.680381,-33.438465],[-70.681219,-33.438519],[-70.682054,-33.438575],[-70.682034,-33.437526],[-70.681004,-33.437453],[-70.681339,-33.436155],[-70.683818,-33.436682],[-70.683734,-33.437675],[-70.684918,-33.437702],[-70.684938,-33.438768],[-70.686562,-33.438876],[-70.688457,-33.439013],[-70.689486,-33.43908],[-70.69105,-33.439185],[-70.691334,-33.439482],[-70.691551,-33.439503],[-70.691563,-33.439719],[-70.691647,-33.441927],[-70.691862,-33.444675],[-70.692301,-33.444699],[-70.692257,-33.44624],[-70.692335,-33.446292],[-70.692472,-33.447985],[-70.693559,-33.447837],[-70.694805,-33.447863],[-70.696215,-33.447799],[-70.697515,-33.447727],[-70.698261,-33.447717],[-70.698829,-33.44779],[-70.700333,-33.447968],[-70.701468,-33.448115],[-70.702717,-33.448269],[-70.70425,-33.448464],[-70.706205,-33.448708],[-70.706248,-33.448757],[-70.707139,-33.448795],[-70.707141,-33.448785],[-70.707148,-33.448478],[-70.70719,-33.448189],[-70.707262,-33.447449],[-70.707326,-33.445924],[-70.707331,-33.444869],[-70.707329,-33.444003],[-70.707345,-33.443191],[-70.707352,-33.442758],[-70.707346,-33.442001],[-70.707309,-33.441521],[-70.707257,-33.440927],[-70.707175,-33.439885],[-70.707078,-33.438515],[-70.70707,-33.438054],[-70.707292,-33.43806],[-70.708724,-33.438104],[-70.709362,-33.438131],[-70.71021,-33.43813],[-70.710977,-33.438103],[-70.711563,-33.438016],[-70.712262,-33.437955],[-70.712749,-33.437848],[-70.712958,-33.437818],[-70.714085,-33.437655],[-70.714761,-33.437558],[-70.71583,-33.43742],[-70.717047,-33.437258],[-70.718435,-33.437077],[-70.719651,-33.436889],[-70.721461,-33.436629],[-70.721544,-33.436651],[-70.72154,-33.436637],[-70.721448,-33.436204],[-70.721237,-33.435216],[-70.721013,-33.434164],[-70.720987,-33.434048],[-70.720958,-33.433917],[-70.720903,-33.43367],[-70.720772,-33.433086],[-70.720509,-33.431832],[-70.720249,-33.430625],[-70.720003,-33.429636],[-70.719241,-33.426729],[-70.718592,-33.424254],[-70.718535,-33.424085],[-70.718487,-33.424002],[-70.718451,-33.423855],[-70.718097,-33.422373],[-70.71796,-33.421763],[-70.717815,-33.421159],[-70.717204,-33.418561],[-70.717067,-33.417962],[-70.716944,-33.41746],[-70.716709,-33.416574],[-70.716691,-33.416407],[-70.71657,-33.416215],[-70.716473,-33.416056],[-70.716358,-33.415877],[-70.716227,-33.415669],[-70.715919,-33.415124],[-70.716741,-33.414846],[-70.717425,-33.414454],[-70.719395,-33.413224],[-70.721047,-33.412552],[-70.722147,-33.412077],[-70.722499,-33.411746],[-70.721734,-33.411315],[-70.72129,-33.410955],[-70.720777,-33.410718],[-70.720264,-33.410543],[-70.719681,-33.410459],[-70.718917,-33.41047],[-70.71819,-33.41048],[-70.717643,-33.410396],[-70.717059,-33.410282],[-70.716399,-33.410017],[-70.71541,-33.409603],[-70.713389,-33.408564],[-70.713182,-33.408457],[-70.712875,-33.408297],[-70.712219,-33.408214],[-70.711528,-33.408193],[-70.710326,-33.408088],[-70.709018,-33.408136],[-70.708404,-33.408086],[-70.707907,-33.408045],[-70.706853,-33.40806],[-70.706089,-33.40804],[-70.70547,-33.408018],[-70.704853,-33.408057]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1312,"DIS_ELEC":18,"NOM_COM":"Quinta Normal","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":11622769.6468,"SHAPE_LENG":17674.57679,"SHAPE_Le_1":17598.274772},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.656188,-33.376777],[-70.655438,-33.376992],[-70.654859,-33.377156],[-70.652821,-33.377902],[-70.651019,-33.378572],[-70.648834,-33.3794],[-70.648449,-33.379561],[-70.647652,-33.37985],[-70.647001,-33.380102],[-70.646436,-33.380323],[-70.645262,-33.380763],[-70.644201,-33.381215],[-70.643241,-33.381697],[-70.641379,-33.382694],[-70.639208,-33.38424],[-70.636662,-33.386119],[-70.634404,-33.387781],[-70.631788,-33.38971],[-70.629843,-33.391148],[-70.627893,-33.392585],[-70.62783,-33.392618],[-70.627822,-33.39263],[-70.627603,-33.39277],[-70.627394,-33.392901],[-70.627198,-33.393015],[-70.626982,-33.393142],[-70.626757,-33.393276],[-70.62657,-33.393369],[-70.62617,-33.393578],[-70.625557,-33.39386],[-70.625201,-33.394029],[-70.624991,-33.394128],[-70.624989,-33.394127],[-70.62495,-33.394147],[-70.62409,-33.394711],[-70.622323,-33.396023],[-70.62162,-33.39673],[-70.618043,-33.399165],[-70.610561,-33.405017],[-70.610561,-33.40502],[-70.610784,-33.405853],[-70.610962,-33.406478],[-70.611473,-33.407169],[-70.611771,-33.407583],[-70.612111,-33.407996],[-70.612617,-33.408373],[-70.614374,-33.409082],[-70.614542,-33.409165],[-70.616764,-33.41027],[-70.61722,-33.41071],[-70.617441,-33.410923],[-70.617906,-33.411335],[-70.61829,-33.411888],[-70.6191,-33.413027],[-70.620203,-33.414267],[-70.622401,-33.416259],[-70.625308,-33.418415],[-70.627113,-33.419437],[-70.627656,-33.419604],[-70.628447,-33.419698],[-70.628906,-33.419762],[-70.629404,-33.419755],[-70.629738,-33.419821],[-70.630323,-33.420022],[-70.630746,-33.4204],[-70.631713,-33.421014],[-70.632051,-33.421323],[-70.632269,-33.421526],[-70.632347,-33.421598],[-70.63252,-33.421944],[-70.632692,-33.42229],[-70.633558,-33.42416],[-70.634378,-33.425787],[-70.634727,-33.426688],[-70.634776,-33.427071],[-70.634914,-33.427766],[-70.635049,-33.428321],[-70.635222,-33.428667],[-70.63552,-33.429082],[-70.635773,-33.429287],[-70.63611,-33.429527],[-70.636144,-33.429595],[-70.636014,-33.429796],[-70.636055,-33.43012],[-70.636242,-33.430767],[-70.636219,-33.430893],[-70.636048,-33.431913],[-70.635951,-33.43246],[-70.635793,-33.433361],[-70.635645,-33.434172],[-70.635526,-33.434824],[-70.635411,-33.435474],[-70.635371,-33.435702],[-70.635354,-33.436217],[-70.635375,-33.436385],[-70.635739,-33.436358],[-70.638061,-33.435828],[-70.640679,-33.435218],[-70.642667,-33.434751],[-70.643273,-33.434616],[-70.645459,-33.434126],[-70.645678,-33.434071],[-70.647726,-33.433555],[-70.649651,-33.433084],[-70.651749,-33.43283],[-70.651753,-33.431833],[-70.651666,-33.431726],[-70.651721,-33.431166],[-70.651652,-33.430391],[-70.651544,-33.429211],[-70.651492,-33.428653],[-70.651383,-33.427202],[-70.65118,-33.424968],[-70.651044,-33.423356],[-70.650768,-33.421285],[-70.650165,-33.417856],[-70.651712,-33.417602],[-70.652723,-33.417562],[-70.652741,-33.416114],[-70.652751,-33.415307],[-70.652978,-33.415227],[-70.652977,-33.411871],[-70.653593,-33.411819],[-70.653521,-33.406646],[-70.657103,-33.405863],[-70.657113,-33.405814],[-70.657112,-33.405792],[-70.657117,-33.40579],[-70.657201,-33.405336],[-70.657216,-33.40521],[-70.65726,-33.404995],[-70.657294,-33.404824],[-70.657302,-33.404785],[-70.65745,-33.404062],[-70.657678,-33.402877],[-70.657913,-33.401815],[-70.658175,-33.400553],[-70.658206,-33.399714],[-70.658289,-33.399703],[-70.658279,-33.399559],[-70.658274,-33.399559],[-70.658166,-33.399142],[-70.658021,-33.398582],[-70.657995,-33.398481],[-70.657865,-33.398429],[-70.657747,-33.397655],[-70.657655,-33.39685],[-70.657637,-33.396655],[-70.657556,-33.395944],[-70.657545,-33.395737],[-70.657426,-33.394819],[-70.657328,-33.393927],[-70.657259,-33.393418],[-70.657186,-33.392937],[-70.657203,-33.392512],[-70.657213,-33.392258],[-70.657155,-33.392071],[-70.657328,-33.391699],[-70.657258,-33.391637],[-70.657317,-33.391041],[-70.657341,-33.390496],[-70.657389,-33.389254],[-70.657403,-33.388839],[-70.657382,-33.388596],[-70.65727,-33.387811],[-70.657239,-33.387588],[-70.65712,-33.386782],[-70.657131,-33.38631],[-70.657169,-33.385832],[-70.657187,-33.385463],[-70.657229,-33.385115],[-70.657275,-33.384747],[-70.657339,-33.384322],[-70.657462,-33.383166],[-70.657485,-33.382853],[-70.657537,-33.382127],[-70.657571,-33.381469],[-70.657602,-33.380774],[-70.657629,-33.380483],[-70.657678,-33.379454],[-70.657726,-33.378768],[-70.65773,-33.378508],[-70.657733,-33.378398],[-70.657712,-33.378308],[-70.657673,-33.378183],[-70.657625,-33.37803],[-70.657625,-33.378027],[-70.657038,-33.376883],[-70.657034,-33.376885],[-70.656824,-33.376536],[-70.656188,-33.376777]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1312,"DIS_ELEC":19,"NOM_COM":"Recoleta","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":15763812.499,"SHAPE_LENG":18338.218321,"SHAPE_Le_1":18386.282055},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.782244,-33.413949],[-70.782325,-33.412818],[-70.782524,-33.406214],[-70.782364,-33.405431],[-70.782372,-33.405248],[-70.776029,-33.399889],[-70.764148,-33.389782],[-70.756567,-33.38378],[-70.756039,-33.384108],[-70.754157,-33.384858],[-70.752384,-33.385365],[-70.75164,-33.385569],[-70.751009,-33.385626],[-70.75108,-33.3863],[-70.751088,-33.386686],[-70.750986,-33.387363],[-70.750773,-33.388187],[-70.75032,-33.388579],[-70.749867,-33.388923],[-70.748493,-33.389232],[-70.746194,-33.389312],[-70.744239,-33.38934],[-70.74286,-33.389408],[-70.741713,-33.389568],[-70.740396,-33.389876],[-70.74023,-33.390033],[-70.739719,-33.390513],[-70.738817,-33.391442],[-70.737139,-33.393343],[-70.736943,-33.393672],[-70.736635,-33.393372],[-70.736337,-33.393171],[-70.735991,-33.392971],[-70.735596,-33.392812],[-70.735056,-33.392696],[-70.734564,-33.39258],[-70.734025,-33.392506],[-70.733435,-33.392391],[-70.732892,-33.392152],[-70.732544,-33.39187],[-70.732049,-33.391548],[-70.731459,-33.391392],[-70.730773,-33.391361],[-70.730188,-33.391451],[-70.729607,-33.391747],[-70.729223,-33.392121],[-70.728791,-33.392538],[-70.728453,-33.392747],[-70.728062,-33.392794],[-70.727718,-33.392717],[-70.727567,-33.392473],[-70.727702,-33.391896],[-70.727546,-33.391447],[-70.727052,-33.391167],[-70.726415,-33.391134],[-70.725876,-33.391101],[-70.725196,-33.391316],[-70.724472,-33.391818],[-70.724232,-33.392068],[-70.723407,-33.392407],[-70.722381,-33.392463],[-70.721207,-33.392438],[-70.720321,-33.392204],[-70.719533,-33.391928],[-70.718197,-33.391125],[-70.717307,-33.390645],[-70.716764,-33.390407],[-70.716222,-33.390209],[-70.715634,-33.390176],[-70.714705,-33.390189],[-70.713294,-33.390578],[-70.711932,-33.390966],[-70.711239,-33.391158],[-70.710599,-33.390328],[-70.710098,-33.38976],[-70.709445,-33.388866],[-70.708998,-33.388503],[-70.708502,-33.388182],[-70.708202,-33.387816],[-70.708096,-33.387408],[-70.707992,-33.387081],[-70.707839,-33.386796],[-70.707538,-33.386389],[-70.707139,-33.386026],[-70.70684,-33.385742],[-70.706341,-33.385216],[-70.705989,-33.384728],[-70.705588,-33.384241],[-70.705337,-33.383916],[-70.704893,-33.383717],[-70.704351,-33.38352],[-70.703763,-33.383446],[-70.703224,-33.383412],[-70.70254,-33.383462],[-70.7022,-33.383549],[-70.701763,-33.38376],[-70.701275,-33.383808],[-70.700736,-33.383774],[-70.70049,-33.383675],[-70.699286,-33.383535],[-70.696554,-33.383115],[-70.694322,-33.382718],[-70.694689,-33.381689],[-70.693552,-33.381344],[-70.693292,-33.381925],[-70.691197,-33.386577],[-70.689931,-33.389387],[-70.687325,-33.394163],[-70.683621,-33.400309],[-70.681818,-33.403063],[-70.68174,-33.403186],[-70.681806,-33.403204],[-70.680881,-33.404865],[-70.680598,-33.405419],[-70.680427,-33.405989],[-70.680329,-33.407036],[-70.679742,-33.411039],[-70.679298,-33.413854],[-70.678805,-33.416587],[-70.678701,-33.41733],[-70.678279,-33.418544],[-70.677779,-33.419345],[-70.677127,-33.420012],[-70.675259,-33.421414],[-70.674476,-33.422113],[-70.673975,-33.422742],[-70.673306,-33.423622],[-70.672505,-33.424656],[-70.671751,-33.42555],[-70.671182,-33.425951],[-70.671514,-33.426868],[-70.671833,-33.426757],[-70.672645,-33.426472],[-70.675893,-33.425178],[-70.676901,-33.424646],[-70.677368,-33.424335],[-70.677909,-33.424083],[-70.678975,-33.423718],[-70.682695,-33.422387],[-70.685466,-33.420886],[-70.686266,-33.420462],[-70.686294,-33.420447],[-70.686763,-33.420258],[-70.687485,-33.420004],[-70.68792,-33.419937],[-70.68861,-33.419867],[-70.689371,-33.419735],[-70.689913,-33.419544],[-70.691077,-33.418598],[-70.691756,-33.41801],[-70.692362,-33.417391],[-70.69275,-33.416776],[-70.693455,-33.415638],[-70.693701,-33.415178],[-70.69402,-33.414746],[-70.694521,-33.414343],[-70.694987,-33.414001],[-70.696282,-33.413252],[-70.698814,-33.411616],[-70.699484,-33.411151],[-70.699531,-33.411118],[-70.699889,-33.410808],[-70.700643,-33.410341],[-70.702769,-33.409336],[-70.704457,-33.408245],[-70.704853,-33.408057],[-70.70547,-33.408018],[-70.706089,-33.40804],[-70.706853,-33.40806],[-70.707907,-33.408045],[-70.708404,-33.408086],[-70.709018,-33.408136],[-70.710326,-33.408088],[-70.711528,-33.408193],[-70.712219,-33.408214],[-70.712875,-33.408297],[-70.713182,-33.408457],[-70.713389,-33.408564],[-70.71541,-33.409603],[-70.716399,-33.410017],[-70.717059,-33.410282],[-70.717643,-33.410396],[-70.71819,-33.41048],[-70.718917,-33.41047],[-70.719681,-33.410459],[-70.720264,-33.410543],[-70.720777,-33.410718],[-70.72129,-33.410955],[-70.721734,-33.411315],[-70.722814,-33.411924],[-70.723186,-33.412134],[-70.724065,-33.412457],[-70.725458,-33.412986],[-70.727436,-33.413721],[-70.727876,-33.413898],[-70.728384,-33.413891],[-70.728855,-33.413793],[-70.729107,-33.413667],[-70.72961,-33.413325],[-70.730295,-33.413041],[-70.731961,-33.412713],[-70.732506,-33.412675],[-70.733643,-33.412555],[-70.733848,-33.412534],[-70.735301,-33.412422],[-70.736262,-33.412332],[-70.736516,-33.412268],[-70.737097,-33.41226],[-70.737498,-33.412315],[-70.738374,-33.412455],[-70.740559,-33.412608],[-70.743277,-33.412441],[-70.743791,-33.41241],[-70.744446,-33.412431],[-70.745138,-33.412513],[-70.745395,-33.412601],[-70.745499,-33.412661],[-70.745652,-33.412749],[-70.745982,-33.412897],[-70.746382,-33.412892],[-70.746672,-33.412827],[-70.74816,-33.412714],[-70.748996,-33.412702],[-70.750524,-33.412742],[-70.751505,-33.412697],[-70.753251,-33.412703],[-70.754052,-33.412753],[-70.754527,-33.412899],[-70.754683,-33.412933],[-70.755039,-33.413013],[-70.755659,-33.413096],[-70.756168,-33.413089],[-70.756604,-33.413083],[-70.757439,-33.41301],[-70.75878,-33.412808],[-70.759888,-33.412747],[-70.759924,-33.412746],[-70.760397,-33.412739],[-70.760946,-33.412914],[-70.761005,-33.412926],[-70.761384,-33.413],[-70.761857,-33.413054],[-70.762294,-33.413048],[-70.762805,-33.413132],[-70.763462,-33.413275],[-70.76401,-33.413389],[-70.76452,-33.413443],[-70.765653,-33.413732],[-70.766312,-33.413936],[-70.767007,-33.41417],[-70.767739,-33.414404],[-70.769564,-33.414713],[-70.769964,-33.414707],[-70.770253,-33.414642],[-70.770323,-33.414519],[-70.770355,-33.414275],[-70.77068,-33.414179],[-70.770864,-33.414267],[-70.771123,-33.414508],[-70.771455,-33.414717],[-70.771823,-33.414955],[-70.772188,-33.415041],[-70.772515,-33.415006],[-70.77284,-33.41488],[-70.773304,-33.414477],[-70.773735,-33.414226],[-70.774096,-33.414069],[-70.774566,-33.41394],[-70.775257,-33.41393],[-70.77613,-33.413948],[-70.777404,-33.414052],[-70.777806,-33.414138],[-70.778389,-33.41419],[-70.778861,-33.414153],[-70.77926,-33.414086],[-70.779658,-33.413989],[-70.780093,-33.413922],[-70.780674,-33.413914],[-70.781584,-33.413931],[-70.782244,-33.413949]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1312,"DIS_ELEC":17,"NOM_COM":"Renca","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":24011796.166,"SHAPE_LENG":28974.956711,"SHAPE_Le_1":28770.72173},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.636594,-33.518728],[-70.637404,-33.518786],[-70.638107,-33.51868],[-70.638867,-33.518525],[-70.641055,-33.51809],[-70.643279,-33.517636],[-70.644621,-33.517366],[-70.646806,-33.516931],[-70.649028,-33.516487],[-70.651288,-33.516051],[-70.655775,-33.515161],[-70.65807,-33.514704],[-70.661382,-33.513707],[-70.662953,-33.513217],[-70.665017,-33.512591],[-70.667113,-33.511961],[-70.668866,-33.511424],[-70.669859,-33.511131],[-70.67049,-33.51098],[-70.671101,-33.51075],[-70.671234,-33.510698],[-70.670393,-33.508921],[-70.668648,-33.505235],[-70.666233,-33.500716],[-70.666085,-33.50044],[-70.663423,-33.494482],[-70.661747,-33.490278],[-70.661665,-33.490116],[-70.65819,-33.483211],[-70.656287,-33.479183],[-70.655433,-33.477599],[-70.655067,-33.476724],[-70.653879,-33.476876],[-70.652433,-33.476928],[-70.650986,-33.476948],[-70.649382,-33.476936],[-70.648678,-33.476945],[-70.64847,-33.476948],[-70.648287,-33.476951],[-70.642888,-33.476957],[-70.642113,-33.476895],[-70.641946,-33.476882],[-70.641932,-33.477177],[-70.641848,-33.477649],[-70.641759,-33.478801],[-70.641849,-33.478868],[-70.641775,-33.480033],[-70.641714,-33.480917],[-70.641652,-33.481451],[-70.641512,-33.482617],[-70.641302,-33.484217],[-70.641163,-33.485367],[-70.641023,-33.486247],[-70.640772,-33.488071],[-70.640582,-33.48968],[-70.640417,-33.490972],[-70.640276,-33.492084],[-70.640086,-33.493332],[-70.64004,-33.493628],[-70.639947,-33.494324],[-70.639803,-33.495317],[-70.639748,-33.495814],[-70.639681,-33.496338],[-70.639559,-33.497284],[-70.639493,-33.497883],[-70.639423,-33.498578],[-70.639329,-33.499445],[-70.639311,-33.499617],[-70.639154,-33.501098],[-70.63902,-33.502586],[-70.638897,-33.504014],[-70.638751,-33.505549],[-70.638646,-33.506314],[-70.63863,-33.506382],[-70.638627,-33.507081],[-70.638606,-33.5073],[-70.638365,-33.508171],[-70.638126,-33.509192],[-70.637668,-33.511218],[-70.637223,-33.513135],[-70.637214,-33.513223],[-70.63715,-33.513849],[-70.637129,-33.514102],[-70.637029,-33.514852],[-70.637003,-33.515176],[-70.636909,-33.516107],[-70.636803,-33.517055],[-70.63671,-33.517976],[-70.636586,-33.518727],[-70.636594,-33.518728]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1313,"DIS_ELEC":28,"NOM_COM":"San Miguel","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":9635028.27913,"SHAPE_LENG":13311.641303,"SHAPE_Le_1":13305.926698},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.671588,-33.476359],[-70.6716,-33.47605],[-70.672611,-33.475463],[-70.672777,-33.475176],[-70.672904,-33.473781],[-70.6729,-33.472708],[-70.672939,-33.470634],[-70.674094,-33.470633],[-70.676783,-33.470663],[-70.679127,-33.470732],[-70.680074,-33.470714],[-70.679691,-33.470081],[-70.679635,-33.470069],[-70.679048,-33.469436],[-70.679082,-33.469067],[-70.678744,-33.463737],[-70.67835,-33.458226],[-70.678242,-33.456747],[-70.678158,-33.455548],[-70.678092,-33.454593],[-70.67801,-33.453494],[-70.67794,-33.452412],[-70.67783,-33.450944],[-70.677932,-33.450492],[-70.679016,-33.450729],[-70.679152,-33.449004],[-70.679088,-33.448368],[-70.679453,-33.446016],[-70.679562,-33.443934],[-70.681926,-33.444007],[-70.684973,-33.444151],[-70.689638,-33.444372],[-70.691847,-33.444489],[-70.691647,-33.441927],[-70.691563,-33.439719],[-70.691551,-33.439503],[-70.691334,-33.439482],[-70.69105,-33.439185],[-70.689486,-33.43908],[-70.688457,-33.439013],[-70.686562,-33.438876],[-70.684938,-33.438768],[-70.684918,-33.437702],[-70.683734,-33.437675],[-70.683818,-33.436682],[-70.681339,-33.436155],[-70.681004,-33.437453],[-70.682034,-33.437526],[-70.682054,-33.438575],[-70.681219,-33.438519],[-70.680381,-33.438465],[-70.680381,-33.438463],[-70.680177,-33.438449],[-70.680071,-33.43845],[-70.680184,-33.437139],[-70.680437,-33.434245],[-70.680581,-33.432762],[-70.680594,-33.431671],[-70.68068,-33.430353],[-70.680717,-33.429816],[-70.680594,-33.429019],[-70.680368,-33.428535],[-70.680145,-33.428196],[-70.679875,-33.427911],[-70.679344,-33.42746],[-70.679255,-33.427384],[-70.679018,-33.427294],[-70.678166,-33.426855],[-70.677705,-33.426849],[-70.677059,-33.426795],[-70.676656,-33.426827],[-70.675472,-33.427123],[-70.673636,-33.427743],[-70.672001,-33.428262],[-70.671989,-33.428151],[-70.671825,-33.428308],[-70.671533,-33.426861],[-70.668148,-33.428047],[-70.665853,-33.428851],[-70.661426,-33.43053],[-70.66031,-33.430953],[-70.65861,-33.431433],[-70.657852,-33.431614],[-70.656981,-33.431821],[-70.653369,-33.43253],[-70.652269,-33.432746],[-70.65198,-33.432802],[-70.649651,-33.433084],[-70.647726,-33.433555],[-70.645678,-33.434071],[-70.645459,-33.434126],[-70.643273,-33.434616],[-70.642667,-33.434751],[-70.640679,-33.435218],[-70.638061,-33.435828],[-70.635739,-33.436358],[-70.635375,-33.436385],[-70.63538,-33.436424],[-70.635288,-33.436885],[-70.634764,-33.438885],[-70.634578,-33.439573],[-70.632851,-33.445412],[-70.631447,-33.4501],[-70.631453,-33.450101],[-70.630898,-33.451933],[-70.629841,-33.455426],[-70.629599,-33.456295],[-70.628553,-33.459925],[-70.627772,-33.462614],[-70.627127,-33.46485],[-70.62641,-33.467391],[-70.626071,-33.468579],[-70.626053,-33.468832],[-70.625762,-33.469205],[-70.625149,-33.469602],[-70.624578,-33.469956],[-70.624868,-33.470322],[-70.624865,-33.470324],[-70.625522,-33.470859],[-70.626196,-33.471342],[-70.627146,-33.471886],[-70.62789,-33.472318],[-70.627906,-33.472357],[-70.630003,-33.47314],[-70.631697,-33.473733],[-70.631909,-33.473808],[-70.632031,-33.473749],[-70.632341,-33.473858],[-70.633874,-33.474388],[-70.634628,-33.47466],[-70.63743,-33.475849],[-70.640615,-33.476725],[-70.64183,-33.476872],[-70.642113,-33.476895],[-70.642888,-33.476957],[-70.648287,-33.476951],[-70.64847,-33.476948],[-70.648678,-33.476945],[-70.649382,-33.476936],[-70.650986,-33.476948],[-70.652433,-33.476928],[-70.653879,-33.476876],[-70.655067,-33.476724],[-70.655596,-33.476657],[-70.656416,-33.476547],[-70.657235,-33.476438],[-70.65829,-33.476358],[-70.660321,-33.4762],[-70.661063,-33.476124],[-70.661689,-33.476116],[-70.663566,-33.476124],[-70.665132,-33.476168],[-70.665207,-33.47617],[-70.667676,-33.476232],[-70.668301,-33.476158],[-70.668887,-33.47615],[-70.669514,-33.476175],[-70.669944,-33.476202],[-70.670571,-33.476226],[-70.671198,-33.476283],[-70.671588,-33.476359]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1310,"DIS_ELEC":22,"NOM_COM":"Santiago","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":22769994.7897,"SHAPE_LENG":24644.018619,"SHAPE_Le_1":22142.660055},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.689282,-33.366237],[-70.689206,-33.365574],[-70.689281,-33.3648],[-70.689438,-33.363803],[-70.690116,-33.361548],[-70.690542,-33.360397],[-70.690701,-33.359926],[-70.690996,-33.35911],[-70.691475,-33.357769],[-70.691931,-33.356347],[-70.692045,-33.355858],[-70.692175,-33.35563],[-70.692269,-33.355255],[-70.692447,-33.354294],[-70.692554,-33.353762],[-70.6928,-33.352915],[-70.692979,-33.352462],[-70.693193,-33.351988],[-70.693358,-33.351607],[-70.692523,-33.350892],[-70.690346,-33.349171],[-70.688691,-33.347491],[-70.688552,-33.346906],[-70.688343,-33.346579],[-70.688098,-33.346178],[-70.687952,-33.345858],[-70.687845,-33.345557],[-70.687764,-33.345135],[-70.687694,-33.3447],[-70.687652,-33.344321],[-70.687607,-33.344004],[-70.6876,-33.343742],[-70.687605,-33.343431],[-70.687618,-33.343171],[-70.68758,-33.342904],[-70.687445,-33.342552],[-70.687204,-33.342282],[-70.686824,-33.342012],[-70.686446,-33.341706],[-70.686161,-33.341408],[-70.685854,-33.341145],[-70.685622,-33.340916],[-70.685248,-33.340678],[-70.684628,-33.340472],[-70.683906,-33.340294],[-70.683205,-33.340089],[-70.682688,-33.339873],[-70.682225,-33.339577],[-70.681764,-33.339246],[-70.68135,-33.338993],[-70.680859,-33.338669],[-70.680406,-33.338379],[-70.680202,-33.338074],[-70.680088,-33.337733],[-70.680097,-33.337548],[-70.680289,-33.337186],[-70.680614,-33.336796],[-70.680851,-33.336435],[-70.680999,-33.336075],[-70.681147,-33.335751],[-70.681163,-33.335419],[-70.680965,-33.335011],[-70.680896,-33.334639],[-70.680876,-33.334165],[-70.680939,-33.333762],[-70.681052,-33.333252],[-70.681199,-33.332929],[-70.681297,-33.332711],[-70.681442,-33.332424],[-70.681548,-33.332058],[-70.681518,-33.331764],[-70.681408,-33.331359],[-70.681291,-33.330999],[-70.681064,-33.33101],[-70.680545,-33.330811],[-70.68008,-33.330574],[-70.67962,-33.330248],[-70.679155,-33.330011],[-70.678583,-33.329811],[-70.678219,-33.329667],[-70.677531,-33.329684],[-70.676633,-33.329652],[-70.67536,-33.329698],[-70.674297,-33.329796],[-70.673505,-33.329769],[-70.672672,-33.329474],[-70.671946,-33.329178],[-70.670892,-33.329056],[-70.670155,-33.328985],[-70.669479,-33.328741],[-70.668698,-33.328488],[-70.668128,-33.328247],[-70.667551,-33.328137],[-70.667177,-33.328214],[-70.666528,-33.328502],[-70.666147,-33.32871],[-70.66529,-33.328905],[-70.664756,-33.329017],[-70.664062,-33.329128],[-70.663514,-33.329257],[-70.663259,-33.32932],[-70.662671,-33.329381],[-70.66262,-33.329388],[-70.662044,-33.329278],[-70.661421,-33.329035],[-70.660738,-33.328922],[-70.660004,-33.328806],[-70.659272,-33.328604],[-70.658696,-33.328494],[-70.658165,-33.328521],[-70.657729,-33.328771],[-70.657549,-33.329211],[-70.65732,-33.329559],[-70.657036,-33.32995],[-70.656582,-33.330555],[-70.656189,-33.331028],[-70.65579,-33.331591],[-70.655396,-33.332068],[-70.654687,-33.332484],[-70.654079,-33.332999],[-70.653265,-33.333412],[-70.652241,-33.333777],[-70.651696,-33.334114],[-70.651193,-33.334628],[-70.650746,-33.335103],[-70.650405,-33.335578],[-70.650114,-33.336104],[-70.649872,-33.336717],[-70.649534,-33.337146],[-70.649042,-33.33744],[-70.648437,-33.337909],[-70.648106,-33.338164],[-70.647834,-33.338334],[-70.647496,-33.338719],[-70.647208,-33.3392],[-70.647182,-33.33973],[-70.646897,-33.340121],[-70.646348,-33.340543],[-70.645958,-33.340926],[-70.645566,-33.341358],[-70.645117,-33.341874],[-70.644577,-33.34208],[-70.643721,-33.342271],[-70.643027,-33.342377],[-70.642242,-33.342219],[-70.641498,-33.342283],[-70.641121,-33.3424],[-70.640533,-33.342515],[-70.640435,-33.342538],[-70.640051,-33.342629],[-70.639411,-33.342741],[-70.63851,-33.342755],[-70.63794,-33.342509],[-70.637262,-33.34231],[-70.63659,-33.341975],[-70.636027,-33.341599],[-70.635569,-33.341228],[-70.634742,-33.340843],[-70.634222,-33.340649],[-70.63365,-33.340448],[-70.632862,-33.340335],[-70.632323,-33.340537],[-70.631569,-33.340776],[-70.630885,-33.340707],[-70.630092,-33.340679],[-70.628772,-33.340632],[-70.627442,-33.340765],[-70.626532,-33.340954],[-70.625846,-33.34093],[-70.625007,-33.340765],[-70.624107,-33.340778],[-70.623402,-33.341109],[-70.622587,-33.341527],[-70.62183,-33.341856],[-70.621075,-33.34214],[-70.620377,-33.342336],[-70.619527,-33.342396],[-70.619336,-33.34236],[-70.618636,-33.342229],[-70.61847,-33.342151],[-70.618015,-33.341942],[-70.617332,-33.341827],[-70.616696,-33.34185],[-70.616068,-33.341693],[-70.615234,-33.341442],[-70.614508,-33.341151],[-70.613993,-33.340867],[-70.613262,-33.340661],[-70.612739,-33.340552],[-70.611953,-33.340394],[-70.611061,-33.340227],[-70.610176,-33.33993],[-70.609232,-33.339762],[-70.6086,-33.339699],[-70.607865,-33.339582],[-70.606859,-33.339592],[-70.605847,-33.339732],[-70.604962,-33.339435],[-70.604183,-33.339141],[-70.603303,-33.338754],[-70.602416,-33.338502],[-70.601522,-33.33838],[-70.60056,-33.338567],[-70.599715,-33.338537],[-70.598344,-33.338443],[-70.597459,-33.338146],[-70.596523,-33.337802],[-70.596222,-33.33748],[-70.596093,-33.337058],[-70.595664,-33.337692],[-70.59534,-33.338114],[-70.594971,-33.338398],[-70.594228,-33.338582],[-70.592734,-33.338601],[-70.592403,-33.338675],[-70.591826,-33.338926],[-70.591417,-33.33921],[-70.590928,-33.339739],[-70.590609,-33.34044],[-70.590266,-33.342151],[-70.589872,-33.343306],[-70.589196,-33.344952],[-70.588879,-33.345758],[-70.588107,-33.346708],[-70.586184,-33.348231],[-70.583768,-33.350074],[-70.583115,-33.350674],[-70.582621,-33.350924],[-70.582515,-33.350965],[-70.582624,-33.351098],[-70.582754,-33.351376],[-70.583133,-33.351684],[-70.583471,-33.351994],[-70.58381,-33.352407],[-70.584188,-33.352611],[-70.584689,-33.352779],[-70.585147,-33.352878],[-70.585606,-33.353012],[-70.585817,-33.353148],[-70.586028,-33.353389],[-70.586368,-33.353803],[-70.586833,-33.35425],[-70.587252,-33.354454],[-70.587793,-33.354551],[-70.588375,-33.354579],[-70.589081,-33.35457],[-70.589787,-33.35463],[-70.590829,-33.354861],[-70.59204,-33.355229],[-70.592627,-33.355535],[-70.593008,-33.355913],[-70.593264,-33.356293],[-70.593602,-33.356637],[-70.594024,-33.357015],[-70.594488,-33.357392],[-70.595038,-33.357977],[-70.595837,-33.358525],[-70.596383,-33.358866],[-70.596723,-33.359314],[-70.596898,-33.3598],[-70.597367,-33.360456],[-70.598334,-33.361105],[-70.59909,-33.361583],[-70.600139,-33.362232],[-70.601062,-33.362708],[-70.600611,-33.363027],[-70.599588,-33.363876],[-70.598688,-33.364585],[-70.597746,-33.365294],[-70.59734,-33.365787],[-70.597345,-33.3661],[-70.597354,-33.366553],[-70.597448,-33.367179],[-70.597466,-33.368189],[-70.597623,-33.369929],[-70.597556,-33.370801],[-70.597605,-33.371219],[-70.597777,-33.371565],[-70.598198,-33.371873],[-70.599087,-33.372802],[-70.599821,-33.374326],[-70.600089,-33.375333],[-70.600103,-33.376134],[-70.600002,-33.377424],[-70.60002,-33.378365],[-70.600156,-33.37899],[-70.600496,-33.379404],[-70.601001,-33.379815],[-70.602895,-33.381184],[-70.603618,-33.382116],[-70.603883,-33.382948],[-70.60389,-33.383366],[-70.603658,-33.384275],[-70.603262,-33.385326],[-70.602817,-33.385993],[-70.602456,-33.386322],[-70.602,-33.386736],[-70.601521,-33.387752],[-70.601451,-33.388485],[-70.601712,-33.389143],[-70.602265,-33.389833],[-70.602984,-33.39052],[-70.605856,-33.393166],[-70.60743,-33.395166],[-70.608541,-33.396859],[-70.608937,-33.398038],[-70.60929,-33.399184],[-70.610071,-33.400985],[-70.610391,-33.402584],[-70.610486,-33.40321],[-70.61054,-33.403906],[-70.610561,-33.405017],[-70.618043,-33.399165],[-70.62162,-33.39673],[-70.622323,-33.396023],[-70.62409,-33.394711],[-70.62495,-33.394147],[-70.624989,-33.394127],[-70.624991,-33.394128],[-70.625201,-33.394029],[-70.625557,-33.39386],[-70.62617,-33.393578],[-70.62657,-33.393369],[-70.626757,-33.393276],[-70.626982,-33.393142],[-70.627198,-33.393015],[-70.627394,-33.392901],[-70.627603,-33.39277],[-70.627822,-33.39263],[-70.62783,-33.392618],[-70.627893,-33.392585],[-70.629843,-33.391148],[-70.631788,-33.38971],[-70.634404,-33.387781],[-70.636662,-33.386119],[-70.639208,-33.38424],[-70.641379,-33.382694],[-70.643241,-33.381697],[-70.644201,-33.381215],[-70.645262,-33.380763],[-70.646436,-33.380323],[-70.647001,-33.380102],[-70.647652,-33.37985],[-70.648449,-33.379561],[-70.648834,-33.3794],[-70.651019,-33.378572],[-70.652821,-33.377902],[-70.654859,-33.377156],[-70.655438,-33.376992],[-70.656188,-33.376777],[-70.657643,-33.376225],[-70.658457,-33.375834],[-70.659244,-33.375517],[-70.660059,-33.37521],[-70.660467,-33.375063],[-70.66094,-33.374896],[-70.661726,-33.374611],[-70.662478,-33.374325],[-70.665026,-33.373359],[-70.6665,-33.372809],[-70.668182,-33.372158],[-70.66893,-33.371885],[-70.669341,-33.371766],[-70.669496,-33.371735],[-70.669641,-33.371706],[-70.669815,-33.37165],[-70.670022,-33.371583],[-70.670513,-33.371413],[-70.670935,-33.371258],[-70.671348,-33.371092],[-70.671821,-33.370916],[-70.672056,-33.370828],[-70.672328,-33.370692],[-70.672848,-33.370443],[-70.673102,-33.370322],[-70.673863,-33.370033],[-70.675265,-33.369507],[-70.675694,-33.369346],[-70.677226,-33.368774],[-70.677834,-33.368545],[-70.678303,-33.368364],[-70.679032,-33.368094],[-70.679668,-33.367853],[-70.680396,-33.367584],[-70.680725,-33.367459],[-70.680998,-33.367354],[-70.681452,-33.36718],[-70.681802,-33.367046],[-70.682245,-33.366904],[-70.682597,-33.366806],[-70.682932,-33.366722],[-70.683191,-33.366666],[-70.683581,-33.366596],[-70.683836,-33.366554],[-70.684136,-33.366517],[-70.68449,-33.36649],[-70.684889,-33.366457],[-70.685429,-33.366413],[-70.6864,-33.366351],[-70.687612,-33.366271],[-70.687868,-33.366275],[-70.687986,-33.366307],[-70.688117,-33.366292],[-70.688247,-33.366294],[-70.688507,-33.366294],[-70.688632,-33.366292],[-70.688903,-33.366272],[-70.689209,-33.366242],[-70.689282,-33.366237]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1310,"DIS_ELEC":17,"NOM_COM":"Huechuraba","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":44740350.6455,"SHAPE_LENG":32111.265818,"SHAPE_Le_1":32061.97711},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.652861,-33.547608],[-70.653197,-33.548791],[-70.653503,-33.548744],[-70.653508,-33.548761],[-70.65453,-33.548577],[-70.654688,-33.548573],[-70.656805,-33.548218],[-70.656804,-33.54817],[-70.656816,-33.548169],[-70.65678,-33.548023],[-70.657548,-33.547892],[-70.657957,-33.547826],[-70.659083,-33.547649],[-70.661513,-33.547241],[-70.663097,-33.546975],[-70.663978,-33.54683],[-70.664133,-33.546801],[-70.664653,-33.546713],[-70.665527,-33.546566],[-70.666665,-33.546369],[-70.66695,-33.546232],[-70.667726,-33.54581],[-70.668086,-33.545615],[-70.66825,-33.545399],[-70.668385,-33.545348],[-70.668761,-33.545206],[-70.669683,-33.544859],[-70.670305,-33.544624],[-70.671091,-33.544333],[-70.671413,-33.544214],[-70.672102,-33.54396],[-70.672624,-33.543763],[-70.673582,-33.543416],[-70.674588,-33.543053],[-70.674779,-33.542984],[-70.675357,-33.542775],[-70.675778,-33.542618],[-70.676074,-33.54251],[-70.676632,-33.542313],[-70.677137,-33.542142],[-70.677628,-33.541964],[-70.678129,-33.541777],[-70.67864,-33.54159],[-70.679369,-33.541327],[-70.680039,-33.541075],[-70.680424,-33.540934],[-70.681118,-33.540672],[-70.682075,-33.540334],[-70.683713,-33.539726],[-70.68456,-33.539429],[-70.685382,-33.539118],[-70.685379,-33.539111],[-70.685619,-33.539026],[-70.685764,-33.538974],[-70.682732,-33.533461],[-70.681909,-33.531975],[-70.677023,-33.523146],[-70.676105,-33.52133],[-70.675096,-33.519335],[-70.673326,-33.515331],[-70.671894,-33.512091],[-70.671331,-33.510902],[-70.671234,-33.510698],[-70.671101,-33.51075],[-70.67049,-33.51098],[-70.669859,-33.511131],[-70.668866,-33.511424],[-70.667113,-33.511961],[-70.665017,-33.512591],[-70.662953,-33.513217],[-70.661382,-33.513707],[-70.65807,-33.514704],[-70.655775,-33.515161],[-70.651288,-33.516051],[-70.649028,-33.516487],[-70.646806,-33.516931],[-70.644621,-33.517366],[-70.644675,-33.51757],[-70.644782,-33.517973],[-70.644893,-33.518364],[-70.645125,-33.51919],[-70.645343,-33.520025],[-70.645441,-33.520322],[-70.645709,-33.521311],[-70.645977,-33.522308],[-70.646191,-33.523032],[-70.646256,-33.523251],[-70.646622,-33.524293],[-70.64677,-33.52485],[-70.647098,-33.526054],[-70.647605,-33.527857],[-70.647708,-33.528234],[-70.648002,-33.528614],[-70.650859,-33.53891],[-70.651107,-33.539786],[-70.650915,-33.540186],[-70.650987,-33.540844],[-70.651776,-33.54362],[-70.652093,-33.544879],[-70.652861,-33.547608]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1310,"DIS_ELEC":27,"NOM_COM":"La Cisterna","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":10076219.337,"SHAPE_LENG":12797.595762,"SHAPE_Le_1":12852.169804},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.636586,-33.518886],[-70.636594,-33.518728],[-70.636098,-33.518669],[-70.635866,-33.518641],[-70.63546,-33.518567],[-70.634836,-33.518532],[-70.634174,-33.518465],[-70.63355,-33.518393],[-70.632899,-33.518329],[-70.632363,-33.518248],[-70.631756,-33.5182],[-70.631175,-33.518137],[-70.630605,-33.518072],[-70.630104,-33.518017],[-70.629647,-33.517965],[-70.629091,-33.517911],[-70.62867,-33.517869],[-70.627935,-33.517789],[-70.627455,-33.517737],[-70.627252,-33.517704],[-70.627125,-33.517669],[-70.626919,-33.517595],[-70.626727,-33.517519],[-70.626595,-33.51746],[-70.626105,-33.517223],[-70.625647,-33.517021],[-70.625472,-33.516934],[-70.624868,-33.516653],[-70.624159,-33.516323],[-70.622665,-33.515627],[-70.62086,-33.514794],[-70.620755,-33.514713],[-70.619925,-33.514328],[-70.617931,-33.513813],[-70.616075,-33.513386],[-70.615948,-33.51333],[-70.615855,-33.513328],[-70.615015,-33.513107],[-70.614084,-33.513098],[-70.613646,-33.513085],[-70.611301,-33.513059],[-70.611265,-33.513058],[-70.611025,-33.515193],[-70.610924,-33.51615],[-70.610655,-33.518477],[-70.61036,-33.520811],[-70.610129,-33.522846],[-70.609984,-33.524118],[-70.609749,-33.526187],[-70.609822,-33.52843],[-70.609986,-33.533153],[-70.610041,-33.534793],[-70.610134,-33.537387],[-70.610318,-33.539019],[-70.610312,-33.539754],[-70.61044,-33.54333],[-70.610559,-33.546654],[-70.610937,-33.54665],[-70.610941,-33.546645],[-70.611391,-33.546631],[-70.612537,-33.546599],[-70.61298,-33.546593],[-70.61371,-33.546569],[-70.614036,-33.546543],[-70.614464,-33.546474],[-70.614824,-33.546397],[-70.614857,-33.546523],[-70.614818,-33.546653],[-70.614809,-33.546663],[-70.614815,-33.546662],[-70.614654,-33.547193],[-70.614572,-33.547478],[-70.61448,-33.547791],[-70.614215,-33.548695],[-70.61403,-33.549339],[-70.613705,-33.550482],[-70.612909,-33.553308],[-70.612691,-33.554064],[-70.612602,-33.554427],[-70.612231,-33.555611],[-70.612607,-33.555734],[-70.612616,-33.555703],[-70.612632,-33.555706],[-70.616218,-33.556483],[-70.619892,-33.557371],[-70.623554,-33.558199],[-70.625613,-33.558645],[-70.627337,-33.559031],[-70.627349,-33.559074],[-70.627362,-33.55911],[-70.627439,-33.559126],[-70.630709,-33.559808],[-70.630729,-33.559737],[-70.630754,-33.559359],[-70.630839,-33.558997],[-70.630898,-33.558715],[-70.631019,-33.558066],[-70.631034,-33.557973],[-70.631179,-33.557428],[-70.631494,-33.555977],[-70.631697,-33.555034],[-70.631872,-33.554266],[-70.631792,-33.554186],[-70.632483,-33.551455],[-70.632926,-33.549345],[-70.633266,-33.547571],[-70.634102,-33.542665],[-70.634131,-33.542329],[-70.634156,-33.541961],[-70.634473,-33.537785],[-70.634511,-33.537291],[-70.634576,-33.535974],[-70.634607,-33.5347],[-70.634672,-33.533946],[-70.63476,-33.532888],[-70.635079,-33.530532],[-70.635321,-33.529752],[-70.635462,-33.529148],[-70.635552,-33.528157],[-70.635653,-33.527314],[-70.635855,-33.525516],[-70.63606,-33.523219],[-70.636576,-33.518885],[-70.636586,-33.518886]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1311,"DIS_ELEC":25,"NOM_COM":"La Granja","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":10059460.6476,"SHAPE_LENG":14001.424777,"SHAPE_Le_1":14049.420448},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.632463,-33.558142],[-70.632073,-33.558165],[-70.631407,-33.558112],[-70.631411,-33.558098],[-70.631019,-33.558066],[-70.630898,-33.558715],[-70.630839,-33.558997],[-70.630754,-33.559359],[-70.630729,-33.559737],[-70.630709,-33.559808],[-70.627439,-33.559126],[-70.627362,-33.55911],[-70.627349,-33.559074],[-70.627337,-33.559031],[-70.625613,-33.558645],[-70.623554,-33.558199],[-70.619892,-33.557371],[-70.616218,-33.556483],[-70.612632,-33.555706],[-70.612616,-33.555703],[-70.612607,-33.555734],[-70.612231,-33.555611],[-70.611916,-33.556772],[-70.611694,-33.557546],[-70.610702,-33.561019],[-70.61044,-33.561963],[-70.610721,-33.562001],[-70.610721,-33.562002],[-70.612516,-33.562184],[-70.612494,-33.562204],[-70.612512,-33.562204],[-70.612502,-33.562232],[-70.612217,-33.564127],[-70.611806,-33.566944],[-70.61144,-33.569432],[-70.611332,-33.570152],[-70.611271,-33.570566],[-70.611297,-33.57057],[-70.610018,-33.580831],[-70.609355,-33.586637],[-70.609401,-33.586705],[-70.609353,-33.586801],[-70.608522,-33.586921],[-70.607774,-33.591442],[-70.607481,-33.594269],[-70.607255,-33.594239],[-70.605965,-33.602018],[-70.60646,-33.602046],[-70.606555,-33.602045],[-70.606553,-33.60206],[-70.61958,-33.603858],[-70.62692,-33.604673],[-70.626658,-33.609436],[-70.626591,-33.610653],[-70.626569,-33.611769],[-70.626533,-33.612813],[-70.626521,-33.613492],[-70.626458,-33.615369],[-70.62645,-33.615991],[-70.626433,-33.616352],[-70.626434,-33.616911],[-70.626416,-33.617678],[-70.626427,-33.618201],[-70.626413,-33.618634],[-70.626512,-33.618813],[-70.627116,-33.621159],[-70.627615,-33.623064],[-70.627747,-33.623666],[-70.628069,-33.624988],[-70.6282,-33.625555],[-70.628485,-33.626452],[-70.628509,-33.626858],[-70.628683,-33.627794],[-70.629111,-33.627768],[-70.629107,-33.627754],[-70.643141,-33.627223],[-70.643135,-33.627178],[-70.642932,-33.625567],[-70.64268,-33.623586],[-70.642442,-33.621669],[-70.642213,-33.619832],[-70.642379,-33.619812],[-70.644347,-33.619621],[-70.644107,-33.617688],[-70.643875,-33.615842],[-70.643665,-33.614126],[-70.643622,-33.613891],[-70.643382,-33.612016],[-70.643208,-33.61062],[-70.643165,-33.610089],[-70.643157,-33.609909],[-70.644971,-33.609753],[-70.654484,-33.608945],[-70.656653,-33.608756],[-70.659316,-33.608528],[-70.6623,-33.608267],[-70.665907,-33.607939],[-70.670615,-33.607477],[-70.67049,-33.607106],[-70.670433,-33.606954],[-70.669641,-33.60466],[-70.669298,-33.603681],[-70.668784,-33.602226],[-70.668303,-33.600878],[-70.668236,-33.60065],[-70.668069,-33.600092],[-70.667497,-33.598494],[-70.666814,-33.596524],[-70.666425,-33.595286],[-70.665521,-33.59252],[-70.665259,-33.591766],[-70.665076,-33.591214],[-70.664961,-33.590778],[-70.664726,-33.589961],[-70.664675,-33.589781],[-70.663988,-33.587563],[-70.663799,-33.587006],[-70.663635,-33.586468],[-70.663244,-33.585174],[-70.662819,-33.583885],[-70.66251,-33.582413],[-70.661861,-33.580188],[-70.660685,-33.575667],[-70.660113,-33.573881],[-70.659933,-33.573778],[-70.659299,-33.571517],[-70.658609,-33.56875],[-70.656788,-33.562547],[-70.65579,-33.558175],[-70.655131,-33.555839],[-70.654938,-33.554955],[-70.654881,-33.554977],[-70.65382,-33.555117],[-70.65343,-33.555175],[-70.653217,-33.555206],[-70.652429,-33.555325],[-70.651907,-33.555395],[-70.65151,-33.555446],[-70.651121,-33.555505],[-70.650647,-33.555574],[-70.65022,-33.555634],[-70.649178,-33.555792],[-70.648441,-33.555901],[-70.64741,-33.55605],[-70.646989,-33.556119],[-70.646596,-33.556178],[-70.646258,-33.556237],[-70.645922,-33.556295],[-70.645504,-33.556355],[-70.644936,-33.556444],[-70.644503,-33.556504],[-70.64406,-33.556566],[-70.643858,-33.556592],[-70.643083,-33.556694],[-70.641808,-33.556855],[-70.641366,-33.556897],[-70.64049,-33.557008],[-70.639673,-33.557129],[-70.63935,-33.557176],[-70.638851,-33.557246],[-70.63845,-33.557296],[-70.638057,-33.557356],[-70.637466,-33.557436],[-70.636657,-33.557546],[-70.635853,-33.557661],[-70.635277,-33.55774],[-70.634648,-33.557829],[-70.634074,-33.557859],[-70.63364,-33.557973],[-70.63316,-33.55804],[-70.632463,-33.558142]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1311,"DIS_ELEC":29,"NOM_COM":"La Pintana","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":30491221.6843,"SHAPE_LENG":26302.790697,"SHAPE_Le_1":26281.25403},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.539081,-33.428925],[-70.539093,-33.430074],[-70.538991,-33.430774],[-70.538877,-33.431271],[-70.538757,-33.43166],[-70.538568,-33.432123],[-70.538302,-33.432685],[-70.538137,-33.432982],[-70.538025,-33.433193],[-70.537954,-33.433379],[-70.537925,-33.433376],[-70.537933,-33.433433],[-70.537447,-33.433386],[-70.536639,-33.433287],[-70.534006,-33.432963],[-70.5325,-33.432779],[-70.530714,-33.432554],[-70.529907,-33.432455],[-70.529255,-33.432374],[-70.528569,-33.432289],[-70.527421,-33.432148],[-70.526111,-33.431989],[-70.524986,-33.431849],[-70.523127,-33.431619],[-70.523028,-33.431611],[-70.523028,-33.431611],[-70.522564,-33.431819],[-70.52198,-33.432131],[-70.521945,-33.432129],[-70.52191,-33.432172],[-70.521736,-33.432275],[-70.521365,-33.432469],[-70.521102,-33.432553],[-70.520796,-33.432647],[-70.520457,-33.432775],[-70.520375,-33.432787],[-70.519987,-33.432956],[-70.519968,-33.432974],[-70.51949,-33.433169],[-70.51939,-33.433138],[-70.518739,-33.433619],[-70.517554,-33.434314],[-70.516956,-33.434707],[-70.516696,-33.434832],[-70.515998,-33.435136],[-70.515024,-33.435377],[-70.510649,-33.435594],[-70.509478,-33.435707],[-70.508156,-33.436149],[-70.506879,-33.436919],[-70.504555,-33.438193],[-70.503436,-33.439091],[-70.502897,-33.439557],[-70.502093,-33.44055],[-70.500832,-33.44227],[-70.500721,-33.442665],[-70.500495,-33.44316],[-70.500189,-33.443524],[-70.499764,-33.443857],[-70.498912,-33.444326],[-70.498101,-33.444926],[-70.497639,-33.445358],[-70.49741,-33.445688],[-70.497222,-33.446084],[-70.496913,-33.446317],[-70.496602,-33.446452],[-70.496215,-33.446686],[-70.495985,-33.446984],[-70.495953,-33.447378],[-70.495959,-33.447739],[-70.496168,-33.44849],[-70.496257,-33.449112],[-70.496305,-33.449636],[-70.49635,-33.449996],[-70.496357,-33.450389],[-70.49613,-33.450818],[-70.495823,-33.451183],[-70.495165,-33.451584],[-70.494161,-33.452317],[-70.493431,-33.45308],[-70.492816,-33.45371],[-70.492235,-33.454045],[-70.491848,-33.454312],[-70.491346,-33.454679],[-70.490998,-33.454912],[-70.490611,-33.455114],[-70.490068,-33.455383],[-70.489682,-33.455715],[-70.489648,-33.456011],[-70.489459,-33.456373],[-70.489189,-33.456639],[-70.489,-33.456969],[-70.488927,-33.457331],[-70.488936,-33.457822],[-70.488786,-33.458217],[-70.488325,-33.458682],[-70.487826,-33.459245],[-70.487716,-33.459673],[-70.487565,-33.460002],[-70.487335,-33.460267],[-70.487143,-33.460466],[-70.486993,-33.460862],[-70.486963,-33.461387],[-70.486946,-33.461752],[-70.493726,-33.461566],[-70.503684,-33.461093],[-70.507116,-33.460842],[-70.507286,-33.460815],[-70.511485,-33.46034],[-70.516039,-33.460037],[-70.518204,-33.460011],[-70.518444,-33.459982],[-70.51872,-33.459925],[-70.521401,-33.459599],[-70.521918,-33.459596],[-70.522013,-33.45959],[-70.522418,-33.45956],[-70.523099,-33.459511],[-70.523856,-33.459469],[-70.524625,-33.459426],[-70.525463,-33.459376],[-70.525859,-33.459352],[-70.526415,-33.459316],[-70.526964,-33.459286],[-70.527749,-33.459233],[-70.529031,-33.459147],[-70.529341,-33.459134],[-70.529549,-33.459141],[-70.529536,-33.459294],[-70.529547,-33.459431],[-70.529538,-33.459451],[-70.529563,-33.45945],[-70.529579,-33.459542],[-70.529637,-33.459682],[-70.529713,-33.45981],[-70.52981,-33.459974],[-70.529881,-33.46011],[-70.529904,-33.460196],[-70.529911,-33.460333],[-70.529938,-33.460638],[-70.530038,-33.460875],[-70.53021,-33.461314],[-70.530305,-33.461694],[-70.53037,-33.462051],[-70.530405,-33.462292],[-70.530511,-33.462794],[-70.530546,-33.462992],[-70.53056,-33.463315],[-70.530564,-33.463409],[-70.530562,-33.463748],[-70.53064,-33.464008],[-70.53087,-33.464679],[-70.530956,-33.464925],[-70.531006,-33.465044],[-70.531092,-33.465185],[-70.531246,-33.465439],[-70.531423,-33.465447],[-70.531424,-33.465445],[-70.531425,-33.465446],[-70.531994,-33.465275],[-70.532369,-33.465171],[-70.533087,-33.464973],[-70.53436,-33.464614],[-70.535666,-33.464237],[-70.535878,-33.464181],[-70.536012,-33.464143],[-70.536691,-33.463954],[-70.537114,-33.463828],[-70.537614,-33.46369],[-70.538077,-33.463553],[-70.538524,-33.463428],[-70.538987,-33.463288],[-70.539789,-33.463067],[-70.540054,-33.462994],[-70.540351,-33.462962],[-70.541506,-33.462864],[-70.541687,-33.462867],[-70.542005,-33.46286],[-70.542268,-33.462868],[-70.542392,-33.462918],[-70.542754,-33.463082],[-70.543031,-33.463207],[-70.543202,-33.463284],[-70.543406,-33.463376],[-70.543465,-33.463389],[-70.54417,-33.463658],[-70.544206,-33.463644],[-70.54482,-33.463591],[-70.54549,-33.463505],[-70.546061,-33.463435],[-70.547613,-33.463223],[-70.548678,-33.463043],[-70.549893,-33.462835],[-70.550567,-33.462713],[-70.550898,-33.462639],[-70.551662,-33.462632],[-70.552946,-33.462615],[-70.553537,-33.462608],[-70.5549,-33.4626],[-70.556362,-33.462602],[-70.556579,-33.462598],[-70.55783,-33.462575],[-70.559431,-33.462569],[-70.560183,-33.462545],[-70.56048,-33.462532],[-70.560906,-33.462532],[-70.561218,-33.462529],[-70.561481,-33.462529],[-70.56204,-33.462522],[-70.562222,-33.462501],[-70.562347,-33.462482],[-70.56256,-33.462425],[-70.562963,-33.462294],[-70.563076,-33.462256],[-70.563567,-33.462087],[-70.56402,-33.461931],[-70.564505,-33.46176],[-70.565111,-33.461568],[-70.565196,-33.461574],[-70.565397,-33.461469],[-70.56581,-33.461326],[-70.567172,-33.46087],[-70.567742,-33.460656],[-70.568199,-33.460487],[-70.568946,-33.460212],[-70.569199,-33.460104],[-70.569773,-33.459881],[-70.570019,-33.459781],[-70.570565,-33.459573],[-70.571184,-33.459362],[-70.571464,-33.459264],[-70.572135,-33.459057],[-70.572257,-33.459011],[-70.5724,-33.458968],[-70.57197,-33.457707],[-70.571435,-33.455495],[-70.57081,-33.453509],[-70.570868,-33.453274],[-70.570902,-33.452663],[-70.572309,-33.443903],[-70.572576,-33.442927],[-70.572686,-33.442325],[-70.572862,-33.441453],[-70.57296,-33.440748],[-70.573029,-33.440333],[-70.573105,-33.439989],[-70.573242,-33.439185],[-70.573351,-33.438606],[-70.573607,-33.437935],[-70.573726,-33.437855],[-70.573823,-33.437835],[-70.574022,-33.437785],[-70.57583,-33.436752],[-70.576901,-33.436383],[-70.578745,-33.435752],[-70.580058,-33.435098],[-70.581806,-33.434054],[-70.582749,-33.43345],[-70.583515,-33.432833],[-70.583932,-33.432442],[-70.584312,-33.431963],[-70.584433,-33.431783],[-70.584437,-33.431783],[-70.584124,-33.431676],[-70.580147,-33.431442],[-70.5786,-33.431351],[-70.574808,-33.43124],[-70.574382,-33.431235],[-70.570103,-33.431062],[-70.565075,-33.430939],[-70.563756,-33.430888],[-70.559693,-33.430711],[-70.557335,-33.430579],[-70.55462,-33.430442],[-70.554075,-33.430428],[-70.551552,-33.430193],[-70.547332,-33.429773],[-70.547228,-33.429823],[-70.546991,-33.429853],[-70.546919,-33.429872],[-70.546829,-33.429862],[-70.545426,-33.429699],[-70.544217,-33.429559],[-70.543449,-33.429468],[-70.542368,-33.429342],[-70.541161,-33.4292],[-70.539802,-33.429047],[-70.539081,-33.428925]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1311,"DIS_ELEC":24,"NOM_COM":"La Reina","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":23334550.406,"SHAPE_LENG":23724.899355,"SHAPE_Le_1":23638.520628},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.532351,-33.382168],[-70.532348,-33.382167],[-70.530844,-33.380758],[-70.5301,-33.380073],[-70.529351,-33.379516],[-70.528748,-33.378649],[-70.527941,-33.377888],[-70.527613,-33.377565],[-70.527093,-33.377147],[-70.525986,-33.376516],[-70.525325,-33.376205],[-70.524944,-33.375874],[-70.52241,-33.37496],[-70.517867,-33.372897],[-70.517573,-33.372763],[-70.517609,-33.372706],[-70.517462,-33.372644],[-70.516413,-33.372206],[-70.515911,-33.372023],[-70.515303,-33.371832],[-70.515042,-33.371752],[-70.514446,-33.371572],[-70.512925,-33.371094],[-70.512634,-33.370998],[-70.511455,-33.370742],[-70.510172,-33.370514],[-70.50986,-33.370483],[-70.509013,-33.370339],[-70.508571,-33.370263],[-70.507884,-33.370172],[-70.506882,-33.37011],[-70.506071,-33.370038],[-70.505724,-33.369979],[-70.505326,-33.369872],[-70.504894,-33.36974],[-70.504398,-33.369556],[-70.503507,-33.369132],[-70.502209,-33.368552],[-70.502137,-33.368518],[-70.501823,-33.368339],[-70.50174,-33.368327],[-70.500851,-33.367926],[-70.500389,-33.367693],[-70.500128,-33.367563],[-70.499667,-33.367345],[-70.499641,-33.367332],[-70.499634,-33.367331],[-70.499633,-33.367329],[-70.499274,-33.367159],[-70.498823,-33.367094],[-70.498395,-33.367034],[-70.497987,-33.36702],[-70.497402,-33.367014],[-70.496774,-33.367003],[-70.496136,-33.366978],[-70.495698,-33.366956],[-70.495402,-33.366851],[-70.495236,-33.366727],[-70.494856,-33.366252],[-70.494489,-33.365807],[-70.494231,-33.365494],[-70.494117,-33.365361],[-70.493905,-33.365183],[-70.493636,-33.365024],[-70.493349,-33.364865],[-70.493059,-33.364715],[-70.492776,-33.364619],[-70.492208,-33.364581],[-70.491869,-33.364567],[-70.491815,-33.364579],[-70.491665,-33.364534],[-70.491287,-33.364468],[-70.490826,-33.364473],[-70.490811,-33.364477],[-70.490746,-33.364479],[-70.490215,-33.364493],[-70.489763,-33.364508],[-70.48933,-33.364564],[-70.489022,-33.364636],[-70.488942,-33.364637],[-70.488489,-33.364711],[-70.488466,-33.364702],[-70.487607,-33.364662],[-70.486834,-33.364613],[-70.486155,-33.364569],[-70.485722,-33.364541],[-70.485431,-33.3645],[-70.485168,-33.36444],[-70.484851,-33.364344],[-70.484655,-33.364302],[-70.484455,-33.364277],[-70.484175,-33.364316],[-70.48391,-33.364446],[-70.483556,-33.364748],[-70.48342,-33.36483],[-70.482917,-33.364918],[-70.482717,-33.36489],[-70.482049,-33.365057],[-70.480876,-33.365635],[-70.479761,-33.365991],[-70.478502,-33.366314],[-70.477775,-33.366716],[-70.476532,-33.367381],[-70.475909,-33.367919],[-70.47553,-33.368419],[-70.475475,-33.368779],[-70.475928,-33.369065],[-70.477235,-33.369502],[-70.477425,-33.369657],[-70.478141,-33.370065],[-70.478713,-33.370356],[-70.479997,-33.370876],[-70.480568,-33.371047],[-70.480996,-33.371221],[-70.481356,-33.371573],[-70.481366,-33.372168],[-70.481307,-33.372823],[-70.481526,-33.373237],[-70.481816,-33.37359],[-70.482251,-33.37418],[-70.482331,-33.374714],[-70.48241,-33.375189],[-70.482702,-33.375662],[-70.483065,-33.376193],[-70.483502,-33.376842],[-70.483731,-33.377791],[-70.483612,-33.37916],[-70.482929,-33.380715],[-70.482029,-33.381975],[-70.481053,-33.382938],[-70.48056,-33.383182],[-70.47993,-33.383606],[-70.479662,-33.383977],[-70.479583,-33.384086],[-70.479522,-33.384681],[-70.479815,-33.385213],[-70.480037,-33.385746],[-70.480122,-33.386578],[-70.479788,-33.387831],[-70.479307,-33.388729],[-70.479176,-33.389325],[-70.478485,-33.390404],[-70.477995,-33.390767],[-70.477715,-33.391008],[-70.477295,-33.391311],[-70.477159,-33.391669],[-70.477168,-33.392204],[-70.477317,-33.392619],[-70.477544,-33.393449],[-70.477551,-33.393865],[-70.477133,-33.394346],[-70.476425,-33.394414],[-70.475787,-33.394422],[-70.474938,-33.394491],[-70.474088,-33.394561],[-70.473454,-33.394806],[-70.472532,-33.394817],[-70.471681,-33.394827],[-70.47097,-33.394717],[-70.470118,-33.394667],[-70.46941,-33.394676],[-70.468279,-33.394927],[-70.467431,-33.395115],[-70.466651,-33.395125],[-70.464808,-33.395147],[-70.462826,-33.395348],[-70.461697,-33.395659],[-70.460571,-33.396208],[-70.459372,-33.396579],[-70.457604,-33.396897],[-70.456544,-33.397088],[-70.455906,-33.397095],[-70.455409,-33.397101],[-70.454913,-33.397107],[-70.45466,-33.397253],[-70.454491,-33.39735],[-70.454362,-33.398065],[-70.454235,-33.398959],[-70.453888,-33.399439],[-70.453401,-33.39998],[-70.453411,-33.400575],[-70.453418,-33.400991],[-70.453359,-33.401705],[-70.453227,-33.402302],[-70.453235,-33.402837],[-70.453421,-33.405452],[-70.453648,-33.406342],[-70.453731,-33.407054],[-70.453743,-33.407768],[-70.453756,-33.408541],[-70.45405,-33.409133],[-70.45399,-33.409788],[-70.453936,-33.410799],[-70.453811,-33.411812],[-70.453656,-33.415323],[-70.453534,-33.416514],[-70.453055,-33.417531],[-70.451523,-33.419274],[-70.450053,-33.420422],[-70.448726,-33.421686],[-70.447323,-33.422654],[-70.445993,-33.423681],[-70.444869,-33.424348],[-70.442822,-33.424967],[-70.438582,-33.425968],[-70.437381,-33.426279],[-70.436181,-33.42665],[-70.435997,-33.426721],[-70.435547,-33.426895],[-70.434984,-33.427199],[-70.434882,-33.427343],[-70.43443,-33.427979],[-70.434017,-33.428757],[-70.433893,-33.429829],[-70.433764,-33.430604],[-70.43378,-33.431615],[-70.433658,-33.432806],[-70.433108,-33.433883],[-70.43221,-33.435381],[-70.43187,-33.436277],[-70.431599,-33.437053],[-70.431188,-33.43795],[-70.430917,-33.438727],[-70.431002,-33.439558],[-70.431298,-33.440328],[-70.431524,-33.441099],[-70.431604,-33.441633],[-70.431908,-33.442879],[-70.432136,-33.443828],[-70.432151,-33.44472],[-70.431881,-33.445556],[-70.431468,-33.446334],[-70.430699,-33.447057],[-70.429377,-33.448618],[-70.428897,-33.449635],[-70.4287,-33.450589],[-70.428647,-33.45172],[-70.428802,-33.452491],[-70.429098,-33.453261],[-70.429181,-33.453974],[-70.428913,-33.454929],[-70.428366,-33.456184],[-70.428172,-33.457376],[-70.428114,-33.45815],[-70.428421,-33.459574],[-70.4296,-33.462237],[-70.430686,-33.463533],[-70.431612,-33.463761],[-70.432401,-33.464227],[-70.43326,-33.464693],[-70.434125,-33.465516],[-70.434632,-33.466105],[-70.434857,-33.466876],[-70.435224,-33.467585],[-70.435445,-33.468059],[-70.435454,-33.468653],[-70.435323,-33.469309],[-70.434563,-33.470567],[-70.433526,-33.472245],[-70.433403,-33.473376],[-70.433635,-33.474504],[-70.433731,-33.476049],[-70.433972,-33.477771],[-70.433988,-33.478723],[-70.433999,-33.479377],[-70.434013,-33.480269],[-70.434163,-33.480743],[-70.434416,-33.48097],[-70.434884,-33.481389],[-70.435811,-33.481676],[-70.436169,-33.48185],[-70.436602,-33.482261],[-70.437758,-33.483497],[-70.438124,-33.484147],[-70.438346,-33.484739],[-70.438639,-33.485271],[-70.439004,-33.485862],[-70.439152,-33.486605],[-70.439778,-33.486597],[-70.440714,-33.486423],[-70.441651,-33.486281],[-70.442624,-33.485941],[-70.443208,-33.485803],[-70.443948,-33.485598],[-70.444846,-33.485489],[-70.445862,-33.485412],[-70.446873,-33.485039],[-70.447959,-33.484469],[-70.448887,-33.483803],[-70.449701,-33.483334],[-70.449972,-33.483167],[-70.450594,-33.482931],[-70.451295,-33.482758],[-70.452112,-33.482454],[-70.452962,-33.481788],[-70.453542,-33.481388],[-70.454392,-33.480755],[-70.455128,-33.48032],[-70.455942,-33.479884],[-70.456522,-33.479451],[-70.457216,-33.478886],[-70.458533,-33.478084],[-70.459305,-33.477484],[-70.460076,-33.476754],[-70.460695,-33.476353],[-70.46112,-33.476053],[-70.461704,-33.475883],[-70.46229,-33.47581],[-70.463345,-33.475765],[-70.464048,-33.475691],[-70.464906,-33.47555],[-70.465725,-33.475409],[-70.466156,-33.475404],[-70.466742,-33.475397],[-70.467212,-33.475391],[-70.467563,-33.475354],[-70.467993,-33.475316],[-70.468384,-33.475312],[-70.468853,-33.475306],[-70.469598,-33.475396],[-70.470693,-33.47535],[-70.47128,-33.475376],[-70.471633,-33.475404],[-70.471985,-33.475433],[-70.472063,-33.475408],[-70.472413,-33.475297],[-70.472956,-33.474995],[-70.473576,-33.47466],[-70.474271,-33.474095],[-70.475044,-33.473593],[-70.476044,-33.472565],[-70.476738,-33.471934],[-70.477043,-33.471504],[-70.477234,-33.471207],[-70.477498,-33.470647],[-70.477919,-33.470084],[-70.478802,-33.469123],[-70.481886,-33.466463],[-70.482541,-33.465865],[-70.483543,-33.465001],[-70.484316,-33.464434],[-70.485793,-33.463859],[-70.486485,-33.463195],[-70.486786,-33.462503],[-70.486934,-33.46201],[-70.486946,-33.461752],[-70.486963,-33.461387],[-70.486993,-33.460862],[-70.487143,-33.460466],[-70.487335,-33.460267],[-70.487565,-33.460002],[-70.487716,-33.459673],[-70.487826,-33.459245],[-70.488325,-33.458682],[-70.488786,-33.458217],[-70.488936,-33.457822],[-70.488927,-33.457331],[-70.489,-33.456969],[-70.489189,-33.456639],[-70.489459,-33.456373],[-70.489648,-33.456011],[-70.489682,-33.455715],[-70.490068,-33.455383],[-70.490611,-33.455114],[-70.490998,-33.454912],[-70.491346,-33.454679],[-70.491848,-33.454312],[-70.492235,-33.454045],[-70.492816,-33.45371],[-70.493431,-33.45308],[-70.494161,-33.452317],[-70.495165,-33.451584],[-70.495823,-33.451183],[-70.49613,-33.450818],[-70.496357,-33.450389],[-70.49635,-33.449996],[-70.496305,-33.449636],[-70.496257,-33.449112],[-70.496168,-33.44849],[-70.495959,-33.447739],[-70.495953,-33.447378],[-70.495985,-33.446984],[-70.496215,-33.446686],[-70.496602,-33.446452],[-70.496913,-33.446317],[-70.497222,-33.446084],[-70.49741,-33.445688],[-70.497639,-33.445358],[-70.498101,-33.444926],[-70.498912,-33.444326],[-70.499764,-33.443857],[-70.500189,-33.443524],[-70.500495,-33.44316],[-70.500721,-33.442665],[-70.500832,-33.44227],[-70.502093,-33.44055],[-70.502897,-33.439557],[-70.503436,-33.439091],[-70.504555,-33.438193],[-70.506879,-33.436919],[-70.508156,-33.436149],[-70.509478,-33.435707],[-70.510649,-33.435594],[-70.515024,-33.435377],[-70.515998,-33.435136],[-70.516696,-33.434832],[-70.516956,-33.434707],[-70.517554,-33.434314],[-70.518739,-33.433619],[-70.51939,-33.433138],[-70.51949,-33.433169],[-70.519968,-33.432974],[-70.519987,-33.432956],[-70.520375,-33.432787],[-70.520457,-33.432775],[-70.520796,-33.432647],[-70.521102,-33.432553],[-70.521365,-33.432469],[-70.521736,-33.432275],[-70.52191,-33.432172],[-70.521945,-33.432129],[-70.52198,-33.432131],[-70.522564,-33.431819],[-70.523028,-33.431611],[-70.523028,-33.431611],[-70.523127,-33.431619],[-70.524986,-33.431849],[-70.526111,-33.431989],[-70.527421,-33.432148],[-70.528569,-33.432289],[-70.529255,-33.432374],[-70.529907,-33.432455],[-70.530714,-33.432554],[-70.5325,-33.432779],[-70.534006,-33.432963],[-70.536639,-33.433287],[-70.537447,-33.433386],[-70.537933,-33.433433],[-70.537925,-33.433376],[-70.537954,-33.433379],[-70.538025,-33.433193],[-70.538137,-33.432982],[-70.538302,-33.432685],[-70.538568,-33.432123],[-70.538757,-33.43166],[-70.538877,-33.431271],[-70.538991,-33.430774],[-70.539093,-33.430074],[-70.539081,-33.428925],[-70.539802,-33.429047],[-70.541161,-33.4292],[-70.542368,-33.429342],[-70.543449,-33.429468],[-70.544217,-33.429559],[-70.545426,-33.429699],[-70.546829,-33.429862],[-70.546919,-33.429872],[-70.546991,-33.429853],[-70.547228,-33.429823],[-70.547332,-33.429773],[-70.551552,-33.430193],[-70.554075,-33.430428],[-70.55462,-33.430442],[-70.557335,-33.430579],[-70.559693,-33.430711],[-70.563756,-33.430888],[-70.565075,-33.430939],[-70.570103,-33.431062],[-70.574382,-33.431235],[-70.574808,-33.43124],[-70.5786,-33.431351],[-70.580147,-33.431442],[-70.584124,-33.431676],[-70.584437,-33.431783],[-70.584445,-33.431783],[-70.584838,-33.431258],[-70.585394,-33.430712],[-70.586029,-33.430251],[-70.58742,-33.428939],[-70.589373,-33.427404],[-70.5913,-33.42587],[-70.593279,-33.424377],[-70.595826,-33.422328],[-70.597881,-33.42077],[-70.599161,-33.420032],[-70.600059,-33.419401],[-70.600562,-33.419023],[-70.601028,-33.418664],[-70.60139,-33.418307],[-70.601555,-33.417981],[-70.601722,-33.417762],[-70.602233,-33.417503],[-70.602567,-33.417372],[-70.603412,-33.417208],[-70.603749,-33.417186],[-70.604253,-33.417125],[-70.604668,-33.417057],[-70.605005,-33.416899],[-70.606228,-33.416264],[-70.606608,-33.416047],[-70.607872,-33.415484],[-70.607306,-33.413491],[-70.606527,-33.410696],[-70.605869,-33.409278],[-70.605493,-33.409282],[-70.604587,-33.408998],[-70.603759,-33.408779],[-70.602263,-33.408404],[-70.601674,-33.408378],[-70.601165,-33.408385],[-70.600341,-33.408363],[-70.599674,-33.408338],[-70.599163,-33.408246],[-70.59861,-33.408056],[-70.59778,-33.407672],[-70.594149,-33.406338],[-70.58685,-33.404228],[-70.586644,-33.404168],[-70.571943,-33.398143],[-70.571614,-33.398045],[-70.569749,-33.397489],[-70.565831,-33.39632],[-70.561611,-33.394955],[-70.561534,-33.394896],[-70.558735,-33.393915],[-70.556616,-33.393193],[-70.554501,-33.392456],[-70.554137,-33.392324],[-70.553318,-33.39198],[-70.552536,-33.391772],[-70.552489,-33.391711],[-70.551394,-33.39129],[-70.550802,-33.391062],[-70.549683,-33.390616],[-70.549436,-33.39052],[-70.548278,-33.390077],[-70.547435,-33.389701],[-70.547234,-33.389508],[-70.545957,-33.389023],[-70.545223,-33.388797],[-70.54379,-33.388282],[-70.543428,-33.388143],[-70.541796,-33.387349],[-70.53734,-33.385364],[-70.534942,-33.384142],[-70.533885,-33.383816],[-70.532351,-33.382168]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1311,"DIS_ELEC":23,"NOM_COM":"Las Condes","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":98396073.9932,"SHAPE_LENG":51230.563241,"SHAPE_Le_1":51374.349006},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.576819,-33.470265],[-70.577826,-33.475389],[-70.578651,-33.47934],[-70.579553,-33.483631],[-70.579959,-33.485573],[-70.580369,-33.488019],[-70.580433,-33.4881],[-70.580552,-33.488975],[-70.580585,-33.489216],[-70.580844,-33.489858],[-70.580775,-33.489989],[-70.5811,-33.490625],[-70.581662,-33.491475],[-70.582695,-33.493124],[-70.584082,-33.495335],[-70.584109,-33.495375],[-70.587262,-33.50031],[-70.589534,-33.50609],[-70.589655,-33.506851],[-70.589907,-33.508931],[-70.589948,-33.509182],[-70.590003,-33.510157],[-70.59016,-33.510145],[-70.591406,-33.509944],[-70.591987,-33.509829],[-70.5938,-33.50971],[-70.597509,-33.50943],[-70.599304,-33.509298],[-70.601892,-33.509038],[-70.604309,-33.508882],[-70.610634,-33.508414],[-70.612273,-33.508384],[-70.612923,-33.508364],[-70.613663,-33.508351],[-70.613746,-33.508261],[-70.613837,-33.508159],[-70.614038,-33.507797],[-70.614165,-33.507314],[-70.61436,-33.506411],[-70.614639,-33.505118],[-70.61481,-33.503882],[-70.615419,-33.501096],[-70.616002,-33.498534],[-70.616274,-33.497322],[-70.616558,-33.49611],[-70.617461,-33.492006],[-70.617537,-33.491586],[-70.618487,-33.487526],[-70.618698,-33.487292],[-70.619126,-33.486864],[-70.619634,-33.486358],[-70.619896,-33.486085],[-70.620082,-33.485837],[-70.620223,-33.485564],[-70.620296,-33.485374],[-70.62035,-33.485179],[-70.620503,-33.484605],[-70.620542,-33.484457],[-70.620571,-33.483984],[-70.621193,-33.481674],[-70.621525,-33.480443],[-70.621798,-33.479412],[-70.621922,-33.478941],[-70.622103,-33.478281],[-70.622945,-33.475221],[-70.622951,-33.475214],[-70.622924,-33.475213],[-70.623,-33.474931],[-70.619831,-33.474775],[-70.619432,-33.474762],[-70.618664,-33.474718],[-70.617564,-33.474665],[-70.616865,-33.47463],[-70.616315,-33.474598],[-70.615541,-33.474557],[-70.615035,-33.474531],[-70.613785,-33.474466],[-70.613415,-33.474453],[-70.612225,-33.474396],[-70.611023,-33.474331],[-70.609884,-33.474273],[-70.608103,-33.474179],[-70.607445,-33.474152],[-70.606316,-33.474094],[-70.604496,-33.473993],[-70.604254,-33.473995],[-70.603849,-33.473963],[-70.602702,-33.473907],[-70.601243,-33.473826],[-70.60057,-33.47379],[-70.599447,-33.473732],[-70.598751,-33.473696],[-70.597324,-33.47363],[-70.596944,-33.473638],[-70.596533,-33.473535],[-70.596436,-33.473595],[-70.595983,-33.473664],[-70.594962,-33.473729],[-70.594424,-33.473752],[-70.593238,-33.473821],[-70.592737,-33.473846],[-70.592102,-33.473881],[-70.591567,-33.473942],[-70.590572,-33.474063],[-70.590083,-33.474123],[-70.589593,-33.474184],[-70.589121,-33.474244],[-70.589063,-33.474266],[-70.588993,-33.47426],[-70.588641,-33.474304],[-70.588357,-33.474344],[-70.588077,-33.474396],[-70.587798,-33.474423],[-70.58749,-33.4744],[-70.587234,-33.474331],[-70.587004,-33.474118],[-70.586946,-33.47402],[-70.586925,-33.474017],[-70.586926,-33.474001],[-70.586876,-33.473903],[-70.586748,-33.47385],[-70.586456,-33.473755],[-70.586304,-33.473736],[-70.585824,-33.473691],[-70.585184,-33.473623],[-70.584681,-33.47357],[-70.584619,-33.473564],[-70.584607,-33.473559],[-70.584339,-33.473518],[-70.583924,-33.4734],[-70.583583,-33.47326],[-70.583187,-33.473071],[-70.582146,-33.472532],[-70.581868,-33.472389],[-70.580184,-33.471507],[-70.579917,-33.471376],[-70.578649,-33.470716],[-70.577294,-33.470028],[-70.577113,-33.470158],[-70.576808,-33.470235],[-70.576819,-33.470265]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1311,"DIS_ELEC":25,"NOM_COM":"Macul","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":12794112.3085,"SHAPE_LENG":15200.750373,"SHAPE_Le_1":15151.816702},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.765051,-33.459258],[-70.76505,-33.45926],[-70.764937,-33.459259],[-70.764744,-33.459776],[-70.763842,-33.462526],[-70.763715,-33.462983],[-70.763462,-33.463821],[-70.75994,-33.464479],[-70.75808,-33.464803],[-70.757201,-33.464957],[-70.757004,-33.464995],[-70.756803,-33.465039],[-70.756454,-33.465109],[-70.756114,-33.465172],[-70.755791,-33.465236],[-70.755468,-33.465299],[-70.755092,-33.465374],[-70.754762,-33.465437],[-70.753674,-33.465647],[-70.752113,-33.465925],[-70.750567,-33.466195],[-70.749448,-33.466388],[-70.748258,-33.466598],[-70.747386,-33.466756],[-70.746154,-33.466979],[-70.745583,-33.46708],[-70.743975,-33.467385],[-70.741938,-33.467737],[-70.740185,-33.468049],[-70.738449,-33.468363],[-70.737915,-33.468452],[-70.737762,-33.468524],[-70.737544,-33.468642],[-70.73737,-33.468709],[-70.73728,-33.469664],[-70.737232,-33.470248],[-70.737218,-33.470415],[-70.737157,-33.470609],[-70.737143,-33.470738],[-70.737087,-33.471215],[-70.737034,-33.471471],[-70.736946,-33.47141],[-70.736193,-33.470969],[-70.735599,-33.470625],[-70.734817,-33.470185],[-70.734426,-33.46997],[-70.733858,-33.469657],[-70.733805,-33.469624],[-70.733323,-33.46978],[-70.732362,-33.470078],[-70.731438,-33.470363],[-70.730976,-33.470491],[-70.730891,-33.470515],[-70.730623,-33.470597],[-70.728634,-33.471209],[-70.728032,-33.471382],[-70.727477,-33.471548],[-70.726681,-33.471772],[-70.726026,-33.471972],[-70.725821,-33.472034],[-70.724812,-33.472359],[-70.724156,-33.472562],[-70.723521,-33.472762],[-70.722781,-33.473007],[-70.722752,-33.473053],[-70.722627,-33.473316],[-70.722372,-33.473394],[-70.722321,-33.47341],[-70.722231,-33.473485],[-70.722312,-33.473602],[-70.722413,-33.47395],[-70.722495,-33.474344],[-70.722703,-33.475453],[-70.722961,-33.47682],[-70.723155,-33.477845],[-70.723299,-33.479199],[-70.723481,-33.47964],[-70.72354,-33.479949],[-70.723734,-33.480465],[-70.724164,-33.480964],[-70.724359,-33.481222],[-70.724522,-33.481493],[-70.724649,-33.481994],[-70.724673,-33.482679],[-70.72514,-33.482488],[-70.725145,-33.482486],[-70.725148,-33.482494],[-70.72581,-33.482321],[-70.726083,-33.482284],[-70.726631,-33.482276],[-70.726986,-33.482435],[-70.727305,-33.482759],[-70.727623,-33.483017],[-70.728099,-33.483305],[-70.72857,-33.483397],[-70.728999,-33.483358],[-70.729468,-33.483319],[-70.729817,-33.48315],[-70.730282,-33.482914],[-70.730593,-33.482844],[-70.731139,-33.482738],[-70.731456,-33.482758],[-70.731547,-33.494906],[-70.732236,-33.495329],[-70.733336,-33.496375],[-70.733924,-33.497354],[-70.735226,-33.499943],[-70.736833,-33.503535],[-70.740087,-33.510122],[-70.733927,-33.509764],[-70.732883,-33.509778],[-70.731296,-33.5098],[-70.730661,-33.509809],[-70.723336,-33.510035],[-70.718522,-33.514083],[-70.719855,-33.516129],[-70.723916,-33.520757],[-70.726524,-33.524076],[-70.729005,-33.527233],[-70.732825,-33.531863],[-70.739321,-33.539427],[-70.739431,-33.539541],[-70.740568,-33.540835],[-70.741241,-33.541609],[-70.743818,-33.54453],[-70.744415,-33.545204],[-70.745996,-33.54697],[-70.749482,-33.550845],[-70.75033,-33.551775],[-70.75125,-33.552794],[-70.752489,-33.554183],[-70.754553,-33.55649],[-70.755854,-33.557953],[-70.759679,-33.562269],[-70.762662,-33.565625],[-70.763376,-33.566433],[-70.763942,-33.567119],[-70.764715,-33.568209],[-70.766008,-33.570056],[-70.767021,-33.571503],[-70.767418,-33.571961],[-70.767613,-33.571892],[-70.767853,-33.57185],[-70.768533,-33.571732],[-70.769851,-33.571602],[-70.773135,-33.570856],[-70.778611,-33.569188],[-70.778664,-33.56918],[-70.783185,-33.568082],[-70.783702,-33.568074],[-70.783747,-33.568046],[-70.783789,-33.56806],[-70.785559,-33.567431],[-70.78871,-33.56491],[-70.793609,-33.560675],[-70.798677,-33.556221],[-70.799855,-33.555019],[-70.799816,-33.554945],[-70.804642,-33.550945],[-70.815989,-33.54372],[-70.815628,-33.543303],[-70.81472,-33.542241],[-70.813879,-33.541511],[-70.813727,-33.541299],[-70.812858,-33.540813],[-70.811879,-33.54017],[-70.810917,-33.539493],[-70.809561,-33.53895],[-70.80851,-33.538428],[-70.807208,-33.537525],[-70.806088,-33.536594],[-70.805806,-33.536291],[-70.805584,-33.53591],[-70.805634,-33.535372],[-70.805656,-33.534962],[-70.805587,-33.534553],[-70.805546,-33.534093],[-70.805358,-33.533865],[-70.8048,-33.533464],[-70.804424,-33.533034],[-70.804202,-33.532653],[-70.804163,-33.532244],[-70.804355,-33.531201],[-70.804459,-33.530774],[-70.804852,-33.530357],[-70.805248,-33.53009],[-70.805603,-33.529973],[-70.805956,-33.529818],[-70.806445,-33.529699],[-70.806846,-33.529655],[-70.80729,-33.529574],[-70.807556,-33.529458],[-70.807816,-33.529081],[-70.807853,-33.528706],[-70.807845,-33.528332],[-70.808899,-33.528789],[-70.809328,-33.529097],[-70.80971,-33.529406],[-70.810138,-33.529675],[-70.810519,-33.529945],[-70.810852,-33.530136],[-70.811371,-33.530286],[-70.811799,-33.530516],[-70.812556,-33.530819],[-70.812888,-33.530972],[-70.813316,-33.53124],[-70.813507,-33.531395],[-70.813698,-33.531549],[-70.81389,-33.531782],[-70.814036,-33.532016],[-70.814137,-33.532368],[-70.814143,-33.532644],[-70.814268,-33.533035],[-70.814464,-33.533425],[-70.814655,-33.53358],[-70.814896,-33.533851],[-70.815184,-33.534161],[-70.815422,-33.534315],[-70.815802,-33.534546],[-70.816183,-33.534815],[-70.816377,-33.535087],[-70.816523,-33.535321],[-70.816715,-33.535554],[-70.816962,-33.53614],[-70.817451,-33.537037],[-70.817647,-33.537467],[-70.817983,-33.537816],[-70.818172,-33.537852],[-70.81841,-33.538006],[-70.818647,-33.538121],[-70.818975,-33.538116],[-70.819538,-33.538068],[-70.819909,-33.537866],[-70.820515,-33.537661],[-70.821029,-33.537535],[-70.821592,-33.537527],[-70.822626,-33.53759],[-70.823141,-33.537543],[-70.823561,-33.537419],[-70.824121,-33.537254],[-70.824777,-33.537205],[-70.825292,-33.537119],[-70.82557,-33.536957],[-70.825798,-33.536639],[-70.826636,-33.536313],[-70.827197,-33.536186],[-70.827761,-33.536217],[-70.827999,-33.536371],[-70.828237,-33.536525],[-70.82871,-33.536714],[-70.829226,-33.536707],[-70.829692,-33.536503],[-70.830063,-33.536301],[-70.830572,-33.53594],[-70.831551,-33.53565],[-70.832578,-33.53536],[-70.833563,-33.535345],[-70.834262,-33.53506],[-70.835051,-33.534655],[-70.835658,-33.534489],[-70.836173,-33.534442],[-70.836549,-33.534475],[-70.836973,-33.534548],[-70.837491,-33.534619],[-70.837871,-33.53481],[-70.838436,-33.53488],[-70.839,-33.53495],[-70.839657,-33.53494],[-70.840266,-33.534853],[-70.840965,-33.534606],[-70.842084,-33.534275],[-70.842599,-33.534189],[-70.843115,-33.534181],[-70.843491,-33.534215],[-70.844058,-33.534364],[-70.844389,-33.534477],[-70.844863,-33.534706],[-70.845617,-33.534852],[-70.845995,-33.534964],[-70.846424,-33.535272],[-70.846711,-33.535504],[-70.847281,-33.53581],[-70.847801,-33.535998],[-70.848367,-33.536108],[-70.848885,-33.536218],[-70.849405,-33.536368],[-70.849785,-33.536558],[-70.850121,-33.536907],[-70.850407,-33.537139],[-70.850789,-33.537408],[-70.851311,-33.537676],[-70.851736,-33.537827],[-70.852017,-33.537783],[-70.852249,-33.537662],[-70.852289,-33.537307],[-70.852278,-33.536796],[-70.852364,-33.536441],[-70.852635,-33.535965],[-70.852911,-33.535686],[-70.854051,-33.535194],[-70.854604,-33.534742],[-70.855187,-33.534123],[-70.856227,-33.533164],[-70.856873,-33.532377],[-70.857324,-33.53176],[-70.857969,-33.530974],[-70.858887,-33.530516],[-70.86001,-33.530333],[-70.861869,-33.530527],[-70.862536,-33.530739],[-70.863267,-33.530838],[-70.863994,-33.530772],[-70.864922,-33.530758],[-70.86565,-33.530747],[-70.866316,-33.530904],[-70.866786,-33.531174],[-70.867253,-33.531333],[-70.86792,-33.531545],[-70.869179,-33.531526],[-70.869776,-33.531573],[-70.870378,-33.531841],[-70.870915,-33.532166],[-70.871321,-33.532548],[-70.871722,-33.532709],[-70.872385,-33.532699],[-70.872846,-33.532581],[-70.873175,-33.532465],[-70.8739,-33.532287],[-70.874428,-33.532224],[-70.875354,-33.532154],[-70.876539,-33.531803],[-70.877451,-33.531068],[-70.878105,-33.53067],[-70.878762,-33.530382],[-70.879686,-33.530257],[-70.880214,-33.530138],[-70.880868,-33.52974],[-70.881327,-33.529511],[-70.881854,-33.529392],[-70.882573,-33.528937],[-70.883421,-33.528314],[-70.88395,-33.52825],[-70.884349,-33.528355],[-70.884682,-33.528406],[-70.885707,-33.528335],[-70.885768,-33.528315],[-70.886628,-33.528043],[-70.887607,-33.527362],[-70.88826,-33.526908],[-70.888648,-33.526459],[-70.889098,-33.525841],[-70.889287,-33.525395],[-70.889473,-33.524781],[-70.889792,-33.524222],[-70.889918,-33.523942],[-70.8903,-33.523215],[-70.890755,-33.52282],[-70.89187,-33.522303],[-70.892257,-33.521798],[-70.892442,-33.521185],[-70.892358,-33.520354],[-70.892748,-33.520015],[-70.893208,-33.519841],[-70.893607,-33.519946],[-70.893809,-33.520054],[-70.89414,-33.520049],[-70.894931,-33.51987],[-70.895516,-33.519362],[-70.89604,-33.519076],[-70.896892,-33.518675],[-70.897548,-33.518387],[-70.898719,-33.517371],[-70.899553,-33.516137],[-70.900327,-33.515182],[-70.900578,-33.514568],[-70.901031,-33.514061],[-70.901947,-33.513548],[-70.90286,-33.512868],[-70.903839,-33.512187],[-70.90436,-33.511791],[-70.904947,-33.511393],[-70.906002,-33.511155],[-70.907053,-33.51075],[-70.908168,-33.510234],[-70.909809,-33.509543],[-70.910535,-33.50942],[-70.91133,-33.509464],[-70.912129,-33.509618],[-70.912863,-33.509884],[-70.913401,-33.510264],[-70.91414,-33.510696],[-70.914872,-33.510852],[-70.915864,-33.510781],[-70.916657,-33.510713],[-70.917649,-33.510642],[-70.918513,-33.51074],[-70.918978,-33.510844],[-70.919448,-33.511114],[-70.919737,-33.511259],[-70.919984,-33.511383],[-70.920319,-33.511544],[-70.92065,-33.511539],[-70.920981,-33.511534],[-70.92131,-33.511418],[-70.921701,-33.511134],[-70.92196,-33.510853],[-70.92215,-33.510461],[-70.922602,-33.509955],[-70.923116,-33.509226],[-70.924103,-33.508933],[-70.92483,-33.508866],[-70.925294,-33.508859],[-70.925824,-33.508851],[-70.926418,-33.508786],[-70.927539,-33.508546],[-70.928064,-33.508316],[-70.928646,-33.507697],[-70.929099,-33.50719],[-70.929677,-33.506405],[-70.930061,-33.505788],[-70.930179,-33.505121],[-70.930165,-33.50451],[-70.930046,-33.502126],[-70.929898,-33.501407],[-70.929754,-33.50091],[-70.929548,-33.50058],[-70.929272,-33.500085],[-70.928855,-33.499204],[-70.928309,-33.498491],[-70.927905,-33.498164],[-70.927102,-33.497788],[-70.926495,-33.497298],[-70.926151,-33.496749],[-70.926139,-33.496194],[-70.925992,-33.49553],[-70.925915,-33.495032],[-70.925774,-33.494646],[-70.925698,-33.494203],[-70.925353,-33.493598],[-70.925142,-33.493047],[-70.925132,-33.492603],[-70.924853,-33.491941],[-70.92457,-33.491113],[-70.924221,-33.490342],[-70.923541,-33.48952],[-70.921996,-33.488545],[-70.921425,-33.488317],[-70.921195,-33.488225],[-70.920133,-33.48813],[-70.919335,-33.487976],[-70.918139,-33.487828],[-70.91741,-33.487784],[-70.916983,-33.487721],[-70.9165,-33.487698],[-70.916093,-33.487704],[-70.915684,-33.487648],[-70.915168,-33.48748],[-70.91393,-33.48696],[-70.913275,-33.486383],[-70.912849,-33.485607],[-70.912664,-33.485169],[-70.912362,-33.484733],[-70.91165,-33.484206],[-70.910825,-33.483876],[-70.908887,-33.483416],[-70.906073,-33.482921],[-70.903599,-33.48198],[-70.899885,-33.480422],[-70.898058,-33.479667],[-70.894995,-33.47849],[-70.893413,-33.478221],[-70.891949,-33.478048],[-70.89078,-33.478017],[-70.889671,-33.478033],[-70.888449,-33.478248],[-70.887049,-33.478318],[-70.885822,-33.478337],[-70.883715,-33.478124],[-70.882128,-33.477659],[-70.880774,-33.477141],[-70.879774,-33.476814],[-70.879128,-33.476677],[-70.878076,-33.476644],[-70.876736,-33.476762],[-70.874879,-33.477328],[-70.873075,-33.477649],[-70.871679,-33.477915],[-70.870173,-33.478476],[-70.868891,-33.478642],[-70.867086,-33.478865],[-70.862832,-33.479321],[-70.860157,-33.479899],[-70.858525,-33.480022],[-70.855776,-33.479867],[-70.854316,-33.479889],[-70.852797,-33.479863],[-70.850288,-33.479949],[-70.849528,-33.479912],[-70.848762,-33.479629],[-70.848346,-33.479293],[-70.848161,-33.478806],[-70.847973,-33.478222],[-70.848014,-33.477389],[-70.847943,-33.476803],[-70.847523,-33.476271],[-70.846019,-33.474189],[-70.844399,-33.472157],[-70.843857,-33.471382],[-70.843549,-33.470652],[-70.843357,-33.469872],[-70.842512,-33.468563],[-70.842144,-33.467737],[-70.841612,-33.467402],[-70.841138,-33.467115],[-70.840667,-33.466926],[-70.839731,-33.466843],[-70.838799,-33.466954],[-70.837749,-33.467019],[-70.836405,-33.46699],[-70.834943,-33.466865],[-70.833826,-33.466538],[-70.832535,-33.466215],[-70.830837,-33.465995],[-70.829896,-33.465716],[-70.829194,-33.465628],[-70.828326,-33.466032],[-70.827637,-33.466581],[-70.826769,-33.466985],[-70.824259,-33.467022],[-70.820988,-33.466972],[-70.818533,-33.466862],[-70.817011,-33.466688],[-70.815777,-33.466315],[-70.814544,-33.466039],[-70.813539,-33.465418],[-70.811581,-33.463929],[-70.810807,-33.463255],[-70.809741,-33.462536],[-70.808088,-33.461631],[-70.806449,-33.460978],[-70.806302,-33.461035],[-70.805963,-33.46137],[-70.805525,-33.461788],[-70.805002,-33.462356],[-70.804831,-33.462695],[-70.80471,-33.462914],[-70.804705,-33.463071],[-70.796782,-33.463132],[-70.796671,-33.463133],[-70.796626,-33.463133],[-70.796637,-33.463084],[-70.796525,-33.46292],[-70.796263,-33.462882],[-70.796087,-33.462783],[-70.796162,-33.462537],[-70.79648,-33.461183],[-70.796661,-33.46044],[-70.783868,-33.462471],[-70.782918,-33.462672],[-70.7823,-33.462681],[-70.781514,-33.462693],[-70.781158,-33.462715],[-70.781076,-33.462701],[-70.780515,-33.462641],[-70.780239,-33.462676],[-70.779831,-33.462791],[-70.779829,-33.462798],[-70.779809,-33.462799],[-70.779796,-33.4628],[-70.779795,-33.462802],[-70.77973,-33.462821],[-70.779574,-33.462868],[-70.779295,-33.462957],[-70.779103,-33.463014],[-70.778882,-33.463052],[-70.778767,-33.463069],[-70.778597,-33.463074],[-70.778413,-33.463065],[-70.778335,-33.463053],[-70.778191,-33.463013],[-70.777992,-33.462943],[-70.777831,-33.462895],[-70.777787,-33.462894],[-70.777667,-33.462892],[-70.777484,-33.462894],[-70.777468,-33.462887],[-70.777196,-33.462896],[-70.775809,-33.45821],[-70.765051,-33.459258]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1311,"DIS_ELEC":20,"NOM_COM":"Maipú","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":138038031.124,"SHAPE_LENG":61424.982525,"SHAPE_Le_1":61429.469835},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.576808,-33.470235],[-70.577113,-33.470158],[-70.577294,-33.470028],[-70.578649,-33.470716],[-70.579917,-33.471376],[-70.580184,-33.471507],[-70.581868,-33.472389],[-70.582146,-33.472532],[-70.583187,-33.473071],[-70.583583,-33.47326],[-70.583924,-33.4734],[-70.584339,-33.473518],[-70.584607,-33.473559],[-70.584619,-33.473564],[-70.584681,-33.47357],[-70.585184,-33.473623],[-70.585824,-33.473691],[-70.586304,-33.473736],[-70.586456,-33.473755],[-70.586748,-33.47385],[-70.586876,-33.473903],[-70.586926,-33.474001],[-70.586925,-33.474017],[-70.586946,-33.47402],[-70.587004,-33.474118],[-70.587234,-33.474331],[-70.58749,-33.4744],[-70.587798,-33.474423],[-70.588077,-33.474396],[-70.588357,-33.474344],[-70.588641,-33.474304],[-70.588993,-33.47426],[-70.589063,-33.474266],[-70.589121,-33.474244],[-70.589593,-33.474184],[-70.590083,-33.474123],[-70.590572,-33.474063],[-70.591567,-33.473942],[-70.592102,-33.473881],[-70.592737,-33.473846],[-70.593238,-33.473821],[-70.594424,-33.473752],[-70.594962,-33.473729],[-70.595983,-33.473664],[-70.596436,-33.473595],[-70.596533,-33.473535],[-70.596944,-33.473638],[-70.597324,-33.47363],[-70.598751,-33.473696],[-70.599447,-33.473732],[-70.60057,-33.47379],[-70.601243,-33.473826],[-70.602702,-33.473907],[-70.603849,-33.473963],[-70.604254,-33.473995],[-70.604496,-33.473993],[-70.606316,-33.474094],[-70.607445,-33.474152],[-70.608103,-33.474179],[-70.609884,-33.474273],[-70.611023,-33.474331],[-70.612225,-33.474396],[-70.613415,-33.474453],[-70.613785,-33.474466],[-70.615035,-33.474531],[-70.615541,-33.474557],[-70.616315,-33.474598],[-70.616865,-33.47463],[-70.617564,-33.474665],[-70.618664,-33.474718],[-70.619432,-33.474762],[-70.619831,-33.474775],[-70.623,-33.474931],[-70.623415,-33.473379],[-70.623966,-33.47152],[-70.624023,-33.471302],[-70.624217,-33.470452],[-70.624346,-33.470162],[-70.624512,-33.469997],[-70.625149,-33.469602],[-70.625762,-33.469205],[-70.626053,-33.468832],[-70.626071,-33.468579],[-70.62641,-33.467391],[-70.627127,-33.46485],[-70.627772,-33.462614],[-70.628553,-33.459925],[-70.629599,-33.456295],[-70.629841,-33.455426],[-70.630898,-33.451933],[-70.631453,-33.450101],[-70.631447,-33.4501],[-70.631526,-33.449836],[-70.631355,-33.449808],[-70.630253,-33.449593],[-70.628945,-33.449341],[-70.627983,-33.449147],[-70.626879,-33.448936],[-70.626766,-33.448919],[-70.62624,-33.448791],[-70.625359,-33.448574],[-70.625131,-33.44854],[-70.623719,-33.448256],[-70.623237,-33.448163],[-70.622248,-33.447959],[-70.620901,-33.447688],[-70.61985,-33.447486],[-70.618764,-33.447265],[-70.618637,-33.447646],[-70.618432,-33.448377],[-70.617814,-33.448266],[-70.617101,-33.448135],[-70.616516,-33.448034],[-70.614031,-33.447614],[-70.614031,-33.447611],[-70.614031,-33.447611],[-70.613744,-33.447565],[-70.613809,-33.447252],[-70.613826,-33.447172],[-70.61389,-33.446833],[-70.613471,-33.446771],[-70.613244,-33.446737],[-70.613151,-33.446723],[-70.612984,-33.446699],[-70.612744,-33.446663],[-70.612592,-33.446641],[-70.612311,-33.446599],[-70.611311,-33.446452],[-70.611211,-33.44644],[-70.610753,-33.446307],[-70.610347,-33.44619],[-70.609779,-33.44602],[-70.60975,-33.446011],[-70.609471,-33.445949],[-70.609457,-33.445929],[-70.608765,-33.445744],[-70.608128,-33.445645],[-70.607163,-33.44554],[-70.606375,-33.445452],[-70.606161,-33.445428],[-70.605219,-33.445296],[-70.60437,-33.445177],[-70.603868,-33.445127],[-70.602895,-33.445027],[-70.602211,-33.444955],[-70.601657,-33.444899],[-70.601095,-33.444852],[-70.600606,-33.444808],[-70.600409,-33.44479],[-70.599963,-33.444749],[-70.599183,-33.444679],[-70.599137,-33.444923],[-70.598871,-33.444896],[-70.598263,-33.444835],[-70.5981,-33.444801],[-70.597953,-33.444839],[-70.597425,-33.445143],[-70.59724,-33.445245],[-70.596989,-33.445435],[-70.596697,-33.445618],[-70.596105,-33.44599],[-70.594495,-33.446858],[-70.594188,-33.44702],[-70.592792,-33.447771],[-70.592718,-33.447666],[-70.592552,-33.447471],[-70.592385,-33.447275],[-70.592261,-33.44713],[-70.59207,-33.446907],[-70.592035,-33.446858],[-70.592027,-33.446857],[-70.591763,-33.446547],[-70.591697,-33.44647],[-70.591618,-33.44635],[-70.591491,-33.446156],[-70.591442,-33.446082],[-70.591402,-33.446021],[-70.591364,-33.445963],[-70.591351,-33.445943],[-70.591331,-33.445907],[-70.591312,-33.445873],[-70.591261,-33.445803],[-70.591233,-33.445784],[-70.591172,-33.445741],[-70.591166,-33.445714],[-70.591155,-33.445675],[-70.591125,-33.445615],[-70.591093,-33.445555],[-70.591068,-33.445508],[-70.590831,-33.445176],[-70.59048,-33.444571],[-70.589937,-33.443721],[-70.589509,-33.443044],[-70.588952,-33.442163],[-70.58872,-33.441797],[-70.588655,-33.441694],[-70.588603,-33.441631],[-70.588196,-33.440978],[-70.588066,-33.440783],[-70.587959,-33.440624],[-70.587915,-33.440558],[-70.587847,-33.440456],[-70.587781,-33.440357],[-70.587675,-33.440183],[-70.587622,-33.440103],[-70.587531,-33.439967],[-70.587447,-33.439841],[-70.587348,-33.439692],[-70.587273,-33.439581],[-70.587175,-33.439431],[-70.587059,-33.439283],[-70.587,-33.439208],[-70.586816,-33.438998],[-70.586663,-33.438822],[-70.58604,-33.43812],[-70.585366,-33.437371],[-70.58508,-33.437032],[-70.584619,-33.436533],[-70.58385,-33.435677],[-70.583099,-33.434821],[-70.582984,-33.434692],[-70.582716,-33.434391],[-70.582611,-33.434273],[-70.582599,-33.434259],[-70.582587,-33.434245],[-70.582464,-33.434107],[-70.582247,-33.433785],[-70.582241,-33.433775],[-70.581806,-33.434054],[-70.580058,-33.435098],[-70.578745,-33.435752],[-70.576901,-33.436383],[-70.57583,-33.436752],[-70.574022,-33.437785],[-70.573823,-33.437835],[-70.573726,-33.437855],[-70.573607,-33.437935],[-70.573351,-33.438606],[-70.573242,-33.439185],[-70.573105,-33.439989],[-70.573029,-33.440333],[-70.57296,-33.440748],[-70.572862,-33.441453],[-70.572686,-33.442325],[-70.572576,-33.442927],[-70.572309,-33.443903],[-70.570902,-33.452663],[-70.570868,-33.453274],[-70.57081,-33.453509],[-70.571435,-33.455495],[-70.57197,-33.457707],[-70.5724,-33.458968],[-70.572257,-33.459011],[-70.57225,-33.459013],[-70.572592,-33.460034],[-70.573851,-33.462811],[-70.57407,-33.463398],[-70.57491,-33.465335],[-70.576298,-33.468807],[-70.576808,-33.470235]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1312,"DIS_ELEC":21,"NOM_COM":"Ñuñoa","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":16911880.4858,"SHAPE_LENG":17714.126051,"SHAPE_Le_1":17848.555565},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.671682,-33.47847],[-70.671688,-33.478469],[-70.681189,-33.478463],[-70.681343,-33.478553],[-70.681322,-33.478363],[-70.682324,-33.478325],[-70.685696,-33.478111],[-70.685697,-33.478108],[-70.687577,-33.478194],[-70.690741,-33.478223],[-70.691574,-33.478127],[-70.691673,-33.47812],[-70.691675,-33.478122],[-70.692154,-33.478099],[-70.693352,-33.478348],[-70.695005,-33.478725],[-70.695812,-33.478928],[-70.696587,-33.479154],[-70.697346,-33.479389],[-70.697924,-33.479567],[-70.698611,-33.479783],[-70.699072,-33.479922],[-70.699624,-33.480035],[-70.700227,-33.480154],[-70.700793,-33.480222],[-70.701246,-33.480271],[-70.701592,-33.480324],[-70.701918,-33.480374],[-70.702466,-33.480481],[-70.70315,-33.480627],[-70.705473,-33.481211],[-70.708654,-33.481936],[-70.708807,-33.481933],[-70.708856,-33.481982],[-70.711877,-33.482664],[-70.712001,-33.482448],[-70.712001,-33.482446],[-70.712003,-33.482447],[-70.712278,-33.482044],[-70.714866,-33.479742],[-70.716955,-33.477883],[-70.71775,-33.477221],[-70.717845,-33.477085],[-70.71873,-33.47625],[-70.719506,-33.475533],[-70.720149,-33.474935],[-70.721273,-33.474032],[-70.722006,-33.473448],[-70.722323,-33.473361],[-70.722406,-33.473384],[-70.722627,-33.473316],[-70.722752,-33.473053],[-70.722781,-33.473007],[-70.723521,-33.472762],[-70.724156,-33.472562],[-70.724812,-33.472359],[-70.725821,-33.472034],[-70.726026,-33.471972],[-70.726681,-33.471772],[-70.727477,-33.471548],[-70.728032,-33.471382],[-70.728634,-33.471209],[-70.730623,-33.470597],[-70.730891,-33.470515],[-70.730976,-33.470491],[-70.731438,-33.470363],[-70.732362,-33.470078],[-70.733323,-33.46978],[-70.733805,-33.469624],[-70.731405,-33.46814],[-70.731403,-33.467844],[-70.731378,-33.466494],[-70.731365,-33.463736],[-70.731345,-33.461702],[-70.731339,-33.461098],[-70.731333,-33.459359],[-70.731312,-33.455871],[-70.731289,-33.455869],[-70.731303,-33.45531],[-70.731331,-33.455305],[-70.731292,-33.454913],[-70.728684,-33.455413],[-70.724882,-33.456148],[-70.719196,-33.457248],[-70.71494,-33.458068],[-70.713456,-33.458365],[-70.712956,-33.458445],[-70.711898,-33.458432],[-70.710415,-33.45829],[-70.708961,-33.457964],[-70.706205,-33.457282],[-70.705586,-33.45716],[-70.705575,-33.456773],[-70.705718,-33.456055],[-70.705753,-33.455497],[-70.706024,-33.453697],[-70.70619,-33.452631],[-70.706234,-33.452369],[-70.706351,-33.452079],[-70.70638,-33.451907],[-70.706501,-33.451616],[-70.706815,-33.450801],[-70.706834,-33.450602],[-70.706912,-33.450114],[-70.707019,-33.449472],[-70.70706,-33.449084],[-70.70709,-33.448804],[-70.707092,-33.448793],[-70.706248,-33.448757],[-70.706205,-33.448708],[-70.70425,-33.448464],[-70.702717,-33.448269],[-70.701468,-33.448115],[-70.700333,-33.447968],[-70.698829,-33.44779],[-70.698261,-33.447717],[-70.697515,-33.447727],[-70.696215,-33.447799],[-70.694805,-33.447863],[-70.693559,-33.447837],[-70.692472,-33.447985],[-70.692335,-33.446292],[-70.692257,-33.44624],[-70.692301,-33.444699],[-70.691862,-33.444675],[-70.691847,-33.444489],[-70.689638,-33.444372],[-70.684973,-33.444151],[-70.681926,-33.444007],[-70.679562,-33.443934],[-70.679453,-33.446016],[-70.679088,-33.448368],[-70.679152,-33.449004],[-70.679016,-33.450729],[-70.677932,-33.450492],[-70.67783,-33.450944],[-70.67794,-33.452412],[-70.67801,-33.453494],[-70.678092,-33.454593],[-70.678158,-33.455548],[-70.678242,-33.456747],[-70.67835,-33.458226],[-70.678744,-33.463737],[-70.679082,-33.469067],[-70.679048,-33.469436],[-70.679635,-33.470069],[-70.679691,-33.470081],[-70.680074,-33.470714],[-70.679127,-33.470732],[-70.676783,-33.470663],[-70.674094,-33.470633],[-70.672939,-33.470634],[-70.6729,-33.472708],[-70.672904,-33.473781],[-70.672777,-33.475176],[-70.672611,-33.475463],[-70.6716,-33.47605],[-70.671588,-33.476359],[-70.671728,-33.476387],[-70.671682,-33.47847]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1310,"DIS_ELEC":20,"NOM_COM":"Estación Central","NOM_PROV":"Santiago","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":14915626.8189,"SHAPE_LENG":13054.563524,"SHAPE_Le_1":19243.649917},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.504691,-33.546376],[-70.504082,-33.546484],[-70.503533,-33.546464],[-70.502933,-33.546424],[-70.502362,-33.546314],[-70.502116,-33.545998],[-70.501943,-33.545794],[-70.501688,-33.545654],[-70.501435,-33.545492],[-70.50118,-33.545347],[-70.500773,-33.545116],[-70.50036,-33.544989],[-70.500107,-33.544804],[-70.499779,-33.544576],[-70.499475,-33.544366],[-70.499149,-33.544089],[-70.498942,-33.543842],[-70.498581,-33.543685],[-70.498206,-33.543568],[-70.497808,-33.543517],[-70.497404,-33.543525],[-70.496979,-33.543483],[-70.49661,-33.543537],[-70.496217,-33.543522],[-70.495799,-33.543633],[-70.495396,-33.543646],[-70.494995,-33.543676],[-70.494505,-33.543703],[-70.494207,-33.543814],[-70.493818,-33.543903],[-70.493433,-33.544006],[-70.493017,-33.544086],[-70.492662,-33.544208],[-70.492268,-33.544257],[-70.491861,-33.544255],[-70.491461,-33.544214],[-70.491073,-33.544128],[-70.490691,-33.544015],[-70.490307,-33.54391],[-70.489936,-33.543865],[-70.489548,-33.543784],[-70.48915,-33.543616],[-70.488777,-33.543472],[-70.488466,-33.543415],[-70.487973,-33.543402],[-70.48767,-33.543422],[-70.487575,-33.543428],[-70.487545,-33.54343],[-70.48668,-33.544363],[-70.486516,-33.544794],[-70.486302,-33.545561],[-70.486025,-33.546041],[-70.485979,-33.54671],[-70.486113,-33.547854],[-70.486237,-33.548425],[-70.48636,-33.548948],[-70.486483,-33.549472],[-70.486606,-33.549995],[-70.486675,-33.55071],[-70.486822,-33.552665],[-70.487059,-33.553187],[-70.487644,-33.554039],[-70.48782,-33.554323],[-70.488349,-33.555271],[-70.488528,-33.555746],[-70.488534,-33.55608],[-70.488601,-33.5567],[-70.488728,-33.557414],[-70.488735,-33.557844],[-70.488746,-33.558512],[-70.488757,-33.559132],[-70.488997,-33.559845],[-70.489463,-33.560412],[-70.490097,-33.560786],[-70.4905,-33.56102],[-70.491074,-33.561299],[-70.491536,-33.561628],[-70.491826,-33.561911],[-70.492195,-33.562171],[-70.492457,-33.562384],[-70.492664,-33.562694],[-70.49313,-33.56305],[-70.493393,-33.563359],[-70.493662,-33.563933],[-70.494422,-33.56467],[-70.494599,-33.56498],[-70.495041,-33.565624],[-70.495076,-33.565961],[-70.495203,-33.566657],[-70.495558,-33.56723],[-70.495969,-33.567717],[-70.496953,-33.568339],[-70.497191,-33.568489],[-70.497684,-33.568888],[-70.498222,-33.569375],[-70.498687,-33.569702],[-70.499444,-33.570647],[-70.500083,-33.571308],[-70.50026,-33.571639],[-70.50038,-33.57202],[-70.500445,-33.572448],[-70.500458,-33.573212],[-70.500374,-33.574931],[-70.500328,-33.5756],[-70.500337,-33.576124],[-70.500348,-33.576745],[-70.500302,-33.577366],[-70.500314,-33.578081],[-70.500325,-33.578701],[-70.50045,-33.579368],[-70.500346,-33.579942],[-70.500182,-33.580326],[-70.499848,-33.580807],[-70.499231,-33.581387],[-70.49861,-33.581729],[-70.498053,-33.582496],[-70.498057,-33.582745],[-70.498064,-33.583119],[-70.498072,-33.583596],[-70.498082,-33.584169],[-70.498032,-33.584599],[-70.498099,-33.585171],[-70.498049,-33.585553],[-70.498057,-33.58603],[-70.498059,-33.586174],[-70.497951,-33.586509],[-70.497959,-33.586938],[-70.498139,-33.587461],[-70.498317,-33.587888],[-70.498378,-33.588126],[-70.498444,-33.58865],[-70.49828,-33.589034],[-70.498059,-33.589466],[-70.497671,-33.590091],[-70.497502,-33.590189],[-70.497337,-33.590573],[-70.49723,-33.590956],[-70.496778,-33.5912],[-70.496325,-33.591396],[-70.496213,-33.591493],[-70.49588,-33.592022],[-70.495891,-33.59269],[-70.495899,-33.593119],[-70.495847,-33.593454],[-70.495742,-33.593874],[-70.495474,-33.594938],[-70.495432,-33.595845],[-70.495385,-33.596418],[-70.495399,-33.59723],[-70.495525,-33.597896],[-70.495593,-33.598516],[-70.495658,-33.598992],[-70.495553,-33.599518],[-70.495357,-33.599858],[-70.495825,-33.599858],[-70.496302,-33.600005],[-70.496707,-33.600184],[-70.497076,-33.600393],[-70.49748,-33.600541],[-70.497921,-33.600689],[-70.498399,-33.600866],[-70.498839,-33.600983],[-70.499136,-33.601255],[-70.499433,-33.601526],[-70.499838,-33.601735],[-70.500171,-33.601976],[-70.50054,-33.602185],[-70.500837,-33.602457],[-70.501135,-33.602759],[-70.501251,-33.603155],[-70.501331,-33.603521],[-70.501264,-33.603919],[-70.501014,-33.604228],[-70.500653,-33.604446],[-70.500217,-33.604635],[-70.499819,-33.604823],[-70.49942,-33.604981],[-70.499021,-33.605138],[-70.498659,-33.605357],[-70.498409,-33.605665],[-70.498196,-33.606004],[-70.498165,-33.606371],[-70.498209,-33.606768],[-70.498325,-33.607134],[-70.498331,-33.6075],[-70.498447,-33.607865],[-70.49878,-33.608137],[-70.499221,-33.608254],[-70.499518,-33.608525],[-70.499958,-33.608642],[-70.500435,-33.608758],[-70.500874,-33.608784],[-70.501311,-33.608748],[-70.501786,-33.608742],[-70.502224,-33.608676],[-70.50266,-33.608579],[-70.503098,-33.608543],[-70.503534,-33.608385],[-70.503933,-33.608227],[-70.504443,-33.60816],[-70.50488,-33.608063],[-70.505318,-33.608057],[-70.505758,-33.608144],[-70.506197,-33.608199],[-70.506674,-33.608316],[-70.507078,-33.608464],[-70.50752,-33.608642],[-70.507853,-33.608882],[-70.50815,-33.609154],[-70.508156,-33.60952],[-70.508163,-33.609887],[-70.508279,-33.610252],[-70.508285,-33.610619],[-70.508291,-33.610986],[-70.508262,-33.611384],[-70.508232,-33.611751],[-70.508238,-33.612118],[-70.508317,-33.612483],[-70.508397,-33.61288],[-70.508586,-33.613214],[-70.508883,-33.613485],[-70.509323,-33.613602],[-70.509763,-33.613658],[-70.510201,-33.613652],[-70.510639,-33.613647],[-70.511077,-33.613642],[-70.511446,-33.613851],[-70.511743,-33.614123],[-70.511787,-33.614519],[-70.512192,-33.614698],[-70.512631,-33.614723],[-70.51307,-33.614779],[-70.513508,-33.614773],[-70.513947,-33.614768],[-70.514346,-33.61461],[-70.514707,-33.614392],[-70.515106,-33.614234],[-70.515467,-33.613985],[-70.515755,-33.613707],[-70.516153,-33.613518],[-70.516609,-33.613467],[-70.517047,-33.613431],[-70.517486,-33.613456],[-70.517926,-33.613573],[-70.518115,-33.613907],[-70.518084,-33.614274],[-70.517908,-33.614613],[-70.517878,-33.61498],[-70.517957,-33.615346],[-70.518146,-33.615679],[-70.518371,-33.616013],[-70.518704,-33.616253],[-70.519073,-33.616463],[-70.519512,-33.616518],[-70.519952,-33.616605],[-70.520391,-33.616661],[-70.52083,-33.616655],[-70.521268,-33.616619],[-70.521706,-33.616614],[-70.522144,-33.616608],[-70.522583,-33.616634],[-70.523022,-33.616689],[-70.523498,-33.616714],[-70.523938,-33.6168],[-70.524377,-33.616856],[-70.524854,-33.616942],[-70.525292,-33.616936],[-70.52573,-33.616931],[-70.52617,-33.616987],[-70.526608,-33.616981],[-70.52708,-33.616853],[-70.52748,-33.616696],[-70.527877,-33.616446],[-70.528239,-33.616228],[-70.528563,-33.615979],[-70.528962,-33.615821],[-70.52936,-33.615602],[-70.529798,-33.615566],[-70.530255,-33.615576],[-70.530828,-33.615604],[-70.531208,-33.615748],[-70.531649,-33.615895],[-70.532053,-33.616043],[-70.532423,-33.616283],[-70.532756,-33.616554],[-70.533125,-33.616763],[-70.533458,-33.617004],[-70.53416,-33.617453],[-70.535339,-33.617958],[-70.535708,-33.618198],[-70.536077,-33.618408],[-70.536482,-33.618586],[-70.536887,-33.618734],[-70.537256,-33.618943],[-70.53766,-33.619091],[-70.53803,-33.619331],[-70.538434,-33.619479],[-70.538875,-33.619595],[-70.539316,-33.619743],[-70.539756,-33.61986],[-70.540195,-33.619885],[-70.540669,-33.619818],[-70.541106,-33.619721],[-70.541633,-33.619607],[-70.542229,-33.619187],[-70.542878,-33.61869],[-70.543239,-33.618471],[-70.543637,-33.618283],[-70.544074,-33.618155],[-70.544512,-33.61815],[-70.544988,-33.618205],[-70.545427,-33.618261],[-70.545903,-33.618316],[-70.546342,-33.61831],[-70.54678,-33.618335],[-70.547256,-33.61836],[-70.547731,-33.618354],[-70.548205,-33.618348],[-70.548644,-33.618373],[-70.549524,-33.618515],[-70.550056,-33.618646],[-70.550773,-33.618897],[-70.552022,-33.619309],[-70.552391,-33.619518],[-70.553127,-33.619815],[-70.554178,-33.620336],[-70.555629,-33.620761],[-70.556069,-33.620848],[-70.556508,-33.620903],[-70.556966,-33.620974],[-70.557405,-33.620999],[-70.557843,-33.620963],[-70.55828,-33.620927],[-70.558718,-33.620891],[-70.559157,-33.620885],[-70.55963,-33.620818],[-70.560068,-33.620782],[-70.560506,-33.620746],[-70.560943,-33.620679],[-70.561417,-33.620612],[-70.563642,-33.620431],[-70.564081,-33.620456],[-70.564671,-33.620413],[-70.564815,-33.620443],[-70.565252,-33.620533],[-70.565875,-33.620678],[-70.566429,-33.620977],[-70.566657,-33.621493],[-70.566777,-33.622042],[-70.56686,-33.622591],[-70.566797,-33.623142],[-70.566843,-33.623692],[-70.566963,-33.62424],[-70.567082,-33.624789],[-70.567492,-33.625212],[-70.568081,-33.625449],[-70.568739,-33.625471],[-70.569396,-33.625432],[-70.570053,-33.625424],[-70.570713,-33.625538],[-70.571409,-33.62562],[-70.572034,-33.625826],[-70.572693,-33.62594],[-70.573318,-33.626146],[-70.573943,-33.626352],[-70.574533,-33.62662],[-70.575121,-33.626857],[-70.575591,-33.627062],[-70.575786,-33.627135],[-70.576152,-33.627272],[-70.57667,-33.627601],[-70.577187,-33.627931],[-70.577633,-33.628353],[-70.578116,-33.628744],[-70.578417,-33.62923],[-70.578718,-33.629715],[-70.578982,-33.6302],[-70.579175,-33.630718],[-70.579403,-33.631234],[-70.579595,-33.631752],[-70.579824,-33.632268],[-70.580162,-33.632784],[-70.580391,-33.6333],[-70.580729,-33.633785],[-70.581212,-33.634207],[-70.581658,-33.634629],[-70.582283,-33.634835],[-70.582939,-33.634765],[-70.583593,-33.634574],[-70.584211,-33.634382],[-70.584866,-33.634221],[-70.58556,-33.634212],[-70.586218,-33.634204],[-70.586807,-33.634441],[-70.587288,-33.634771],[-70.587769,-33.635101],[-70.588322,-33.635399],[-70.588804,-33.63579],[-70.58905,-33.635942],[-70.589433,-33.63618],[-70.589879,-33.636571],[-70.590361,-33.636962],[-70.590807,-33.637385],[-70.591108,-33.63787],[-70.591626,-33.63823],[-70.592286,-33.638313],[-70.592943,-33.638305],[-70.593599,-33.638205],[-70.594255,-33.638104],[-70.594911,-33.637974],[-70.595547,-33.637797],[-70.596202,-33.637667],[-70.596898,-33.637749],[-70.597488,-33.638017],[-70.598006,-33.638377],[-70.59856,-33.638675],[-70.599114,-33.639035],[-70.599597,-33.639426],[-70.600114,-33.639756],[-70.600738,-33.6399],[-70.601364,-33.640167],[-70.60199,-33.640404],[-70.60258,-33.640671],[-70.603206,-33.640938],[-70.603867,-33.641113],[-70.604491,-33.641258],[-70.605116,-33.641464],[-70.60574,-33.641639],[-70.606399,-33.641691],[-70.607093,-33.641682],[-70.607787,-33.641673],[-70.608444,-33.641634],[-70.609086,-33.641733],[-70.609781,-33.641785],[-70.610475,-33.641745],[-70.611167,-33.641645],[-70.611825,-33.641636],[-70.612483,-33.641658],[-70.613177,-33.641649],[-70.613832,-33.641518],[-70.614527,-33.641509],[-70.615116,-33.641746],[-70.61574,-33.641921],[-70.616365,-33.642127],[-70.616884,-33.642487],[-70.61733,-33.642909],[-70.617848,-33.643238],[-70.618437,-33.643475],[-70.618991,-33.643774],[-70.619617,-33.644041],[-70.620277,-33.644154],[-70.620936,-33.644237],[-70.621595,-33.64429],[-70.622253,-33.644281],[-70.622964,-33.644195],[-70.623581,-33.644004],[-70.624161,-33.643752],[-70.624667,-33.643409],[-70.625172,-33.643066],[-70.625677,-33.642723],[-70.626144,-33.64232],[-70.626723,-33.642006],[-70.627376,-33.641753],[-70.62803,-33.641531],[-70.628686,-33.64143],[-70.629343,-33.641422],[-70.629967,-33.641566],[-70.630521,-33.641865],[-70.630859,-33.642349],[-70.631233,-33.642839],[-70.631018,-33.641019],[-70.630942,-33.640948],[-70.630806,-33.639868],[-70.630476,-33.637545],[-70.630336,-33.636519],[-70.630052,-33.634352],[-70.629772,-33.632315],[-70.629421,-33.63094],[-70.628804,-33.62836],[-70.628691,-33.627793],[-70.628683,-33.627794],[-70.628509,-33.626858],[-70.628485,-33.626452],[-70.6282,-33.625555],[-70.628069,-33.624988],[-70.627747,-33.623666],[-70.627615,-33.623064],[-70.627116,-33.621159],[-70.626512,-33.618813],[-70.626413,-33.618634],[-70.626427,-33.618201],[-70.626416,-33.617678],[-70.626434,-33.616911],[-70.626433,-33.616352],[-70.62645,-33.615991],[-70.626458,-33.615369],[-70.626521,-33.613492],[-70.626533,-33.612813],[-70.626569,-33.611769],[-70.626591,-33.610653],[-70.626658,-33.609436],[-70.62692,-33.604673],[-70.61958,-33.603858],[-70.606553,-33.60206],[-70.606555,-33.602045],[-70.60646,-33.602046],[-70.605965,-33.602018],[-70.607255,-33.594239],[-70.607481,-33.594269],[-70.607774,-33.591442],[-70.608522,-33.586921],[-70.609353,-33.586801],[-70.609401,-33.586705],[-70.609355,-33.586637],[-70.610018,-33.580831],[-70.611297,-33.57057],[-70.611144,-33.570546],[-70.607332,-33.569267],[-70.606811,-33.569112],[-70.605901,-33.56888],[-70.605576,-33.568862],[-70.603601,-33.568331],[-70.602206,-33.567936],[-70.600741,-33.567502],[-70.599949,-33.567296],[-70.599327,-33.56725],[-70.598799,-33.567293],[-70.598306,-33.567489],[-70.597732,-33.567911],[-70.597365,-33.568087],[-70.596519,-33.568432],[-70.595812,-33.568693],[-70.595399,-33.568861],[-70.594675,-33.569159],[-70.593381,-33.569682],[-70.59224,-33.570117],[-70.588503,-33.569772],[-70.588466,-33.569995],[-70.586383,-33.569761],[-70.584174,-33.569506],[-70.58417,-33.569506],[-70.58417,-33.569506],[-70.583738,-33.569456],[-70.583858,-33.568874],[-70.584413,-33.565968],[-70.584473,-33.565584],[-70.583871,-33.565519],[-70.582233,-33.565215],[-70.58102,-33.565003],[-70.580748,-33.564955],[-70.580467,-33.564904],[-70.580198,-33.564854],[-70.57992,-33.564803],[-70.579559,-33.564749],[-70.579402,-33.564721],[-70.57905,-33.564659],[-70.578769,-33.564609],[-70.578668,-33.564591],[-70.578573,-33.564573],[-70.578296,-33.564523],[-70.578018,-33.564474],[-70.577745,-33.564426],[-70.577471,-33.564375],[-70.577196,-33.564324],[-70.576238,-33.564156],[-70.574867,-33.563912],[-70.573304,-33.563629],[-70.571942,-33.563386],[-70.571269,-33.563271],[-70.570895,-33.563204],[-70.570522,-33.563137],[-70.570135,-33.563072],[-70.569731,-33.563],[-70.569381,-33.562939],[-70.56908,-33.562888],[-70.56876,-33.562831],[-70.568201,-33.562731],[-70.568199,-33.562725],[-70.567844,-33.562674],[-70.566826,-33.562488],[-70.56443,-33.562072],[-70.564429,-33.562068],[-70.564214,-33.562034],[-70.563684,-33.561948],[-70.563304,-33.561905],[-70.56216,-33.561679],[-70.557761,-33.560858],[-70.557357,-33.560782],[-70.557452,-33.560689],[-70.55878,-33.559236],[-70.559182,-33.558756],[-70.55963,-33.558188],[-70.559991,-33.557608],[-70.560991,-33.556397],[-70.562385,-33.554683],[-70.563888,-33.552926],[-70.568256,-33.547743],[-70.568251,-33.547743],[-70.568259,-33.54774],[-70.568452,-33.547484],[-70.568008,-33.547481],[-70.565383,-33.547649],[-70.563167,-33.547706],[-70.56151,-33.547736],[-70.55981,-33.547773],[-70.557822,-33.547817],[-70.556932,-33.547835],[-70.5544,-33.547913],[-70.552969,-33.548029],[-70.552609,-33.54801],[-70.552062,-33.548017],[-70.551431,-33.548025],[-70.550885,-33.548137],[-70.550383,-33.54832],[-70.549715,-33.54861],[-70.549257,-33.548863],[-70.549007,-33.549042],[-70.548676,-33.549364],[-70.548512,-33.549577],[-70.548392,-33.549966],[-70.54827,-33.550215],[-70.548148,-33.550428],[-70.548066,-33.550534],[-70.547566,-33.550858],[-70.547361,-33.551178],[-70.547242,-33.551567],[-70.547205,-33.551849],[-70.547123,-33.551956],[-70.546787,-33.552031],[-70.546406,-33.551895],[-70.546191,-33.551651],[-70.545894,-33.551513],[-70.545471,-33.551413],[-70.545177,-33.551416],[-70.544756,-33.551457],[-70.544247,-33.551217],[-70.544075,-33.551042],[-70.543778,-33.55087],[-70.543144,-33.550737],[-70.541286,-33.550443],[-70.540567,-33.550205],[-70.540211,-33.549892],[-70.539834,-33.549726],[-70.539376,-33.549589],[-70.538918,-33.549499],[-70.538401,-33.549267],[-70.537999,-33.549081],[-70.537482,-33.548849],[-70.537228,-33.5486],[-70.536789,-33.548332],[-70.5361,-33.548055],[-70.535278,-33.547602],[-70.534755,-33.547228],[-70.53454,-33.546881],[-70.534183,-33.546766],[-70.533967,-33.546697],[-70.53345,-33.546465],[-70.532989,-33.546184],[-70.532698,-33.545854],[-70.532464,-33.545475],[-70.532113,-33.545002],[-70.531823,-33.544719],[-70.531363,-33.544439],[-70.531019,-33.544348],[-70.530446,-33.544164],[-70.529875,-33.544123],[-70.528335,-33.544047],[-70.527879,-33.544052],[-70.527136,-33.543918],[-70.52662,-33.543734],[-70.526048,-33.543598],[-70.525531,-33.543365],[-70.525073,-33.543276],[-70.524674,-33.54328],[-70.524046,-33.543193],[-70.523531,-33.543104],[-70.52256,-33.542972],[-70.521563,-33.542905],[-70.521363,-33.542911],[-70.521327,-33.542913],[-70.521091,-33.542926],[-70.520854,-33.542945],[-70.520618,-33.542959],[-70.520382,-33.542982],[-70.520146,-33.542996],[-70.519909,-33.543014],[-70.519673,-33.543033],[-70.519435,-33.543042],[-70.519198,-33.543052],[-70.518961,-33.543056],[-70.518723,-33.54307],[-70.518486,-33.543075],[-70.518249,-33.543089],[-70.518013,-33.543103],[-70.517777,-33.543126],[-70.517543,-33.543154],[-70.517309,-33.543186],[-70.517077,-33.543227],[-70.516751,-33.543238],[-70.516408,-33.543293],[-70.515907,-33.543338],[-70.51527,-33.54349],[-70.514535,-33.543531],[-70.513579,-33.543758],[-70.512697,-33.544099],[-70.511515,-33.544651],[-70.510503,-33.544966],[-70.509493,-33.545235],[-70.507212,-33.545765],[-70.505326,-33.546246],[-70.504691,-33.546376]]],"type":"Polygon"},"properties":{"CIR_SENA":8,"COD_COMUNA":1320,"DIS_ELEC":29,"NOM_COM":"Puente Alto","NOM_PROV":"Cordillera","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":87831935.1934,"SHAPE_LENG":48961.654839,"SHAPE_Le_1":48986.347276},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.79438,-33.171888],[-70.792756,-33.1729],[-70.792677,-33.17292],[-70.79249,-33.172954],[-70.792301,-33.172984],[-70.792111,-33.173014],[-70.79195,-33.173035],[-70.791943,-33.173053],[-70.791911,-33.173058],[-70.791749,-33.173369],[-70.791024,-33.174249],[-70.790028,-33.175022],[-70.785812,-33.178126],[-70.784385,-33.179117],[-70.783613,-33.180221],[-70.782972,-33.181592],[-70.781771,-33.184289],[-70.781437,-33.185033],[-70.781082,-33.18583],[-70.780439,-33.187273],[-70.779539,-33.189292],[-70.778779,-33.190991],[-70.778226,-33.192229],[-70.777544,-33.193762],[-70.77702,-33.194931],[-70.776209,-33.196751],[-70.775744,-33.197791],[-70.775192,-33.199027],[-70.774666,-33.200206],[-70.774215,-33.201217],[-70.773196,-33.203499],[-70.7714,-33.207527],[-70.771143,-33.208103],[-70.771298,-33.208316],[-70.771075,-33.208255],[-70.767498,-33.216269],[-70.766547,-33.2184],[-70.765947,-33.21974],[-70.764633,-33.222691],[-70.763834,-33.224465],[-70.760259,-33.232117],[-70.758801,-33.235377],[-70.758758,-33.235473],[-70.758746,-33.235498],[-70.757723,-33.237778],[-70.756585,-33.240321],[-70.755663,-33.242385],[-70.755195,-33.243438],[-70.754266,-33.245525],[-70.753354,-33.247567],[-70.752537,-33.249398],[-70.751349,-33.252055],[-70.751221,-33.252343],[-70.750612,-33.253704],[-70.749999,-33.255073],[-70.749023,-33.257253],[-70.746499,-33.262887],[-70.746565,-33.262961],[-70.746466,-33.262962],[-70.745565,-33.264975],[-70.743482,-33.26963],[-70.742814,-33.271077],[-70.742068,-33.272777],[-70.740949,-33.275286],[-70.739555,-33.278397],[-70.739156,-33.279286],[-70.738394,-33.280989],[-70.737647,-33.282652],[-70.734861,-33.288874],[-70.733382,-33.292166],[-70.732063,-33.295113],[-70.731316,-33.296779],[-70.730167,-33.299335],[-70.728805,-33.302373],[-70.728303,-33.303491],[-70.72671,-33.307041],[-70.724718,-33.311479],[-70.72333,-33.314577],[-70.723332,-33.314581],[-70.723328,-33.314581],[-70.722278,-33.316912],[-70.721797,-33.31798],[-70.720934,-33.319937],[-70.719576,-33.32296],[-70.718833,-33.324609],[-70.719484,-33.324811],[-70.723959,-33.325667],[-70.726513,-33.326242],[-70.726509,-33.326271],[-70.726563,-33.326254],[-70.726943,-33.326343],[-70.727929,-33.326311],[-70.728967,-33.326721],[-70.72925,-33.326812],[-70.729274,-33.326824],[-70.730174,-33.327053],[-70.731646,-33.327335],[-70.732092,-33.327329],[-70.732218,-33.32739],[-70.745582,-33.330426],[-70.75279,-33.332092],[-70.75279,-33.332092],[-70.756869,-33.333044],[-70.756908,-33.333015],[-70.756943,-33.333033],[-70.759903,-33.333701],[-70.766188,-33.335199],[-70.79349,-33.341266],[-70.793499,-33.341265],[-70.797876,-33.338472],[-70.797762,-33.338952],[-70.797771,-33.339411],[-70.797784,-33.340049],[-70.798037,-33.341287],[-70.798469,-33.342951],[-70.798543,-33.343761],[-70.798794,-33.344902],[-70.79932,-33.345611],[-70.79942,-33.345696],[-70.800308,-33.346451],[-70.800942,-33.346973],[-70.801063,-33.347057],[-70.801465,-33.347336],[-70.801878,-33.347701],[-70.802109,-33.348192],[-70.803284,-33.349844],[-70.8036,-33.350377],[-70.803683,-33.350581],[-70.803783,-33.350825],[-70.803922,-33.351144],[-70.804131,-33.351624],[-70.80447,-33.351959],[-70.804731,-33.35214],[-70.805031,-33.352383],[-70.805329,-33.352564],[-70.80574,-33.352867],[-70.806482,-33.353135],[-70.806817,-33.353315],[-70.806939,-33.353374],[-70.807189,-33.353495],[-70.807342,-33.35374],[-70.807356,-33.353816],[-70.807383,-33.353956],[-70.807499,-33.354232],[-70.807615,-33.354478],[-70.807916,-33.354813],[-70.808144,-33.35515],[-70.808557,-33.355515],[-70.808967,-33.355787],[-70.809193,-33.356],[-70.809382,-33.356244],[-70.809505,-33.356419],[-70.809514,-33.356461],[-70.809569,-33.356613],[-70.80964,-33.356723],[-70.809749,-33.356947],[-70.809778,-33.35696],[-70.810336,-33.357198],[-70.810415,-33.357242],[-70.810813,-33.357451],[-70.811125,-33.357699],[-70.811193,-33.357923],[-70.811223,-33.358021],[-70.811222,-33.358164],[-70.81122,-33.358443],[-70.811192,-33.358568],[-70.81113,-33.358846],[-70.811135,-33.359093],[-70.811214,-33.359339],[-70.811512,-33.35952],[-70.811772,-33.35964],[-70.812107,-33.359789],[-70.812663,-33.359997],[-70.813256,-33.360143],[-70.81381,-33.360259],[-70.814364,-33.360343],[-70.814514,-33.360434],[-70.814738,-33.360616],[-70.814926,-33.360768],[-70.815113,-33.36095],[-70.815376,-33.361163],[-70.815714,-33.361498],[-70.816122,-33.361647],[-70.816677,-33.361762],[-70.81701,-33.361819],[-70.817194,-33.361847],[-70.81749,-33.361874],[-70.81769,-33.36192],[-70.817936,-33.362084],[-70.818139,-33.362313],[-70.81831,-33.362387],[-70.818646,-33.362568],[-70.818793,-33.362647],[-70.818876,-33.362667],[-70.819129,-33.362777],[-70.81935,-33.362773],[-70.819532,-33.362709],[-70.819751,-33.362613],[-70.819899,-33.362611],[-70.82016,-33.362632],[-70.820378,-33.362666],[-70.820489,-33.362695],[-70.820585,-33.362741],[-70.82077,-33.362689],[-70.821249,-33.363129],[-70.821499,-33.363555],[-70.821869,-33.364377],[-70.822328,-33.365036],[-70.822687,-33.365447],[-70.82285,-33.36573],[-70.822819,-33.366065],[-70.822701,-33.36618],[-70.82276,-33.366453],[-70.822905,-33.366868],[-70.823168,-33.367363],[-70.823459,-33.368166],[-70.823515,-33.368463],[-70.82355,-33.36847],[-70.823747,-33.368895],[-70.82385,-33.36918],[-70.823908,-33.369346],[-70.823983,-33.369504],[-70.824272,-33.36976],[-70.824524,-33.369982],[-70.824636,-33.370179],[-70.824709,-33.370381],[-70.824818,-33.370666],[-70.825012,-33.370908],[-70.825138,-33.371005],[-70.825443,-33.371104],[-70.825805,-33.371112],[-70.82617,-33.371067],[-70.826318,-33.371054],[-70.826528,-33.371082],[-70.826787,-33.37117],[-70.827253,-33.371433],[-70.827572,-33.371643],[-70.827746,-33.371789],[-70.828008,-33.372122],[-70.828181,-33.372356],[-70.828441,-33.37274],[-70.828508,-33.372889],[-70.828586,-33.373186],[-70.828636,-33.373461],[-70.828742,-33.373657],[-70.828942,-33.373924],[-70.82909,-33.374123],[-70.829197,-33.374326],[-70.829244,-33.374535],[-70.829339,-33.37475],[-70.829327,-33.374898],[-70.829321,-33.374907],[-70.829322,-33.374909],[-70.82939,-33.375617],[-70.829508,-33.376192],[-70.829939,-33.376584],[-70.830368,-33.376888],[-70.831223,-33.377363],[-70.831649,-33.377534],[-70.832236,-33.377791],[-70.832401,-33.378099],[-70.832619,-33.378407],[-70.832892,-33.378846],[-70.832902,-33.379289],[-70.832913,-33.379821],[-70.832815,-33.380177],[-70.832611,-33.380534],[-70.832565,-33.38089],[-70.832836,-33.381196],[-70.833369,-33.38141],[-70.834006,-33.381534],[-70.835066,-33.381695],[-70.836502,-33.382161],[-70.836982,-33.382376],[-70.837413,-33.382769],[-70.83758,-33.383165],[-70.837532,-33.383388],[-70.837433,-33.383699],[-70.83744,-33.384054],[-70.837498,-33.384275],[-70.837557,-33.384584],[-70.837934,-33.384933],[-70.838467,-33.385147],[-70.839194,-33.385288],[-70.839228,-33.38527],[-70.839508,-33.385083],[-70.839817,-33.384884],[-70.840305,-33.38473],[-70.841109,-33.384553],[-70.841472,-33.384469],[-70.842262,-33.384222],[-70.842959,-33.384013],[-70.843189,-33.383912],[-70.843712,-33.38358],[-70.844275,-33.383195],[-70.844723,-33.382918],[-70.844946,-33.382784],[-70.845319,-33.382593],[-70.846003,-33.382327],[-70.846734,-33.382047],[-70.847603,-33.381732],[-70.848015,-33.38152],[-70.848117,-33.381615],[-70.848255,-33.381754],[-70.848509,-33.381676],[-70.849381,-33.381462],[-70.850223,-33.381294],[-70.850405,-33.38126],[-70.850495,-33.381223],[-70.850585,-33.381236],[-70.850657,-33.381212],[-70.850998,-33.381088],[-70.851432,-33.380883],[-70.851611,-33.380777],[-70.851797,-33.38066],[-70.852056,-33.380436],[-70.85226,-33.380245],[-70.852695,-33.379911],[-70.852702,-33.379885],[-70.852755,-33.379859],[-70.852799,-33.379838],[-70.852917,-33.379755],[-70.853118,-33.379627],[-70.853286,-33.379532],[-70.853641,-33.379362],[-70.853961,-33.379208],[-70.854187,-33.379105],[-70.8545,-33.378972],[-70.854711,-33.378882],[-70.854875,-33.378803],[-70.855078,-33.378716],[-70.855414,-33.378573],[-70.855698,-33.378453],[-70.855728,-33.378448],[-70.857097,-33.377799],[-70.860135,-33.376556],[-70.862917,-33.375717],[-70.863708,-33.375616],[-70.864447,-33.375605],[-70.867724,-33.375644],[-70.870152,-33.375519],[-70.87089,-33.375464],[-70.871622,-33.375098],[-70.872618,-33.374728],[-70.873815,-33.373868],[-70.87439,-33.373593],[-70.875129,-33.373538],[-70.875658,-33.373574],[-70.876032,-33.373746],[-70.876304,-33.374141],[-70.876522,-33.374448],[-70.877114,-33.374926],[-70.877969,-33.375401],[-70.879603,-33.375852],[-70.88151,-33.376078],[-70.884221,-33.375817],[-70.88526,-33.3755],[-70.887741,-33.37519],[-70.889696,-33.375178],[-70.891039,-33.37534],[-70.892476,-33.375464],[-70.894648,-33.374788],[-70.895796,-33.374124],[-70.89759,-33.373597],[-70.899702,-33.373199],[-70.90052,-33.37264],[-70.901389,-33.371966],[-70.901993,-33.371008],[-70.903784,-33.370522],[-70.904644,-33.370042],[-70.905887,-33.369339],[-70.907325,-33.36845],[-70.908962,-33.36827],[-70.909845,-33.368299],[-70.910257,-33.368429],[-70.911105,-33.369201],[-70.911979,-33.369423],[-70.912851,-33.369686],[-70.913962,-33.369804],[-70.914401,-33.369988],[-70.914967,-33.370225],[-70.915441,-33.370565],[-70.915488,-33.370598],[-70.916261,-33.371821],[-70.916899,-33.372383],[-70.91742,-33.372805],[-70.918051,-33.373081],[-70.918512,-33.373313],[-70.919315,-33.373635],[-70.920117,-33.373908],[-70.921093,-33.374323],[-70.92213,-33.374927],[-70.92293,-33.375106],[-70.923507,-33.375478],[-70.924339,-33.37567],[-70.924481,-33.375693],[-70.925105,-33.375795],[-70.925676,-33.375827],[-70.92636,-33.375864],[-70.927046,-33.376044],[-70.927389,-33.376134],[-70.927619,-33.376226],[-70.928032,-33.376523],[-70.928139,-33.3766],[-70.928714,-33.376877],[-70.929571,-33.377054],[-70.929881,-33.37705],[-70.930139,-33.377046],[-70.930879,-33.377034],[-70.931278,-33.377076],[-70.931794,-33.377258],[-70.932083,-33.377493],[-70.932317,-33.377775],[-70.932666,-33.378151],[-70.932959,-33.378529],[-70.933308,-33.378857],[-70.933882,-33.379087],[-70.934452,-33.379174],[-70.935023,-33.37926],[-70.935819,-33.379248],[-70.936561,-33.379379],[-70.936905,-33.379469],[-70.937421,-33.379652],[-70.937939,-33.37993],[-70.938568,-33.380111],[-70.939829,-33.380521],[-70.940285,-33.380562],[-70.9412,-33.380786],[-70.941999,-33.380917],[-70.942745,-33.381191],[-70.943317,-33.381373],[-70.943662,-33.381511],[-70.944068,-33.381886],[-70.944415,-33.38212],[-70.944593,-33.382451],[-70.944771,-33.382782],[-70.945006,-33.383112],[-70.945239,-33.383395],[-70.945473,-33.383678],[-70.945892,-33.384142],[-70.94594,-33.384195],[-70.946582,-33.384863],[-70.946664,-33.384909],[-70.94766,-33.384789],[-70.948113,-33.384734],[-70.948734,-33.384569],[-70.949358,-33.384506],[-70.950155,-33.384463],[-70.950373,-33.384404],[-70.95072,-33.384311],[-70.951523,-33.384078],[-70.951621,-33.384035],[-70.95219,-33.383906],[-70.952867,-33.383657],[-70.953487,-33.383409],[-70.954163,-33.383112],[-70.955175,-33.382571],[-70.955733,-33.382085],[-70.956231,-33.381457],[-70.956849,-33.380934],[-70.957407,-33.380627],[-70.958256,-33.38047],[-70.95922,-33.380356],[-70.960482,-33.3801],[-70.960976,-33.379998],[-70.961399,-33.37977],[-70.961707,-33.379605],[-70.962281,-33.379471],[-70.962834,-33.379157],[-70.963335,-33.378672],[-70.963555,-33.378335],[-70.964056,-33.377849],[-70.964731,-33.377505],[-70.965466,-33.377302],[-70.967097,-33.376513],[-70.967547,-33.376267],[-70.967681,-33.376185],[-70.968108,-33.375924],[-70.968272,-33.375635],[-70.968486,-33.375264],[-70.968527,-33.375192],[-70.968563,-33.375143],[-70.968652,-33.374818],[-70.968872,-33.374528],[-70.969234,-33.374203],[-70.969525,-33.373795],[-70.969866,-33.373318],[-70.96998,-33.373157],[-70.970063,-33.373036],[-70.970199,-33.372837],[-70.970283,-33.372584],[-70.970379,-33.372292],[-70.970625,-33.371542],[-70.97067,-33.371016],[-70.971053,-33.370342],[-70.971332,-33.370099],[-70.971676,-33.36985],[-70.972341,-33.369463],[-70.972858,-33.369128],[-70.973294,-33.368827],[-70.973694,-33.368527],[-70.97402,-33.368243],[-70.974875,-33.367786],[-70.975311,-33.367507],[-70.976038,-33.366774],[-70.97709,-33.365713],[-70.977593,-33.365323],[-70.978044,-33.365125],[-70.978946,-33.364777],[-70.979398,-33.364626],[-70.980018,-33.364426],[-70.980579,-33.364083],[-70.981022,-33.36355],[-70.981464,-33.362971],[-70.981852,-33.362535],[-70.98218,-33.361957],[-70.982906,-33.361373],[-70.983581,-33.361028],[-70.9842,-33.360732],[-70.984646,-33.360343],[-70.984833,-33.360138],[-70.984993,-33.359962],[-70.985367,-33.359568],[-70.985697,-33.359038],[-70.985947,-33.358218],[-70.986348,-33.357691],[-70.986792,-33.357207],[-70.987176,-33.356581],[-70.987299,-33.35594],[-70.987262,-33.355339],[-70.987251,-33.354862],[-70.987011,-33.354341],[-70.986829,-33.353818],[-70.986679,-33.353339],[-70.986397,-33.352571],[-70.986205,-33.351395],[-70.986297,-33.350439],[-70.986452,-33.349721],[-70.986946,-33.348949],[-70.987444,-33.348369],[-70.987717,-33.347839],[-70.988326,-33.347114],[-70.988715,-33.346726],[-70.98887,-33.346652],[-70.989952,-33.346133],[-70.990964,-33.34564],[-70.991864,-33.345196],[-70.992597,-33.344946],[-70.993554,-33.344501],[-70.994394,-33.343963],[-70.995344,-33.343461],[-70.995893,-33.343025],[-70.996406,-33.342451],[-70.996733,-33.341825],[-70.997011,-33.34122],[-70.997613,-33.340523],[-70.998596,-33.338741],[-70.999088,-33.337874],[-70.999638,-33.337102],[-71.000135,-33.336426],[-71.000529,-33.335687],[-71.000571,-33.335608],[-71.000901,-33.335125],[-71.001286,-33.334594],[-71.001686,-33.333838],[-71.002049,-33.33315],[-71.002034,-33.332483],[-71.002018,-33.331767],[-71.002174,-33.331144],[-71.002467,-33.330679],[-71.002946,-33.330082],[-71.00334,-33.329434],[-71.003492,-33.329119],[-71.00359,-33.328449],[-71.003637,-33.328019],[-71.003623,-33.327399],[-71.003555,-33.326923],[-71.003601,-33.326445],[-71.003709,-33.326204],[-71.003856,-33.325946],[-71.003834,-33.325292],[-71.003656,-33.323764],[-71.003717,-33.32245],[-71.002715,-33.319088],[-71.002061,-33.31713],[-71.001729,-33.315385],[-71.001624,-33.314066],[-71.001608,-33.31261],[-71.001684,-33.31095],[-71.00183,-33.309567],[-71.001801,-33.309287],[-71.00166,-33.308677],[-71.001247,-33.308015],[-71.000839,-33.307545],[-71.000544,-33.307072],[-71.000182,-33.306636],[-70.999785,-33.306178],[-70.999435,-33.305802],[-70.997874,-33.304634],[-70.997471,-33.304402],[-70.997013,-33.304266],[-70.996388,-33.304276],[-70.995588,-33.304098],[-70.994728,-33.30373],[-70.993923,-33.303314],[-70.993403,-33.30294],[-70.990523,-33.301268],[-70.98989,-33.300897],[-70.989545,-33.300712],[-70.989083,-33.300385],[-70.988624,-33.300201],[-70.987994,-33.299973],[-70.987136,-33.299748],[-70.986327,-33.299141],[-70.985808,-33.298815],[-70.984426,-33.298026],[-70.983797,-33.297845],[-70.983114,-33.297808],[-70.982261,-33.297774],[-70.981458,-33.297453],[-70.981,-33.297269],[-70.9802,-33.297091],[-70.979686,-33.296956],[-70.978488,-33.296784],[-70.978147,-33.296742],[-70.977576,-33.296656],[-70.977059,-33.296378],[-70.976717,-33.296335],[-70.975861,-33.296206],[-70.97529,-33.296072],[-70.974719,-33.295938],[-70.974087,-33.295614],[-70.973509,-33.295193],[-70.972653,-33.29437],[-70.972289,-33.29402],[-70.97158,-33.293569],[-70.971114,-33.292996],[-70.970891,-33.292467],[-70.970598,-33.29209],[-70.97042,-33.291759],[-70.970243,-33.291475],[-70.969953,-33.291194],[-70.969434,-33.290868],[-70.968744,-33.290497],[-70.968481,-33.290158],[-70.968465,-33.290027],[-70.969681,-33.289194],[-70.969737,-33.289138],[-70.97007,-33.288806],[-70.970348,-33.288529],[-70.970459,-33.288418],[-70.971071,-33.287883],[-70.971793,-33.287108],[-70.972141,-33.286838],[-70.972295,-33.286718],[-70.972564,-33.286046],[-70.972667,-33.285567],[-70.972992,-33.284846],[-70.973145,-33.28408],[-70.97319,-33.283555],[-70.973359,-33.282554],[-70.973388,-33.28243],[-70.9735,-33.282166],[-70.973587,-33.281602],[-70.973648,-33.281209],[-70.973924,-33.280202],[-70.974253,-33.278998],[-70.974607,-33.278379],[-70.975546,-33.277171],[-70.975933,-33.276687],[-70.976323,-33.276347],[-70.97688,-33.275861],[-70.97727,-33.275521],[-70.977716,-33.275132],[-70.977817,-33.274605],[-70.977978,-33.274173],[-70.978138,-33.273694],[-70.978316,-33.273433],[-70.978728,-33.272157],[-70.978706,-33.271181],[-70.978699,-33.270869],[-70.978739,-33.270153],[-70.978641,-33.268293],[-70.978733,-33.267338],[-70.978831,-33.266668],[-70.979016,-33.266136],[-70.979256,-33.265373],[-70.979347,-33.26513],[-70.979471,-33.264797],[-70.97985,-33.264451],[-70.980306,-33.264068],[-70.980583,-33.26367],[-70.980912,-33.263199],[-70.982074,-33.261844],[-70.982345,-33.261267],[-70.982501,-33.260645],[-70.982712,-33.259925],[-70.982814,-33.259399],[-70.982738,-33.258541],[-70.982926,-33.25682],[-70.983084,-33.256293],[-70.983244,-33.255813],[-70.983346,-33.255286],[-70.983618,-33.254757],[-70.984001,-33.254131],[-70.984277,-33.253792],[-70.984549,-33.253263],[-70.984763,-33.252687],[-70.98515,-33.252204],[-70.985764,-33.251717],[-70.986296,-33.251072],[-70.986483,-33.250846],[-70.986758,-33.25046],[-70.98703,-33.249931],[-70.987071,-33.249262],[-70.987229,-33.248687],[-70.98739,-33.24829],[-70.987444,-33.248159],[-70.987832,-33.247723],[-70.988452,-33.246953],[-70.988525,-33.246841],[-70.989654,-33.245451],[-70.990261,-33.244694],[-70.99082,-33.244287],[-70.991374,-33.243658],[-70.991644,-33.243033],[-70.991965,-33.242169],[-70.992286,-33.241305],[-70.992556,-33.240663],[-70.992711,-33.240294],[-70.993043,-33.239622],[-70.993588,-33.238612],[-70.994754,-33.237448],[-70.995242,-33.236438],[-70.995619,-33.235525],[-70.995878,-33.234423],[-70.995914,-33.233927],[-70.99608,-33.231679],[-70.996138,-33.230888],[-70.996092,-33.230461],[-70.996066,-33.230221],[-70.995937,-33.229555],[-70.995983,-33.229077],[-70.996145,-33.228693],[-70.996704,-33.228302],[-70.997478,-33.227383],[-70.997864,-33.226899],[-70.998303,-33.226224],[-70.998575,-33.225695],[-70.998898,-33.224926],[-70.99917,-33.224397],[-70.99967,-33.223912],[-71.000562,-33.223182],[-71.000913,-33.222554],[-71.000898,-33.222414],[-71.000814,-33.221794],[-71.000518,-33.221274],[-71.000219,-33.22061],[-70.999972,-33.219708],[-70.999902,-33.219136],[-70.999823,-33.218183],[-70.999813,-33.217706],[-71.000024,-33.217035],[-71.000255,-33.216586],[-71.000296,-33.216505],[-71.000948,-33.215206],[-71.001376,-33.214054],[-71.001535,-33.213574],[-71.001688,-33.212808],[-71.001608,-33.211808],[-71.001293,-33.210429],[-71.001115,-33.210098],[-71.000706,-33.209579],[-71.000242,-33.209157],[-70.999773,-33.208497],[-70.99959,-33.207927],[-70.999514,-33.207069],[-70.999646,-33.205397],[-70.999565,-33.204349],[-70.999552,-33.203776],[-70.999367,-33.203111],[-70.999068,-33.202448],[-70.998715,-33.201881],[-70.998305,-33.201219],[-70.998019,-33.200468],[-70.997819,-33.199939],[-70.997693,-33.199368],[-70.997499,-33.198367],[-70.996926,-33.197566],[-70.997029,-33.196315],[-70.997161,-33.195461],[-70.997794,-33.1938],[-70.998166,-33.192793],[-70.998191,-33.192252],[-70.996783,-33.190484],[-70.995302,-33.186252],[-70.993308,-33.183475],[-70.993119,-33.183284],[-70.992882,-33.183067],[-70.992675,-33.182844],[-70.992544,-33.182599],[-70.992502,-33.182324],[-70.992518,-33.182035],[-70.992555,-33.181742],[-70.992591,-33.181448],[-70.992667,-33.181172],[-70.992828,-33.18093],[-70.993067,-33.180723],[-70.993292,-33.180512],[-70.993467,-33.180266],[-70.99363,-33.180011],[-70.993763,-33.179752],[-70.993812,-33.179476],[-70.993721,-33.179193],[-70.993566,-33.178939],[-70.993456,-33.178679],[-70.993473,-33.17839],[-70.993434,-33.178107],[-70.993385,-33.177824],[-70.993376,-33.177663],[-70.991727,-33.17775],[-70.987358,-33.177735],[-70.985682,-33.177474],[-70.984889,-33.176362],[-70.984002,-33.174036],[-70.983457,-33.172933],[-70.982829,-33.172538],[-70.982246,-33.172267],[-70.981699,-33.172294],[-70.980974,-33.172938],[-70.980568,-33.173132],[-70.979313,-33.173425],[-70.978167,-33.173514],[-70.97763,-33.17333],[-70.977195,-33.173063],[-70.976516,-33.172708],[-70.976192,-33.172197],[-70.975607,-33.171971],[-70.975104,-33.172072],[-70.974421,-33.172933],[-70.973536,-33.173824],[-70.972811,-33.174381],[-70.972712,-33.174468],[-70.971398,-33.174966],[-70.969669,-33.17587],[-70.968157,-33.176366],[-70.966747,-33.17678],[-70.965046,-33.177058],[-70.963304,-33.17752],[-70.962264,-33.177279],[-70.961539,-33.17689],[-70.960435,-33.176701],[-70.959269,-33.176505],[-70.957937,-33.176201],[-70.956101,-33.175096],[-70.955203,-33.174107],[-70.954075,-33.172737],[-70.953291,-33.172499],[-70.95229,-33.172679],[-70.95164,-33.172779],[-70.951083,-33.173018],[-70.950481,-33.173165],[-70.949579,-33.173343],[-70.94878,-33.173443],[-70.947584,-33.17353],[-70.946339,-33.173878],[-70.945612,-33.174261],[-70.945053,-33.174651],[-70.944271,-33.175236],[-70.943822,-33.175434],[-70.943261,-33.175729],[-70.942866,-33.175831],[-70.942415,-33.175981],[-70.941741,-33.176278],[-70.941289,-33.17638],[-70.940896,-33.176577],[-70.940559,-33.176726],[-70.939724,-33.177455],[-70.93962,-33.177886],[-70.939461,-33.178413],[-70.939244,-33.178846],[-70.938577,-33.179477],[-70.937964,-33.180011],[-70.936955,-33.180552],[-70.935835,-33.181237],[-70.93528,-33.181819],[-70.934838,-33.18235],[-70.934678,-33.18283],[-70.934519,-33.183357],[-70.934186,-33.183697],[-70.933677,-33.183752],[-70.933393,-33.183757],[-70.932944,-33.184002],[-70.932781,-33.184291],[-70.932619,-33.184675],[-70.932348,-33.185252],[-70.931907,-33.18588],[-70.931461,-33.186221],[-70.930957,-33.186515],[-70.930071,-33.186732],[-70.929834,-33.186791],[-70.928976,-33.186784],[-70.928466,-33.186723],[-70.92761,-33.186614],[-70.927039,-33.186432],[-70.926524,-33.186249],[-70.926067,-33.186113],[-70.925324,-33.185886],[-70.924812,-33.185799],[-70.92407,-33.185619],[-70.92367,-33.185482],[-70.923098,-33.1853],[-70.922583,-33.185117],[-70.921727,-33.184892],[-70.921327,-33.184755],[-70.92053,-33.184624],[-70.919735,-33.184636],[-70.918826,-33.184603],[-70.918257,-33.184516],[-70.917742,-33.184333],[-70.917171,-33.184151],[-70.916656,-33.183968],[-70.914255,-33.183146],[-70.913397,-33.182873],[-70.912939,-33.182689],[-70.912313,-33.182603],[-70.911802,-33.182563],[-70.911345,-33.182427],[-70.910941,-33.182147],[-70.910368,-33.18187],[-70.909796,-33.181687],[-70.909111,-33.181507],[-70.907575,-33.181292],[-70.905812,-33.181184],[-70.905504,-33.181181],[-70.904792,-33.181191],[-70.903827,-33.181206],[-70.9032,-33.181137],[-70.902893,-33.181125],[-70.90235,-33.181133],[-70.902223,-33.181099],[-70.901498,-33.181076],[-70.900761,-33.18111],[-70.90008,-33.18112],[-70.899691,-33.181156],[-70.899487,-33.181175],[-70.89861,-33.181381],[-70.89742,-33.181447],[-70.897021,-33.181406],[-70.896011,-33.181306],[-70.89451,-33.181157],[-70.892929,-33.181086],[-70.892254,-33.181383],[-70.890846,-33.18307],[-70.890786,-33.183142],[-70.890317,-33.183703],[-70.890237,-33.183947],[-70.889762,-33.185391],[-70.889718,-33.186042],[-70.889761,-33.18799],[-70.890235,-33.194723],[-70.890517,-33.197138],[-70.890538,-33.198797],[-70.890877,-33.199966],[-70.8913,-33.201476],[-70.891908,-33.203235],[-70.892039,-33.204649],[-70.89219,-33.20565],[-70.893176,-33.207755],[-70.894453,-33.209153],[-70.894444,-33.209923],[-70.89458,-33.210337],[-70.894592,-33.210886],[-70.894148,-33.21137],[-70.893697,-33.21152],[-70.893192,-33.211767],[-70.892763,-33.211921],[-70.892579,-33.211987],[-70.891948,-33.212024],[-70.891268,-33.212082],[-70.890477,-33.212237],[-70.89007,-33.212373],[-70.890025,-33.212375],[-70.889461,-33.212539],[-70.888561,-33.212887],[-70.887439,-33.213524],[-70.886991,-33.213817],[-70.886215,-33.214688],[-70.886114,-33.215262],[-70.886127,-33.215883],[-70.885971,-33.216553],[-70.886049,-33.217554],[-70.886118,-33.218125],[-70.88625,-33.218982],[-70.886383,-33.219887],[-70.886393,-33.220364],[-70.88646,-33.22084],[-70.886584,-33.221316],[-70.886775,-33.222267],[-70.887179,-33.222595],[-70.887701,-33.223112],[-70.887738,-33.223171],[-70.887876,-33.223392],[-70.887937,-33.22349],[-70.887832,-33.223921],[-70.887325,-33.224072],[-70.886033,-33.224712],[-70.885083,-33.225442],[-70.884025,-33.226413],[-70.883368,-33.227568],[-70.883089,-33.228431],[-70.88295,-33.22886],[-70.882059,-33.227665],[-70.881128,-33.226999],[-70.879697,-33.226717],[-70.878742,-33.226572],[-70.877147,-33.226866],[-70.875261,-33.227493],[-70.873419,-33.227202],[-70.8722,-33.226815],[-70.869885,-33.226332],[-70.868586,-33.226177],[-70.866818,-33.225771],[-70.866307,-33.224943],[-70.865965,-33.223431],[-70.865309,-33.222774],[-70.86446,-33.221822],[-70.863287,-33.220454],[-70.862342,-33.218634],[-70.861908,-33.217638],[-70.861493,-33.216236],[-70.860954,-33.214542],[-70.860116,-33.213357],[-70.859575,-33.211721],[-70.859228,-33.210327],[-70.858418,-33.208565],[-70.857624,-33.206457],[-70.856528,-33.204083],[-70.854993,-33.2025],[-70.853125,-33.200631],[-70.85247,-33.200037],[-70.850048,-33.197771],[-70.849414,-33.195281],[-70.849177,-33.194525],[-70.849427,-33.192119],[-70.84995,-33.189726],[-70.850378,-33.187902],[-70.851071,-33.186258],[-70.852241,-33.184631],[-70.855457,-33.183071],[-70.857206,-33.18221],[-70.857364,-33.181756],[-70.857175,-33.181407],[-70.856567,-33.18127],[-70.85371,-33.181003],[-70.850223,-33.181058],[-70.848038,-33.181044],[-70.845721,-33.180908],[-70.842256,-33.180504],[-70.840416,-33.180388],[-70.83819,-33.179795],[-70.835257,-33.179697],[-70.832311,-33.180846],[-70.830802,-33.181381],[-70.829938,-33.182154],[-70.828602,-33.183502],[-70.82721,-33.184685],[-70.825863,-33.184905],[-70.824938,-33.184289],[-70.823749,-33.183244],[-70.822933,-33.181811],[-70.822535,-33.180888],[-70.821956,-33.179629],[-70.820338,-33.17798],[-70.818992,-33.176863],[-70.816677,-33.175983],[-70.815295,-33.17567],[-70.813169,-33.175166],[-70.811255,-33.174656],[-70.809248,-33.173174],[-70.808466,-33.172782],[-70.808107,-33.172392],[-70.807646,-33.171759],[-70.807208,-33.171663],[-70.806028,-33.171705],[-70.804683,-33.172114],[-70.803304,-33.172189],[-70.802215,-33.172081],[-70.80142,-33.171509],[-70.800823,-33.170659],[-70.799982,-33.169766],[-70.799401,-33.16958],[-70.798463,-33.169674],[-70.797263,-33.170129],[-70.795549,-33.171062],[-70.79438,-33.171888]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1330,"DIS_ELEC":16,"NOM_COM":"Lampa","NOM_PROV":"Chacabuco","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":449554864.302,"SHAPE_LENG":105302.271643,"SHAPE_Le_1":105148.763529},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.781437,-33.185033],[-70.781771,-33.184289],[-70.782972,-33.181592],[-70.783613,-33.180221],[-70.784385,-33.179117],[-70.785812,-33.178126],[-70.790028,-33.175022],[-70.791024,-33.174249],[-70.791749,-33.173369],[-70.791911,-33.173058],[-70.791943,-33.173053],[-70.79195,-33.173035],[-70.792275,-33.172194],[-70.790191,-33.172338],[-70.788658,-33.17209],[-70.788429,-33.172052],[-70.787841,-33.17184],[-70.786995,-33.171701],[-70.785582,-33.171527],[-70.784455,-33.171615],[-70.781969,-33.171972],[-70.781203,-33.172324],[-70.77976,-33.17278],[-70.778247,-33.173107],[-70.777042,-33.173251],[-70.77605,-33.173658],[-70.775497,-33.17427],[-70.774869,-33.17488],[-70.774095,-33.175416],[-70.772824,-33.175373],[-70.772311,-33.175166],[-70.771722,-33.174962],[-70.77098,-33.17481],[-70.770009,-33.174777],[-70.769167,-33.175186],[-70.768312,-33.17585],[-70.767749,-33.176651],[-70.76728,-33.177072],[-70.766738,-33.177432],[-70.765961,-33.178036],[-70.765114,-33.178512],[-70.764341,-33.179049],[-70.763354,-33.17933],[-70.762314,-33.179169],[-70.761211,-33.178757],[-70.7598,-33.17852],[-70.759045,-33.178683],[-70.758049,-33.179149],[-70.757059,-33.179494],[-70.756456,-33.1796],[-70.755425,-33.179249],[-70.754471,-33.178838],[-70.753976,-33.178258],[-70.753549,-33.177802],[-70.753125,-33.177283],[-70.752773,-33.176829],[-70.752342,-33.176441],[-70.75199,-33.175987],[-70.751793,-33.175413],[-70.751668,-33.174904],[-70.751391,-33.174453],[-70.750661,-33.174054],[-70.750036,-33.173799],[-70.74937,-33.173614],[-70.748951,-33.173316],[-70.74867,-33.173144],[-70.748109,-33.1728],[-70.747643,-33.17246],[-70.747028,-33.172236],[-70.746222,-33.171965],[-70.745656,-33.171703],[-70.745383,-33.171369],[-70.745265,-33.170838],[-70.745286,-33.170393],[-70.74526,-33.16995],[-70.744986,-33.169617],[-70.744378,-33.169231],[-70.743667,-33.169004],[-70.742797,-33.169055],[-70.74289,-33.169139],[-70.742116,-33.169194],[-70.741348,-33.169127],[-70.740348,-33.16889],[-70.739448,-33.168575],[-70.738746,-33.168146],[-70.738044,-33.167716],[-70.737389,-33.167329],[-70.73711,-33.167117],[-70.736586,-33.166977],[-70.735831,-33.166667],[-70.735735,-33.166626],[-70.735317,-33.166141],[-70.735025,-33.165746],[-70.734777,-33.165231],[-70.734381,-33.164398],[-70.734276,-33.163841],[-70.734173,-33.163443],[-70.734211,-33.162964],[-70.734341,-33.162324],[-70.734517,-33.161643],[-70.734648,-33.161083],[-70.73492,-33.160441],[-70.735479,-33.159914],[-70.735951,-33.159678],[-70.736069,-33.15962],[-70.736137,-33.159586],[-70.736199,-33.159566],[-70.736329,-33.159524],[-70.73646,-33.159483],[-70.736591,-33.159441],[-70.73672,-33.1594],[-70.736851,-33.159358],[-70.73698,-33.159317],[-70.737111,-33.159275],[-70.737315,-33.15921],[-70.737622,-33.159086],[-70.737746,-33.159036],[-70.737927,-33.158962],[-70.738722,-33.158392],[-70.738953,-33.158003],[-70.739015,-33.157899],[-70.739034,-33.157867],[-70.739063,-33.157787],[-70.73909,-33.15767],[-70.739116,-33.157557],[-70.739142,-33.157441],[-70.739169,-33.157325],[-70.739195,-33.157213],[-70.739219,-33.157109],[-70.739226,-33.156977],[-70.739254,-33.15647],[-70.739243,-33.155911],[-70.739564,-33.155388],[-70.740204,-33.154435],[-70.740272,-33.154333],[-70.740348,-33.15422],[-70.740626,-33.153897],[-70.741139,-33.153451],[-70.741701,-33.153084],[-70.74198,-33.152801],[-70.742255,-33.151714],[-70.742321,-33.150881],[-70.742302,-33.149923],[-70.742292,-33.149405],[-70.742431,-33.148596],[-70.742445,-33.148519],[-70.742474,-33.148503],[-70.743121,-33.148156],[-70.743682,-33.147749],[-70.743862,-33.147228],[-70.743943,-33.146549],[-70.744026,-33.145949],[-70.744208,-33.145548],[-70.744867,-33.145299],[-70.745339,-33.145173],[-70.746095,-33.145042],[-70.747088,-33.144869],[-70.748362,-33.144532],[-70.748925,-33.144245],[-70.749579,-33.143717],[-70.750093,-33.14335],[-70.75075,-33.142982],[-70.751124,-33.142697],[-70.751442,-33.14235],[-70.751495,-33.142293],[-70.751916,-33.142008],[-70.752481,-33.141801],[-70.752929,-33.141611],[-70.752954,-33.141562],[-70.753033,-33.14141],[-70.753132,-33.141268],[-70.753229,-33.141128],[-70.753303,-33.141022],[-70.753332,-33.140984],[-70.753371,-33.140831],[-70.753496,-33.14035],[-70.753812,-33.139587],[-70.754373,-33.13914],[-70.754745,-33.138776],[-70.754929,-33.138494],[-70.754972,-33.138254],[-70.754523,-33.137183],[-70.754327,-33.136867],[-70.754177,-33.13647],[-70.754027,-33.136073],[-70.753972,-33.135675],[-70.754011,-33.135275],[-70.754003,-33.134876],[-70.754002,-33.134833],[-70.753996,-33.134517],[-70.754216,-33.133636],[-70.754774,-33.13307],[-70.755143,-33.132586],[-70.755511,-33.131982],[-70.755691,-33.131501],[-70.756012,-33.130938],[-70.756427,-33.130373],[-70.756745,-33.129651],[-70.757252,-33.128925],[-70.757807,-33.128239],[-70.758266,-33.127475],[-70.758729,-33.126909],[-70.759235,-33.126104],[-70.759457,-33.125343],[-70.759494,-33.124824],[-70.759485,-33.124385],[-70.759377,-33.123748],[-70.759177,-33.123192],[-70.75869,-33.122561],[-70.757673,-33.121498],[-70.757378,-33.120983],[-70.756944,-33.12059],[-70.756461,-33.120158],[-70.755787,-33.119649],[-70.755163,-33.119259],[-70.754874,-33.119063],[-70.754288,-33.118194],[-70.754224,-33.117357],[-70.754308,-33.116797],[-70.754439,-33.116277],[-70.75471,-33.115555],[-70.755121,-33.114791],[-70.755482,-33.113868],[-70.755849,-33.113224],[-70.756029,-33.112743],[-70.756439,-33.111939],[-70.757149,-33.110799],[-70.757197,-33.110687],[-70.757476,-33.110044],[-70.75769,-33.109056],[-70.757673,-33.108171],[-70.757664,-33.107728],[-70.757716,-33.107432],[-70.758171,-33.106786],[-70.759136,-33.105296],[-70.759755,-33.104106],[-70.759748,-33.103762],[-70.759684,-33.103468],[-70.75962,-33.103222],[-70.759558,-33.103027],[-70.759436,-33.102782],[-70.759137,-33.102442],[-70.759015,-33.102198],[-70.758834,-33.101905],[-70.758653,-33.101612],[-70.758649,-33.101415],[-70.758584,-33.101072],[-70.758578,-33.100777],[-70.758513,-33.100433],[-70.757293,-33.098463],[-70.7567,-33.097506],[-70.755873,-33.095935],[-70.754299,-33.093393],[-70.750909,-33.086342],[-70.749952,-33.084246],[-70.749276,-33.083032],[-70.749187,-33.082779],[-70.749003,-33.082449],[-70.748707,-33.081709],[-70.748676,-33.081559],[-70.748635,-33.081414],[-70.748592,-33.081263],[-70.748545,-33.081118],[-70.748496,-33.080967],[-70.748444,-33.080821],[-70.74839,-33.08068],[-70.748334,-33.080534],[-70.748264,-33.080392],[-70.748183,-33.080258],[-70.748104,-33.080116],[-70.748038,-33.079974],[-70.747991,-33.079833],[-70.747948,-33.079683],[-70.747908,-33.079533],[-70.747872,-33.079387],[-70.747838,-33.079233],[-70.747808,-33.079083],[-70.747781,-33.078934],[-70.747757,-33.078784],[-70.747737,-33.07863],[-70.747725,-33.078477],[-70.747724,-33.078328],[-70.747728,-33.078175],[-70.747734,-33.078022],[-70.747738,-33.077869],[-70.747736,-33.077716],[-70.747724,-33.077567],[-70.747696,-33.077413],[-70.747658,-33.077267],[-70.747615,-33.077117],[-70.747573,-33.076967],[-70.747526,-33.076821],[-70.747475,-33.076671],[-70.747422,-33.076529],[-70.747374,-33.076379],[-70.747332,-33.076233],[-70.747299,-33.076084],[-70.747279,-33.075934],[-70.747269,-33.075781],[-70.747267,-33.075628],[-70.747268,-33.075479],[-70.74727,-33.075326],[-70.74727,-33.075173],[-70.747262,-33.075019],[-70.747244,-33.07487],[-70.747209,-33.07472],[-70.747168,-33.07457],[-70.747131,-33.074425],[-70.747109,-33.074271],[-70.747095,-33.074117],[-70.747084,-33.073964],[-70.747077,-33.07381],[-70.74707,-33.073661],[-70.747062,-33.073508],[-70.747051,-33.073354],[-70.747037,-33.073205],[-70.747015,-33.073056],[-70.746986,-33.072906],[-70.746954,-33.072752],[-70.746923,-33.072607],[-70.746985,-33.072361],[-70.747025,-33.072209],[-70.74706,-33.072062],[-70.747084,-33.071914],[-70.747093,-33.071761],[-70.747076,-33.071612],[-70.747042,-33.071457],[-70.747004,-33.071307],[-70.74697,-33.071158],[-70.746933,-33.071008],[-70.746944,-33.070877],[-70.746951,-33.070616],[-70.746977,-33.070489],[-70.746898,-33.070094],[-70.746884,-33.069355],[-70.746963,-33.06891],[-70.74722,-33.068611],[-70.747564,-33.068236],[-70.748085,-33.067933],[-70.748697,-33.067777],[-70.749308,-33.06762],[-70.749746,-33.06754],[-70.750441,-33.067161],[-70.750782,-33.066638],[-70.751123,-33.066116],[-70.751635,-33.065369],[-70.75241,-33.064619],[-70.75319,-33.064091],[-70.753974,-33.063784],[-70.754758,-33.063477],[-70.756418,-33.06301],[-70.757026,-33.062706],[-70.758156,-33.062098],[-70.759115,-33.061789],[-70.759727,-33.061632],[-70.760508,-33.061178],[-70.761025,-33.060653],[-70.76163,-33.060201],[-70.76224,-33.05997],[-70.762587,-33.059743],[-70.763539,-33.059064],[-70.764133,-33.058021],[-70.76689,-33.055357],[-70.766701,-33.054694],[-70.766335,-33.05396],[-70.766062,-33.053446],[-70.765873,-33.052783],[-70.765852,-33.051749],[-70.765741,-33.050567],[-70.765643,-33.050051],[-70.765274,-33.049169],[-70.764822,-33.04851],[-70.764112,-33.04815],[-70.76323,-33.047941],[-70.762436,-33.04773],[-70.761726,-33.04737],[-70.761192,-33.047008],[-70.760561,-33.046204],[-70.760016,-33.04525],[-70.75965,-33.044516],[-70.759465,-33.044075],[-70.759454,-33.043484],[-70.759613,-33.042668],[-70.759688,-33.042001],[-70.760274,-33.040588],[-70.760529,-33.040141],[-70.760688,-33.039326],[-70.761198,-33.038505],[-70.761533,-33.037687],[-70.761875,-33.037238],[-70.762301,-33.036567],[-70.762291,-33.036049],[-70.762187,-33.035238],[-70.761825,-33.034725],[-70.761464,-33.034213],[-70.760753,-33.033779],[-70.759542,-33.033369],[-70.759151,-33.033146],[-70.758499,-33.032632],[-70.758036,-33.032211],[-70.757584,-33.031543],[-70.757317,-33.031047],[-70.756858,-33.03054],[-70.756418,-33.029629],[-70.756264,-33.028808],[-70.756106,-33.028073],[-70.755651,-33.027485],[-70.755284,-33.027067],[-70.75472,-33.026719],[-70.753774,-33.026282],[-70.753315,-33.025775],[-70.753064,-33.024951],[-70.753204,-33.024064],[-70.753529,-33.023341],[-70.754332,-33.022715],[-70.754939,-33.022163],[-70.755442,-33.021775],[-70.756133,-33.021474],[-70.756744,-33.020842],[-70.757061,-33.02028],[-70.75689,-33.019788],[-70.756439,-33.01912],[-70.756204,-33.017972],[-70.755853,-33.017225],[-70.755421,-33.016152],[-70.754584,-33.01547],[-70.754031,-33.014884],[-70.753372,-33.014533],[-70.752812,-33.014108],[-70.752437,-33.013852],[-70.751966,-33.013593],[-70.751491,-33.01341],[-70.751231,-33.013234],[-70.750942,-33.013022],[-70.750744,-33.01279],[-70.750573,-33.012604],[-70.750374,-33.012399],[-70.750205,-33.012163],[-70.750219,-33.011862],[-70.750264,-33.011562],[-70.750462,-33.01119],[-70.750771,-33.010975],[-70.751079,-33.010783],[-70.751211,-33.010535],[-70.75135,-33.010134],[-70.75164,-33.009694],[-70.751866,-33.009346],[-70.752119,-33.009079],[-70.752365,-33.008935],[-70.752763,-33.008746],[-70.753039,-33.008606],[-70.753286,-33.008254],[-70.753495,-33.007932],[-70.75392,-33.007136],[-70.754808,-33.006756],[-70.7555,-33.006456],[-70.756187,-33.006236],[-70.757068,-33.006018],[-70.757848,-33.005882],[-70.758354,-33.005413],[-70.758953,-33.005023],[-70.759081,-33.004379],[-70.759116,-33.003646],[-70.75944,-33.002923],[-70.759765,-33.0022],[-70.759707,-33.001382],[-70.759379,-33.00015],[-70.759033,-32.999323],[-70.759095,-32.998023],[-70.759343,-32.996892],[-70.759566,-32.996246],[-70.759907,-32.995199],[-70.760344,-32.994155],[-70.760781,-32.993111],[-70.761225,-32.991901],[-70.76165,-32.9911],[-70.762168,-32.990388],[-70.762886,-32.989516],[-70.763414,-32.988728],[-70.763745,-32.988582],[-70.764587,-32.988092],[-70.765247,-32.987923],[-70.765811,-32.987715],[-70.766798,-32.987382],[-70.767264,-32.987016],[-70.767682,-32.986572],[-70.768006,-32.986208],[-70.76847,-32.985762],[-70.768937,-32.985397],[-70.769307,-32.984992],[-70.769621,-32.984578],[-70.769666,-32.984551],[-70.769862,-32.984346],[-70.770139,-32.983983],[-70.770414,-32.98371],[-70.770071,-32.983331],[-70.768856,-32.982569],[-70.767442,-32.981855],[-70.766863,-32.98156],[-70.766211,-32.981425],[-70.765167,-32.981223],[-70.764322,-32.980974],[-70.763602,-32.980891],[-70.762171,-32.980513],[-70.76159,-32.980268],[-70.761075,-32.98003],[-70.76072,-32.979184],[-70.760681,-32.978629],[-70.760373,-32.978173],[-70.760066,-32.977721],[-70.759485,-32.977476],[-70.759164,-32.977302],[-70.758456,-32.976945],[-70.75762,-32.976525],[-70.756916,-32.976113],[-70.756337,-32.975814],[-70.755507,-32.97529],[-70.754673,-32.974816],[-70.753902,-32.974402],[-70.753283,-32.973602],[-70.752849,-32.973033],[-70.752302,-32.972073],[-70.751808,-32.971389],[-70.751511,-32.970712],[-70.751072,-32.970252],[-70.750699,-32.969797],[-70.750205,-32.969114],[-70.749832,-32.968655],[-70.749451,-32.968367],[-70.748872,-32.968068],[-70.748168,-32.967657],[-70.747658,-32.967306],[-70.747277,-32.967014],[-70.746756,-32.966888],[-70.745846,-32.966632],[-70.744732,-32.966539],[-70.74348,-32.966551],[-70.742743,-32.966805],[-70.742012,-32.966947],[-70.741097,-32.966803],[-70.739853,-32.966652],[-70.739146,-32.966295],[-70.738116,-32.965813],[-70.737677,-32.965357],[-70.736923,-32.964606],[-70.736229,-32.963974],[-70.735596,-32.963452],[-70.734962,-32.962931],[-70.73452,-32.962528],[-70.734012,-32.962123],[-70.7333,-32.961878],[-70.732525,-32.961572],[-70.731492,-32.96115],[-70.730916,-32.960796],[-70.730272,-32.9605],[-70.729628,-32.960198],[-70.729116,-32.959901],[-70.728288,-32.959319],[-70.727657,-32.958743],[-70.726961,-32.958165],[-70.726193,-32.957693],[-70.725686,-32.957288],[-70.725499,-32.957061],[-70.725319,-32.956721],[-70.725077,-32.956267],[-70.724907,-32.955707],[-70.724602,-32.955197],[-70.7241,-32.954679],[-70.723716,-32.954446],[-70.723272,-32.954097],[-70.722826,-32.953802],[-70.722442,-32.953568],[-70.721598,-32.953319],[-70.720886,-32.953069],[-70.719999,-32.953029],[-70.719979,-32.95307],[-70.719653,-32.95357],[-70.719075,-32.954074],[-70.718241,-32.954369],[-70.717485,-32.954379],[-70.716983,-32.954457],[-70.716319,-32.95482],[-70.715819,-32.955039],[-70.714898,-32.955193],[-70.714148,-32.955486],[-70.713569,-32.955919],[-70.713163,-32.956632],[-70.712835,-32.957062],[-70.712007,-32.957639],[-70.711169,-32.957722],[-70.71025,-32.957946],[-70.709754,-32.958378],[-70.70901,-32.958954],[-70.708194,-32.960169],[-70.707781,-32.960529],[-70.707364,-32.960676],[-70.706944,-32.960682],[-70.706852,-32.960258],[-70.706757,-32.959693],[-70.706414,-32.959344],[-70.705991,-32.959137],[-70.705315,-32.958934],[-70.704977,-32.958797],[-70.704217,-32.958595],[-70.703541,-32.958392],[-70.702954,-32.9584],[-70.702031,-32.958413],[-70.701191,-32.958424],[-70.699854,-32.958726],[-70.698344,-32.958817],[-70.697333,-32.958618],[-70.696564,-32.957921],[-70.696132,-32.95729],[-70.695791,-32.957011],[-70.694515,-32.956179],[-70.693249,-32.955842],[-70.692742,-32.955637],[-70.691814,-32.955437],[-70.690807,-32.955451],[-70.690052,-32.955461],[-70.6888,-32.955867],[-70.687718,-32.956377],[-70.686886,-32.956742],[-70.686224,-32.957247],[-70.685476,-32.957682],[-70.684481,-32.958332],[-70.683479,-32.958629],[-70.68214,-32.958859],[-70.680213,-32.959097],[-70.678957,-32.959256],[-70.677867,-32.959341],[-70.676696,-32.959569],[-70.675438,-32.959657],[-70.674011,-32.959676],[-70.672406,-32.959132],[-70.671058,-32.958937],[-70.669871,-32.958316],[-70.669268,-32.957475],[-70.669088,-32.95684],[-70.668743,-32.956349],[-70.668149,-32.956003],[-70.667137,-32.955804],[-70.665958,-32.955608],[-70.664024,-32.955421],[-70.66301,-32.955081],[-70.661744,-32.954744],[-70.660729,-32.954332],[-70.659876,-32.953636],[-70.659551,-32.95364],[-70.659253,-32.953771],[-70.658674,-32.953932],[-70.658093,-32.95397],[-70.655875,-32.954092],[-70.655077,-32.954225],[-70.654313,-32.954235],[-70.653912,-32.95424],[-70.653585,-32.954245],[-70.653148,-32.95425],[-70.65249,-32.954075],[-70.651868,-32.953869],[-70.651499,-32.953628],[-70.651167,-32.953387],[-70.650653,-32.953118],[-70.650142,-32.953032],[-70.649593,-32.952886],[-70.649244,-32.952722],[-70.648878,-32.952604],[-70.648588,-32.952639],[-70.648227,-32.952827],[-70.648011,-32.952922],[-70.647647,-32.952927],[-70.647138,-32.952964],[-70.646774,-32.952969],[-70.646335,-32.952822],[-70.645934,-32.952766],[-70.645168,-32.952684],[-70.644839,-32.952596],[-70.644436,-32.952448],[-70.644214,-32.952297],[-70.643989,-32.951932],[-70.643949,-32.951687],[-70.643798,-32.951444],[-70.643649,-32.951262],[-70.643319,-32.951113],[-70.642772,-32.951058],[-70.642335,-32.951003],[-70.642005,-32.950915],[-70.641676,-32.950827],[-70.641529,-32.950737],[-70.641381,-32.950616],[-70.641161,-32.950497],[-70.640352,-32.950047],[-70.63976,-32.949533],[-70.639355,-32.949262],[-70.638877,-32.949023],[-70.638507,-32.94866],[-70.638174,-32.948388],[-70.637842,-32.948116],[-70.637437,-32.947846],[-70.637178,-32.947665],[-70.636666,-32.947488],[-70.635664,-32.947455],[-70.635191,-32.94743],[-70.634754,-32.947405],[-70.634281,-32.947442],[-70.633737,-32.947511],[-70.633051,-32.947796],[-70.631894,-32.94824],[-70.631099,-32.948496],[-70.630012,-32.948786],[-70.629431,-32.948825],[-70.628125,-32.949056],[-70.626819,-32.949258],[-70.626273,-32.949265],[-70.625727,-32.949241],[-70.625143,-32.949187],[-70.624778,-32.949131],[-70.624449,-32.949043],[-70.623863,-32.948805],[-70.62353,-32.948533],[-70.623272,-32.948322],[-70.622937,-32.947958],[-70.622753,-32.947807],[-70.622533,-32.947718],[-70.622096,-32.947724],[-70.621242,-32.947781],[-70.620626,-32.947911],[-70.620119,-32.948041],[-70.619286,-32.948297],[-70.618819,-32.948579],[-70.618243,-32.948924],[-70.617703,-32.949238],[-70.617306,-32.949458],[-70.616765,-32.949741],[-70.616296,-32.949931],[-70.615935,-32.950089],[-70.615543,-32.950524],[-70.615295,-32.950895],[-70.615048,-32.951359],[-70.614761,-32.951577],[-70.614472,-32.951704],[-70.614072,-32.951709],[-70.613632,-32.95153],[-70.613408,-32.951226],[-70.613029,-32.950403],[-70.612836,-32.949792],[-70.612722,-32.949486],[-70.612534,-32.949151],[-70.612347,-32.948908],[-70.612123,-32.948604],[-70.61179,-32.948271],[-70.611601,-32.947875],[-70.611512,-32.947017],[-70.611577,-32.946556],[-70.611463,-32.946281],[-70.611056,-32.945949],[-70.610872,-32.945798],[-70.610576,-32.945556],[-70.610427,-32.945374],[-70.610092,-32.944949],[-70.609978,-32.944674],[-70.609827,-32.944369],[-70.60964,-32.944096],[-70.609307,-32.943793],[-70.60901,-32.94349],[-70.608511,-32.943052],[-70.608143,-32.942841],[-70.607924,-32.942752],[-70.607594,-32.942634],[-70.607267,-32.942638],[-70.606867,-32.942705],[-70.606505,-32.942771],[-70.606068,-32.942776],[-70.605736,-32.942535],[-70.605551,-32.942323],[-70.605074,-32.942145],[-70.604564,-32.942121],[-70.604237,-32.942125],[-70.603839,-32.942253],[-70.602977,-32.942877],[-70.602586,-32.943373],[-70.602303,-32.943837],[-70.601909,-32.94418],[-70.601476,-32.9444],[-70.600967,-32.944406],[-70.600638,-32.944349],[-70.600311,-32.944323],[-70.599804,-32.944513],[-70.599483,-32.944855],[-70.598944,-32.94523],[-70.598328,-32.945361],[-70.597929,-32.945458],[-70.597172,-32.945836],[-70.596487,-32.946213],[-70.596056,-32.946494],[-70.595696,-32.946714],[-70.595195,-32.94718],[-70.594765,-32.947554],[-70.594467,-32.948187],[-70.594398,-32.948402],[-70.594292,-32.948557],[-70.594298,-32.948925],[-70.594488,-32.949383],[-70.594569,-32.949812],[-70.594682,-32.950025],[-70.59516,-32.950326],[-70.595382,-32.950538],[-70.595569,-32.950811],[-70.595607,-32.950903],[-70.595835,-32.951421],[-70.595914,-32.951758],[-70.596284,-32.952121],[-70.596686,-32.952208],[-70.59709,-32.952387],[-70.597459,-32.952689],[-70.597609,-32.952964],[-70.597478,-32.953763],[-70.597306,-32.954287],[-70.597095,-32.954719],[-70.596667,-32.955185],[-70.595035,-32.956509],[-70.594496,-32.956885],[-70.594101,-32.957227],[-70.59378,-32.957569],[-70.593426,-32.958126],[-70.593104,-32.958406],[-70.592745,-32.958687],[-70.592422,-32.958967],[-70.59192,-32.959372],[-70.591751,-32.96008],[-70.591653,-32.960725],[-70.591695,-32.961062],[-70.591773,-32.961307],[-70.592035,-32.961702],[-70.592294,-32.961975],[-70.592534,-32.962172],[-70.592611,-32.962416],[-70.59269,-32.962722],[-70.592732,-32.963028],[-70.592519,-32.963338],[-70.59234,-32.963524],[-70.592052,-32.963712],[-70.591837,-32.963899],[-70.591551,-32.964178],[-70.591303,-32.96455],[-70.591236,-32.964888],[-70.591171,-32.965288],[-70.591398,-32.965806],[-70.591478,-32.966204],[-70.591557,-32.96651],[-70.591745,-32.966845],[-70.592004,-32.967087],[-70.5923,-32.96736],[-70.592634,-32.967724],[-70.592895,-32.968089],[-70.593083,-32.968424],[-70.593089,-32.96873],[-70.593094,-32.969006],[-70.59299,-32.969315],[-70.592596,-32.969688],[-70.592274,-32.969968],[-70.591409,-32.970439],[-70.590504,-32.970758],[-70.589819,-32.971073],[-70.589351,-32.971417],[-70.588848,-32.971761],[-70.588273,-32.972197],[-70.587845,-32.972663],[-70.58731,-32.973283],[-70.58688,-32.973657],[-70.586449,-32.974],[-70.585945,-32.974283],[-70.585439,-32.974504],[-70.584968,-32.974602],[-70.584569,-32.974668],[-70.584278,-32.974733],[-70.583628,-32.974987],[-70.582873,-32.975518],[-70.582442,-32.975861],[-70.581687,-32.976392],[-70.580324,-32.977514],[-70.579388,-32.978109],[-70.578776,-32.978516],[-70.578239,-32.979013],[-70.577919,-32.979447],[-70.577637,-32.979941],[-70.577461,-32.980281],[-70.577307,-32.98082],[-70.577141,-32.981742],[-70.57693,-32.982175],[-70.576397,-32.982887],[-70.575859,-32.983354],[-70.575324,-32.983974],[-70.57497,-32.984531],[-70.574616,-32.985119],[-70.574371,-32.985643],[-70.573765,-32.986357],[-70.573157,-32.986978],[-70.572439,-32.987539],[-70.571535,-32.987888],[-70.569887,-32.988384],[-70.569198,-32.988516],[-70.568509,-32.988709],[-70.567893,-32.98887],[-70.567314,-32.989061],[-70.566593,-32.989438],[-70.56598,-32.989783],[-70.565547,-32.990034],[-70.565296,-32.990252],[-70.564977,-32.990716],[-70.56491,-32.991055],[-70.564918,-32.991515],[-70.564926,-32.991944],[-70.564969,-32.992343],[-70.564974,-32.992619],[-70.564799,-32.99302],[-70.564295,-32.993333],[-70.563754,-32.993616],[-70.563215,-32.994052],[-70.562715,-32.99458],[-70.562325,-32.995168],[-70.561715,-32.995666],[-70.561282,-32.995887],[-70.560434,-32.996342],[-70.559676,-32.99672],[-70.559029,-32.997219],[-70.558493,-32.997747],[-70.558099,-32.99812],[-70.557634,-32.998617],[-70.557459,-32.999018],[-70.557431,-32.999478],[-70.557438,-32.999877],[-70.557631,-33.000519],[-70.557855,-33.000854],[-70.557971,-33.00119],[-70.557978,-33.001589],[-70.557984,-33.001926],[-70.557991,-33.002356],[-70.557965,-33.002939],[-70.557866,-33.003554],[-70.5574,-33.003928],[-70.557072,-33.003932],[-70.556563,-33.003969],[-70.556182,-33.00405],[-70.555679,-33.004425],[-70.555502,-33.004703],[-70.555436,-33.005103],[-70.55526,-33.005473],[-70.554724,-33.006063],[-70.554368,-33.006497],[-70.553973,-33.006808],[-70.55325,-33.007124],[-70.552451,-33.007226],[-70.552052,-33.007323],[-70.551508,-33.007483],[-70.551039,-33.007735],[-70.550685,-33.008291],[-70.550405,-33.008909],[-70.550157,-33.00931],[-70.54991,-33.009804],[-70.549772,-33.010205],[-70.54978,-33.010665],[-70.549822,-33.010971],[-70.54983,-33.011462],[-70.5498,-33.0118],[-70.549659,-33.012109],[-70.54939,-33.012342],[-70.548814,-33.012687],[-70.548489,-33.012844],[-70.54802,-33.013126],[-70.547482,-33.013593],[-70.547196,-33.013873],[-70.546947,-33.014213],[-70.546917,-33.014582],[-70.546922,-33.014889],[-70.547,-33.015194],[-70.547189,-33.01556],[-70.547449,-33.015864],[-70.547819,-33.016227],[-70.547862,-33.016595],[-70.547725,-33.017057],[-70.54755,-33.017458],[-70.546868,-33.01805],[-70.546818,-33.018342],[-70.546897,-33.018678],[-70.54705,-33.019075],[-70.547201,-33.019411],[-70.547276,-33.019533],[-70.547389,-33.019746],[-70.547464,-33.019837],[-70.547944,-33.020199],[-70.548273,-33.020318],[-70.548679,-33.02062],[-70.548864,-33.020771],[-70.549345,-33.021225],[-70.549688,-33.02208],[-70.549696,-33.022509],[-70.549703,-33.022939],[-70.54971,-33.023307],[-70.549792,-33.023858],[-70.549846,-33.024839],[-70.549956,-33.025958],[-70.550182,-33.026384],[-70.5503,-33.026874],[-70.550637,-33.027361],[-70.551352,-33.028702],[-70.551909,-33.029308],[-70.552467,-33.029977],[-70.552663,-33.030268],[-70.552919,-33.030799],[-70.553033,-33.031074],[-70.553075,-33.031411],[-70.553153,-33.031717],[-70.553308,-33.032206],[-70.553423,-33.032542],[-70.553466,-33.03291],[-70.553472,-33.033278],[-70.553374,-33.033892],[-70.553272,-33.034323],[-70.553135,-33.034816],[-70.552851,-33.035249],[-70.552244,-33.035931],[-70.551883,-33.036151],[-70.551488,-33.036432],[-70.550987,-33.03696],[-70.550775,-33.037361],[-70.550491,-33.037794],[-70.550351,-33.038103],[-70.550214,-33.038565],[-70.550111,-33.038934],[-70.549861,-33.039244],[-70.549174,-33.039529],[-70.548304,-33.039754],[-70.547794,-33.039761],[-70.547467,-33.039826],[-70.546889,-33.040079],[-70.546379,-33.040116],[-70.545943,-33.040152],[-70.54536,-33.040159],[-70.544706,-33.040259],[-70.544166,-33.040634],[-70.5437,-33.041039],[-70.543416,-33.041502],[-70.543352,-33.041994],[-70.543216,-33.042517],[-70.542895,-33.042951],[-70.542535,-33.043201],[-70.541847,-33.043393],[-70.54145,-33.043613],[-70.541162,-33.043801],[-70.540461,-33.044377],[-70.54003,-33.04472],[-70.539559,-33.044879],[-70.539014,-33.044978],[-70.538542,-33.045045],[-70.537999,-33.045236],[-70.537491,-33.045365],[-70.537095,-33.045646],[-70.536629,-33.04605],[-70.536343,-33.046391],[-70.536095,-33.046793],[-70.53592,-33.047194],[-70.535597,-33.047474],[-70.535126,-33.047634],[-70.534545,-33.047733],[-70.534183,-33.04786],[-70.533785,-33.048049],[-70.532382,-33.049048],[-70.532024,-33.04939],[-70.531341,-33.04992],[-70.5308,-33.050264],[-70.530183,-33.050425],[-70.529604,-33.050647],[-70.529206,-33.050775],[-70.528809,-33.050994],[-70.528485,-33.051213],[-70.527534,-33.052068],[-70.527212,-33.05241],[-70.527037,-33.052841],[-70.526971,-33.05321],[-70.526906,-33.053671],[-70.526914,-33.054132],[-70.527069,-33.054682],[-70.527332,-33.055139],[-70.527556,-33.055474],[-70.527634,-33.055749],[-70.527572,-33.056394],[-70.527436,-33.056917],[-70.527295,-33.057226],[-70.527193,-33.057657],[-70.527095,-33.058271],[-70.526848,-33.058765],[-70.52667,-33.058982],[-70.526046,-33.059803],[-70.525798,-33.060205],[-70.525552,-33.060729],[-70.525415,-33.061253],[-70.525314,-33.061714],[-70.525321,-33.062144],[-70.525296,-33.062758],[-70.525303,-33.063187],[-70.525309,-33.063555],[-70.525279,-33.063893],[-70.525141,-33.064355],[-70.524641,-33.064944],[-70.524354,-33.065193],[-70.524139,-33.065441],[-70.524108,-33.065748],[-70.523606,-33.067242],[-70.523611,-33.06758],[-70.523582,-33.06801],[-70.523409,-33.068533],[-70.523196,-33.068843],[-70.522945,-33.069091],[-70.522624,-33.069494],[-70.522162,-33.070144],[-70.521841,-33.070547],[-70.521269,-33.071198],[-70.520985,-33.071631],[-70.520629,-33.072126],[-70.520305,-33.072376],[-70.520178,-33.072393],[-70.519854,-33.072612],[-70.519638,-33.072768],[-70.51946,-33.073015],[-70.519321,-33.073446],[-70.519294,-33.073999],[-70.519413,-33.074519],[-70.519489,-33.074733],[-70.519643,-33.075191],[-70.519687,-33.075651],[-70.519622,-33.076112],[-70.519555,-33.07645],[-70.519525,-33.076819],[-70.519571,-33.07734],[-70.519365,-33.078079],[-70.519154,-33.078572],[-70.518904,-33.078821],[-70.51842,-33.079333],[-70.51777,-33.079678],[-70.517047,-33.080025],[-70.51654,-33.080184],[-70.515962,-33.080467],[-70.515567,-33.08084],[-70.515252,-33.081581],[-70.51508,-33.082166],[-70.514725,-33.082722],[-70.514291,-33.082942],[-70.51371,-33.083041],[-70.513167,-33.083293],[-70.512843,-33.083481],[-70.512558,-33.083884],[-70.512455,-33.084253],[-70.512245,-33.084747],[-70.51196,-33.085149],[-70.511747,-33.085458],[-70.511609,-33.085951],[-70.511506,-33.08629],[-70.511418,-33.08649],[-70.511095,-33.086801],[-70.510845,-33.08708],[-70.510561,-33.087544],[-70.51035,-33.087976],[-70.510101,-33.088347],[-70.509814,-33.088627],[-70.509528,-33.088906],[-70.509461,-33.088953],[-70.509132,-33.089187],[-70.508623,-33.089316],[-70.507895,-33.089325],[-70.507382,-33.089178],[-70.506976,-33.088876],[-70.506313,-33.088516],[-70.505798,-33.088215],[-70.504514,-33.08774],[-70.503926,-33.08744],[-70.503412,-33.087231],[-70.502717,-33.087055],[-70.502132,-33.08694],[-70.501512,-33.086917],[-70.500821,-33.087017],[-70.50053,-33.087051],[-70.500202,-33.087055],[-70.499653,-33.086939],[-70.49914,-33.086761],[-70.49881,-33.086642],[-70.498189,-33.086558],[-70.497603,-33.086411],[-70.497199,-33.086201],[-70.49683,-33.08593],[-70.496609,-33.08581],[-70.494936,-33.084955],[-70.491191,-33.083313],[-70.48939,-33.082414],[-70.488877,-33.082236],[-70.488329,-33.08215],[-70.487928,-33.082155],[-70.487107,-33.082088],[-70.486742,-33.082093],[-70.485975,-33.08201],[-70.484989,-33.081868],[-70.483856,-33.081667],[-70.482977,-33.081401],[-70.482279,-33.081102],[-70.481687,-33.080557],[-70.481465,-33.080345],[-70.480513,-33.079022],[-70.480214,-33.078596],[-70.480025,-33.078168],[-70.479614,-33.07759],[-70.479203,-33.076951],[-70.478866,-33.076403],[-70.478378,-33.07558],[-70.478221,-33.074876],[-70.478135,-33.07411],[-70.47819,-33.073036],[-70.478181,-33.072483],[-70.4781,-33.072024],[-70.477926,-33.071428],[-70.477628,-33.071033],[-70.477549,-33.070665],[-70.477576,-33.070082],[-70.47771,-33.069406],[-70.477703,-33.068976],[-70.477658,-33.068486],[-70.477396,-33.068059],[-70.477173,-33.067786],[-70.476693,-33.067393],[-70.475483,-33.066977],[-70.474568,-33.066743],[-70.47398,-33.066443],[-70.473503,-33.066234],[-70.473027,-33.066117],[-70.472333,-33.065971],[-70.471528,-33.065797],[-70.471125,-33.065648],[-70.470722,-33.06553],[-70.470321,-33.065535],[-70.469922,-33.065601],[-70.469265,-33.065548],[-70.468714,-33.065278],[-70.468342,-33.064822],[-70.467932,-33.064275],[-70.467562,-33.063941],[-70.467229,-33.063638],[-70.466696,-33.063384],[-70.466293,-33.063205],[-70.465887,-33.062903],[-70.46559,-33.062569],[-70.46529,-33.062081],[-70.465211,-33.061714],[-70.465059,-33.061317],[-70.464979,-33.060919],[-70.464677,-33.060247],[-70.464596,-33.059788],[-70.46455,-33.059175],[-70.464573,-33.058408],[-70.464565,-33.057886],[-70.464373,-33.057306],[-70.464144,-33.056695],[-70.463696,-33.056056],[-70.463358,-33.055446],[-70.463169,-33.055019],[-70.462851,-33.054516],[-70.462661,-33.054027],[-70.462585,-33.053844],[-70.462287,-33.053449],[-70.46188,-33.053085],[-70.461474,-33.052722],[-70.461249,-33.052387],[-70.461025,-33.052052],[-70.460874,-33.051686],[-70.46068,-33.050982],[-70.460489,-33.050494],[-70.460411,-33.050126],[-70.460293,-33.049606],[-70.460213,-33.049178],[-70.46006,-33.04878],[-70.459721,-33.048109],[-70.459424,-33.047775],[-70.459199,-33.047379],[-70.45883,-33.047046],[-70.45846,-33.046743],[-70.458165,-33.046532],[-70.457981,-33.046412],[-70.457812,-33.046122],[-70.457583,-33.04545],[-70.457469,-33.045175],[-70.457357,-33.044992],[-70.457135,-33.044811],[-70.456914,-33.044629],[-70.456324,-33.044237],[-70.455774,-33.043998],[-70.455257,-33.043605],[-70.454741,-33.043212],[-70.454261,-33.04285],[-70.454075,-33.042576],[-70.453887,-33.042241],[-70.453626,-33.041875],[-70.453366,-33.041541],[-70.453136,-33.040899],[-70.453023,-33.040625],[-70.452799,-33.04029],[-70.452499,-33.039771],[-70.452201,-33.039376],[-70.451663,-33.038815],[-70.451439,-33.03848],[-70.451142,-33.038115],[-70.450811,-33.037904],[-70.45048,-33.037724],[-70.450041,-33.037637],[-70.449493,-33.037521],[-70.449163,-33.037371],[-70.448721,-33.037131],[-70.448245,-33.036952],[-70.447877,-33.036711],[-70.447616,-33.036376],[-70.447058,-33.035616],[-70.446649,-33.03513],[-70.446497,-33.034733],[-70.446381,-33.034335],[-70.446244,-33.033738],[-70.446054,-33.03325],[-70.445753,-33.032701],[-70.4449,-33.03176],[-70.444157,-33.030848],[-70.443191,-33.029693],[-70.442747,-33.029269],[-70.442269,-33.029029],[-70.441903,-33.02891],[-70.441501,-33.028792],[-70.441098,-33.028674],[-70.440767,-33.028494],[-70.440105,-33.028072],[-70.439476,-33.027465],[-70.43903,-33.026949],[-70.438621,-33.026432],[-70.438267,-33.025899],[-70.438188,-33.025532],[-70.437925,-33.025075],[-70.437811,-33.024769],[-70.437586,-33.024373],[-70.437252,-33.024009],[-70.437028,-33.023674],[-70.436694,-33.023279],[-70.436064,-33.022611],[-70.435731,-33.022277],[-70.435399,-33.022005],[-70.435066,-33.021671],[-70.434697,-33.021399],[-70.434258,-33.021251],[-70.433783,-33.021195],[-70.433092,-33.021234],[-70.432436,-33.021241],[-70.43189,-33.021248],[-70.431161,-33.021194],[-70.430504,-33.02111],[-70.428755,-33.021038],[-70.427989,-33.020985],[-70.427151,-33.020995],[-70.426315,-33.021097],[-70.425626,-33.021289],[-70.425226,-33.021293],[-70.424666,-33.02156],[-70.424347,-33.022116],[-70.424099,-33.022549],[-70.423994,-33.022826],[-70.423856,-33.023318],[-70.423429,-33.023937],[-70.423292,-33.024491],[-70.423202,-33.025688],[-70.422797,-33.025386],[-70.422612,-33.025204],[-70.422428,-33.025084],[-70.421989,-33.024997],[-70.421588,-33.02497],[-70.421152,-33.025006],[-70.420933,-33.025018],[-70.42046,-33.025045],[-70.419951,-33.025051],[-70.419368,-33.025088],[-70.418858,-33.025063],[-70.41842,-33.025007],[-70.418019,-33.02498],[-70.4174,-33.024987],[-70.416999,-33.024992],[-70.416564,-33.02512],[-70.41577,-33.025528],[-70.415228,-33.02581],[-70.414214,-33.02619],[-70.413781,-33.026471],[-70.413493,-33.026627],[-70.413167,-33.026754],[-70.412805,-33.026911],[-70.412408,-33.027161],[-70.411938,-33.027381],[-70.410528,-33.028042],[-70.410059,-33.028292],[-70.409626,-33.028543],[-70.409118,-33.028671],[-70.408683,-33.028829],[-70.40825,-33.02908],[-70.407817,-33.029299],[-70.407383,-33.029519],[-70.40695,-33.02977],[-70.406518,-33.030112],[-70.405257,-33.030955],[-70.403956,-33.031613],[-70.403449,-33.031803],[-70.402835,-33.032117],[-70.40211,-33.032371],[-70.400633,-33.03343],[-70.400092,-33.033743],[-70.399732,-33.033993],[-70.399481,-33.034241],[-70.399291,-33.034934],[-70.399015,-33.035918],[-70.399024,-33.036471],[-70.399036,-33.037207],[-70.399013,-33.038097],[-70.398915,-33.038773],[-70.398887,-33.039295],[-70.398829,-33.040277],[-70.398911,-33.040829],[-70.399099,-33.041226],[-70.399251,-33.041592],[-70.399472,-33.041774],[-70.4003,-33.042301],[-70.400817,-33.042694],[-70.401184,-33.042905],[-70.401258,-33.042996],[-70.401264,-33.043364],[-70.400977,-33.043613],[-70.400471,-33.043864],[-70.400001,-33.044084],[-70.399352,-33.044521],[-70.39903,-33.044924],[-70.398602,-33.045511],[-70.398175,-33.04613],[-70.398039,-33.046745],[-70.397965,-33.047058],[-70.397936,-33.047176],[-70.397762,-33.047669],[-70.397554,-33.048315],[-70.397267,-33.048625],[-70.39687,-33.048875],[-70.396656,-33.049154],[-70.396551,-33.0494],[-70.396507,-33.05006],[-70.396511,-33.050367],[-70.396553,-33.050704],[-70.396704,-33.05104],[-70.397074,-33.051404],[-70.397555,-33.051828],[-70.397998,-33.052222],[-70.398477,-33.052554],[-70.399289,-33.05322],[-70.399952,-33.053704],[-70.400357,-33.053945],[-70.400725,-33.054155],[-70.401758,-33.055003],[-70.402018,-33.055276],[-70.402242,-33.055611],[-70.40232,-33.055978],[-70.402217,-33.056378],[-70.40215,-33.056747],[-70.402195,-33.057268],[-70.402345,-33.057543],[-70.402495,-33.057817],[-70.403701,-33.0592],[-70.404332,-33.059929],[-70.404815,-33.060476],[-70.405262,-33.061085],[-70.4056,-33.061725],[-70.405971,-33.062181],[-70.406684,-33.063462],[-70.406949,-33.064103],[-70.407029,-33.064532],[-70.407,-33.064962],[-70.406857,-33.065178],[-70.406846,-33.065623],[-70.406597,-33.065994],[-70.406127,-33.066245],[-70.405763,-33.06628],[-70.405254,-33.066347],[-70.405,-33.06638],[-70.404564,-33.066508],[-70.404311,-33.066633],[-70.403915,-33.066914],[-70.403594,-33.067347],[-70.40331,-33.067841],[-70.402914,-33.068153],[-70.402225,-33.068344],[-70.401792,-33.068595],[-70.401215,-33.068969],[-70.400889,-33.069096],[-70.399917,-33.069843],[-70.399087,-33.070405],[-70.398292,-33.070813],[-70.39786,-33.071124],[-70.397318,-33.071468],[-70.396596,-33.071844],[-70.396055,-33.072218],[-70.395678,-33.072575],[-70.395174,-33.07298],[-70.394851,-33.073321],[-70.394784,-33.07369],[-70.394829,-33.074211],[-70.394911,-33.074762],[-70.394736,-33.075224],[-70.394704,-33.075532],[-70.394821,-33.075991],[-70.395082,-33.076417],[-70.395343,-33.076752],[-70.395499,-33.077425],[-70.39551,-33.078069],[-70.3953,-33.078624],[-70.395126,-33.079147],[-70.395021,-33.079455],[-70.394919,-33.079917],[-70.394707,-33.080349],[-70.394239,-33.080692],[-70.393876,-33.080818],[-70.393366,-33.080824],[-70.392891,-33.080707],[-70.392487,-33.080527],[-70.39214,-33.080485],[-70.391812,-33.080458],[-70.391374,-33.080463],[-70.391048,-33.080558],[-70.390363,-33.081057],[-70.38975,-33.081432],[-70.389423,-33.081558],[-70.389136,-33.081807],[-70.388921,-33.082055],[-70.388525,-33.082335],[-70.388088,-33.082402],[-70.387542,-33.082438],[-70.386889,-33.08263],[-70.386419,-33.082881],[-70.386025,-33.083314],[-70.38596,-33.083837],[-70.386188,-33.084386],[-70.386599,-33.085026],[-70.386863,-33.085606],[-70.387016,-33.086095],[-70.387241,-33.086492],[-70.387504,-33.086949],[-70.387691,-33.087254],[-70.387898,-33.087697],[-70.388233,-33.088122],[-70.388492,-33.088396],[-70.388607,-33.088732],[-70.388574,-33.088978],[-70.388179,-33.08935],[-70.387709,-33.089601],[-70.386955,-33.090315],[-70.386563,-33.090872],[-70.385851,-33.091953],[-70.385604,-33.092478],[-70.385356,-33.09291],[-70.385325,-33.093309],[-70.385256,-33.093525],[-70.38504,-33.093681],[-70.384638,-33.093654],[-70.384456,-33.093626],[-70.383909,-33.093663],[-70.383294,-33.093945],[-70.38286,-33.094165],[-70.382245,-33.094448],[-70.381957,-33.094697],[-70.381455,-33.095224],[-70.381259,-33.095518],[-70.381009,-33.095858],[-70.380722,-33.096106],[-70.380469,-33.096263],[-70.380365,-33.096601],[-70.380406,-33.096908],[-70.380375,-33.097276],[-70.380125,-33.097586],[-70.379728,-33.097836],[-70.379403,-33.098023],[-70.379006,-33.098273],[-70.378645,-33.098492],[-70.378284,-33.098711],[-70.377928,-33.099298],[-70.377643,-33.09973],[-70.377575,-33.100007],[-70.377507,-33.100315],[-70.377439,-33.100653],[-70.377446,-33.101113],[-70.377452,-33.101481],[-70.377386,-33.101942],[-70.377174,-33.102374],[-70.376741,-33.102655],[-70.376234,-33.102845],[-70.375385,-33.10336],[-70.375062,-33.103671],[-70.374957,-33.103948],[-70.374821,-33.104563],[-70.374539,-33.105241],[-70.374107,-33.105553],[-70.373573,-33.105725],[-70.373903,-33.105991],[-70.374497,-33.106373],[-70.374963,-33.106859],[-70.375613,-33.107347],[-70.37626,-33.107889],[-70.376851,-33.108326],[-70.377626,-33.108764],[-70.378228,-33.108994],[-70.379095,-33.108873],[-70.380262,-33.108862],[-70.381365,-33.108903],[-70.382095,-33.109034],[-70.382874,-33.109428],[-70.383339,-33.109909],[-70.383869,-33.110343],[-70.384202,-33.111026],[-70.384175,-33.111543],[-70.384255,-33.11237],[-70.384475,-33.112847],[-70.384944,-33.113274],[-70.38536,-33.113551],[-70.385647,-33.113922],[-70.385927,-33.11445],[-70.386087,-33.11492],[-70.386374,-33.115291],[-70.386787,-33.115617],[-70.387144,-33.115838],[-70.38781,-33.11602],[-70.388657,-33.116259],[-70.389198,-33.116481],[-70.389915,-33.116873],[-70.390501,-33.117408],[-70.391148,-33.11795],[-70.391812,-33.118182],[-70.392862,-33.118067],[-70.393467,-33.118243],[-70.393997,-33.118677],[-70.39446,-33.119212],[-70.395225,-33.119857],[-70.395942,-33.120249],[-70.396957,-33.120804],[-70.397427,-33.121232],[-70.397956,-33.121666],[-70.398503,-33.121789],[-70.3993,-33.121819],[-70.39998,-33.12174],[-70.400827,-33.121979],[-70.401485,-33.122314],[-70.402152,-33.122492],[-70.403314,-33.122589],[-70.40393,-33.122558],[-70.404918,-33.122441],[-70.405851,-33.122219],[-70.406897,-33.122203],[-70.407933,-33.122345],[-70.40897,-33.122487],[-70.409709,-33.122451],[-70.410746,-33.122593],[-70.411773,-33.122942],[-70.412559,-33.123178],[-70.413604,-33.123167],[-70.414411,-33.12299],[-70.415203,-33.123122],[-70.415983,-33.123462],[-70.416834,-33.123646],[-70.417868,-33.123838],[-70.41882,-33.124445],[-70.419523,-33.125088],[-70.420285,-33.125791],[-70.42093,-33.126383],[-70.421152,-33.126855],[-70.421373,-33.127327],[-70.421836,-33.127862],[-70.4225,-33.128094],[-70.422985,-33.128215],[-70.423659,-33.12824],[-70.424393,-33.128316],[-70.425307,-33.128454],[-70.426091,-33.128744],[-70.426986,-33.12924],[-70.427695,-33.129785],[-70.42834,-33.130376],[-70.428623,-33.13085],[-70.429028,-33.131333],[-70.42942,-33.132068],[-70.429705,-33.132493],[-70.430224,-33.133134],[-70.430443,-33.133655],[-70.430478,-33.134175],[-70.430563,-33.134903],[-70.430968,-33.135382],[-70.431442,-33.13571],[-70.432103,-33.135991],[-70.432825,-33.136279],[-70.433236,-33.136654],[-70.433524,-33.137025],[-70.433926,-33.137558],[-70.434078,-33.138185],[-70.434294,-33.13876],[-70.434561,-33.139545],[-70.434958,-33.140181],[-70.435408,-33.140972],[-70.435622,-33.141597],[-70.435905,-33.142072],[-70.436128,-33.142494],[-70.43628,-33.143121],[-70.436491,-33.1438],[-70.436712,-33.144272],[-70.437061,-33.14465],[-70.437474,-33.144976],[-70.43789,-33.145248],[-70.43837,-33.145473],[-70.439274,-33.145817],[-70.439991,-33.146203],[-70.440586,-33.146585],[-70.441177,-33.147022],[-70.441468,-33.147343],[-70.441503,-33.147862],[-70.441223,-33.148523],[-70.441241,-33.149353],[-70.441452,-33.150031],[-70.441839,-33.15087],[-70.442404,-33.151823],[-70.44291,-33.15272],[-70.443123,-33.153349],[-70.443392,-33.15408],[-70.443793,-33.154666],[-70.444315,-33.155253],[-70.444648,-33.155936],[-70.444923,-33.156568],[-70.445019,-33.157085],[-70.444872,-33.157548],[-70.444664,-33.158004],[-70.444443,-33.158721],[-70.44448,-33.159187],[-70.444824,-33.159663],[-70.445413,-33.160153],[-70.44612,-33.160747],[-70.44672,-33.161025],[-70.447307,-33.161565],[-70.447776,-33.161996],[-70.448424,-33.162534],[-70.449083,-33.162873],[-70.449802,-33.16321],[-70.450522,-33.163547],[-70.450936,-33.163873],[-70.451219,-33.164348],[-70.451563,-33.164824],[-70.451664,-33.165242],[-70.451947,-33.165716],[-70.452414,-33.166197],[-70.453181,-33.166798],[-70.454069,-33.167447],[-70.454648,-33.168144],[-70.455099,-33.168935],[-70.455139,-33.169351],[-70.455054,-33.169812],[-70.4546,-33.170259],[-70.454216,-33.170556],[-70.453702,-33.171001],[-70.453549,-33.171563],[-70.453832,-33.172042],[-70.454192,-33.172208],[-70.454726,-33.172588],[-70.455555,-33.17319],[-70.456449,-33.173736],[-70.457404,-33.174289],[-70.458231,-33.174941],[-70.459001,-33.175487],[-70.459591,-33.175973],[-70.460428,-33.176418],[-70.461146,-33.176804],[-70.46168,-33.177184],[-70.462272,-33.17762],[-70.462608,-33.178254],[-70.46252,-33.178769],[-70.462192,-33.179171],[-70.46168,-33.179562],[-70.460978,-33.180055],[-70.460586,-33.180504],[-70.460068,-33.181003],[-70.459794,-33.181561],[-70.459511,-33.182271],[-70.45953,-33.183101],[-70.459669,-33.183984],[-70.459816,-33.184715],[-70.459954,-33.185598],[-70.459842,-33.186576],[-70.459498,-33.187288],[-70.459405,-33.187902],[-70.459421,-33.188781],[-70.459818,-33.189417],[-70.460528,-33.189961],[-70.460997,-33.190393],[-70.46152,-33.190979],[-70.462414,-33.19153],[-70.463132,-33.191916],[-70.463724,-33.192352],[-70.464564,-33.192743],[-70.465338,-33.193236],[-70.465802,-33.193771],[-70.466267,-33.194305],[-70.4668,-33.194685],[-70.467262,-33.19527],[-70.46754,-33.195852],[-70.467694,-33.196425],[-70.467598,-33.197093],[-70.467617,-33.197922],[-70.467812,-33.198911],[-70.467962,-33.199588],[-70.467929,-33.200217],[-70.467961,-33.200786],[-70.467811,-33.201298],[-70.467307,-33.201537],[-70.466683,-33.201721],[-70.465755,-33.20184],[-70.465247,-33.202133],[-70.465096,-33.202694],[-70.465005,-33.203263],[-70.465157,-33.203886],[-70.465608,-33.204677],[-70.466307,-33.205428],[-70.466841,-33.205808],[-70.467732,-33.206412],[-70.468559,-33.207059],[-70.469186,-33.208015],[-70.469637,-33.208806],[-70.470086,-33.209651],[-70.470176,-33.210271],[-70.470211,-33.210791],[-70.469912,-33.211816],[-70.469939,-33.212488],[-70.47015,-33.213167],[-70.470417,-33.213951],[-70.470505,-33.214625],[-70.470479,-33.215142],[-70.470132,-33.215904],[-70.470158,-33.216577],[-70.470556,-33.217213],[-70.471197,-33.217907],[-70.471725,-33.218395],[-70.472558,-33.218939],[-70.473201,-33.219584],[-70.473449,-33.219701],[-70.473801,-33.219862],[-70.474592,-33.220049],[-70.475464,-33.219819],[-70.476161,-33.219435],[-70.476913,-33.219151],[-70.477975,-33.218825],[-70.478787,-33.218598],[-70.479651,-33.218526],[-70.480762,-33.218463],[-70.481509,-33.218278],[-70.482686,-33.218114],[-70.483308,-33.217983],[-70.484845,-33.217985],[-70.485573,-33.218169],[-70.48654,-33.218515],[-70.4877,-33.218661],[-70.48911,-33.218762],[-70.489838,-33.218941],[-70.490391,-33.218962],[-70.491637,-33.218646],[-70.49276,-33.218327],[-70.493868,-33.218313],[-70.494661,-33.218445],[-70.495504,-33.218787],[-70.496217,-33.219277],[-70.497303,-33.219681],[-70.498272,-33.219973],[-70.499236,-33.220368],[-70.500207,-33.22061],[-70.501256,-33.220545],[-70.502198,-33.220169],[-70.50325,-33.220049],[-70.504173,-33.220033],[-70.505232,-33.219761],[-70.505801,-33.219471],[-70.506801,-33.219146],[-70.507607,-33.219018],[-70.508405,-33.219047],[-70.5092,-33.21913],[-70.509747,-33.219253],[-70.510345,-33.219581],[-70.511136,-33.219767],[-70.511984,-33.220005],[-70.51302,-33.220196],[-70.513551,-33.220629],[-70.513829,-33.221207],[-70.513915,-33.221935],[-70.513937,-33.222711],[-70.513713,-33.223477],[-70.513431,-33.224192],[-70.513213,-33.22486],[-70.513115,-33.225577],[-70.513214,-33.226049],[-70.513428,-33.226674],[-70.513708,-33.227202],[-70.513935,-33.227571],[-70.514461,-33.228108],[-70.514747,-33.228532],[-70.514959,-33.229211],[-70.514919,-33.229985],[-70.515074,-33.230558],[-70.515234,-33.231032],[-70.51564,-33.231511],[-70.516238,-33.231843],[-70.516834,-33.232225],[-70.517429,-33.232611],[-70.518078,-33.233148],[-70.518485,-33.233631],[-70.518824,-33.234211],[-70.519348,-33.234797],[-70.519758,-33.235173],[-70.520538,-33.235566],[-70.521193,-33.235999],[-70.52166,-33.236484],[-70.522053,-33.237219],[-70.522149,-33.237741],[-70.522865,-33.238181],[-70.523522,-33.238565],[-70.524243,-33.238902],[-70.524911,-33.239083],[-70.525647,-33.23911],[-70.52688,-33.239051],[-70.527975,-33.239297],[-70.528768,-33.23943],[-70.529324,-33.239396],[-70.530375,-33.23928],[-70.531427,-33.239161],[-70.532713,-33.239261],[-70.533683,-33.239553],[-70.534529,-33.23984],[-70.535504,-33.240032],[-70.536422,-33.240115],[-70.5371,-33.24009],[-70.537794,-33.239754],[-70.538544,-33.23952],[-70.53911,-33.239284],[-70.540412,-33.239069],[-70.541523,-33.239006],[-70.542457,-33.238782],[-70.543377,-33.238815],[-70.543915,-33.239145],[-70.54408,-33.239512],[-70.54435,-33.239909],[-70.5447,-33.240394],[-70.545242,-33.240779],[-70.546284,-33.241131],[-70.547717,-33.241183],[-70.549085,-33.241286],[-70.550185,-33.241744],[-70.551296,-33.241991],[-70.55236,-33.241926],[-70.55386,-33.241876],[-70.555182,-33.241662],[-70.555994,-33.241637],[-70.556817,-33.241405],[-70.557382,-33.241425],[-70.557996,-33.241551],[-70.558291,-33.241877],[-70.558457,-33.242302],[-70.558617,-33.24283],[-70.558791,-33.243102],[-70.558889,-33.243628],[-70.559122,-33.243952],[-70.55942,-33.244223],[-70.559848,-33.244396],[-70.560201,-33.244828],[-70.560618,-33.245212],[-70.560904,-33.245745],[-70.561368,-33.246442],[-70.56165,-33.247028],[-70.56181,-33.247561],[-70.561973,-33.24804],[-70.561952,-33.248458],[-70.561676,-33.248971],[-70.561403,-33.249434],[-70.561008,-33.249839],[-70.560429,-33.250187],[-70.559956,-33.250905],[-70.559864,-33.251478],[-70.56009,-33.251955],[-70.56038,-33.252388],[-70.560859,-33.25277],[-70.561282,-33.253047],[-70.562149,-33.253186],[-70.562762,-33.253415],[-70.563299,-33.253907],[-70.563597,-33.254179],[-70.564131,-33.254725],[-70.564736,-33.255111],[-70.56528,-33.255446],[-70.566145,-33.255635],[-70.567055,-33.25614],[-70.567476,-33.256466],[-70.567831,-33.256848],[-70.568127,-33.257174],[-70.568284,-33.257756],[-70.568325,-33.258177],[-70.568424,-33.258703],[-70.568278,-33.259188],[-70.568566,-33.259775],[-70.56895,-33.260546],[-70.569283,-33.261265],[-70.569571,-33.261856],[-70.570024,-33.262314],[-70.570632,-33.262826],[-70.571144,-33.263156],[-70.5715,-33.263434],[-70.571845,-33.263933],[-70.572295,-33.26444],[-70.572913,-33.264773],[-70.573322,-33.265053],[-70.573563,-33.265508],[-70.573647,-33.265952],[-70.573836,-33.266405],[-70.573809,-33.266935],[-70.57363,-33.26733],[-70.57355,-33.267858],[-70.573477,-33.268257],[-70.57345,-33.268787],[-70.573428,-33.269232],[-70.573396,-33.269853],[-70.573209,-33.270423],[-70.573233,-33.271],[-70.573313,-33.271494],[-70.573291,-33.271939],[-70.57306,-33.272327],[-70.572517,-33.272619],[-70.572074,-33.273004],[-70.571939,-33.273576],[-70.572018,-33.274115],[-70.572257,-33.27461],[-70.572657,-33.27507],[-70.57285,-33.275433],[-70.572828,-33.275873],[-70.57255,-33.276129],[-70.571956,-33.276378],[-70.571624,-33.276677],[-70.571451,-33.276941],[-70.571327,-33.277288],[-70.571049,-33.277548],[-70.570763,-33.27798],[-70.570734,-33.278555],[-70.570817,-33.279004],[-70.571052,-33.279589],[-70.571283,-33.280264],[-70.571521,-33.280763],[-70.571612,-33.281077],[-70.571908,-33.281484],[-70.572203,-33.281941],[-70.572605,-33.282356],[-70.572956,-33.282724],[-70.573138,-33.283307],[-70.573059,-33.283836],[-70.573137,-33.284375],[-70.573423,-33.285007],[-70.573763,-33.285596],[-70.574211,-33.286143],[-70.574455,-33.286553],[-70.574582,-33.287179],[-70.574503,-33.287708],[-70.574311,-33.288367],[-70.574391,-33.288861],[-70.57452,-33.289442],[-70.575175,-33.290087],[-70.575842,-33.290512],[-70.576249,-33.290837],[-70.577229,-33.291314],[-70.578001,-33.291742],[-70.578722,-33.292124],[-70.579239,-33.292363],[-70.5804,-33.292404],[-70.581188,-33.292522],[-70.581758,-33.292763],[-70.582166,-33.293048],[-70.582786,-33.293336],[-70.583356,-33.293577],[-70.583763,-33.293902],[-70.584216,-33.294364],[-70.584508,-33.294861],[-70.585172,-33.295331],[-70.585684,-33.29566],[-70.586786,-33.295834],[-70.58757,-33.296038],[-70.588241,-33.296372],[-70.588804,-33.296748],[-70.589414,-33.297216],[-70.589968,-33.297767],[-70.590686,-33.298239],[-70.591609,-33.298803],[-70.592383,-33.299186],[-70.592891,-33.299605],[-70.593083,-33.300009],[-70.593005,-33.300497],[-70.592721,-33.300888],[-70.592393,-33.301097],[-70.591691,-33.301382],[-70.591407,-33.301773],[-70.59107,-33.302158],[-70.591054,-33.302468],[-70.59097,-33.303087],[-70.591165,-33.303409],[-70.591255,-33.303723],[-70.591557,-33.304044],[-70.592021,-33.304282],[-70.592947,-33.304801],[-70.593363,-33.304951],[-70.593877,-33.305235],[-70.594284,-33.30556],[-70.59479,-33.306024],[-70.595293,-33.306528],[-70.5957,-33.306854],[-70.595788,-33.307213],[-70.595968,-33.307841],[-70.596203,-33.308426],[-70.596612,-33.30871],[-70.59725,-33.308643],[-70.597952,-33.308357],[-70.598604,-33.308024],[-70.599414,-33.307697],[-70.600059,-33.307499],[-70.600792,-33.307656],[-70.601357,-33.307987],[-70.601711,-33.30831],[-70.601952,-33.308765],[-70.60225,-33.309176],[-70.602498,-33.309496],[-70.602902,-33.309866],[-70.603261,-33.310099],[-70.603725,-33.310337],[-70.604302,-33.310447],[-70.604555,-33.310677],[-70.60444,-33.310853],[-70.60417,-33.310979],[-70.603994,-33.311328],[-70.603857,-33.311945],[-70.603603,-33.312783],[-70.603264,-33.313212],[-70.602668,-33.313502],[-70.602069,-33.313836],[-70.601938,-33.314323],[-70.601808,-33.314805],[-70.601577,-33.315197],[-70.601183,-33.31567],[-70.600844,-33.316104],[-70.600286,-33.316661],[-70.600204,-33.317234],[-70.600122,-33.317812],[-70.600197,-33.318437],[-70.600287,-33.318751],[-70.600401,-33.319642],[-70.600315,-33.320306],[-70.600226,-33.321014],[-70.599975,-33.321803],[-70.599796,-33.322197],[-70.599569,-33.3225],[-70.599259,-33.323421],[-70.599018,-33.323989],[-70.598677,-33.324468],[-70.598379,-33.325124],[-70.59809,-33.325601],[-70.597907,-33.326085],[-70.597779,-33.326522],[-70.597544,-33.327],[-70.5972,-33.32752],[-70.596868,-33.327818],[-70.596439,-33.327938],[-70.596048,-33.328325],[-70.595604,-33.328751],[-70.595372,-33.329144],[-70.59524,-33.329671],[-70.595328,-33.33003],[-70.595408,-33.330523],[-70.594906,-33.331037],[-70.594413,-33.331375],[-70.594074,-33.331809],[-70.594049,-33.332295],[-70.593866,-33.332779],[-70.593683,-33.333259],[-70.593601,-33.333833],[-70.593673,-33.334502],[-70.593858,-33.33504],[-70.594198,-33.335633],[-70.594902,-33.336366],[-70.595472,-33.336611],[-70.595941,-33.336759],[-70.596086,-33.337034],[-70.596093,-33.337058],[-70.596222,-33.33748],[-70.596523,-33.337802],[-70.597459,-33.338146],[-70.598344,-33.338443],[-70.599715,-33.338537],[-70.60056,-33.338567],[-70.601522,-33.33838],[-70.602416,-33.338502],[-70.603303,-33.338754],[-70.604183,-33.339141],[-70.604962,-33.339435],[-70.605847,-33.339732],[-70.606859,-33.339592],[-70.607865,-33.339582],[-70.6086,-33.339699],[-70.609232,-33.339762],[-70.610176,-33.33993],[-70.611061,-33.340227],[-70.611953,-33.340394],[-70.612739,-33.340552],[-70.613262,-33.340661],[-70.613993,-33.340867],[-70.614508,-33.341151],[-70.615234,-33.341442],[-70.616068,-33.341693],[-70.616696,-33.34185],[-70.617332,-33.341827],[-70.618015,-33.341942],[-70.61847,-33.342151],[-70.618636,-33.342229],[-70.619336,-33.34236],[-70.619527,-33.342396],[-70.620377,-33.342336],[-70.621075,-33.34214],[-70.62183,-33.341856],[-70.622587,-33.341527],[-70.623402,-33.341109],[-70.624107,-33.340778],[-70.625007,-33.340765],[-70.625846,-33.34093],[-70.626532,-33.340954],[-70.627442,-33.340765],[-70.628772,-33.340632],[-70.630092,-33.340679],[-70.630885,-33.340707],[-70.631569,-33.340776],[-70.632323,-33.340537],[-70.632862,-33.340335],[-70.63365,-33.340448],[-70.634222,-33.340649],[-70.634742,-33.340843],[-70.635569,-33.341228],[-70.636027,-33.341599],[-70.63659,-33.341975],[-70.637262,-33.34231],[-70.63794,-33.342509],[-70.63851,-33.342755],[-70.639411,-33.342741],[-70.640051,-33.342629],[-70.640435,-33.342538],[-70.640533,-33.342515],[-70.641121,-33.3424],[-70.641498,-33.342283],[-70.642242,-33.342219],[-70.643027,-33.342377],[-70.643721,-33.342271],[-70.644577,-33.34208],[-70.645117,-33.341874],[-70.645566,-33.341358],[-70.645958,-33.340926],[-70.646348,-33.340543],[-70.646897,-33.340121],[-70.647182,-33.33973],[-70.647208,-33.3392],[-70.647496,-33.338719],[-70.647834,-33.338334],[-70.648106,-33.338164],[-70.648437,-33.337909],[-70.649042,-33.33744],[-70.649534,-33.337146],[-70.649872,-33.336717],[-70.650114,-33.336104],[-70.650405,-33.335578],[-70.650746,-33.335103],[-70.651193,-33.334628],[-70.651696,-33.334114],[-70.652241,-33.333777],[-70.653265,-33.333412],[-70.654079,-33.332999],[-70.654687,-33.332484],[-70.655396,-33.332068],[-70.65579,-33.331591],[-70.656189,-33.331028],[-70.656582,-33.330555],[-70.657036,-33.32995],[-70.65732,-33.329559],[-70.657549,-33.329211],[-70.657729,-33.328771],[-70.658165,-33.328521],[-70.658696,-33.328494],[-70.659272,-33.328604],[-70.660004,-33.328806],[-70.660738,-33.328922],[-70.661421,-33.329035],[-70.662044,-33.329278],[-70.66262,-33.329388],[-70.662671,-33.329381],[-70.663259,-33.32932],[-70.663514,-33.329257],[-70.664062,-33.329128],[-70.664756,-33.329017],[-70.66529,-33.328905],[-70.666147,-33.32871],[-70.666528,-33.328502],[-70.667177,-33.328214],[-70.667551,-33.328137],[-70.668128,-33.328247],[-70.668698,-33.328488],[-70.669479,-33.328741],[-70.670155,-33.328985],[-70.670892,-33.329056],[-70.671946,-33.329178],[-70.672672,-33.329474],[-70.673505,-33.329769],[-70.674297,-33.329796],[-70.67536,-33.329698],[-70.676633,-33.329652],[-70.677531,-33.329684],[-70.678219,-33.329667],[-70.678583,-33.329811],[-70.679155,-33.330011],[-70.67962,-33.330248],[-70.68008,-33.330574],[-70.680545,-33.330811],[-70.681064,-33.33101],[-70.681291,-33.330999],[-70.6817,-33.330987],[-70.682077,-33.330865],[-70.682407,-33.33061],[-70.682592,-33.330085],[-70.682767,-33.329736],[-70.683247,-33.329662],[-70.683298,-33.329651],[-70.683446,-33.329467],[-70.683731,-33.32922],[-70.684079,-33.329216],[-70.684371,-33.329358],[-70.684608,-33.329598],[-70.685014,-33.329641],[-70.685418,-33.329538],[-70.68582,-33.329338],[-70.68622,-33.329089],[-70.686678,-33.328791],[-70.687025,-33.328738],[-70.68743,-33.328732],[-70.687839,-33.328873],[-70.688128,-33.328869],[-70.688534,-33.328863],[-70.689053,-33.328759],[-70.689398,-33.328608],[-70.68974,-33.328312],[-70.689966,-33.328017],[-70.690185,-33.327381],[-70.690446,-33.32587],[-70.690438,-33.325432],[-70.690604,-33.325041],[-70.690942,-33.32455],[-70.691573,-33.324201],[-70.692091,-33.324048],[-70.692669,-33.323991],[-70.693365,-33.323982],[-70.694662,-33.323672],[-70.695179,-33.323422],[-70.695807,-33.322927],[-70.69626,-33.322386],[-70.696603,-33.322002],[-70.698155,-33.32097],[-70.69949,-33.320468],[-70.70083,-33.320234],[-70.702299,-33.320053],[-70.703383,-33.319823],[-70.704916,-33.319587],[-70.706508,-33.319135],[-70.707272,-33.318909],[-70.707975,-33.318846],[-70.708935,-33.318833],[-70.709898,-33.318927],[-70.710731,-33.318969],[-70.711057,-33.319101],[-70.710999,-33.319219],[-70.710281,-33.319661],[-70.70975,-33.319993],[-70.709614,-33.320148],[-70.708987,-33.32114],[-70.708285,-33.322698],[-70.708496,-33.322818],[-70.710405,-33.323426],[-70.713172,-33.324298],[-70.715983,-33.325192],[-70.718258,-33.325887],[-70.719576,-33.32296],[-70.720934,-33.319937],[-70.721797,-33.31798],[-70.722278,-33.316912],[-70.723328,-33.314581],[-70.723332,-33.314581],[-70.72333,-33.314577],[-70.724718,-33.311479],[-70.72671,-33.307041],[-70.728303,-33.303491],[-70.728805,-33.302373],[-70.730167,-33.299335],[-70.731316,-33.296779],[-70.732063,-33.295113],[-70.733382,-33.292166],[-70.734861,-33.288874],[-70.737647,-33.282652],[-70.738394,-33.280989],[-70.739156,-33.279286],[-70.739555,-33.278397],[-70.740949,-33.275286],[-70.742068,-33.272777],[-70.742814,-33.271077],[-70.743482,-33.26963],[-70.745565,-33.264975],[-70.746466,-33.262962],[-70.746565,-33.262961],[-70.746499,-33.262887],[-70.749023,-33.257253],[-70.749999,-33.255073],[-70.750612,-33.253704],[-70.751221,-33.252343],[-70.751349,-33.252055],[-70.752537,-33.249398],[-70.753354,-33.247567],[-70.754266,-33.245525],[-70.755195,-33.243438],[-70.755663,-33.242385],[-70.756585,-33.240321],[-70.757723,-33.237778],[-70.758801,-33.235377],[-70.760259,-33.232117],[-70.763834,-33.224465],[-70.764633,-33.222691],[-70.765947,-33.21974],[-70.766547,-33.2184],[-70.767498,-33.216269],[-70.771075,-33.208255],[-70.771298,-33.208316],[-70.771143,-33.208103],[-70.7714,-33.207527],[-70.773196,-33.203499],[-70.774215,-33.201217],[-70.774666,-33.200206],[-70.775192,-33.199027],[-70.775744,-33.197791],[-70.776209,-33.196751],[-70.77702,-33.194931],[-70.777544,-33.193762],[-70.778226,-33.192229],[-70.778779,-33.190991],[-70.779539,-33.189292],[-70.780439,-33.187273],[-70.781082,-33.18583],[-70.781437,-33.185033]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1330,"DIS_ELEC":16,"NOM_COM":"Colina","NOM_PROV":"Chacabuco","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":969694064.665,"SHAPE_LENG":172581.44753,"SHAPE_Le_1":172775.199957},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}},{"geometry":{"coordinates":[[[-70.742094,-33.663208],[-70.741778,-33.663237],[-70.741208,-33.662349],[-70.740352,-33.660744],[-70.7401,-33.660269],[-70.739412,-33.659068],[-70.737887,-33.656425],[-70.737724,-33.655996],[-70.737424,-33.654872],[-70.737026,-33.653274],[-70.736651,-33.651784],[-70.736292,-33.650443],[-70.735948,-33.648978],[-70.735742,-33.648133],[-70.735553,-33.647099],[-70.735493,-33.646405],[-70.735606,-33.646446],[-70.735598,-33.646413],[-70.737016,-33.645723],[-70.737341,-33.645489],[-70.737989,-33.644928],[-70.73863,-33.643999],[-70.738893,-33.643398],[-70.739533,-33.642423],[-70.739746,-33.642052],[-70.740226,-33.641356],[-70.740493,-33.640938],[-70.740595,-33.640569],[-70.74086,-33.64006],[-70.740962,-33.63969],[-70.741116,-33.639136],[-70.741436,-33.638626],[-70.741864,-33.638068],[-70.742372,-33.637372],[-70.742749,-33.636953],[-70.743066,-33.63635],[-70.743108,-33.635706],[-70.743477,-33.634919],[-70.743743,-33.634456],[-70.744336,-33.633896],[-70.745637,-33.633004],[-70.746286,-33.632489],[-70.746824,-33.631883],[-70.747088,-33.631374],[-70.747409,-33.63091],[-70.747839,-33.630444],[-70.748106,-33.630072],[-70.748262,-33.62961],[-70.748363,-33.629195],[-70.748742,-33.628868],[-70.749013,-33.628726],[-70.749942,-33.628437],[-70.751079,-33.627851],[-70.751683,-33.627539],[-70.752549,-33.626883],[-70.753004,-33.626279],[-70.753643,-33.625304],[-70.754221,-33.623963],[-70.754593,-33.62336],[-70.755883,-33.621916],[-70.756588,-33.621446],[-70.756912,-33.621166],[-70.756961,-33.620889],[-70.756791,-33.620616],[-70.75657,-33.620573],[-70.755632,-33.620402],[-70.755137,-33.620363],[-70.753538,-33.62011],[-70.750832,-33.619459],[-70.749066,-33.61907],[-70.747674,-33.618216],[-70.747065,-33.617949],[-70.746727,-33.61754],[-70.746922,-33.616342],[-70.746968,-33.615881],[-70.747176,-33.615327],[-70.747389,-33.614956],[-70.74771,-33.614537],[-70.747921,-33.614075],[-70.748383,-33.612505],[-70.748757,-33.611948],[-70.749185,-33.61139],[-70.749672,-33.611015],[-70.750213,-33.610594],[-70.750751,-33.610035],[-70.751286,-33.609291],[-70.751494,-33.608737],[-70.751648,-33.608183],[-70.751853,-33.607444],[-70.752063,-33.606982],[-70.752493,-33.606516],[-70.753085,-33.605864],[-70.753346,-33.605216],[-70.753557,-33.604753],[-70.753715,-33.604429],[-70.754037,-33.604057],[-70.754357,-33.603593],[-70.754385,-33.603168],[-70.754288,-33.602832],[-70.754211,-33.602733],[-70.754044,-33.602315],[-70.753778,-33.601771],[-70.753332,-33.60129],[-70.751818,-33.600275],[-70.75038,-33.599351],[-70.748759,-33.598399],[-70.747471,-33.597747],[-70.745894,-33.59716],[-70.744932,-33.596412],[-70.744116,-33.595662],[-70.743484,-33.595],[-70.743338,-33.594572],[-70.743182,-33.594272],[-70.743572,-33.594075],[-70.743832,-33.59385],[-70.744176,-33.593477],[-70.744651,-33.592992],[-70.744995,-33.592582],[-70.745338,-33.592135],[-70.745503,-33.591617],[-70.745732,-33.590951],[-70.746065,-33.589988],[-70.746794,-33.589057],[-70.747309,-33.588424],[-70.747958,-33.587862],[-70.748608,-33.587374],[-70.749039,-33.586926],[-70.749736,-33.586548],[-70.750169,-33.58621],[-70.750465,-33.585617],[-70.750632,-33.585135],[-70.750838,-33.58447],[-70.751352,-33.583762],[-70.752714,-33.582565],[-70.7531,-33.582043],[-70.753091,-33.581602],[-70.752931,-33.580241],[-70.752836,-33.579911],[-70.752783,-33.579433],[-70.752865,-33.579137],[-70.753123,-33.578839],[-70.753426,-33.578613],[-70.753773,-33.578351],[-70.754813,-33.577562],[-70.755331,-33.577076],[-70.755631,-33.576667],[-70.755845,-33.576369],[-70.756447,-33.575661],[-70.757052,-33.575136],[-70.757702,-33.574612],[-70.758354,-33.574234],[-70.759231,-33.574111],[-70.760572,-33.574055],[-70.761276,-33.574045],[-70.761717,-33.574076],[-70.762116,-33.574254],[-70.762386,-33.574508],[-70.762785,-33.574687],[-70.763226,-33.574717],[-70.763488,-33.57464],[-70.76366,-33.574416],[-70.764005,-33.57408],[-70.764953,-33.573109],[-70.765518,-33.572732],[-70.76604,-33.572467],[-70.766739,-33.572199],[-70.767418,-33.571961],[-70.767021,-33.571503],[-70.766008,-33.570056],[-70.764715,-33.568209],[-70.763942,-33.567119],[-70.763376,-33.566433],[-70.762662,-33.565625],[-70.759679,-33.562269],[-70.755854,-33.557953],[-70.754553,-33.55649],[-70.752489,-33.554183],[-70.75125,-33.552794],[-70.75033,-33.551775],[-70.749482,-33.550845],[-70.745996,-33.54697],[-70.744415,-33.545204],[-70.743818,-33.54453],[-70.741241,-33.541609],[-70.740568,-33.540835],[-70.739431,-33.539541],[-70.739321,-33.539427],[-70.732825,-33.531863],[-70.729005,-33.527233],[-70.726524,-33.524076],[-70.726397,-33.523914],[-70.724713,-33.524559],[-70.721796,-33.525636],[-70.718373,-33.526914],[-70.718247,-33.526942],[-70.715996,-33.527779],[-70.707298,-33.53103],[-70.706741,-33.531239],[-70.706739,-33.531225],[-70.706273,-33.531414],[-70.704359,-33.53213],[-70.702988,-33.532627],[-70.701513,-33.533152],[-70.699925,-33.533756],[-70.698781,-33.534172],[-70.696803,-33.534912],[-70.695272,-33.535501],[-70.693872,-33.536007],[-70.689831,-33.53748],[-70.687831,-33.538218],[-70.686614,-33.538667],[-70.685763,-33.538973],[-70.685764,-33.538974],[-70.685619,-33.539026],[-70.685379,-33.539111],[-70.685533,-33.539399],[-70.685536,-33.539398],[-70.68589,-33.540066],[-70.686038,-33.540371],[-70.686118,-33.54046],[-70.686385,-33.540809],[-70.686499,-33.540959],[-70.686607,-33.54108],[-70.686769,-33.541263],[-70.687087,-33.541575],[-70.687248,-33.541734],[-70.68727,-33.541815],[-70.687352,-33.541884],[-70.687355,-33.541885],[-70.687356,-33.541888],[-70.687395,-33.541921],[-70.687611,-33.542144],[-70.687397,-33.542039],[-70.687054,-33.541836],[-70.686872,-33.541668],[-70.686595,-33.541391],[-70.686481,-33.541294],[-70.686304,-33.541179],[-70.68624,-33.541171],[-70.686248,-33.541252],[-70.686403,-33.541574],[-70.686574,-33.541806],[-70.686596,-33.541968],[-70.68688,-33.54253],[-70.687397,-33.543617],[-70.687902,-33.544704],[-70.688012,-33.544941],[-70.689042,-33.547256],[-70.68944,-33.548125],[-70.689585,-33.548448],[-70.689907,-33.549156],[-70.690063,-33.549496],[-70.690254,-33.549935],[-70.690449,-33.550357],[-70.690715,-33.550975],[-70.691004,-33.551576],[-70.691195,-33.552006],[-70.691384,-33.552427],[-70.691926,-33.553611],[-70.691948,-33.553601],[-70.692918,-33.55613],[-70.693071,-33.55613],[-70.69441,-33.555968],[-70.69546,-33.555897],[-70.695673,-33.5569],[-70.69603,-33.55857],[-70.696287,-33.559773],[-70.696664,-33.561102],[-70.697018,-33.563154],[-70.69705,-33.563721],[-70.696819,-33.563818],[-70.697093,-33.56483],[-70.697432,-33.565493],[-70.69741,-33.565529],[-70.69802,-33.566888],[-70.698686,-33.568337],[-70.698975,-33.56897],[-70.69925,-33.569558],[-70.699346,-33.569858],[-70.699626,-33.570413],[-70.699851,-33.570912],[-70.700055,-33.571372],[-70.700267,-33.571829],[-70.700478,-33.572304],[-70.700798,-33.572966],[-70.700792,-33.572967],[-70.69974,-33.573379],[-70.698793,-33.573752],[-70.697718,-33.574164],[-70.697325,-33.574314],[-70.696942,-33.574445],[-70.696418,-33.574658],[-70.696254,-33.574725],[-70.69558,-33.574987],[-70.694675,-33.575404],[-70.692128,-33.576342],[-70.691061,-33.576789],[-70.689298,-33.577496],[-70.687128,-33.578358],[-70.685202,-33.579097],[-70.682869,-33.580057],[-70.680817,-33.580834],[-70.67983,-33.581244],[-70.67835,-33.581841],[-70.676674,-33.582439],[-70.675866,-33.582596],[-70.674839,-33.582802],[-70.671112,-33.583559],[-70.670776,-33.58363],[-70.666637,-33.584461],[-70.663398,-33.5851],[-70.66324,-33.585164],[-70.663244,-33.585174],[-70.663635,-33.586468],[-70.663799,-33.587006],[-70.663988,-33.587563],[-70.664675,-33.589781],[-70.664726,-33.589961],[-70.664961,-33.590778],[-70.665076,-33.591214],[-70.665259,-33.591766],[-70.665521,-33.59252],[-70.666425,-33.595286],[-70.666814,-33.596524],[-70.667497,-33.598494],[-70.668069,-33.600092],[-70.668236,-33.60065],[-70.668303,-33.600878],[-70.668784,-33.602226],[-70.669298,-33.603681],[-70.669641,-33.60466],[-70.670433,-33.606954],[-70.67049,-33.607106],[-70.670615,-33.607477],[-70.665907,-33.607939],[-70.6623,-33.608267],[-70.659316,-33.608528],[-70.656653,-33.608756],[-70.654484,-33.608945],[-70.644971,-33.609753],[-70.643157,-33.609909],[-70.643165,-33.610089],[-70.643208,-33.61062],[-70.643382,-33.612016],[-70.643622,-33.613891],[-70.643665,-33.614126],[-70.643875,-33.615842],[-70.644107,-33.617688],[-70.644347,-33.619621],[-70.642379,-33.619812],[-70.642213,-33.619832],[-70.642442,-33.621669],[-70.64268,-33.623586],[-70.642932,-33.625567],[-70.643135,-33.627178],[-70.643141,-33.627223],[-70.629107,-33.627754],[-70.629111,-33.627768],[-70.628691,-33.627793],[-70.628804,-33.62836],[-70.629421,-33.63094],[-70.629772,-33.632315],[-70.630052,-33.634352],[-70.630336,-33.636519],[-70.630476,-33.637545],[-70.630806,-33.639868],[-70.630942,-33.640948],[-70.631018,-33.641019],[-70.631233,-33.642839],[-70.631235,-33.642841],[-70.631515,-33.643299],[-70.631872,-33.643711],[-70.632246,-33.644165],[-70.632764,-33.644525],[-70.633388,-33.644669],[-70.634047,-33.644722],[-70.634704,-33.644713],[-70.635364,-33.644796],[-70.635988,-33.644971],[-70.636613,-33.645146],[-70.637237,-33.645321],[-70.637809,-33.645604],[-70.638364,-33.645933],[-70.638882,-33.646262],[-70.639471,-33.646499],[-70.639989,-33.646829],[-70.640578,-33.647096],[-70.64124,-33.64727],[-70.641864,-33.647445],[-70.642489,-33.647621],[-70.643149,-33.647734],[-70.643809,-33.647847],[-70.644398,-33.648084],[-70.644987,-33.648321],[-70.645613,-33.648557],[-70.646274,-33.648701],[-70.646898,-33.648846],[-70.647488,-33.649143],[-70.648077,-33.64938],[-70.648737,-33.649463],[-70.649433,-33.649545],[-70.650058,-33.649751],[-70.650849,-33.650031],[-70.651804,-33.650263],[-70.652394,-33.65053],[-70.653052,-33.650582],[-70.653708,-33.650482],[-70.654326,-33.650321],[-70.655019,-33.65022],[-70.655675,-33.65015],[-70.656333,-33.65011],[-70.656991,-33.650132],[-70.657616,-33.650338],[-70.658171,-33.650697],[-70.658762,-33.650995],[-70.659316,-33.651323],[-70.659545,-33.65184],[-70.659846,-33.652294],[-70.66015,-33.652871],[-70.66027,-33.653389],[-70.660239,-33.653901],[-70.66068,-33.654167],[-70.660798,-33.654238],[-70.66128,-33.654629],[-70.661727,-33.655081],[-70.662281,-33.655379],[-70.662799,-33.655709],[-70.663424,-33.655853],[-70.663977,-33.656151],[-70.664567,-33.656418],[-70.665157,-33.656655],[-70.665748,-33.656983],[-70.666356,-33.657235],[-70.666946,-33.657532],[-70.667536,-33.657769],[-70.668195,-33.657852],[-70.668855,-33.657965],[-70.669481,-33.658171],[-70.67007,-33.658407],[-70.670444,-33.658861],[-70.670962,-33.65919],[-70.671553,-33.659487],[-70.672142,-33.659724],[-70.672804,-33.659929],[-70.673429,-33.660104],[-70.674126,-33.660247],[-70.674823,-33.66036],[-70.675483,-33.660504],[-70.676142,-33.660556],[-70.676803,-33.6607],[-70.677393,-33.660967],[-70.677983,-33.661234],[-70.678643,-33.661317],[-70.679302,-33.6614],[-70.679983,-33.66162],[-70.680643,-33.661764],[-70.681338,-33.661754],[-70.68203,-33.661653],[-70.682722,-33.661521],[-70.683378,-33.66139],[-70.684033,-33.661259],[-70.684688,-33.661128],[-70.685347,-33.661149],[-70.685937,-33.661447],[-70.686491,-33.661745],[-70.68701,-33.662105],[-70.6876,-33.662372],[-70.68819,-33.662639],[-70.688815,-33.662814],[-70.689439,-33.662958],[-70.690098,-33.662979],[-70.690756,-33.663001],[-70.69138,-33.663145],[-70.692039,-33.663167],[-70.692696,-33.663158],[-70.693353,-33.663088],[-70.69403,-33.663124],[-70.694686,-33.663054],[-70.695305,-33.662893],[-70.69596,-33.662762],[-70.69669,-33.662721],[-70.697348,-33.662712],[-70.698009,-33.662886],[-70.698563,-33.663184],[-70.699119,-33.663543],[-70.699637,-33.663873],[-70.700228,-33.664201],[-70.700746,-33.66453],[-70.701373,-33.664796],[-70.70207,-33.664909],[-70.702731,-33.665083],[-70.703391,-33.665196],[-70.704089,-33.665339],[-70.704748,-33.665422],[-70.705408,-33.665505],[-70.706067,-33.665587],[-70.706725,-33.665548],[-70.7074,-33.665523],[-70.708057,-33.665453],[-70.708713,-33.665352],[-70.709372,-33.665404],[-70.710032,-33.665517],[-70.710516,-33.665938],[-70.710854,-33.666423],[-70.711011,-33.666971],[-70.711241,-33.667487],[-70.711688,-33.667909],[-70.712171,-33.668299],[-70.712691,-33.66872],[-70.713282,-33.669018],[-70.713657,-33.669501],[-70.71385,-33.670018],[-70.714189,-33.670533],[-70.71431,-33.671082],[-70.714394,-33.671661],[-70.714442,-33.672211],[-70.714453,-33.672761],[-70.714427,-33.673311],[-70.714421,-33.673938],[-70.714432,-33.674488],[-70.714589,-33.675036],[-70.714782,-33.675553],[-70.714975,-33.67607],[-70.715132,-33.676618],[-70.71518,-33.677167],[-70.715264,-33.677747],[-70.715422,-33.678295],[-70.715543,-33.678874],[-70.715663,-33.679422],[-70.715784,-33.680001],[-70.716015,-33.680548],[-70.7161,-33.681159],[-70.716402,-33.681643],[-70.716542,-33.682268],[-70.716736,-33.682785],[-70.716929,-33.683302],[-70.717304,-33.683786],[-70.717571,-33.684332],[-70.717837,-33.684879],[-70.718248,-33.685301],[-70.718767,-33.68566],[-70.719286,-33.68602],[-70.719877,-33.686317],[-70.720361,-33.686738],[-70.720808,-33.68716],[-70.72111,-33.687645],[-70.721267,-33.688193],[-70.721497,-33.68874],[-70.721655,-33.689288],[-70.722012,-33.689787],[-70.722684,-33.690511],[-70.722898,-33.690575],[-70.723273,-33.690687],[-70.723828,-33.691015],[-70.724346,-33.691344],[-70.724794,-33.691766],[-70.724987,-33.692313],[-70.725435,-33.692735],[-70.725918,-33.693125],[-70.726473,-33.693484],[-70.727028,-33.693782],[-70.727618,-33.694018],[-70.728242,-33.694162],[-70.728939,-33.694275],[-70.729634,-33.694265],[-70.730292,-33.694287],[-70.730918,-33.694492],[-70.73158,-33.694666],[-70.732205,-33.694841],[-70.732795,-33.695077],[-70.733349,-33.695375],[-70.73376,-33.695797],[-70.734278,-33.696126],[-70.734833,-33.696424],[-70.735172,-33.696908],[-70.735582,-33.69733],[-70.73603,-33.697752],[-70.736655,-33.697926],[-70.737314,-33.698009],[-70.737972,-33.697969],[-70.73859,-33.697807],[-70.739285,-33.697797],[-70.739944,-33.697849],[-70.740603,-33.697901],[-70.741299,-33.697952],[-70.741958,-33.698004],[-70.742584,-33.698209],[-70.743209,-33.698384],[-70.74387,-33.698527],[-70.744496,-33.698733],[-70.745015,-33.699062],[-70.745605,-33.699328],[-70.746196,-33.699625],[-70.746952,-33.699936],[-70.747471,-33.700265],[-70.748097,-33.70047],[-70.748758,-33.700613],[-70.749348,-33.700849],[-70.749866,-33.701178],[-70.750526,-33.701261],[-70.751185,-33.701282],[-70.751845,-33.701395],[-70.752579,-33.701507],[-70.753205,-33.701712],[-70.753796,-33.702009],[-70.754388,-33.702337],[-70.754978,-33.702573],[-70.755568,-33.70284],[-70.756123,-33.703137],[-70.756677,-33.703435],[-70.757337,-33.703517],[-70.757997,-33.7036],[-70.758692,-33.70362],[-70.759348,-33.703519],[-70.760007,-33.70354],[-70.760686,-33.703638],[-70.761313,-33.703904],[-70.761903,-33.70417],[-70.762458,-33.704468],[-70.762869,-33.70489],[-70.763425,-33.705249],[-70.763981,-33.705639],[-70.764571,-33.705875],[-70.765231,-33.705957],[-70.765856,-33.706131],[-70.766482,-33.706306],[-70.767071,-33.706542],[-70.767663,-33.706839],[-70.768146,-33.707229],[-70.768449,-33.707745],[-70.768643,-33.708292],[-70.768982,-33.708776],[-70.76923,-33.709246],[-70.769495,-33.709701],[-70.769874,-33.710337],[-70.770178,-33.710883],[-70.770697,-33.711243],[-70.771145,-33.711664],[-70.771735,-33.711931],[-70.77229,-33.712228],[-70.772774,-33.712649],[-70.773365,-33.712916],[-70.773884,-33.713275],[-70.774404,-33.713665],[-70.774707,-33.71415],[-70.775083,-33.714664],[-70.775531,-33.715085],[-70.776051,-33.715506],[-70.776535,-33.715896],[-70.777159,-33.71604],[-70.777784,-33.716184],[-70.778445,-33.716297],[-70.779108,-33.716532],[-70.779663,-33.71686],[-70.780289,-33.717034],[-70.780773,-33.717455],[-70.781076,-33.71797],[-70.781632,-33.718329],[-70.781971,-33.718813],[-70.782382,-33.719235],[-70.782757,-33.719688],[-70.783133,-33.720141],[-70.783669,-33.720454],[-70.784225,-33.720782],[-70.784746,-33.721233],[-70.785375,-33.72156],[-70.785895,-33.72195],[-70.786234,-33.722434],[-70.786718,-33.722855],[-70.787131,-33.723338],[-70.787543,-33.723791],[-70.788027,-33.724212],[-70.78844,-33.724725],[-70.788889,-33.725238],[-70.789265,-33.725722],[-70.789713,-33.726174],[-70.790161,-33.726595],[-70.790536,-33.727048],[-70.790984,-33.72747],[-70.791539,-33.727767],[-70.792167,-33.728094],[-70.792561,-33.728532],[-70.793046,-33.728983],[-70.793602,-33.729373],[-70.794159,-33.729731],[-70.794679,-33.730121],[-70.795162,-33.730511],[-70.795681,-33.73084],[-70.796306,-33.730984],[-70.796965,-33.731005],[-70.797658,-33.730903],[-70.798352,-33.730862],[-70.798979,-33.731098],[-70.79957,-33.731364],[-70.80009,-33.731754],[-70.80061,-33.732113],[-70.800985,-33.732566],[-70.801469,-33.732987],[-70.802024,-33.733284],[-70.80265,-33.733459],[-70.803307,-33.733388],[-70.803925,-33.733226],[-70.804583,-33.733186],[-70.805244,-33.733329],[-70.805869,-33.733473],[-70.80648,-33.733815],[-70.807071,-33.734082],[-70.807697,-33.734286],[-70.808216,-33.734615],[-70.808736,-33.735005],[-70.80922,-33.735395],[-70.809668,-33.735816],[-70.810117,-33.736268],[-70.810601,-33.736689],[-70.810976,-33.737142],[-70.811388,-33.737564],[-70.81169,-33.738048],[-70.811885,-33.738596],[-70.812116,-33.739173],[-70.812274,-33.739721],[-70.812432,-33.740269],[-70.812481,-33.740849],[-70.812457,-33.74143],[-70.812451,-33.742026],[-70.812426,-33.742576],[-70.812437,-33.743126],[-70.812339,-33.743678],[-70.812351,-33.744228],[-70.812326,-33.744778],[-70.812154,-33.7453],[-70.812166,-33.74585],[-70.81225,-33.746399],[-70.812299,-33.746979],[-70.812602,-33.747464],[-70.812941,-33.747948],[-70.813244,-33.748432],[-70.813547,-33.748917],[-70.813742,-33.749464],[-70.813699,-33.75003],[-70.813966,-33.750546],[-70.814377,-33.750968],[-70.815075,-33.75111],[-70.8157,-33.751254],[-70.816326,-33.751428],[-70.816846,-33.751787],[-70.81733,-33.752208],[-70.817742,-33.75263],[-70.818333,-33.752896],[-70.818996,-33.7531],[-70.819587,-33.753367],[-70.820177,-33.753603],[-70.820993,-33.754115],[-70.821078,-33.754249],[-70.823062,-33.752889],[-70.824016,-33.752148],[-70.824754,-33.751575],[-70.825349,-33.750535],[-70.825555,-33.749869],[-70.825895,-33.749238],[-70.826079,-33.748572],[-70.826029,-33.747787],[-70.826013,-33.747542],[-70.82595,-33.746659],[-70.825936,-33.745996],[-70.825739,-33.745004],[-70.825075,-33.741773],[-70.824981,-33.741517],[-70.824575,-33.741081],[-70.823727,-33.740578],[-70.823242,-33.740365],[-70.823238,-33.740364],[-70.823229,-33.740361],[-70.822794,-33.740223],[-70.822306,-33.740083],[-70.821682,-33.739761],[-70.821544,-33.739505],[-70.821044,-33.738776],[-70.820964,-33.738488],[-70.82071,-33.737565],[-70.820521,-33.736978],[-70.820512,-33.736537],[-70.820587,-33.735946],[-70.820757,-33.735649],[-70.820972,-33.735388],[-70.821135,-33.73476],[-70.821124,-33.734244],[-70.821263,-33.733505],[-70.821244,-33.732585],[-70.821084,-33.730815],[-70.821071,-33.730672],[-70.821109,-33.73005],[-70.821235,-33.727981],[-70.821324,-33.726985],[-70.821488,-33.72643],[-70.821653,-33.725876],[-70.821951,-33.725392],[-70.822206,-33.724947],[-70.822851,-33.724164],[-70.82306,-33.723608],[-70.823182,-33.723127],[-70.823345,-33.722499],[-70.823552,-33.72187],[-70.823808,-33.721498],[-70.824284,-33.721085],[-70.824387,-33.721047],[-70.823649,-33.720436],[-70.822624,-33.720213],[-70.821314,-33.719974],[-70.82029,-33.719746],[-70.818434,-33.719823],[-70.817896,-33.720025],[-70.816922,-33.720452],[-70.81558,-33.721222],[-70.814712,-33.721584],[-70.813468,-33.722447],[-70.81278,-33.722717],[-70.811894,-33.722835],[-70.810728,-33.722543],[-70.809842,-33.722202],[-70.808993,-33.721583],[-70.807934,-33.721034],[-70.807452,-33.720698],[-70.806359,-33.720246],[-70.806574,-33.71933],[-70.806836,-33.718668],[-70.806747,-33.718137],[-70.80633,-33.717258],[-70.805833,-33.716012],[-70.805702,-33.715075],[-70.805255,-33.714532],[-70.804692,-33.714162],[-70.804596,-33.712731],[-70.804301,-33.711711],[-70.803324,-33.710525],[-70.801592,-33.709506],[-70.800049,-33.708157],[-70.798994,-33.7074],[-70.798574,-33.70657],[-70.79833,-33.705697],[-70.797704,-33.704378],[-70.796757,-33.703769],[-70.795686,-33.70335],[-70.794982,-33.702461],[-70.794607,-33.701917],[-70.794621,-33.701629],[-70.794262,-33.700752],[-70.793439,-33.699958],[-70.792501,-33.699155],[-70.791839,-33.698124],[-70.791566,-33.697105],[-70.791445,-33.696047],[-70.792174,-33.695252],[-70.792776,-33.694696],[-70.793033,-33.694128],[-70.793498,-33.692851],[-70.793609,-33.691886],[-70.793853,-33.691467],[-70.793854,-33.690268],[-70.794054,-33.689699],[-70.79444,-33.688847],[-70.794929,-33.688237],[-70.796131,-33.687657],[-70.796325,-33.686686],[-70.795914,-33.685726],[-70.795664,-33.684951],[-70.79553,-33.684176],[-70.79562,-33.683513],[-70.796157,-33.683099],[-70.796531,-33.68249],[-70.797317,-33.681701],[-70.798297,-33.681113],[-70.799129,-33.680285],[-70.79912,-33.679258],[-70.799451,-33.677976],[-70.800205,-33.67666],[-70.801239,-33.674947],[-70.801533,-33.673961],[-70.801523,-33.673344],[-70.801966,-33.672643],[-70.803548,-33.672147],[-70.803531,-33.670808],[-70.803298,-33.669706],[-70.802487,-33.668714],[-70.802464,-33.668411],[-70.802323,-33.668425],[-70.801304,-33.668449],[-70.800091,-33.668569],[-70.798754,-33.668281],[-70.798446,-33.667491],[-70.79844,-33.666774],[-70.798345,-33.666185],[-70.797841,-33.665312],[-70.796937,-33.664804],[-70.795977,-33.664325],[-70.795227,-33.663867],[-70.794215,-33.662851],[-70.793686,-33.662225],[-70.793055,-33.661208],[-70.792532,-33.660163],[-70.791584,-33.659446],[-70.790073,-33.658502],[-70.78879,-33.657909],[-70.787281,-33.656934],[-70.786496,-33.656204],[-70.785997,-33.65552],[-70.785252,-33.655157],[-70.784516,-33.6542],[-70.784054,-33.653341],[-70.782955,-33.653182],[-70.780938,-33.653947],[-70.77829,-33.654928],[-70.778197,-33.654957],[-70.775126,-33.65614],[-70.773788,-33.656617],[-70.769193,-33.658356],[-70.764545,-33.660084],[-70.762761,-33.660739],[-70.760855,-33.661435],[-70.760054,-33.661727],[-70.757196,-33.662908],[-70.755207,-33.662894],[-70.754205,-33.66285],[-70.753327,-33.662951],[-70.753023,-33.662966],[-70.752766,-33.663031],[-70.751775,-33.663307],[-70.751136,-33.663676],[-70.750283,-33.664139],[-70.749801,-33.664281],[-70.749157,-33.664425],[-70.748509,-33.66439],[-70.74797,-33.664352],[-70.746996,-33.664186],[-70.746402,-33.664104],[-70.746023,-33.664064],[-70.745264,-33.663805],[-70.744775,-33.663631],[-70.744287,-33.663503],[-70.743908,-33.663418],[-70.743529,-33.663333],[-70.742881,-33.663252],[-70.74245,-33.663258],[-70.742126,-33.663263],[-70.742094,-33.663208]]],"type":"Polygon"},"properties":{"CIR_SENA":7,"COD_COMUNA":1340,"DIS_ELEC":30,"NOM_COM":"San Bernardo","NOM_PROV":"Maipo","NOM_REG":"Región Metropolitana de Santiago","SHAPE_Area":154007610.151,"SHAPE_LENG":86349.611515,"SHAPE_Le_1":86456.603601},"type":"Feature","crs":{"properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"},"type":"name"}}]}
  

  const geo_json_alert = {
    "type": "FeatureCollection",
    "features": [
      {
        "geometry": {
          "coordinates": [
            [
              [
                -70.439462,
                -33.492062
              ],
              [
                -70.438253,
                -33.492151
              ],
              [
                -70.437901,
                -33.492155
              ],
              [
                -70.437851,
                -33.4922
              ],
              [
                -70.437788,
                -33.492662
              ],
              [
                -70.437796,
                -33.494106
              ],
              [
                -70.437705,
                -33.494562
              ],
              [
                -70.437517,
                -33.495141
              ],
              [
                -70.43741,
                -33.495271
              ],
              [
                -70.437367,
                -33.495445
              ],
              [
                -70.437291,
                -33.49582
              ],
              [
                -70.437235,
                -33.496179
              ],
              [
                -70.437193,
                -33.496632
              ],
              [
                -70.437152,
                -33.49704
              ],
              [
                -70.437144,
                -33.497409
              ],
              [
                -70.437165,
                -33.497753
              ],
              [
                -70.437247,
                -33.498039
              ],
              [
                -70.437439,
                -33.498312
              ],
              [
                -70.437653,
                -33.498523
              ],
              [
                -70.437883,
                -33.49877
              ],
              [
                -70.43814,
                -33.499
              ],
              [
                -70.438383,
                -33.499266
              ],
              [
                -70.438561,
                -33.499543
              ],
              [
                -70.438771,
                -33.499924
              ],
              [
                -70.438987,
                -33.500225
              ],
              [
                -70.439205,
                -33.500467
              ],
              [
                -70.43945,
                -33.50071
              ],
              [
                -70.439702,
                -33.500909
              ],
              [
                -70.44006,
                -33.501219
              ],
              [
                -70.440363,
                -33.501514
              ],
              [
                -70.440629,
                -33.501808
              ],
              [
                -70.440897,
                -33.502065
              ],
              [
                -70.441199,
                -33.502369
              ],
              [
                -70.441486,
                -33.502619
              ],
              [
                -70.441767,
                -33.502877
              ],
              [
                -70.442041,
                -33.503139
              ],
              [
                -70.442312,
                -33.503401
              ],
              [
                -70.442711,
                -33.503893
              ],
              [
                -70.443109,
                -33.504183
              ],
              [
                -70.444181,
                -33.504475
              ],
              [
                -70.445572,
                -33.504593
              ],
              [
                -70.446486,
                -33.504713
              ],
              [
                -70.446886,
                -33.504804
              ],
              [
                -70.447293,
                -33.504891
              ],
              [
                -70.447682,
                -33.504991
              ],
              [
                -70.448077,
                -33.505073
              ],
              [
                -70.448465,
                -33.505164
              ],
              [
                -70.448822,
                -33.505308
              ],
              [
                -70.449149,
                -33.5055
              ],
              [
                -70.449514,
                -33.505599
              ],
              [
                -70.449862,
                -33.505747
              ],
              [
                -70.450209,
                -33.505926
              ],
              [
                -70.450519,
                -33.506068
              ],
              [
                -70.450819,
                -33.506377
              ],
              [
                -70.451085,
                -33.506584
              ],
              [
                -70.451399,
                -33.506847
              ],
              [
                -70.451862,
                -33.507123
              ],
              [
                -70.452575,
                -33.507934
              ],
              [
                -70.452834,
                -33.508198
              ],
              [
                -70.453482,
                -33.508779
              ],
              [
                -70.453838,
                -33.509095
              ],
              [
                -70.454776,
                -33.509859
              ],
              [
                -70.455039,
                -33.51031
              ],
              [
                -70.45543,
                -33.510813
              ],
              [
                -70.456368,
                -33.511577
              ],
              [
                -70.456852,
                -33.511919
              ],
              [
                -70.458536,
                -33.513422
              ],
              [
                -70.459057,
                -33.513761
              ],
              [
                -70.4595,
                -33.514144
              ],
              [
                -70.460135,
                -33.514661
              ],
              [
                -70.460712,
                -33.515084
              ],
              [
                -70.46146,
                -33.515505
              ],
              [
                -70.462719,
                -33.515824
              ],
              [
                -70.463292,
                -33.516008
              ],
              [
                -70.463923,
                -33.516287
              ],
              [
                -70.464212,
                -33.516522
              ],
              [
                -70.464558,
                -33.516757
              ],
              [
                -70.464734,
                -33.517089
              ],
              [
                -70.465142,
                -33.517609
              ],
              [
                -70.46584,
                -33.518459
              ],
              [
                -70.466197,
                -33.519362
              ],
              [
                -70.466556,
                -33.52036
              ],
              [
                -70.466621,
                -33.520836
              ],
              [
                -70.466744,
                -33.521408
              ],
              [
                -70.466985,
                -33.522168
              ],
              [
                -70.467111,
                -33.522883
              ],
              [
                -70.467475,
                -33.524214
              ],
              [
                -70.468003,
                -33.525115
              ],
              [
                -70.468182,
                -33.525302
              ],
              [
                -70.468409,
                -33.52554
              ],
              [
                -70.468758,
                -33.525917
              ],
              [
                -70.468877,
                -33.52625
              ],
              [
                -70.469228,
                -33.526771
              ],
              [
                -70.469974,
                -33.527096
              ],
              [
                -70.470547,
                -33.52728
              ],
              [
                -70.471462,
                -33.52746
              ],
              [
                -70.472034,
                -33.527596
              ],
              [
                -70.472663,
                -33.527732
              ],
              [
                -70.473631,
                -33.528023
              ],
              [
                -70.4745,
                -33.528522
              ],
              [
                -70.474902,
                -33.528708
              ],
              [
                -70.475248,
                -33.528942
              ],
              [
                -70.475763,
                -33.529079
              ],
              [
                -70.476165,
                -33.529265
              ],
              [
                -70.476569,
                -33.529595
              ],
              [
                -70.47778,
                -33.530391
              ],
              [
                -70.478184,
                -33.530721
              ],
              [
                -70.478587,
                -33.530954
              ],
              [
                -70.479047,
                -33.531187
              ],
              [
                -70.47945,
                -33.531421
              ],
              [
                -70.479795,
                -33.531656
              ],
              [
                -70.479914,
                -33.531941
              ],
              [
                -70.480035,
                -33.532321
              ],
              [
                -70.479989,
                -33.53299
              ],
              [
                -70.479997,
                -33.533467
              ],
              [
                -70.480005,
                -33.533944
              ],
              [
                -70.480014,
                -33.534469
              ],
              [
                -70.479909,
                -33.534995
              ],
              [
                -70.479805,
                -33.535569
              ],
              [
                -70.479815,
                -33.536141
              ],
              [
                -70.479878,
                -33.536522
              ],
              [
                -70.479998,
                -33.536855
              ],
              [
                -70.480287,
                -33.53709
              ],
              [
                -70.480577,
                -33.537373
              ],
              [
                -70.480923,
                -33.537655
              ],
              [
                -70.481554,
                -33.537886
              ],
              [
                -70.48207,
                -33.538023
              ],
              [
                -70.482585,
                -33.53816
              ],
              [
                -70.4831,
                -33.538297
              ],
              [
                -70.484587,
                -33.538614
              ],
              [
                -70.485219,
                -33.538892
              ],
              [
                -70.485852,
                -33.539267
              ],
              [
                -70.486143,
                -33.539597
              ],
              [
                -70.486318,
                -33.539787
              ],
              [
                -70.486665,
                -33.540164
              ],
              [
                -70.486842,
                -33.540496
              ],
              [
                -70.486849,
                -33.540925
              ],
              [
                -70.486855,
                -33.541259
              ],
              [
                -70.486834,
                -33.54142
              ],
              [
                -70.486754,
                -33.542024
              ],
              [
                -70.486823,
                -33.542739
              ],
              [
                -70.486982,
                -33.543229
              ],
              [
                -70.487545,
                -33.54343
              ],
              [
                -70.487575,
                -33.543428
              ],
              [
                -70.48767,
                -33.543422
              ],
              [
                -70.487973,
                -33.543402
              ],
              [
                -70.488466,
                -33.543415
              ],
              [
                -70.488777,
                -33.543472
              ],
              [
                -70.48915,
                -33.543616
              ],
              [
                -70.489548,
                -33.543784
              ],
              [
                -70.489936,
                -33.543865
              ],
              [
                -70.490307,
                -33.54391
              ],
              [
                -70.490691,
                -33.544015
              ],
              [
                -70.491073,
                -33.544128
              ],
              [
                -70.491461,
                -33.544214
              ],
              [
                -70.491861,
                -33.544255
              ],
              [
                -70.492268,
                -33.544257
              ],
              [
                -70.492662,
                -33.544208
              ],
              [
                -70.493017,
                -33.544086
              ],
              [
                -70.493433,
                -33.544006
              ],
              [
                -70.493818,
                -33.543903
              ],
              [
                -70.494207,
                -33.543814
              ],
              [
                -70.494505,
                -33.543703
              ],
              [
                -70.494995,
                -33.543676
              ],
              [
                -70.495396,
                -33.543646
              ],
              [
                -70.495799,
                -33.543633
              ],
              [
                -70.496217,
                -33.543522
              ],
              [
                -70.49661,
                -33.543537
              ],
              [
                -70.496979,
                -33.543483
              ],
              [
                -70.497404,
                -33.543525
              ],
              [
                -70.497808,
                -33.543517
              ],
              [
                -70.498206,
                -33.543568
              ],
              [
                -70.498581,
                -33.543685
              ],
              [
                -70.498942,
                -33.543842
              ],
              [
                -70.499149,
                -33.544089
              ],
              [
                -70.499475,
                -33.544366
              ],
              [
                -70.499779,
                -33.544576
              ],
              [
                -70.500107,
                -33.544804
              ],
              [
                -70.50036,
                -33.544989
              ],
              [
                -70.500773,
                -33.545116
              ],
              [
                -70.50118,
                -33.545347
              ],
              [
                -70.501435,
                -33.545492
              ],
              [
                -70.501688,
                -33.545654
              ],
              [
                -70.501943,
                -33.545794
              ],
              [
                -70.502116,
                -33.545998
              ],
              [
                -70.502362,
                -33.546314
              ],
              [
                -70.502933,
                -33.546424
              ],
              [
                -70.503533,
                -33.546464
              ],
              [
                -70.504082,
                -33.546484
              ],
              [
                -70.504691,
                -33.546376
              ],
              [
                -70.505326,
                -33.546246
              ],
              [
                -70.507212,
                -33.545765
              ],
              [
                -70.509493,
                -33.545235
              ],
              [
                -70.510503,
                -33.544966
              ],
              [
                -70.511515,
                -33.544651
              ],
              [
                -70.512697,
                -33.544099
              ],
              [
                -70.513579,
                -33.543758
              ],
              [
                -70.514535,
                -33.543531
              ],
              [
                -70.51527,
                -33.54349
              ],
              [
                -70.515907,
                -33.543338
              ],
              [
                -70.516408,
                -33.543293
              ],
              [
                -70.516751,
                -33.543238
              ],
              [
                -70.517077,
                -33.543227
              ],
              [
                -70.517309,
                -33.543186
              ],
              [
                -70.517543,
                -33.543154
              ],
              [
                -70.517777,
                -33.543126
              ],
              [
                -70.518013,
                -33.543103
              ],
              [
                -70.518249,
                -33.543089
              ],
              [
                -70.518486,
                -33.543075
              ],
              [
                -70.518723,
                -33.54307
              ],
              [
                -70.518961,
                -33.543056
              ],
              [
                -70.519198,
                -33.543052
              ],
              [
                -70.519435,
                -33.543042
              ],
              [
                -70.519673,
                -33.543033
              ],
              [
                -70.519909,
                -33.543014
              ],
              [
                -70.520146,
                -33.542996
              ],
              [
                -70.520382,
                -33.542982
              ],
              [
                -70.520618,
                -33.542959
              ],
              [
                -70.520854,
                -33.542945
              ],
              [
                -70.521091,
                -33.542926
              ],
              [
                -70.521327,
                -33.542913
              ],
              [
                -70.521363,
                -33.542911
              ],
              [
                -70.521563,
                -33.542905
              ],
              [
                -70.52256,
                -33.542972
              ],
              [
                -70.523531,
                -33.543104
              ],
              [
                -70.524046,
                -33.543193
              ],
              [
                -70.524674,
                -33.54328
              ],
              [
                -70.525073,
                -33.543276
              ],
              [
                -70.525531,
                -33.543365
              ],
              [
                -70.526048,
                -33.543598
              ],
              [
                -70.52662,
                -33.543734
              ],
              [
                -70.527136,
                -33.543918
              ],
              [
                -70.527879,
                -33.544052
              ],
              [
                -70.528335,
                -33.544047
              ],
              [
                -70.529875,
                -33.544123
              ],
              [
                -70.530446,
                -33.544164
              ],
              [
                -70.531019,
                -33.544348
              ],
              [
                -70.531363,
                -33.544439
              ],
              [
                -70.531823,
                -33.544719
              ],
              [
                -70.532113,
                -33.545002
              ],
              [
                -70.532464,
                -33.545475
              ],
              [
                -70.532698,
                -33.545854
              ],
              [
                -70.532989,
                -33.546184
              ],
              [
                -70.53345,
                -33.546465
              ],
              [
                -70.533967,
                -33.546697
              ],
              [
                -70.534183,
                -33.546766
              ],
              [
                -70.53454,
                -33.546881
              ],
              [
                -70.534755,
                -33.547228
              ],
              [
                -70.535278,
                -33.547602
              ],
              [
                -70.5361,
                -33.548055
              ],
              [
                -70.536789,
                -33.548332
              ],
              [
                -70.537228,
                -33.5486
              ],
              [
                -70.537482,
                -33.548849
              ],
              [
                -70.537999,
                -33.549081
              ],
              [
                -70.538401,
                -33.549267
              ],
              [
                -70.538918,
                -33.549499
              ],
              [
                -70.539376,
                -33.549589
              ],
              [
                -70.539834,
                -33.549726
              ],
              [
                -70.540211,
                -33.549892
              ],
              [
                -70.540567,
                -33.550205
              ],
              [
                -70.541286,
                -33.550443
              ],
              [
                -70.543144,
                -33.550737
              ],
              [
                -70.543778,
                -33.55087
              ],
              [
                -70.544075,
                -33.551042
              ],
              [
                -70.544247,
                -33.551217
              ],
              [
                -70.544756,
                -33.551457
              ],
              [
                -70.545177,
                -33.551416
              ],
              [
                -70.545471,
                -33.551413
              ],
              [
                -70.545894,
                -33.551513
              ],
              [
                -70.546191,
                -33.551651
              ],
              [
                -70.546406,
                -33.551895
              ],
              [
                -70.546787,
                -33.552031
              ],
              [
                -70.547123,
                -33.551956
              ],
              [
                -70.547205,
                -33.551849
              ],
              [
                -70.547242,
                -33.551567
              ],
              [
                -70.547361,
                -33.551178
              ],
              [
                -70.547566,
                -33.550858
              ],
              [
                -70.548066,
                -33.550534
              ],
              [
                -70.548148,
                -33.550428
              ],
              [
                -70.54827,
                -33.550215
              ],
              [
                -70.548392,
                -33.549966
              ],
              [
                -70.548512,
                -33.549577
              ],
              [
                -70.548676,
                -33.549364
              ],
              [
                -70.549007,
                -33.549042
              ],
              [
                -70.549257,
                -33.548863
              ],
              [
                -70.549715,
                -33.54861
              ],
              [
                -70.550383,
                -33.54832
              ],
              [
                -70.550885,
                -33.548137
              ],
              [
                -70.551431,
                -33.548025
              ],
              [
                -70.552062,
                -33.548017
              ],
              [
                -70.552609,
                -33.54801
              ],
              [
                -70.552969,
                -33.548029
              ],
              [
                -70.5544,
                -33.547913
              ],
              [
                -70.556932,
                -33.547835
              ],
              [
                -70.557822,
                -33.547817
              ],
              [
                -70.55981,
                -33.547773
              ],
              [
                -70.56151,
                -33.547736
              ],
              [
                -70.563167,
                -33.547706
              ],
              [
                -70.565383,
                -33.547649
              ],
              [
                -70.568008,
                -33.547481
              ],
              [
                -70.568452,
                -33.547484
              ],
              [
                -70.568259,
                -33.54774
              ],
              [
                -70.568251,
                -33.547743
              ],
              [
                -70.568256,
                -33.547743
              ],
              [
                -70.563888,
                -33.552926
              ],
              [
                -70.562385,
                -33.554683
              ],
              [
                -70.560991,
                -33.556397
              ],
              [
                -70.559991,
                -33.557608
              ],
              [
                -70.55963,
                -33.558188
              ],
              [
                -70.559182,
                -33.558756
              ],
              [
                -70.55878,
                -33.559236
              ],
              [
                -70.557452,
                -33.560689
              ],
              [
                -70.557357,
                -33.560782
              ],
              [
                -70.557761,
                -33.560858
              ],
              [
                -70.56216,
                -33.561679
              ],
              [
                -70.563304,
                -33.561905
              ],
              [
                -70.563684,
                -33.561948
              ],
              [
                -70.564214,
                -33.562034
              ],
              [
                -70.564429,
                -33.562068
              ],
              [
                -70.56443,
                -33.562072
              ],
              [
                -70.566826,
                -33.562488
              ],
              [
                -70.567844,
                -33.562674
              ],
              [
                -70.568199,
                -33.562725
              ],
              [
                -70.568201,
                -33.562731
              ],
              [
                -70.56876,
                -33.562831
              ],
              [
                -70.56908,
                -33.562888
              ],
              [
                -70.569381,
                -33.562939
              ],
              [
                -70.569731,
                -33.563
              ],
              [
                -70.570135,
                -33.563072
              ],
              [
                -70.570522,
                -33.563137
              ],
              [
                -70.570895,
                -33.563204
              ],
              [
                -70.571269,
                -33.563271
              ],
              [
                -70.571942,
                -33.563386
              ],
              [
                -70.573304,
                -33.563629
              ],
              [
                -70.574867,
                -33.563912
              ],
              [
                -70.576238,
                -33.564156
              ],
              [
                -70.577196,
                -33.564324
              ],
              [
                -70.577471,
                -33.564375
              ],
              [
                -70.577745,
                -33.564426
              ],
              [
                -70.578018,
                -33.564474
              ],
              [
                -70.578296,
                -33.564523
              ],
              [
                -70.578573,
                -33.564573
              ],
              [
                -70.578668,
                -33.564591
              ],
              [
                -70.578769,
                -33.564609
              ],
              [
                -70.57905,
                -33.564659
              ],
              [
                -70.579402,
                -33.564721
              ],
              [
                -70.579559,
                -33.564749
              ],
              [
                -70.57992,
                -33.564803
              ],
              [
                -70.580198,
                -33.564854
              ],
              [
                -70.580467,
                -33.564904
              ],
              [
                -70.580748,
                -33.564955
              ],
              [
                -70.58102,
                -33.565003
              ],
              [
                -70.582233,
                -33.565215
              ],
              [
                -70.583871,
                -33.565519
              ],
              [
                -70.584473,
                -33.565584
              ],
              [
                -70.584413,
                -33.565968
              ],
              [
                -70.583858,
                -33.568874
              ],
              [
                -70.583738,
                -33.569456
              ],
              [
                -70.58417,
                -33.569506
              ],
              [
                -70.58417,
                -33.569506
              ],
              [
                -70.584174,
                -33.569506
              ],
              [
                -70.586383,
                -33.569761
              ],
              [
                -70.588466,
                -33.569995
              ],
              [
                -70.588503,
                -33.569772
              ],
              [
                -70.59224,
                -33.570117
              ],
              [
                -70.593381,
                -33.569682
              ],
              [
                -70.594675,
                -33.569159
              ],
              [
                -70.595399,
                -33.568861
              ],
              [
                -70.595812,
                -33.568693
              ],
              [
                -70.596519,
                -33.568432
              ],
              [
                -70.597365,
                -33.568087
              ],
              [
                -70.597732,
                -33.567911
              ],
              [
                -70.598306,
                -33.567489
              ],
              [
                -70.598799,
                -33.567293
              ],
              [
                -70.599327,
                -33.56725
              ],
              [
                -70.599949,
                -33.567296
              ],
              [
                -70.600741,
                -33.567502
              ],
              [
                -70.602206,
                -33.567936
              ],
              [
                -70.603601,
                -33.568331
              ],
              [
                -70.605576,
                -33.568862
              ],
              [
                -70.605901,
                -33.56888
              ],
              [
                -70.606811,
                -33.569112
              ],
              [
                -70.607332,
                -33.569267
              ],
              [
                -70.611144,
                -33.570546
              ],
              [
                -70.611271,
                -33.570566
              ],
              [
                -70.611332,
                -33.570152
              ],
              [
                -70.61144,
                -33.569432
              ],
              [
                -70.611806,
                -33.566944
              ],
              [
                -70.612217,
                -33.564127
              ],
              [
                -70.612502,
                -33.562232
              ],
              [
                -70.612512,
                -33.562204
              ],
              [
                -70.612494,
                -33.562204
              ],
              [
                -70.612516,
                -33.562184
              ],
              [
                -70.610721,
                -33.562002
              ],
              [
                -70.610721,
                -33.562001
              ],
              [
                -70.61044,
                -33.561963
              ],
              [
                -70.610702,
                -33.561019
              ],
              [
                -70.611694,
                -33.557546
              ],
              [
                -70.611916,
                -33.556772
              ],
              [
                -70.612231,
                -33.555611
              ],
              [
                -70.612602,
                -33.554427
              ],
              [
                -70.612691,
                -33.554064
              ],
              [
                -70.612909,
                -33.553308
              ],
              [
                -70.613705,
                -33.550482
              ],
              [
                -70.61403,
                -33.549339
              ],
              [
                -70.614215,
                -33.548695
              ],
              [
                -70.61448,
                -33.547791
              ],
              [
                -70.614572,
                -33.547478
              ],
              [
                -70.614654,
                -33.547193
              ],
              [
                -70.614815,
                -33.546662
              ],
              [
                -70.614809,
                -33.546663
              ],
              [
                -70.614818,
                -33.546653
              ],
              [
                -70.614857,
                -33.546523
              ],
              [
                -70.614824,
                -33.546397
              ],
              [
                -70.614464,
                -33.546474
              ],
              [
                -70.614036,
                -33.546543
              ],
              [
                -70.61371,
                -33.546569
              ],
              [
                -70.61298,
                -33.546593
              ],
              [
                -70.612537,
                -33.546599
              ],
              [
                -70.611391,
                -33.546631
              ],
              [
                -70.610941,
                -33.546645
              ],
              [
                -70.610937,
                -33.54665
              ],
              [
                -70.610559,
                -33.546654
              ],
              [
                -70.61044,
                -33.54333
              ],
              [
                -70.610312,
                -33.539754
              ],
              [
                -70.610318,
                -33.539019
              ],
              [
                -70.610134,
                -33.537387
              ],
              [
                -70.610041,
                -33.534793
              ],
              [
                -70.609986,
                -33.533153
              ],
              [
                -70.609822,
                -33.52843
              ],
              [
                -70.609749,
                -33.526187
              ],
              [
                -70.609984,
                -33.524118
              ],
              [
                -70.610129,
                -33.522846
              ],
              [
                -70.61036,
                -33.520811
              ],
              [
                -70.610655,
                -33.518477
              ],
              [
                -70.610924,
                -33.51615
              ],
              [
                -70.611025,
                -33.515193
              ],
              [
                -70.611309,
                -33.512669
              ],
              [
                -70.611309,
                -33.512669
              ],
              [
                -70.611351,
                -33.512307
              ],
              [
                -70.611529,
                -33.510875
              ],
              [
                -70.611516,
                -33.510868
              ],
              [
                -70.611562,
                -33.510388
              ],
              [
                -70.611642,
                -33.510297
              ],
              [
                -70.612859,
                -33.509143
              ],
              [
                -70.61313,
                -33.508888
              ],
              [
                -70.61355,
                -33.508474
              ],
              [
                -70.613594,
                -33.508427
              ],
              [
                -70.613594,
                -33.508427
              ],
              [
                -70.613663,
                -33.508351
              ],
              [
                -70.612923,
                -33.508364
              ],
              [
                -70.612273,
                -33.508384
              ],
              [
                -70.610634,
                -33.508414
              ],
              [
                -70.604309,
                -33.508882
              ],
              [
                -70.601892,
                -33.509038
              ],
              [
                -70.599304,
                -33.509298
              ],
              [
                -70.597509,
                -33.50943
              ],
              [
                -70.5938,
                -33.50971
              ],
              [
                -70.591987,
                -33.509829
              ],
              [
                -70.591406,
                -33.509944
              ],
              [
                -70.59016,
                -33.510145
              ],
              [
                -70.590003,
                -33.510157
              ],
              [
                -70.588983,
                -33.510233
              ],
              [
                -70.588179,
                -33.510292
              ],
              [
                -70.587954,
                -33.510168
              ],
              [
                -70.5871,
                -33.510042
              ],
              [
                -70.58501,
                -33.510194
              ],
              [
                -70.579929,
                -33.510642
              ],
              [
                -70.576158,
                -33.510762
              ],
              [
                -70.574636,
                -33.510959
              ],
              [
                -70.572593,
                -33.511181
              ],
              [
                -70.571051,
                -33.511308
              ],
              [
                -70.570663,
                -33.511366
              ],
              [
                -70.566434,
                -33.511637
              ],
              [
                -70.56559,
                -33.511542
              ],
              [
                -70.564705,
                -33.511447
              ],
              [
                -70.561552,
                -33.511628
              ],
              [
                -70.560724,
                -33.511678
              ],
              [
                -70.557097,
                -33.511896
              ],
              [
                -70.555078,
                -33.512081
              ],
              [
                -70.554931,
                -33.512032
              ],
              [
                -70.551823,
                -33.512167
              ],
              [
                -70.550676,
                -33.512208
              ],
              [
                -70.548884,
                -33.512312
              ],
              [
                -70.546703,
                -33.51242
              ],
              [
                -70.545075,
                -33.512483
              ],
              [
                -70.544464,
                -33.512435
              ],
              [
                -70.543814,
                -33.512411
              ],
              [
                -70.542676,
                -33.512485
              ],
              [
                -70.542012,
                -33.512533
              ],
              [
                -70.541708,
                -33.512531
              ],
              [
                -70.541444,
                -33.51244
              ],
              [
                -70.541173,
                -33.512368
              ],
              [
                -70.540635,
                -33.512337
              ],
              [
                -70.539916,
                -33.512271
              ],
              [
                -70.539331,
                -33.512166
              ],
              [
                -70.53888,
                -33.512059
              ],
              [
                -70.538337,
                -33.511802
              ],
              [
                -70.537793,
                -33.511471
              ],
              [
                -70.537206,
                -33.511253
              ],
              [
                -70.536125,
                -33.510966
              ],
              [
                -70.532246,
                -33.509774
              ],
              [
                -70.531568,
                -33.509481
              ],
              [
                -70.530847,
                -33.509302
              ],
              [
                -70.529902,
                -33.509089
              ],
              [
                -70.528503,
                -33.508617
              ],
              [
                -70.527737,
                -33.508439
              ],
              [
                -70.527018,
                -33.508335
              ],
              [
                -70.526389,
                -33.508268
              ],
              [
                -70.525671,
                -33.508277
              ],
              [
                -70.525134,
                -33.508321
              ],
              [
                -70.52464,
                -33.508289
              ],
              [
                -70.524141,
                -33.507995
              ],
              [
                -70.523868,
                -33.507735
              ],
              [
                -70.522955,
                -33.506845
              ],
              [
                -70.522136,
                -33.506178
              ],
              [
                -70.519419,
                -33.504709
              ],
              [
                -70.518418,
                -33.503894
              ],
              [
                -70.517828,
                -33.503488
              ],
              [
                -70.517461,
                -33.503004
              ],
              [
                -70.517275,
                -33.502668
              ],
              [
                -70.517046,
                -33.502408
              ],
              [
                -70.516729,
                -33.502187
              ],
              [
                -70.516322,
                -33.502004
              ],
              [
                -70.516007,
                -33.501932
              ],
              [
                -70.515333,
                -33.501866
              ],
              [
                -70.514749,
                -33.501835
              ],
              [
                -70.514164,
                -33.501692
              ],
              [
                -70.513579,
                -33.501586
              ],
              [
                -70.513084,
                -33.50148
              ],
              [
                -70.512498,
                -33.501337
              ],
              [
                -70.5116,
                -33.50131
              ],
              [
                -70.511152,
                -33.501316
              ],
              [
                -70.509984,
                -33.501179
              ],
              [
                -70.509443,
                -33.501036
              ],
              [
                -70.508631,
                -33.500745
              ],
              [
                -70.507324,
                -33.500423
              ],
              [
                -70.506918,
                -33.500277
              ],
              [
                -70.506557,
                -33.500131
              ],
              [
                -70.506016,
                -33.499988
              ],
              [
                -70.504893,
                -33.499851
              ],
              [
                -70.504352,
                -33.499707
              ],
              [
                -70.503499,
                -33.499643
              ],
              [
                -70.502915,
                -33.499612
              ],
              [
                -70.502289,
                -33.499695
              ],
              [
                -70.501621,
                -33.500003
              ],
              [
                -70.501356,
                -33.500232
              ],
              [
                -70.500865,
                -33.500388
              ],
              [
                -70.500503,
                -33.500205
              ],
              [
                -70.500496,
                -33.499754
              ],
              [
                -70.500667,
                -33.499264
              ],
              [
                -70.500657,
                -33.498738
              ],
              [
                -70.500562,
                -33.498438
              ],
              [
                -70.500378,
                -33.49814
              ],
              [
                -70.50015,
                -33.497917
              ],
              [
                -70.499744,
                -33.497809
              ],
              [
                -70.499206,
                -33.497778
              ],
              [
                -70.498404,
                -33.498089
              ],
              [
                -70.497649,
                -33.498549
              ],
              [
                -70.497118,
                -33.498931
              ],
              [
                -70.496541,
                -33.499276
              ],
              [
                -70.495917,
                -33.499509
              ],
              [
                -70.495559,
                -33.499551
              ],
              [
                -70.495021,
                -33.499557
              ],
              [
                -70.494348,
                -33.499565
              ],
              [
                -70.493675,
                -33.499574
              ],
              [
                -70.493228,
                -33.499654
              ],
              [
                -70.492871,
                -33.499734
              ],
              [
                -70.492517,
                -33.500038
              ],
              [
                -70.492388,
                -33.500378
              ],
              [
                -70.492349,
                -33.500717
              ],
              [
                -70.492039,
                -33.500946
              ],
              [
                -70.491727,
                -33.501062
              ],
              [
                -70.491368,
                -33.501029
              ],
              [
                -70.491052,
                -33.500883
              ],
              [
                -70.490735,
                -33.500736
              ],
              [
                -70.490421,
                -33.500702
              ],
              [
                -70.489883,
                -33.500709
              ],
              [
                -70.489438,
                -33.50094
              ],
              [
                -70.489263,
                -33.501167
              ],
              [
                -70.488955,
                -33.501547
              ],
              [
                -70.488374,
                -33.501666
              ],
              [
                -70.486221,
                -33.501655
              ],
              [
                -70.485682,
                -33.501624
              ],
              [
                -70.485231,
                -33.501441
              ],
              [
                -70.48491,
                -33.501069
              ],
              [
                -70.484728,
                -33.500884
              ],
              [
                -70.484722,
                -33.500545
              ],
              [
                -70.484671,
                -33.500208
              ],
              [
                -70.484533,
                -33.499984
              ],
              [
                -70.48435,
                -33.499761
              ],
              [
                -70.484033,
                -33.499577
              ],
              [
                -70.483627,
                -33.499469
              ],
              [
                -70.483176,
                -33.499324
              ],
              [
                -70.482949,
                -33.499176
              ],
              [
                -70.482676,
                -33.498917
              ],
              [
                -70.482493,
                -33.498731
              ],
              [
                -70.482175,
                -33.498472
              ],
              [
                -70.481768,
                -33.498289
              ],
              [
                -70.481451,
                -33.498105
              ],
              [
                -70.481267,
                -33.497806
              ],
              [
                -70.481082,
                -33.497508
              ],
              [
                -70.480765,
                -33.497324
              ],
              [
                -70.480136,
                -33.497219
              ],
              [
                -70.479594,
                -33.497
              ],
              [
                -70.479278,
                -33.496891
              ],
              [
                -70.478916,
                -33.496707
              ],
              [
                -70.478555,
                -33.496561
              ],
              [
                -70.478056,
                -33.496229
              ],
              [
                -70.477872,
                -33.495968
              ],
              [
                -70.477507,
                -33.495634
              ],
              [
                -70.47719,
                -33.49545
              ],
              [
                -70.476785,
                -33.495342
              ],
              [
                -70.475842,
                -33.495278
              ],
              [
                -70.474855,
                -33.495252
              ],
              [
                -70.474315,
                -33.495184
              ],
              [
                -70.473867,
                -33.495152
              ],
              [
                -70.473419,
                -33.495194
              ],
              [
                -70.473015,
                -33.495162
              ],
              [
                -70.472743,
                -33.495015
              ],
              [
                -70.472427,
                -33.494868
              ],
              [
                -70.471978,
                -33.494836
              ],
              [
                -70.47171,
                -33.494914
              ],
              [
                -70.471221,
                -33.495183
              ],
              [
                -70.47064,
                -33.495303
              ],
              [
                -70.470329,
                -33.495457
              ],
              [
                -70.469969,
                -33.495386
              ],
              [
                -70.469517,
                -33.495166
              ],
              [
                -70.469059,
                -33.494645
              ],
              [
                -70.468412,
                -33.493488
              ],
              [
                -70.467907,
                -33.492817
              ],
              [
                -70.467497,
                -33.492447
              ],
              [
                -70.467,
                -33.492227
              ],
              [
                -70.466729,
                -33.492118
              ],
              [
                -70.466281,
                -33.492123
              ],
              [
                -70.46579,
                -33.492279
              ],
              [
                -70.4653,
                -33.492435
              ],
              [
                -70.464494,
                -33.49252
              ],
              [
                -70.463775,
                -33.492415
              ],
              [
                -70.46346,
                -33.492382
              ],
              [
                -70.463101,
                -33.492386
              ],
              [
                -70.462701,
                -33.492578
              ],
              [
                -70.462481,
                -33.492844
              ],
              [
                -70.462218,
                -33.493185
              ],
              [
                -70.461999,
                -33.493526
              ],
              [
                -70.461689,
                -33.493755
              ],
              [
                -70.46111,
                -33.493987
              ],
              [
                -70.460664,
                -33.494143
              ],
              [
                -70.459726,
                -33.494342
              ],
              [
                -70.459278,
                -33.494347
              ],
              [
                -70.458741,
                -33.494429
              ],
              [
                -70.458297,
                -33.494697
              ],
              [
                -70.457721,
                -33.495117
              ],
              [
                -70.457053,
                -33.495388
              ],
              [
                -70.456026,
                -33.495663
              ],
              [
                -70.454547,
                -33.495718
              ],
              [
                -70.453652,
                -33.495841
              ],
              [
                -70.453157,
                -33.495772
              ],
              [
                -70.452708,
                -33.49574
              ],
              [
                -70.452484,
                -33.495742
              ],
              [
                -70.452038,
                -33.49586
              ],
              [
                -70.451635,
                -33.495902
              ],
              [
                -70.451097,
                -33.495909
              ],
              [
                -70.450781,
                -33.495837
              ],
              [
                -70.4506,
                -33.495689
              ],
              [
                -70.450371,
                -33.495429
              ],
              [
                -70.450098,
                -33.495169
              ],
              [
                -70.449826,
                -33.495022
              ],
              [
                -70.44942,
                -33.494876
              ],
              [
                -70.449059,
                -33.49473
              ],
              [
                -70.448606,
                -33.494473
              ],
              [
                -70.448288,
                -33.494213
              ],
              [
                -70.447791,
                -33.493993
              ],
              [
                -70.447339,
                -33.493811
              ],
              [
                -70.4468,
                -33.493742
              ],
              [
                -70.446079,
                -33.493525
              ],
              [
                -70.445491,
                -33.493231
              ],
              [
                -70.444993,
                -33.492974
              ],
              [
                -70.444585,
                -33.492678
              ],
              [
                -70.443954,
                -33.492498
              ],
              [
                -70.443189,
                -33.492319
              ],
              [
                -70.442245,
                -33.492217
              ],
              [
                -70.4413,
                -33.49204
              ],
              [
                -70.440359,
                -33.492051
              ],
              [
                -70.439462,
                -33.492062
              ]
            ]
          ],
          "type": "Polygon"
        },
        "properties": {
          "CIR_SENA": 8,
          "COD_COMUNA": 1311,
          "DIS_ELEC": 26,
          "NOM_COM": "La Florida",
          "NOM_PROV": "Santiago",
          "NOM_REG": "Región Metropolitana de Santiago",
          "SHAPE_Area": 71037326.9664,
          "SHAPE_LENG": 49696.426792,
          "SHAPE_Le_1": 49621.402174
        },
        "type": "Feature",
        "crs": {
          "properties": {
            "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
          },
          "type": "name"
        }
      },
      {
        "geometry": {
          "coordinates": [
            [
              [
                -70.579444,
                -33.35201
              ],
              [
                -70.578946,
                -33.352016
              ],
              [
                -70.578531,
                -33.352022
              ],
              [
                -70.577826,
                -33.352065
              ],
              [
                -70.577164,
                -33.352178
              ],
              [
                -70.576134,
                -33.35261
              ],
              [
                -70.575395,
                -33.353072
              ],
              [
                -70.574826,
                -33.353776
              ],
              [
                -70.574094,
                -33.354621
              ],
              [
                -70.573404,
                -33.355501
              ],
              [
                -70.57287,
                -33.355787
              ],
              [
                -70.572126,
                -33.35597
              ],
              [
                -70.571545,
                -33.355977
              ],
              [
                -70.57092,
                -33.355846
              ],
              [
                -70.570253,
                -33.355715
              ],
              [
                -70.568755,
                -33.355525
              ],
              [
                -70.56809,
                -33.355499
              ],
              [
                -70.567591,
                -33.35547
              ],
              [
                -70.566847,
                -33.355654
              ],
              [
                -70.566106,
                -33.355977
              ],
              [
                -70.565697,
                -33.35633
              ],
              [
                -70.565373,
                -33.356752
              ],
              [
                -70.5648,
                -33.357247
              ],
              [
                -70.564142,
                -33.357604
              ],
              [
                -70.56253,
                -33.357973
              ],
              [
                -70.560256,
                -33.358524
              ],
              [
                -70.559345,
                -33.358675
              ],
              [
                -70.558267,
                -33.358758
              ],
              [
                -70.557728,
                -33.3588
              ],
              [
                -70.55742,
                -33.358881
              ],
              [
                -70.556293,
                -33.358896
              ],
              [
                -70.55484,
                -33.35887
              ],
              [
                -70.552771,
                -33.359201
              ],
              [
                -70.550335,
                -33.359275
              ],
              [
                -70.54962,
                -33.359937
              ],
              [
                -70.548903,
                -33.360468
              ],
              [
                -70.548665,
                -33.36169
              ],
              [
                -70.547719,
                -33.363878
              ],
              [
                -70.546905,
                -33.364803
              ],
              [
                -70.544845,
                -33.366118
              ],
              [
                -70.543782,
                -33.367149
              ],
              [
                -70.54251,
                -33.368557
              ],
              [
                -70.541389,
                -33.369747
              ],
              [
                -70.541184,
                -33.370068
              ],
              [
                -70.540618,
                -33.370267
              ],
              [
                -70.539584,
                -33.370523
              ],
              [
                -70.538089,
                -33.370507
              ],
              [
                -70.53622,
                -33.370495
              ],
              [
                -70.535389,
                -33.370471
              ],
              [
                -70.534226,
                -33.37045
              ],
              [
                -70.533065,
                -33.370569
              ],
              [
                -70.531986,
                -33.370583
              ],
              [
                -70.531073,
                -33.370629
              ],
              [
                -70.530326,
                -33.370603
              ],
              [
                -70.529681,
                -33.370526
              ],
              [
                -70.529582,
                -33.370524
              ],
              [
                -70.5285,
                -33.370356
              ],
              [
                -70.527537,
                -33.370187
              ],
              [
                -70.526645,
                -33.369916
              ],
              [
                -70.525513,
                -33.369648
              ],
              [
                -70.524863,
                -33.369495
              ],
              [
                -70.524431,
                -33.36944
              ],
              [
                -70.523999,
                -33.369426
              ],
              [
                -70.523663,
                -33.36945
              ],
              [
                -70.523306,
                -33.369595
              ],
              [
                -70.523045,
                -33.369739
              ],
              [
                -70.5224,
                -33.369908
              ],
              [
                -70.52173,
                -33.370017
              ],
              [
                -70.521085,
                -33.370145
              ],
              [
                -70.520463,
                -33.370214
              ],
              [
                -70.520241,
                -33.370244
              ],
              [
                -70.519922,
                -33.37033
              ],
              [
                -70.519471,
                -33.370365
              ],
              [
                -70.518495,
                -33.371378
              ],
              [
                -70.517689,
                -33.372578
              ],
              [
                -70.517573,
                -33.372763
              ],
              [
                -70.517867,
                -33.372897
              ],
              [
                -70.52241,
                -33.37496
              ],
              [
                -70.524944,
                -33.375874
              ],
              [
                -70.525325,
                -33.376205
              ],
              [
                -70.525986,
                -33.376516
              ],
              [
                -70.527093,
                -33.377147
              ],
              [
                -70.527613,
                -33.377565
              ],
              [
                -70.527941,
                -33.377888
              ],
              [
                -70.528748,
                -33.378649
              ],
              [
                -70.529351,
                -33.379516
              ],
              [
                -70.5301,
                -33.380073
              ],
              [
                -70.530844,
                -33.380758
              ],
              [
                -70.532348,
                -33.382167
              ],
              [
                -70.532351,
                -33.382168
              ],
              [
                -70.533885,
                -33.383816
              ],
              [
                -70.534942,
                -33.384142
              ],
              [
                -70.53734,
                -33.385364
              ],
              [
                -70.541796,
                -33.387349
              ],
              [
                -70.543428,
                -33.388143
              ],
              [
                -70.54379,
                -33.388282
              ],
              [
                -70.545223,
                -33.388797
              ],
              [
                -70.545957,
                -33.389023
              ],
              [
                -70.547234,
                -33.389508
              ],
              [
                -70.547435,
                -33.389701
              ],
              [
                -70.548278,
                -33.390077
              ],
              [
                -70.549436,
                -33.39052
              ],
              [
                -70.549683,
                -33.390616
              ],
              [
                -70.550802,
                -33.391062
              ],
              [
                -70.551394,
                -33.39129
              ],
              [
                -70.552489,
                -33.391711
              ],
              [
                -70.552536,
                -33.391772
              ],
              [
                -70.553318,
                -33.39198
              ],
              [
                -70.554137,
                -33.392324
              ],
              [
                -70.554501,
                -33.392456
              ],
              [
                -70.556616,
                -33.393193
              ],
              [
                -70.558735,
                -33.393915
              ],
              [
                -70.561534,
                -33.394896
              ],
              [
                -70.561611,
                -33.394955
              ],
              [
                -70.565831,
                -33.39632
              ],
              [
                -70.569749,
                -33.397489
              ],
              [
                -70.571614,
                -33.398045
              ],
              [
                -70.571943,
                -33.398143
              ],
              [
                -70.586508,
                -33.404113
              ],
              [
                -70.586644,
                -33.404168
              ],
              [
                -70.58685,
                -33.404228
              ],
              [
                -70.594149,
                -33.406338
              ],
              [
                -70.59595,
                -33.407
              ],
              [
                -70.59778,
                -33.407672
              ],
              [
                -70.59861,
                -33.408056
              ],
              [
                -70.599163,
                -33.408246
              ],
              [
                -70.599674,
                -33.408338
              ],
              [
                -70.600341,
                -33.408363
              ],
              [
                -70.601165,
                -33.408385
              ],
              [
                -70.601674,
                -33.408378
              ],
              [
                -70.602263,
                -33.408404
              ],
              [
                -70.603759,
                -33.408779
              ],
              [
                -70.604587,
                -33.408998
              ],
              [
                -70.605493,
                -33.409282
              ],
              [
                -70.605869,
                -33.409278
              ],
              [
                -70.605924,
                -33.409277
              ],
              [
                -70.614542,
                -33.409165
              ],
              [
                -70.614374,
                -33.409082
              ],
              [
                -70.612617,
                -33.408373
              ],
              [
                -70.612111,
                -33.407996
              ],
              [
                -70.611771,
                -33.407583
              ],
              [
                -70.611473,
                -33.407169
              ],
              [
                -70.610962,
                -33.406478
              ],
              [
                -70.610784,
                -33.405853
              ],
              [
                -70.610561,
                -33.40502
              ],
              [
                -70.610561,
                -33.405017
              ],
              [
                -70.61054,
                -33.403906
              ],
              [
                -70.610486,
                -33.40321
              ],
              [
                -70.610391,
                -33.402584
              ],
              [
                -70.610071,
                -33.400985
              ],
              [
                -70.60929,
                -33.399184
              ],
              [
                -70.608937,
                -33.398038
              ],
              [
                -70.608541,
                -33.396859
              ],
              [
                -70.60743,
                -33.395166
              ],
              [
                -70.605856,
                -33.393166
              ],
              [
                -70.602984,
                -33.39052
              ],
              [
                -70.602265,
                -33.389833
              ],
              [
                -70.601712,
                -33.389143
              ],
              [
                -70.601451,
                -33.388485
              ],
              [
                -70.601521,
                -33.387752
              ],
              [
                -70.602,
                -33.386736
              ],
              [
                -70.602456,
                -33.386322
              ],
              [
                -70.602817,
                -33.385993
              ],
              [
                -70.603262,
                -33.385326
              ],
              [
                -70.603658,
                -33.384275
              ],
              [
                -70.60389,
                -33.383366
              ],
              [
                -70.603883,
                -33.382948
              ],
              [
                -70.603618,
                -33.382116
              ],
              [
                -70.602895,
                -33.381184
              ],
              [
                -70.601001,
                -33.379815
              ],
              [
                -70.600496,
                -33.379404
              ],
              [
                -70.600156,
                -33.37899
              ],
              [
                -70.60002,
                -33.378365
              ],
              [
                -70.600002,
                -33.377424
              ],
              [
                -70.600103,
                -33.376134
              ],
              [
                -70.600089,
                -33.375333
              ],
              [
                -70.599821,
                -33.374326
              ],
              [
                -70.599087,
                -33.372802
              ],
              [
                -70.598198,
                -33.371873
              ],
              [
                -70.597777,
                -33.371565
              ],
              [
                -70.597605,
                -33.371219
              ],
              [
                -70.597556,
                -33.370801
              ],
              [
                -70.597623,
                -33.369929
              ],
              [
                -70.597466,
                -33.368189
              ],
              [
                -70.597448,
                -33.367179
              ],
              [
                -70.597354,
                -33.366553
              ],
              [
                -70.597345,
                -33.3661
              ],
              [
                -70.59734,
                -33.365787
              ],
              [
                -70.597746,
                -33.365294
              ],
              [
                -70.598688,
                -33.364585
              ],
              [
                -70.599588,
                -33.363876
              ],
              [
                -70.600611,
                -33.363027
              ],
              [
                -70.601062,
                -33.362708
              ],
              [
                -70.600139,
                -33.362232
              ],
              [
                -70.59909,
                -33.361583
              ],
              [
                -70.598334,
                -33.361105
              ],
              [
                -70.597367,
                -33.360456
              ],
              [
                -70.596898,
                -33.3598
              ],
              [
                -70.596723,
                -33.359314
              ],
              [
                -70.596383,
                -33.358866
              ],
              [
                -70.595837,
                -33.358525
              ],
              [
                -70.595038,
                -33.357977
              ],
              [
                -70.594488,
                -33.357392
              ],
              [
                -70.594024,
                -33.357015
              ],
              [
                -70.593602,
                -33.356637
              ],
              [
                -70.593264,
                -33.356293
              ],
              [
                -70.593008,
                -33.355913
              ],
              [
                -70.592627,
                -33.355535
              ],
              [
                -70.59204,
                -33.355229
              ],
              [
                -70.590829,
                -33.354861
              ],
              [
                -70.589787,
                -33.35463
              ],
              [
                -70.589081,
                -33.35457
              ],
              [
                -70.588375,
                -33.354579
              ],
              [
                -70.587793,
                -33.354551
              ],
              [
                -70.587252,
                -33.354454
              ],
              [
                -70.586833,
                -33.35425
              ],
              [
                -70.586368,
                -33.353803
              ],
              [
                -70.586028,
                -33.353389
              ],
              [
                -70.585817,
                -33.353148
              ],
              [
                -70.585606,
                -33.353012
              ],
              [
                -70.585147,
                -33.352878
              ],
              [
                -70.584689,
                -33.352779
              ],
              [
                -70.584188,
                -33.352611
              ],
              [
                -70.58381,
                -33.352407
              ],
              [
                -70.583471,
                -33.351994
              ],
              [
                -70.583133,
                -33.351684
              ],
              [
                -70.582754,
                -33.351376
              ],
              [
                -70.582624,
                -33.351098
              ],
              [
                -70.582515,
                -33.350965
              ],
              [
                -70.581961,
                -33.351177
              ],
              [
                -70.581342,
                -33.351359
              ],
              [
                -70.580767,
                -33.351714
              ],
              [
                -70.580149,
                -33.351966
              ],
              [
                -70.579444,
                -33.35201
              ]
            ]
          ],
          "type": "Polygon"
        },
        "properties": {
          "CIR_SENA": 8,
          "COD_COMUNA": 1313,
          "DIS_ELEC": 23,
          "NOM_COM": "Vitacura",
          "NOM_PROV": "Santiago",
          "NOM_REG": "Región Metropolitana de Santiago",
          "SHAPE_Area": 28668485.1847,
          "SHAPE_LENG": 25316.04602,
          "SHAPE_Le_1": 25555.323821
        },
        "type": "Feature",
        "crs": {
          "properties": {
            "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
          },
          "type": "name"
        }
      },
      {
        "geometry": {
          "coordinates": [
            [
              [
                -70.689282,
                -33.366237
              ],
              [
                -70.689206,
                -33.365574
              ],
              [
                -70.689281,
                -33.3648
              ],
              [
                -70.689438,
                -33.363803
              ],
              [
                -70.690116,
                -33.361548
              ],
              [
                -70.690542,
                -33.360397
              ],
              [
                -70.690701,
                -33.359926
              ],
              [
                -70.690996,
                -33.35911
              ],
              [
                -70.691475,
                -33.357769
              ],
              [
                -70.691931,
                -33.356347
              ],
              [
                -70.692045,
                -33.355858
              ],
              [
                -70.692175,
                -33.35563
              ],
              [
                -70.692269,
                -33.355255
              ],
              [
                -70.692447,
                -33.354294
              ],
              [
                -70.692554,
                -33.353762
              ],
              [
                -70.6928,
                -33.352915
              ],
              [
                -70.692979,
                -33.352462
              ],
              [
                -70.693193,
                -33.351988
              ],
              [
                -70.693358,
                -33.351607
              ],
              [
                -70.692523,
                -33.350892
              ],
              [
                -70.690346,
                -33.349171
              ],
              [
                -70.688691,
                -33.347491
              ],
              [
                -70.688552,
                -33.346906
              ],
              [
                -70.688343,
                -33.346579
              ],
              [
                -70.688098,
                -33.346178
              ],
              [
                -70.687952,
                -33.345858
              ],
              [
                -70.687845,
                -33.345557
              ],
              [
                -70.687764,
                -33.345135
              ],
              [
                -70.687694,
                -33.3447
              ],
              [
                -70.687652,
                -33.344321
              ],
              [
                -70.687607,
                -33.344004
              ],
              [
                -70.6876,
                -33.343742
              ],
              [
                -70.687605,
                -33.343431
              ],
              [
                -70.687618,
                -33.343171
              ],
              [
                -70.68758,
                -33.342904
              ],
              [
                -70.687445,
                -33.342552
              ],
              [
                -70.687204,
                -33.342282
              ],
              [
                -70.686824,
                -33.342012
              ],
              [
                -70.686446,
                -33.341706
              ],
              [
                -70.686161,
                -33.341408
              ],
              [
                -70.685854,
                -33.341145
              ],
              [
                -70.685622,
                -33.340916
              ],
              [
                -70.685248,
                -33.340678
              ],
              [
                -70.684628,
                -33.340472
              ],
              [
                -70.683906,
                -33.340294
              ],
              [
                -70.683205,
                -33.340089
              ],
              [
                -70.682688,
                -33.339873
              ],
              [
                -70.682225,
                -33.339577
              ],
              [
                -70.681764,
                -33.339246
              ],
              [
                -70.68135,
                -33.338993
              ],
              [
                -70.680859,
                -33.338669
              ],
              [
                -70.680406,
                -33.338379
              ],
              [
                -70.680202,
                -33.338074
              ],
              [
                -70.680088,
                -33.337733
              ],
              [
                -70.680097,
                -33.337548
              ],
              [
                -70.680289,
                -33.337186
              ],
              [
                -70.680614,
                -33.336796
              ],
              [
                -70.680851,
                -33.336435
              ],
              [
                -70.680999,
                -33.336075
              ],
              [
                -70.681147,
                -33.335751
              ],
              [
                -70.681163,
                -33.335419
              ],
              [
                -70.680965,
                -33.335011
              ],
              [
                -70.680896,
                -33.334639
              ],
              [
                -70.680876,
                -33.334165
              ],
              [
                -70.680939,
                -33.333762
              ],
              [
                -70.681052,
                -33.333252
              ],
              [
                -70.681199,
                -33.332929
              ],
              [
                -70.681297,
                -33.332711
              ],
              [
                -70.681442,
                -33.332424
              ],
              [
                -70.681548,
                -33.332058
              ],
              [
                -70.681518,
                -33.331764
              ],
              [
                -70.681408,
                -33.331359
              ],
              [
                -70.681291,
                -33.330999
              ],
              [
                -70.681064,
                -33.33101
              ],
              [
                -70.680545,
                -33.330811
              ],
              [
                -70.68008,
                -33.330574
              ],
              [
                -70.67962,
                -33.330248
              ],
              [
                -70.679155,
                -33.330011
              ],
              [
                -70.678583,
                -33.329811
              ],
              [
                -70.678219,
                -33.329667
              ],
              [
                -70.677531,
                -33.329684
              ],
              [
                -70.676633,
                -33.329652
              ],
              [
                -70.67536,
                -33.329698
              ],
              [
                -70.674297,
                -33.329796
              ],
              [
                -70.673505,
                -33.329769
              ],
              [
                -70.672672,
                -33.329474
              ],
              [
                -70.671946,
                -33.329178
              ],
              [
                -70.670892,
                -33.329056
              ],
              [
                -70.670155,
                -33.328985
              ],
              [
                -70.669479,
                -33.328741
              ],
              [
                -70.668698,
                -33.328488
              ],
              [
                -70.668128,
                -33.328247
              ],
              [
                -70.667551,
                -33.328137
              ],
              [
                -70.667177,
                -33.328214
              ],
              [
                -70.666528,
                -33.328502
              ],
              [
                -70.666147,
                -33.32871
              ],
              [
                -70.66529,
                -33.328905
              ],
              [
                -70.664756,
                -33.329017
              ],
              [
                -70.664062,
                -33.329128
              ],
              [
                -70.663514,
                -33.329257
              ],
              [
                -70.663259,
                -33.32932
              ],
              [
                -70.662671,
                -33.329381
              ],
              [
                -70.66262,
                -33.329388
              ],
              [
                -70.662044,
                -33.329278
              ],
              [
                -70.661421,
                -33.329035
              ],
              [
                -70.660738,
                -33.328922
              ],
              [
                -70.660004,
                -33.328806
              ],
              [
                -70.659272,
                -33.328604
              ],
              [
                -70.658696,
                -33.328494
              ],
              [
                -70.658165,
                -33.328521
              ],
              [
                -70.657729,
                -33.328771
              ],
              [
                -70.657549,
                -33.329211
              ],
              [
                -70.65732,
                -33.329559
              ],
              [
                -70.657036,
                -33.32995
              ],
              [
                -70.656582,
                -33.330555
              ],
              [
                -70.656189,
                -33.331028
              ],
              [
                -70.65579,
                -33.331591
              ],
              [
                -70.655396,
                -33.332068
              ],
              [
                -70.654687,
                -33.332484
              ],
              [
                -70.654079,
                -33.332999
              ],
              [
                -70.653265,
                -33.333412
              ],
              [
                -70.652241,
                -33.333777
              ],
              [
                -70.651696,
                -33.334114
              ],
              [
                -70.651193,
                -33.334628
              ],
              [
                -70.650746,
                -33.335103
              ],
              [
                -70.650405,
                -33.335578
              ],
              [
                -70.650114,
                -33.336104
              ],
              [
                -70.649872,
                -33.336717
              ],
              [
                -70.649534,
                -33.337146
              ],
              [
                -70.649042,
                -33.33744
              ],
              [
                -70.648437,
                -33.337909
              ],
              [
                -70.648106,
                -33.338164
              ],
              [
                -70.647834,
                -33.338334
              ],
              [
                -70.647496,
                -33.338719
              ],
              [
                -70.647208,
                -33.3392
              ],
              [
                -70.647182,
                -33.33973
              ],
              [
                -70.646897,
                -33.340121
              ],
              [
                -70.646348,
                -33.340543
              ],
              [
                -70.645958,
                -33.340926
              ],
              [
                -70.645566,
                -33.341358
              ],
              [
                -70.645117,
                -33.341874
              ],
              [
                -70.644577,
                -33.34208
              ],
              [
                -70.643721,
                -33.342271
              ],
              [
                -70.643027,
                -33.342377
              ],
              [
                -70.642242,
                -33.342219
              ],
              [
                -70.641498,
                -33.342283
              ],
              [
                -70.641121,
                -33.3424
              ],
              [
                -70.640533,
                -33.342515
              ],
              [
                -70.640435,
                -33.342538
              ],
              [
                -70.640051,
                -33.342629
              ],
              [
                -70.639411,
                -33.342741
              ],
              [
                -70.63851,
                -33.342755
              ],
              [
                -70.63794,
                -33.342509
              ],
              [
                -70.637262,
                -33.34231
              ],
              [
                -70.63659,
                -33.341975
              ],
              [
                -70.636027,
                -33.341599
              ],
              [
                -70.635569,
                -33.341228
              ],
              [
                -70.634742,
                -33.340843
              ],
              [
                -70.634222,
                -33.340649
              ],
              [
                -70.63365,
                -33.340448
              ],
              [
                -70.632862,
                -33.340335
              ],
              [
                -70.632323,
                -33.340537
              ],
              [
                -70.631569,
                -33.340776
              ],
              [
                -70.630885,
                -33.340707
              ],
              [
                -70.630092,
                -33.340679
              ],
              [
                -70.628772,
                -33.340632
              ],
              [
                -70.627442,
                -33.340765
              ],
              [
                -70.626532,
                -33.340954
              ],
              [
                -70.625846,
                -33.34093
              ],
              [
                -70.625007,
                -33.340765
              ],
              [
                -70.624107,
                -33.340778
              ],
              [
                -70.623402,
                -33.341109
              ],
              [
                -70.622587,
                -33.341527
              ],
              [
                -70.62183,
                -33.341856
              ],
              [
                -70.621075,
                -33.34214
              ],
              [
                -70.620377,
                -33.342336
              ],
              [
                -70.619527,
                -33.342396
              ],
              [
                -70.619336,
                -33.34236
              ],
              [
                -70.618636,
                -33.342229
              ],
              [
                -70.61847,
                -33.342151
              ],
              [
                -70.618015,
                -33.341942
              ],
              [
                -70.617332,
                -33.341827
              ],
              [
                -70.616696,
                -33.34185
              ],
              [
                -70.616068,
                -33.341693
              ],
              [
                -70.615234,
                -33.341442
              ],
              [
                -70.614508,
                -33.341151
              ],
              [
                -70.613993,
                -33.340867
              ],
              [
                -70.613262,
                -33.340661
              ],
              [
                -70.612739,
                -33.340552
              ],
              [
                -70.611953,
                -33.340394
              ],
              [
                -70.611061,
                -33.340227
              ],
              [
                -70.610176,
                -33.33993
              ],
              [
                -70.609232,
                -33.339762
              ],
              [
                -70.6086,
                -33.339699
              ],
              [
                -70.607865,
                -33.339582
              ],
              [
                -70.606859,
                -33.339592
              ],
              [
                -70.605847,
                -33.339732
              ],
              [
                -70.604962,
                -33.339435
              ],
              [
                -70.604183,
                -33.339141
              ],
              [
                -70.603303,
                -33.338754
              ],
              [
                -70.602416,
                -33.338502
              ],
              [
                -70.601522,
                -33.33838
              ],
              [
                -70.60056,
                -33.338567
              ],
              [
                -70.599715,
                -33.338537
              ],
              [
                -70.598344,
                -33.338443
              ],
              [
                -70.597459,
                -33.338146
              ],
              [
                -70.596523,
                -33.337802
              ],
              [
                -70.596222,
                -33.33748
              ],
              [
                -70.596093,
                -33.337058
              ],
              [
                -70.595664,
                -33.337692
              ],
              [
                -70.59534,
                -33.338114
              ],
              [
                -70.594971,
                -33.338398
              ],
              [
                -70.594228,
                -33.338582
              ],
              [
                -70.592734,
                -33.338601
              ],
              [
                -70.592403,
                -33.338675
              ],
              [
                -70.591826,
                -33.338926
              ],
              [
                -70.591417,
                -33.33921
              ],
              [
                -70.590928,
                -33.339739
              ],
              [
                -70.590609,
                -33.34044
              ],
              [
                -70.590266,
                -33.342151
              ],
              [
                -70.589872,
                -33.343306
              ],
              [
                -70.589196,
                -33.344952
              ],
              [
                -70.588879,
                -33.345758
              ],
              [
                -70.588107,
                -33.346708
              ],
              [
                -70.586184,
                -33.348231
              ],
              [
                -70.583768,
                -33.350074
              ],
              [
                -70.583115,
                -33.350674
              ],
              [
                -70.582621,
                -33.350924
              ],
              [
                -70.582515,
                -33.350965
              ],
              [
                -70.582624,
                -33.351098
              ],
              [
                -70.582754,
                -33.351376
              ],
              [
                -70.583133,
                -33.351684
              ],
              [
                -70.583471,
                -33.351994
              ],
              [
                -70.58381,
                -33.352407
              ],
              [
                -70.584188,
                -33.352611
              ],
              [
                -70.584689,
                -33.352779
              ],
              [
                -70.585147,
                -33.352878
              ],
              [
                -70.585606,
                -33.353012
              ],
              [
                -70.585817,
                -33.353148
              ],
              [
                -70.586028,
                -33.353389
              ],
              [
                -70.586368,
                -33.353803
              ],
              [
                -70.586833,
                -33.35425
              ],
              [
                -70.587252,
                -33.354454
              ],
              [
                -70.587793,
                -33.354551
              ],
              [
                -70.588375,
                -33.354579
              ],
              [
                -70.589081,
                -33.35457
              ],
              [
                -70.589787,
                -33.35463
              ],
              [
                -70.590829,
                -33.354861
              ],
              [
                -70.59204,
                -33.355229
              ],
              [
                -70.592627,
                -33.355535
              ],
              [
                -70.593008,
                -33.355913
              ],
              [
                -70.593264,
                -33.356293
              ],
              [
                -70.593602,
                -33.356637
              ],
              [
                -70.594024,
                -33.357015
              ],
              [
                -70.594488,
                -33.357392
              ],
              [
                -70.595038,
                -33.357977
              ],
              [
                -70.595837,
                -33.358525
              ],
              [
                -70.596383,
                -33.358866
              ],
              [
                -70.596723,
                -33.359314
              ],
              [
                -70.596898,
                -33.3598
              ],
              [
                -70.597367,
                -33.360456
              ],
              [
                -70.598334,
                -33.361105
              ],
              [
                -70.59909,
                -33.361583
              ],
              [
                -70.600139,
                -33.362232
              ],
              [
                -70.601062,
                -33.362708
              ],
              [
                -70.600611,
                -33.363027
              ],
              [
                -70.599588,
                -33.363876
              ],
              [
                -70.598688,
                -33.364585
              ],
              [
                -70.597746,
                -33.365294
              ],
              [
                -70.59734,
                -33.365787
              ],
              [
                -70.597345,
                -33.3661
              ],
              [
                -70.597354,
                -33.366553
              ],
              [
                -70.597448,
                -33.367179
              ],
              [
                -70.597466,
                -33.368189
              ],
              [
                -70.597623,
                -33.369929
              ],
              [
                -70.597556,
                -33.370801
              ],
              [
                -70.597605,
                -33.371219
              ],
              [
                -70.597777,
                -33.371565
              ],
              [
                -70.598198,
                -33.371873
              ],
              [
                -70.599087,
                -33.372802
              ],
              [
                -70.599821,
                -33.374326
              ],
              [
                -70.600089,
                -33.375333
              ],
              [
                -70.600103,
                -33.376134
              ],
              [
                -70.600002,
                -33.377424
              ],
              [
                -70.60002,
                -33.378365
              ],
              [
                -70.600156,
                -33.37899
              ],
              [
                -70.600496,
                -33.379404
              ],
              [
                -70.601001,
                -33.379815
              ],
              [
                -70.602895,
                -33.381184
              ],
              [
                -70.603618,
                -33.382116
              ],
              [
                -70.603883,
                -33.382948
              ],
              [
                -70.60389,
                -33.383366
              ],
              [
                -70.603658,
                -33.384275
              ],
              [
                -70.603262,
                -33.385326
              ],
              [
                -70.602817,
                -33.385993
              ],
              [
                -70.602456,
                -33.386322
              ],
              [
                -70.602,
                -33.386736
              ],
              [
                -70.601521,
                -33.387752
              ],
              [
                -70.601451,
                -33.388485
              ],
              [
                -70.601712,
                -33.389143
              ],
              [
                -70.602265,
                -33.389833
              ],
              [
                -70.602984,
                -33.39052
              ],
              [
                -70.605856,
                -33.393166
              ],
              [
                -70.60743,
                -33.395166
              ],
              [
                -70.608541,
                -33.396859
              ],
              [
                -70.608937,
                -33.398038
              ],
              [
                -70.60929,
                -33.399184
              ],
              [
                -70.610071,
                -33.400985
              ],
              [
                -70.610391,
                -33.402584
              ],
              [
                -70.610486,
                -33.40321
              ],
              [
                -70.61054,
                -33.403906
              ],
              [
                -70.610561,
                -33.405017
              ],
              [
                -70.618043,
                -33.399165
              ],
              [
                -70.62162,
                -33.39673
              ],
              [
                -70.622323,
                -33.396023
              ],
              [
                -70.62409,
                -33.394711
              ],
              [
                -70.62495,
                -33.394147
              ],
              [
                -70.624989,
                -33.394127
              ],
              [
                -70.624991,
                -33.394128
              ],
              [
                -70.625201,
                -33.394029
              ],
              [
                -70.625557,
                -33.39386
              ],
              [
                -70.62617,
                -33.393578
              ],
              [
                -70.62657,
                -33.393369
              ],
              [
                -70.626757,
                -33.393276
              ],
              [
                -70.626982,
                -33.393142
              ],
              [
                -70.627198,
                -33.393015
              ],
              [
                -70.627394,
                -33.392901
              ],
              [
                -70.627603,
                -33.39277
              ],
              [
                -70.627822,
                -33.39263
              ],
              [
                -70.62783,
                -33.392618
              ],
              [
                -70.627893,
                -33.392585
              ],
              [
                -70.629843,
                -33.391148
              ],
              [
                -70.631788,
                -33.38971
              ],
              [
                -70.634404,
                -33.387781
              ],
              [
                -70.636662,
                -33.386119
              ],
              [
                -70.639208,
                -33.38424
              ],
              [
                -70.641379,
                -33.382694
              ],
              [
                -70.643241,
                -33.381697
              ],
              [
                -70.644201,
                -33.381215
              ],
              [
                -70.645262,
                -33.380763
              ],
              [
                -70.646436,
                -33.380323
              ],
              [
                -70.647001,
                -33.380102
              ],
              [
                -70.647652,
                -33.37985
              ],
              [
                -70.648449,
                -33.379561
              ],
              [
                -70.648834,
                -33.3794
              ],
              [
                -70.651019,
                -33.378572
              ],
              [
                -70.652821,
                -33.377902
              ],
              [
                -70.654859,
                -33.377156
              ],
              [
                -70.655438,
                -33.376992
              ],
              [
                -70.656188,
                -33.376777
              ],
              [
                -70.657643,
                -33.376225
              ],
              [
                -70.658457,
                -33.375834
              ],
              [
                -70.659244,
                -33.375517
              ],
              [
                -70.660059,
                -33.37521
              ],
              [
                -70.660467,
                -33.375063
              ],
              [
                -70.66094,
                -33.374896
              ],
              [
                -70.661726,
                -33.374611
              ],
              [
                -70.662478,
                -33.374325
              ],
              [
                -70.665026,
                -33.373359
              ],
              [
                -70.6665,
                -33.372809
              ],
              [
                -70.668182,
                -33.372158
              ],
              [
                -70.66893,
                -33.371885
              ],
              [
                -70.669341,
                -33.371766
              ],
              [
                -70.669496,
                -33.371735
              ],
              [
                -70.669641,
                -33.371706
              ],
              [
                -70.669815,
                -33.37165
              ],
              [
                -70.670022,
                -33.371583
              ],
              [
                -70.670513,
                -33.371413
              ],
              [
                -70.670935,
                -33.371258
              ],
              [
                -70.671348,
                -33.371092
              ],
              [
                -70.671821,
                -33.370916
              ],
              [
                -70.672056,
                -33.370828
              ],
              [
                -70.672328,
                -33.370692
              ],
              [
                -70.672848,
                -33.370443
              ],
              [
                -70.673102,
                -33.370322
              ],
              [
                -70.673863,
                -33.370033
              ],
              [
                -70.675265,
                -33.369507
              ],
              [
                -70.675694,
                -33.369346
              ],
              [
                -70.677226,
                -33.368774
              ],
              [
                -70.677834,
                -33.368545
              ],
              [
                -70.678303,
                -33.368364
              ],
              [
                -70.679032,
                -33.368094
              ],
              [
                -70.679668,
                -33.367853
              ],
              [
                -70.680396,
                -33.367584
              ],
              [
                -70.680725,
                -33.367459
              ],
              [
                -70.680998,
                -33.367354
              ],
              [
                -70.681452,
                -33.36718
              ],
              [
                -70.681802,
                -33.367046
              ],
              [
                -70.682245,
                -33.366904
              ],
              [
                -70.682597,
                -33.366806
              ],
              [
                -70.682932,
                -33.366722
              ],
              [
                -70.683191,
                -33.366666
              ],
              [
                -70.683581,
                -33.366596
              ],
              [
                -70.683836,
                -33.366554
              ],
              [
                -70.684136,
                -33.366517
              ],
              [
                -70.68449,
                -33.36649
              ],
              [
                -70.684889,
                -33.366457
              ],
              [
                -70.685429,
                -33.366413
              ],
              [
                -70.6864,
                -33.366351
              ],
              [
                -70.687612,
                -33.366271
              ],
              [
                -70.687868,
                -33.366275
              ],
              [
                -70.687986,
                -33.366307
              ],
              [
                -70.688117,
                -33.366292
              ],
              [
                -70.688247,
                -33.366294
              ],
              [
                -70.688507,
                -33.366294
              ],
              [
                -70.688632,
                -33.366292
              ],
              [
                -70.688903,
                -33.366272
              ],
              [
                -70.689209,
                -33.366242
              ],
              [
                -70.689282,
                -33.366237
              ]
            ]
          ],
          "type": "Polygon"
        },
        "properties": {
          "CIR_SENA": 7,
          "COD_COMUNA": 1310,
          "DIS_ELEC": 17,
          "NOM_COM": "Huechuraba",
          "NOM_PROV": "Santiago",
          "NOM_REG": "Región Metropolitana de Santiago",
          "SHAPE_Area": 44740350.6455,
          "SHAPE_LENG": 32111.265818,
          "SHAPE_Le_1": 32061.97711
        },
        "type": "Feature",
        "crs": {
          "properties": {
            "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
          },
          "type": "name"
        }
      },
      {
        "geometry": {
          "coordinates": [
            [
              [
                -70.636586,
                -33.518886
              ],
              [
                -70.636594,
                -33.518728
              ],
              [
                -70.636098,
                -33.518669
              ],
              [
                -70.635866,
                -33.518641
              ],
              [
                -70.63546,
                -33.518567
              ],
              [
                -70.634836,
                -33.518532
              ],
              [
                -70.634174,
                -33.518465
              ],
              [
                -70.63355,
                -33.518393
              ],
              [
                -70.632899,
                -33.518329
              ],
              [
                -70.632363,
                -33.518248
              ],
              [
                -70.631756,
                -33.5182
              ],
              [
                -70.631175,
                -33.518137
              ],
              [
                -70.630605,
                -33.518072
              ],
              [
                -70.630104,
                -33.518017
              ],
              [
                -70.629647,
                -33.517965
              ],
              [
                -70.629091,
                -33.517911
              ],
              [
                -70.62867,
                -33.517869
              ],
              [
                -70.627935,
                -33.517789
              ],
              [
                -70.627455,
                -33.517737
              ],
              [
                -70.627252,
                -33.517704
              ],
              [
                -70.627125,
                -33.517669
              ],
              [
                -70.626919,
                -33.517595
              ],
              [
                -70.626727,
                -33.517519
              ],
              [
                -70.626595,
                -33.51746
              ],
              [
                -70.626105,
                -33.517223
              ],
              [
                -70.625647,
                -33.517021
              ],
              [
                -70.625472,
                -33.516934
              ],
              [
                -70.624868,
                -33.516653
              ],
              [
                -70.624159,
                -33.516323
              ],
              [
                -70.622665,
                -33.515627
              ],
              [
                -70.62086,
                -33.514794
              ],
              [
                -70.620755,
                -33.514713
              ],
              [
                -70.619925,
                -33.514328
              ],
              [
                -70.617931,
                -33.513813
              ],
              [
                -70.616075,
                -33.513386
              ],
              [
                -70.615948,
                -33.51333
              ],
              [
                -70.615855,
                -33.513328
              ],
              [
                -70.615015,
                -33.513107
              ],
              [
                -70.614084,
                -33.513098
              ],
              [
                -70.613646,
                -33.513085
              ],
              [
                -70.611301,
                -33.513059
              ],
              [
                -70.611265,
                -33.513058
              ],
              [
                -70.611025,
                -33.515193
              ],
              [
                -70.610924,
                -33.51615
              ],
              [
                -70.610655,
                -33.518477
              ],
              [
                -70.61036,
                -33.520811
              ],
              [
                -70.610129,
                -33.522846
              ],
              [
                -70.609984,
                -33.524118
              ],
              [
                -70.609749,
                -33.526187
              ],
              [
                -70.609822,
                -33.52843
              ],
              [
                -70.609986,
                -33.533153
              ],
              [
                -70.610041,
                -33.534793
              ],
              [
                -70.610134,
                -33.537387
              ],
              [
                -70.610318,
                -33.539019
              ],
              [
                -70.610312,
                -33.539754
              ],
              [
                -70.61044,
                -33.54333
              ],
              [
                -70.610559,
                -33.546654
              ],
              [
                -70.610937,
                -33.54665
              ],
              [
                -70.610941,
                -33.546645
              ],
              [
                -70.611391,
                -33.546631
              ],
              [
                -70.612537,
                -33.546599
              ],
              [
                -70.61298,
                -33.546593
              ],
              [
                -70.61371,
                -33.546569
              ],
              [
                -70.614036,
                -33.546543
              ],
              [
                -70.614464,
                -33.546474
              ],
              [
                -70.614824,
                -33.546397
              ],
              [
                -70.614857,
                -33.546523
              ],
              [
                -70.614818,
                -33.546653
              ],
              [
                -70.614809,
                -33.546663
              ],
              [
                -70.614815,
                -33.546662
              ],
              [
                -70.614654,
                -33.547193
              ],
              [
                -70.614572,
                -33.547478
              ],
              [
                -70.61448,
                -33.547791
              ],
              [
                -70.614215,
                -33.548695
              ],
              [
                -70.61403,
                -33.549339
              ],
              [
                -70.613705,
                -33.550482
              ],
              [
                -70.612909,
                -33.553308
              ],
              [
                -70.612691,
                -33.554064
              ],
              [
                -70.612602,
                -33.554427
              ],
              [
                -70.612231,
                -33.555611
              ],
              [
                -70.612607,
                -33.555734
              ],
              [
                -70.612616,
                -33.555703
              ],
              [
                -70.612632,
                -33.555706
              ],
              [
                -70.616218,
                -33.556483
              ],
              [
                -70.619892,
                -33.557371
              ],
              [
                -70.623554,
                -33.558199
              ],
              [
                -70.625613,
                -33.558645
              ],
              [
                -70.627337,
                -33.559031
              ],
              [
                -70.627349,
                -33.559074
              ],
              [
                -70.627362,
                -33.55911
              ],
              [
                -70.627439,
                -33.559126
              ],
              [
                -70.630709,
                -33.559808
              ],
              [
                -70.630729,
                -33.559737
              ],
              [
                -70.630754,
                -33.559359
              ],
              [
                -70.630839,
                -33.558997
              ],
              [
                -70.630898,
                -33.558715
              ],
              [
                -70.631019,
                -33.558066
              ],
              [
                -70.631034,
                -33.557973
              ],
              [
                -70.631179,
                -33.557428
              ],
              [
                -70.631494,
                -33.555977
              ],
              [
                -70.631697,
                -33.555034
              ],
              [
                -70.631872,
                -33.554266
              ],
              [
                -70.631792,
                -33.554186
              ],
              [
                -70.632483,
                -33.551455
              ],
              [
                -70.632926,
                -33.549345
              ],
              [
                -70.633266,
                -33.547571
              ],
              [
                -70.634102,
                -33.542665
              ],
              [
                -70.634131,
                -33.542329
              ],
              [
                -70.634156,
                -33.541961
              ],
              [
                -70.634473,
                -33.537785
              ],
              [
                -70.634511,
                -33.537291
              ],
              [
                -70.634576,
                -33.535974
              ],
              [
                -70.634607,
                -33.5347
              ],
              [
                -70.634672,
                -33.533946
              ],
              [
                -70.63476,
                -33.532888
              ],
              [
                -70.635079,
                -33.530532
              ],
              [
                -70.635321,
                -33.529752
              ],
              [
                -70.635462,
                -33.529148
              ],
              [
                -70.635552,
                -33.528157
              ],
              [
                -70.635653,
                -33.527314
              ],
              [
                -70.635855,
                -33.525516
              ],
              [
                -70.63606,
                -33.523219
              ],
              [
                -70.636576,
                -33.518885
              ],
              [
                -70.636586,
                -33.518886
              ]
            ]
          ],
          "type": "Polygon"
        },
        "properties": {
          "CIR_SENA": 8,
          "COD_COMUNA": 1311,
          "DIS_ELEC": 25,
          "NOM_COM": "La Granja",
          "NOM_PROV": "Santiago",
          "NOM_REG": "Región Metropolitana de Santiago",
          "SHAPE_Area": 10059460.6476,
          "SHAPE_LENG": 14001.424777,
          "SHAPE_Le_1": 14049.420448
        },
        "type": "Feature",
        "crs": {
          "properties": {
            "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
          },
          "type": "name"
        },
        "id": 6
      },
      {
        "geometry": {
          "coordinates": [
            [
              [
                -70.765051,
                -33.459258
              ],
              [
                -70.76505,
                -33.45926
              ],
              [
                -70.764937,
                -33.459259
              ],
              [
                -70.764744,
                -33.459776
              ],
              [
                -70.763842,
                -33.462526
              ],
              [
                -70.763715,
                -33.462983
              ],
              [
                -70.763462,
                -33.463821
              ],
              [
                -70.75994,
                -33.464479
              ],
              [
                -70.75808,
                -33.464803
              ],
              [
                -70.757201,
                -33.464957
              ],
              [
                -70.757004,
                -33.464995
              ],
              [
                -70.756803,
                -33.465039
              ],
              [
                -70.756454,
                -33.465109
              ],
              [
                -70.756114,
                -33.465172
              ],
              [
                -70.755791,
                -33.465236
              ],
              [
                -70.755468,
                -33.465299
              ],
              [
                -70.755092,
                -33.465374
              ],
              [
                -70.754762,
                -33.465437
              ],
              [
                -70.753674,
                -33.465647
              ],
              [
                -70.752113,
                -33.465925
              ],
              [
                -70.750567,
                -33.466195
              ],
              [
                -70.749448,
                -33.466388
              ],
              [
                -70.748258,
                -33.466598
              ],
              [
                -70.747386,
                -33.466756
              ],
              [
                -70.746154,
                -33.466979
              ],
              [
                -70.745583,
                -33.46708
              ],
              [
                -70.743975,
                -33.467385
              ],
              [
                -70.741938,
                -33.467737
              ],
              [
                -70.740185,
                -33.468049
              ],
              [
                -70.738449,
                -33.468363
              ],
              [
                -70.737915,
                -33.468452
              ],
              [
                -70.737762,
                -33.468524
              ],
              [
                -70.737544,
                -33.468642
              ],
              [
                -70.73737,
                -33.468709
              ],
              [
                -70.73728,
                -33.469664
              ],
              [
                -70.737232,
                -33.470248
              ],
              [
                -70.737218,
                -33.470415
              ],
              [
                -70.737157,
                -33.470609
              ],
              [
                -70.737143,
                -33.470738
              ],
              [
                -70.737087,
                -33.471215
              ],
              [
                -70.737034,
                -33.471471
              ],
              [
                -70.736946,
                -33.47141
              ],
              [
                -70.736193,
                -33.470969
              ],
              [
                -70.735599,
                -33.470625
              ],
              [
                -70.734817,
                -33.470185
              ],
              [
                -70.734426,
                -33.46997
              ],
              [
                -70.733858,
                -33.469657
              ],
              [
                -70.733805,
                -33.469624
              ],
              [
                -70.733323,
                -33.46978
              ],
              [
                -70.732362,
                -33.470078
              ],
              [
                -70.731438,
                -33.470363
              ],
              [
                -70.730976,
                -33.470491
              ],
              [
                -70.730891,
                -33.470515
              ],
              [
                -70.730623,
                -33.470597
              ],
              [
                -70.728634,
                -33.471209
              ],
              [
                -70.728032,
                -33.471382
              ],
              [
                -70.727477,
                -33.471548
              ],
              [
                -70.726681,
                -33.471772
              ],
              [
                -70.726026,
                -33.471972
              ],
              [
                -70.725821,
                -33.472034
              ],
              [
                -70.724812,
                -33.472359
              ],
              [
                -70.724156,
                -33.472562
              ],
              [
                -70.723521,
                -33.472762
              ],
              [
                -70.722781,
                -33.473007
              ],
              [
                -70.722752,
                -33.473053
              ],
              [
                -70.722627,
                -33.473316
              ],
              [
                -70.722372,
                -33.473394
              ],
              [
                -70.722321,
                -33.47341
              ],
              [
                -70.722231,
                -33.473485
              ],
              [
                -70.722312,
                -33.473602
              ],
              [
                -70.722413,
                -33.47395
              ],
              [
                -70.722495,
                -33.474344
              ],
              [
                -70.722703,
                -33.475453
              ],
              [
                -70.722961,
                -33.47682
              ],
              [
                -70.723155,
                -33.477845
              ],
              [
                -70.723299,
                -33.479199
              ],
              [
                -70.723481,
                -33.47964
              ],
              [
                -70.72354,
                -33.479949
              ],
              [
                -70.723734,
                -33.480465
              ],
              [
                -70.724164,
                -33.480964
              ],
              [
                -70.724359,
                -33.481222
              ],
              [
                -70.724522,
                -33.481493
              ],
              [
                -70.724649,
                -33.481994
              ],
              [
                -70.724673,
                -33.482679
              ],
              [
                -70.72514,
                -33.482488
              ],
              [
                -70.725145,
                -33.482486
              ],
              [
                -70.725148,
                -33.482494
              ],
              [
                -70.72581,
                -33.482321
              ],
              [
                -70.726083,
                -33.482284
              ],
              [
                -70.726631,
                -33.482276
              ],
              [
                -70.726986,
                -33.482435
              ],
              [
                -70.727305,
                -33.482759
              ],
              [
                -70.727623,
                -33.483017
              ],
              [
                -70.728099,
                -33.483305
              ],
              [
                -70.72857,
                -33.483397
              ],
              [
                -70.728999,
                -33.483358
              ],
              [
                -70.729468,
                -33.483319
              ],
              [
                -70.729817,
                -33.48315
              ],
              [
                -70.730282,
                -33.482914
              ],
              [
                -70.730593,
                -33.482844
              ],
              [
                -70.731139,
                -33.482738
              ],
              [
                -70.731456,
                -33.482758
              ],
              [
                -70.731547,
                -33.494906
              ],
              [
                -70.732236,
                -33.495329
              ],
              [
                -70.733336,
                -33.496375
              ],
              [
                -70.733924,
                -33.497354
              ],
              [
                -70.735226,
                -33.499943
              ],
              [
                -70.736833,
                -33.503535
              ],
              [
                -70.740087,
                -33.510122
              ],
              [
                -70.733927,
                -33.509764
              ],
              [
                -70.732883,
                -33.509778
              ],
              [
                -70.731296,
                -33.5098
              ],
              [
                -70.730661,
                -33.509809
              ],
              [
                -70.723336,
                -33.510035
              ],
              [
                -70.718522,
                -33.514083
              ],
              [
                -70.719855,
                -33.516129
              ],
              [
                -70.723916,
                -33.520757
              ],
              [
                -70.726524,
                -33.524076
              ],
              [
                -70.729005,
                -33.527233
              ],
              [
                -70.732825,
                -33.531863
              ],
              [
                -70.739321,
                -33.539427
              ],
              [
                -70.739431,
                -33.539541
              ],
              [
                -70.740568,
                -33.540835
              ],
              [
                -70.741241,
                -33.541609
              ],
              [
                -70.743818,
                -33.54453
              ],
              [
                -70.744415,
                -33.545204
              ],
              [
                -70.745996,
                -33.54697
              ],
              [
                -70.749482,
                -33.550845
              ],
              [
                -70.75033,
                -33.551775
              ],
              [
                -70.75125,
                -33.552794
              ],
              [
                -70.752489,
                -33.554183
              ],
              [
                -70.754553,
                -33.55649
              ],
              [
                -70.755854,
                -33.557953
              ],
              [
                -70.759679,
                -33.562269
              ],
              [
                -70.762662,
                -33.565625
              ],
              [
                -70.763376,
                -33.566433
              ],
              [
                -70.763942,
                -33.567119
              ],
              [
                -70.764715,
                -33.568209
              ],
              [
                -70.766008,
                -33.570056
              ],
              [
                -70.767021,
                -33.571503
              ],
              [
                -70.767418,
                -33.571961
              ],
              [
                -70.767613,
                -33.571892
              ],
              [
                -70.767853,
                -33.57185
              ],
              [
                -70.768533,
                -33.571732
              ],
              [
                -70.769851,
                -33.571602
              ],
              [
                -70.773135,
                -33.570856
              ],
              [
                -70.778611,
                -33.569188
              ],
              [
                -70.778664,
                -33.56918
              ],
              [
                -70.783185,
                -33.568082
              ],
              [
                -70.783702,
                -33.568074
              ],
              [
                -70.783747,
                -33.568046
              ],
              [
                -70.783789,
                -33.56806
              ],
              [
                -70.785559,
                -33.567431
              ],
              [
                -70.78871,
                -33.56491
              ],
              [
                -70.793609,
                -33.560675
              ],
              [
                -70.798677,
                -33.556221
              ],
              [
                -70.799855,
                -33.555019
              ],
              [
                -70.799816,
                -33.554945
              ],
              [
                -70.804642,
                -33.550945
              ],
              [
                -70.815989,
                -33.54372
              ],
              [
                -70.815628,
                -33.543303
              ],
              [
                -70.81472,
                -33.542241
              ],
              [
                -70.813879,
                -33.541511
              ],
              [
                -70.813727,
                -33.541299
              ],
              [
                -70.812858,
                -33.540813
              ],
              [
                -70.811879,
                -33.54017
              ],
              [
                -70.810917,
                -33.539493
              ],
              [
                -70.809561,
                -33.53895
              ],
              [
                -70.80851,
                -33.538428
              ],
              [
                -70.807208,
                -33.537525
              ],
              [
                -70.806088,
                -33.536594
              ],
              [
                -70.805806,
                -33.536291
              ],
              [
                -70.805584,
                -33.53591
              ],
              [
                -70.805634,
                -33.535372
              ],
              [
                -70.805656,
                -33.534962
              ],
              [
                -70.805587,
                -33.534553
              ],
              [
                -70.805546,
                -33.534093
              ],
              [
                -70.805358,
                -33.533865
              ],
              [
                -70.8048,
                -33.533464
              ],
              [
                -70.804424,
                -33.533034
              ],
              [
                -70.804202,
                -33.532653
              ],
              [
                -70.804163,
                -33.532244
              ],
              [
                -70.804355,
                -33.531201
              ],
              [
                -70.804459,
                -33.530774
              ],
              [
                -70.804852,
                -33.530357
              ],
              [
                -70.805248,
                -33.53009
              ],
              [
                -70.805603,
                -33.529973
              ],
              [
                -70.805956,
                -33.529818
              ],
              [
                -70.806445,
                -33.529699
              ],
              [
                -70.806846,
                -33.529655
              ],
              [
                -70.80729,
                -33.529574
              ],
              [
                -70.807556,
                -33.529458
              ],
              [
                -70.807816,
                -33.529081
              ],
              [
                -70.807853,
                -33.528706
              ],
              [
                -70.807845,
                -33.528332
              ],
              [
                -70.808899,
                -33.528789
              ],
              [
                -70.809328,
                -33.529097
              ],
              [
                -70.80971,
                -33.529406
              ],
              [
                -70.810138,
                -33.529675
              ],
              [
                -70.810519,
                -33.529945
              ],
              [
                -70.810852,
                -33.530136
              ],
              [
                -70.811371,
                -33.530286
              ],
              [
                -70.811799,
                -33.530516
              ],
              [
                -70.812556,
                -33.530819
              ],
              [
                -70.812888,
                -33.530972
              ],
              [
                -70.813316,
                -33.53124
              ],
              [
                -70.813507,
                -33.531395
              ],
              [
                -70.813698,
                -33.531549
              ],
              [
                -70.81389,
                -33.531782
              ],
              [
                -70.814036,
                -33.532016
              ],
              [
                -70.814137,
                -33.532368
              ],
              [
                -70.814143,
                -33.532644
              ],
              [
                -70.814268,
                -33.533035
              ],
              [
                -70.814464,
                -33.533425
              ],
              [
                -70.814655,
                -33.53358
              ],
              [
                -70.814896,
                -33.533851
              ],
              [
                -70.815184,
                -33.534161
              ],
              [
                -70.815422,
                -33.534315
              ],
              [
                -70.815802,
                -33.534546
              ],
              [
                -70.816183,
                -33.534815
              ],
              [
                -70.816377,
                -33.535087
              ],
              [
                -70.816523,
                -33.535321
              ],
              [
                -70.816715,
                -33.535554
              ],
              [
                -70.816962,
                -33.53614
              ],
              [
                -70.817451,
                -33.537037
              ],
              [
                -70.817647,
                -33.537467
              ],
              [
                -70.817983,
                -33.537816
              ],
              [
                -70.818172,
                -33.537852
              ],
              [
                -70.81841,
                -33.538006
              ],
              [
                -70.818647,
                -33.538121
              ],
              [
                -70.818975,
                -33.538116
              ],
              [
                -70.819538,
                -33.538068
              ],
              [
                -70.819909,
                -33.537866
              ],
              [
                -70.820515,
                -33.537661
              ],
              [
                -70.821029,
                -33.537535
              ],
              [
                -70.821592,
                -33.537527
              ],
              [
                -70.822626,
                -33.53759
              ],
              [
                -70.823141,
                -33.537543
              ],
              [
                -70.823561,
                -33.537419
              ],
              [
                -70.824121,
                -33.537254
              ],
              [
                -70.824777,
                -33.537205
              ],
              [
                -70.825292,
                -33.537119
              ],
              [
                -70.82557,
                -33.536957
              ],
              [
                -70.825798,
                -33.536639
              ],
              [
                -70.826636,
                -33.536313
              ],
              [
                -70.827197,
                -33.536186
              ],
              [
                -70.827761,
                -33.536217
              ],
              [
                -70.827999,
                -33.536371
              ],
              [
                -70.828237,
                -33.536525
              ],
              [
                -70.82871,
                -33.536714
              ],
              [
                -70.829226,
                -33.536707
              ],
              [
                -70.829692,
                -33.536503
              ],
              [
                -70.830063,
                -33.536301
              ],
              [
                -70.830572,
                -33.53594
              ],
              [
                -70.831551,
                -33.53565
              ],
              [
                -70.832578,
                -33.53536
              ],
              [
                -70.833563,
                -33.535345
              ],
              [
                -70.834262,
                -33.53506
              ],
              [
                -70.835051,
                -33.534655
              ],
              [
                -70.835658,
                -33.534489
              ],
              [
                -70.836173,
                -33.534442
              ],
              [
                -70.836549,
                -33.534475
              ],
              [
                -70.836973,
                -33.534548
              ],
              [
                -70.837491,
                -33.534619
              ],
              [
                -70.837871,
                -33.53481
              ],
              [
                -70.838436,
                -33.53488
              ],
              [
                -70.839,
                -33.53495
              ],
              [
                -70.839657,
                -33.53494
              ],
              [
                -70.840266,
                -33.534853
              ],
              [
                -70.840965,
                -33.534606
              ],
              [
                -70.842084,
                -33.534275
              ],
              [
                -70.842599,
                -33.534189
              ],
              [
                -70.843115,
                -33.534181
              ],
              [
                -70.843491,
                -33.534215
              ],
              [
                -70.844058,
                -33.534364
              ],
              [
                -70.844389,
                -33.534477
              ],
              [
                -70.844863,
                -33.534706
              ],
              [
                -70.845617,
                -33.534852
              ],
              [
                -70.845995,
                -33.534964
              ],
              [
                -70.846424,
                -33.535272
              ],
              [
                -70.846711,
                -33.535504
              ],
              [
                -70.847281,
                -33.53581
              ],
              [
                -70.847801,
                -33.535998
              ],
              [
                -70.848367,
                -33.536108
              ],
              [
                -70.848885,
                -33.536218
              ],
              [
                -70.849405,
                -33.536368
              ],
              [
                -70.849785,
                -33.536558
              ],
              [
                -70.850121,
                -33.536907
              ],
              [
                -70.850407,
                -33.537139
              ],
              [
                -70.850789,
                -33.537408
              ],
              [
                -70.851311,
                -33.537676
              ],
              [
                -70.851736,
                -33.537827
              ],
              [
                -70.852017,
                -33.537783
              ],
              [
                -70.852249,
                -33.537662
              ],
              [
                -70.852289,
                -33.537307
              ],
              [
                -70.852278,
                -33.536796
              ],
              [
                -70.852364,
                -33.536441
              ],
              [
                -70.852635,
                -33.535965
              ],
              [
                -70.852911,
                -33.535686
              ],
              [
                -70.854051,
                -33.535194
              ],
              [
                -70.854604,
                -33.534742
              ],
              [
                -70.855187,
                -33.534123
              ],
              [
                -70.856227,
                -33.533164
              ],
              [
                -70.856873,
                -33.532377
              ],
              [
                -70.857324,
                -33.53176
              ],
              [
                -70.857969,
                -33.530974
              ],
              [
                -70.858887,
                -33.530516
              ],
              [
                -70.86001,
                -33.530333
              ],
              [
                -70.861869,
                -33.530527
              ],
              [
                -70.862536,
                -33.530739
              ],
              [
                -70.863267,
                -33.530838
              ],
              [
                -70.863994,
                -33.530772
              ],
              [
                -70.864922,
                -33.530758
              ],
              [
                -70.86565,
                -33.530747
              ],
              [
                -70.866316,
                -33.530904
              ],
              [
                -70.866786,
                -33.531174
              ],
              [
                -70.867253,
                -33.531333
              ],
              [
                -70.86792,
                -33.531545
              ],
              [
                -70.869179,
                -33.531526
              ],
              [
                -70.869776,
                -33.531573
              ],
              [
                -70.870378,
                -33.531841
              ],
              [
                -70.870915,
                -33.532166
              ],
              [
                -70.871321,
                -33.532548
              ],
              [
                -70.871722,
                -33.532709
              ],
              [
                -70.872385,
                -33.532699
              ],
              [
                -70.872846,
                -33.532581
              ],
              [
                -70.873175,
                -33.532465
              ],
              [
                -70.8739,
                -33.532287
              ],
              [
                -70.874428,
                -33.532224
              ],
              [
                -70.875354,
                -33.532154
              ],
              [
                -70.876539,
                -33.531803
              ],
              [
                -70.877451,
                -33.531068
              ],
              [
                -70.878105,
                -33.53067
              ],
              [
                -70.878762,
                -33.530382
              ],
              [
                -70.879686,
                -33.530257
              ],
              [
                -70.880214,
                -33.530138
              ],
              [
                -70.880868,
                -33.52974
              ],
              [
                -70.881327,
                -33.529511
              ],
              [
                -70.881854,
                -33.529392
              ],
              [
                -70.882573,
                -33.528937
              ],
              [
                -70.883421,
                -33.528314
              ],
              [
                -70.88395,
                -33.52825
              ],
              [
                -70.884349,
                -33.528355
              ],
              [
                -70.884682,
                -33.528406
              ],
              [
                -70.885707,
                -33.528335
              ],
              [
                -70.885768,
                -33.528315
              ],
              [
                -70.886628,
                -33.528043
              ],
              [
                -70.887607,
                -33.527362
              ],
              [
                -70.88826,
                -33.526908
              ],
              [
                -70.888648,
                -33.526459
              ],
              [
                -70.889098,
                -33.525841
              ],
              [
                -70.889287,
                -33.525395
              ],
              [
                -70.889473,
                -33.524781
              ],
              [
                -70.889792,
                -33.524222
              ],
              [
                -70.889918,
                -33.523942
              ],
              [
                -70.8903,
                -33.523215
              ],
              [
                -70.890755,
                -33.52282
              ],
              [
                -70.89187,
                -33.522303
              ],
              [
                -70.892257,
                -33.521798
              ],
              [
                -70.892442,
                -33.521185
              ],
              [
                -70.892358,
                -33.520354
              ],
              [
                -70.892748,
                -33.520015
              ],
              [
                -70.893208,
                -33.519841
              ],
              [
                -70.893607,
                -33.519946
              ],
              [
                -70.893809,
                -33.520054
              ],
              [
                -70.89414,
                -33.520049
              ],
              [
                -70.894931,
                -33.51987
              ],
              [
                -70.895516,
                -33.519362
              ],
              [
                -70.89604,
                -33.519076
              ],
              [
                -70.896892,
                -33.518675
              ],
              [
                -70.897548,
                -33.518387
              ],
              [
                -70.898719,
                -33.517371
              ],
              [
                -70.899553,
                -33.516137
              ],
              [
                -70.900327,
                -33.515182
              ],
              [
                -70.900578,
                -33.514568
              ],
              [
                -70.901031,
                -33.514061
              ],
              [
                -70.901947,
                -33.513548
              ],
              [
                -70.90286,
                -33.512868
              ],
              [
                -70.903839,
                -33.512187
              ],
              [
                -70.90436,
                -33.511791
              ],
              [
                -70.904947,
                -33.511393
              ],
              [
                -70.906002,
                -33.511155
              ],
              [
                -70.907053,
                -33.51075
              ],
              [
                -70.908168,
                -33.510234
              ],
              [
                -70.909809,
                -33.509543
              ],
              [
                -70.910535,
                -33.50942
              ],
              [
                -70.91133,
                -33.509464
              ],
              [
                -70.912129,
                -33.509618
              ],
              [
                -70.912863,
                -33.509884
              ],
              [
                -70.913401,
                -33.510264
              ],
              [
                -70.91414,
                -33.510696
              ],
              [
                -70.914872,
                -33.510852
              ],
              [
                -70.915864,
                -33.510781
              ],
              [
                -70.916657,
                -33.510713
              ],
              [
                -70.917649,
                -33.510642
              ],
              [
                -70.918513,
                -33.51074
              ],
              [
                -70.918978,
                -33.510844
              ],
              [
                -70.919448,
                -33.511114
              ],
              [
                -70.919737,
                -33.511259
              ],
              [
                -70.919984,
                -33.511383
              ],
              [
                -70.920319,
                -33.511544
              ],
              [
                -70.92065,
                -33.511539
              ],
              [
                -70.920981,
                -33.511534
              ],
              [
                -70.92131,
                -33.511418
              ],
              [
                -70.921701,
                -33.511134
              ],
              [
                -70.92196,
                -33.510853
              ],
              [
                -70.92215,
                -33.510461
              ],
              [
                -70.922602,
                -33.509955
              ],
              [
                -70.923116,
                -33.509226
              ],
              [
                -70.924103,
                -33.508933
              ],
              [
                -70.92483,
                -33.508866
              ],
              [
                -70.925294,
                -33.508859
              ],
              [
                -70.925824,
                -33.508851
              ],
              [
                -70.926418,
                -33.508786
              ],
              [
                -70.927539,
                -33.508546
              ],
              [
                -70.928064,
                -33.508316
              ],
              [
                -70.928646,
                -33.507697
              ],
              [
                -70.929099,
                -33.50719
              ],
              [
                -70.929677,
                -33.506405
              ],
              [
                -70.930061,
                -33.505788
              ],
              [
                -70.930179,
                -33.505121
              ],
              [
                -70.930165,
                -33.50451
              ],
              [
                -70.930046,
                -33.502126
              ],
              [
                -70.929898,
                -33.501407
              ],
              [
                -70.929754,
                -33.50091
              ],
              [
                -70.929548,
                -33.50058
              ],
              [
                -70.929272,
                -33.500085
              ],
              [
                -70.928855,
                -33.499204
              ],
              [
                -70.928309,
                -33.498491
              ],
              [
                -70.927905,
                -33.498164
              ],
              [
                -70.927102,
                -33.497788
              ],
              [
                -70.926495,
                -33.497298
              ],
              [
                -70.926151,
                -33.496749
              ],
              [
                -70.926139,
                -33.496194
              ],
              [
                -70.925992,
                -33.49553
              ],
              [
                -70.925915,
                -33.495032
              ],
              [
                -70.925774,
                -33.494646
              ],
              [
                -70.925698,
                -33.494203
              ],
              [
                -70.925353,
                -33.493598
              ],
              [
                -70.925142,
                -33.493047
              ],
              [
                -70.925132,
                -33.492603
              ],
              [
                -70.924853,
                -33.491941
              ],
              [
                -70.92457,
                -33.491113
              ],
              [
                -70.924221,
                -33.490342
              ],
              [
                -70.923541,
                -33.48952
              ],
              [
                -70.921996,
                -33.488545
              ],
              [
                -70.921425,
                -33.488317
              ],
              [
                -70.921195,
                -33.488225
              ],
              [
                -70.920133,
                -33.48813
              ],
              [
                -70.919335,
                -33.487976
              ],
              [
                -70.918139,
                -33.487828
              ],
              [
                -70.91741,
                -33.487784
              ],
              [
                -70.916983,
                -33.487721
              ],
              [
                -70.9165,
                -33.487698
              ],
              [
                -70.916093,
                -33.487704
              ],
              [
                -70.915684,
                -33.487648
              ],
              [
                -70.915168,
                -33.48748
              ],
              [
                -70.91393,
                -33.48696
              ],
              [
                -70.913275,
                -33.486383
              ],
              [
                -70.912849,
                -33.485607
              ],
              [
                -70.912664,
                -33.485169
              ],
              [
                -70.912362,
                -33.484733
              ],
              [
                -70.91165,
                -33.484206
              ],
              [
                -70.910825,
                -33.483876
              ],
              [
                -70.908887,
                -33.483416
              ],
              [
                -70.906073,
                -33.482921
              ],
              [
                -70.903599,
                -33.48198
              ],
              [
                -70.899885,
                -33.480422
              ],
              [
                -70.898058,
                -33.479667
              ],
              [
                -70.894995,
                -33.47849
              ],
              [
                -70.893413,
                -33.478221
              ],
              [
                -70.891949,
                -33.478048
              ],
              [
                -70.89078,
                -33.478017
              ],
              [
                -70.889671,
                -33.478033
              ],
              [
                -70.888449,
                -33.478248
              ],
              [
                -70.887049,
                -33.478318
              ],
              [
                -70.885822,
                -33.478337
              ],
              [
                -70.883715,
                -33.478124
              ],
              [
                -70.882128,
                -33.477659
              ],
              [
                -70.880774,
                -33.477141
              ],
              [
                -70.879774,
                -33.476814
              ],
              [
                -70.879128,
                -33.476677
              ],
              [
                -70.878076,
                -33.476644
              ],
              [
                -70.876736,
                -33.476762
              ],
              [
                -70.874879,
                -33.477328
              ],
              [
                -70.873075,
                -33.477649
              ],
              [
                -70.871679,
                -33.477915
              ],
              [
                -70.870173,
                -33.478476
              ],
              [
                -70.868891,
                -33.478642
              ],
              [
                -70.867086,
                -33.478865
              ],
              [
                -70.862832,
                -33.479321
              ],
              [
                -70.860157,
                -33.479899
              ],
              [
                -70.858525,
                -33.480022
              ],
              [
                -70.855776,
                -33.479867
              ],
              [
                -70.854316,
                -33.479889
              ],
              [
                -70.852797,
                -33.479863
              ],
              [
                -70.850288,
                -33.479949
              ],
              [
                -70.849528,
                -33.479912
              ],
              [
                -70.848762,
                -33.479629
              ],
              [
                -70.848346,
                -33.479293
              ],
              [
                -70.848161,
                -33.478806
              ],
              [
                -70.847973,
                -33.478222
              ],
              [
                -70.848014,
                -33.477389
              ],
              [
                -70.847943,
                -33.476803
              ],
              [
                -70.847523,
                -33.476271
              ],
              [
                -70.846019,
                -33.474189
              ],
              [
                -70.844399,
                -33.472157
              ],
              [
                -70.843857,
                -33.471382
              ],
              [
                -70.843549,
                -33.470652
              ],
              [
                -70.843357,
                -33.469872
              ],
              [
                -70.842512,
                -33.468563
              ],
              [
                -70.842144,
                -33.467737
              ],
              [
                -70.841612,
                -33.467402
              ],
              [
                -70.841138,
                -33.467115
              ],
              [
                -70.840667,
                -33.466926
              ],
              [
                -70.839731,
                -33.466843
              ],
              [
                -70.838799,
                -33.466954
              ],
              [
                -70.837749,
                -33.467019
              ],
              [
                -70.836405,
                -33.46699
              ],
              [
                -70.834943,
                -33.466865
              ],
              [
                -70.833826,
                -33.466538
              ],
              [
                -70.832535,
                -33.466215
              ],
              [
                -70.830837,
                -33.465995
              ],
              [
                -70.829896,
                -33.465716
              ],
              [
                -70.829194,
                -33.465628
              ],
              [
                -70.828326,
                -33.466032
              ],
              [
                -70.827637,
                -33.466581
              ],
              [
                -70.826769,
                -33.466985
              ],
              [
                -70.824259,
                -33.467022
              ],
              [
                -70.820988,
                -33.466972
              ],
              [
                -70.818533,
                -33.466862
              ],
              [
                -70.817011,
                -33.466688
              ],
              [
                -70.815777,
                -33.466315
              ],
              [
                -70.814544,
                -33.466039
              ],
              [
                -70.813539,
                -33.465418
              ],
              [
                -70.811581,
                -33.463929
              ],
              [
                -70.810807,
                -33.463255
              ],
              [
                -70.809741,
                -33.462536
              ],
              [
                -70.808088,
                -33.461631
              ],
              [
                -70.806449,
                -33.460978
              ],
              [
                -70.806302,
                -33.461035
              ],
              [
                -70.805963,
                -33.46137
              ],
              [
                -70.805525,
                -33.461788
              ],
              [
                -70.805002,
                -33.462356
              ],
              [
                -70.804831,
                -33.462695
              ],
              [
                -70.80471,
                -33.462914
              ],
              [
                -70.804705,
                -33.463071
              ],
              [
                -70.796782,
                -33.463132
              ],
              [
                -70.796671,
                -33.463133
              ],
              [
                -70.796626,
                -33.463133
              ],
              [
                -70.796637,
                -33.463084
              ],
              [
                -70.796525,
                -33.46292
              ],
              [
                -70.796263,
                -33.462882
              ],
              [
                -70.796087,
                -33.462783
              ],
              [
                -70.796162,
                -33.462537
              ],
              [
                -70.79648,
                -33.461183
              ],
              [
                -70.796661,
                -33.46044
              ],
              [
                -70.783868,
                -33.462471
              ],
              [
                -70.782918,
                -33.462672
              ],
              [
                -70.7823,
                -33.462681
              ],
              [
                -70.781514,
                -33.462693
              ],
              [
                -70.781158,
                -33.462715
              ],
              [
                -70.781076,
                -33.462701
              ],
              [
                -70.780515,
                -33.462641
              ],
              [
                -70.780239,
                -33.462676
              ],
              [
                -70.779831,
                -33.462791
              ],
              [
                -70.779829,
                -33.462798
              ],
              [
                -70.779809,
                -33.462799
              ],
              [
                -70.779796,
                -33.4628
              ],
              [
                -70.779795,
                -33.462802
              ],
              [
                -70.77973,
                -33.462821
              ],
              [
                -70.779574,
                -33.462868
              ],
              [
                -70.779295,
                -33.462957
              ],
              [
                -70.779103,
                -33.463014
              ],
              [
                -70.778882,
                -33.463052
              ],
              [
                -70.778767,
                -33.463069
              ],
              [
                -70.778597,
                -33.463074
              ],
              [
                -70.778413,
                -33.463065
              ],
              [
                -70.778335,
                -33.463053
              ],
              [
                -70.778191,
                -33.463013
              ],
              [
                -70.777992,
                -33.462943
              ],
              [
                -70.777831,
                -33.462895
              ],
              [
                -70.777787,
                -33.462894
              ],
              [
                -70.777667,
                -33.462892
              ],
              [
                -70.777484,
                -33.462894
              ],
              [
                -70.777468,
                -33.462887
              ],
              [
                -70.777196,
                -33.462896
              ],
              [
                -70.775809,
                -33.45821
              ],
              [
                -70.765051,
                -33.459258
              ]
            ]
          ],
          "type": "Polygon"
        },
        "properties": {
          "CIR_SENA": 7,
          "COD_COMUNA": 1311,
          "DIS_ELEC": 20,
          "NOM_COM": "Maipú",
          "NOM_PROV": "Santiago",
          "NOM_REG": "Región Metropolitana de Santiago",
          "SHAPE_Area": 138038031.124,
          "SHAPE_LENG": 61424.982525,
          "SHAPE_Le_1": 61429.469835
        },
        "type": "Feature",
        "crs": {
          "properties": {
            "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
          },
          "type": "name"
        },
        "id": 26
      }
    ]
}

const unidades_medida = {
  longitud: {
    code: 'LEN',
    type: 'Medida de tamaño o longitud',
    units: [
      {
        code: 'MTR',
        unit: 'Metro',
        countries: ['ALL', 'INT'],
      },
      {
        code: 'INCH',
        unit: 'Pulgada',
        countries: ['USA', 'CAN'],
      },
      {
        code: 'CM',
        unit: 'Centímetro',
        countries: ['ALL', 'INT'],
      },
      // {
      //   code: 'SQM',
      //   unit: 'Metro cuadrado',
      //   countries: ['ALL', 'INT'],
      // },
      // {
      //   code: 'SQFT',
      //   unit: 'Pies cuadrados',
      //   countries: ['USA'],
      // },
    ],
  },
  peso: {
    code: 'WGT',
    type: 'Medida de peso',
    units: [
      {
        code: 'KG',
        unit: 'Kilogramo',
        countries: ['ALL', 'INT'],
      },
      {
        code: 'LB',
        unit: 'Libra',
        countries: ['USA', 'UK'],
      },
      // {
      //   code: 'KGPCM',
      //   unit: 'Kilogramo por metro cúbico',
      //   countries: ['ALL', 'INT'],
      // },
      // {
      //   code: 'LBPCIN',
      //   unit: 'Libra por pulgada cúbica',
      //   countries: ['USA'],
      // },
    ],
  },
  volumen: {
    code: 'VOL',
    type: 'Medida de volumen',
    units: [
      {
        code: 'L',
        unit: 'Litro',
        countries: ['ALL', 'INT'],
      },
      {
        code: 'GAL',
        unit: 'Galón',
        countries: ['USA', 'CAN'],
      },
      {
        code: 'M3',
        unit: 'Metro cúbico',
        countries: ['ALL', 'INT'],
      }
    ],
  },
  temperatura: {
    code: 'TMP',
    type: 'Medida de temperatura',
    units: [
      {
        code: 'C',
        unit: 'Grado Celsius',
        countries: ['ALL', 'INT'],
      },
      {
        code: 'F',
        unit: 'Grado Fahrenheit',
        countries: ['USA'],
      },
    ],
  },
  velocidad: {
    code: 'SPD',
    type: 'Medida de velocidad',
    units: [
      {
        code: 'MPS',
        unit: 'Metros por segundo',
        countries: ['ALL', 'INT'],
      },
      {
        code: 'KMPH',
        unit: 'Kilómetros por hora',
        countries: ['ALL', 'INT'],
      },
      {
        code: 'FTPSEC',
        unit: 'Pies por segundo',
        countries: ['USA'],
      },
      {
        code: 'MIPH',
        unit: 'Millas por hora',
        countries: ['USA'],
      },
    ],
  },
};

module.exports = {
    geojson_rm,
    acciones,
    unidades_medida,
    paises_sistema,
    geo_json_alert,
    paises_codigos_telefonos,
    logotipo,
    host,
    markerSmall,
    virtual_tour_settings,
    botones,
    url_images,
    paises_nombres
}